import { a as createCommonjsModule, u as unwrapExports, c as commonjsGlobal } from './_commonjsHelpers-556cd408.js';
import { f as _objectSpread2$1, a as _inherits$3, b as _createClass$4, c as _classCallCheck$4, d as _callSuper, e as _defineProperty$1, g as _extends$9, i as _toConsumableArray$2, j as _slicedToArray$2, m as _typeof$1 } from './_rollupPluginBabelHelpers-047e4aae.js';
import React, { createElement, Component, useState } from 'react';
import PropTypes from 'prop-types';
import ReactDOM, { findDOMNode } from 'react-dom';
import { c as _extends$8, _ as _slicedToArray$1, a as _objectSpread2, e as _asyncToGenerator, f as _regeneratorRuntime, g as _inherits$4, h as _createSuper, i as _createClass$5, j as _classCallCheck$5, k as _defineProperty$2, l as _assertThisInitialized$1, m as _toConsumableArray$3 } from './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import styled from 'styled-components';
import { u as useActivify, a as useEscapeKey, P as Portal$3$1, s as styleInject } from './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon, C as CloseIcon, A as ArrowIcon, b as CloseV2Icon, c as CloneIcon, P as PlaceholderIcon$1, d as PlaceholderIcon, e as PlusIcon, T as TrashIcon, f as AngleDownIcon } from './index-28a062d6-3659b895.js';
import './index-155df85b-a520c7f0.js';
import { i as isValidURL$1 } from './generic-7099c3ed-1383f6f8.js';
import { B as Button } from './button-fb2021fd.js';
import { T as Text } from './text-5e5c8ea1.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import { B as Box } from './box-e581bc98.js';
import { L as Label, T as Text$1, c as cc } from './index-5dfda37f-a2c0763c.js';
import { L as Loader } from './loader-4d85b9a1.js';
import { A as Activify } from './activify-bf855d3e.js';
import { s as styleInject$1 } from './style-inject.es-1f59c1d0.js';
import { u as useEnterKey } from './useEnterKey-1841e752-4d3d6e9b.js';
import { M as Modal$1 } from './modal-bda55b09.js';
import { R as RephraseBotResponses } from './index-30009c89.js';
import { I as IMAGE_EXTENSIONS, E as ENDPOINTS$1, V as VIDEO_EXTENSIONS$1, A as AUDIO_EXTENSIONS, D as Dropdown } from './dropdown-75073a0f.js';
import { T as Toggle } from './toggle-6e04c39b.js';
import { T as ToastMessage } from './toastMessage-bc50b53b.js';
import { S as Search$1, G as GlobalConstants } from './index-06b8b31f.js';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1 = invariant;

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var Manager = function () {
  function Manager() {
    _classCallCheck(this, Manager);

    _defineProperty(this, "refs", {});
  }

  _createClass(Manager, [{
    key: "add",
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: "remove",
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var _this = this;

      return this.refs[this.active.collection].find(function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: "getIndex",
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: "getOrderedRefs",
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
      return this.refs[collection].sort(sortByIndex);
    }
  }]);

  return Manager;
}();

function sortByIndex(_ref2, _ref3) {
  var index1 = _ref2.node.sortableInfo.index;
  var index2 = _ref3.node.sortableInfo.index;
  return index1 - index2;
}

function arrayMove(array, from, to) {

  array = array.slice();
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
  return array;
}
function omit(obj, keysToOmit) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}
var events = {
  end: ['touchend', 'touchcancel', 'mouseup'],
  move: ['touchmove', 'mousemove'],
  start: ['touchstart', 'mousedown']
};
var vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return '';
  }

  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';

    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();
function setInlineStyles(node, styles) {
  Object.keys(styles).forEach(function (key) {
    node.style[key] = styles[key];
  });
}
function setTranslate3d(node, translate) {
  node.style["".concat(vendorPrefix, "Transform")] = translate == null ? '' : "translate3d(".concat(translate.x, "px,").concat(translate.y, "px,0)");
}
function setTransitionDuration(node, duration) {
  node.style["".concat(vendorPrefix, "TransitionDuration")] = duration == null ? '' : "".concat(duration, "ms");
}
function closest(el, fn) {
  while (el) {
    if (fn(el)) {
      return el;
    }

    el = el.parentNode;
  }

  return null;
}
function limit(min, max, value) {
  return Math.max(min, Math.min(value, max));
}

function getPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }

  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);
  return {
    bottom: getPixelValue(style.marginBottom),
    left: getPixelValue(style.marginLeft),
    right: getPixelValue(style.marginRight),
    top: getPixelValue(style.marginTop)
  };
}
function provideDisplayName(prefix, Component$$1) {
  var componentName = Component$$1.displayName || Component$$1.name;
  return componentName ? "".concat(prefix, "(").concat(componentName, ")") : prefix;
}
function getScrollAdjustedBoundingClientRect(node, scrollDelta) {
  var boundingClientRect = node.getBoundingClientRect();
  return {
    top: boundingClientRect.top + scrollDelta.top,
    left: boundingClientRect.left + scrollDelta.left
  };
}
function getPosition(event) {
  if (event.touches && event.touches.length) {
    return {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
  } else if (event.changedTouches && event.changedTouches.length) {
    return {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY
    };
  } else {
    return {
      x: event.pageX,
      y: event.pageY
    };
  }
}
function isTouchEvent(event) {
  return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function getEdgeOffset(node, parent) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    left: 0,
    top: 0
  };

  if (!node) {
    return undefined;
  }

  var nodeOffset = {
    left: offset.left + node.offsetLeft,
    top: offset.top + node.offsetTop
  };

  if (node.parentNode === parent) {
    return nodeOffset;
  }

  return getEdgeOffset(node.parentNode, parent, nodeOffset);
}
function getTargetIndex(newIndex, prevIndex, oldIndex) {
  if (newIndex < oldIndex && newIndex > prevIndex) {
    return newIndex - 1;
  } else if (newIndex > oldIndex && newIndex < prevIndex) {
    return newIndex + 1;
  } else {
    return newIndex;
  }
}
function getLockPixelOffset(_ref) {
  var lockOffset = _ref.lockOffset,
      width = _ref.width,
      height = _ref.height;
  var offsetX = lockOffset;
  var offsetY = lockOffset;
  var unit = 'px';

  if (typeof lockOffset === 'string') {
    var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
    invariant_1(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);
    offsetX = parseFloat(lockOffset);
    offsetY = parseFloat(lockOffset);
    unit = match[1];
  }

  invariant_1(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

  if (unit === '%') {
    offsetX = offsetX * width / 100;
    offsetY = offsetY * height / 100;
  }

  return {
    x: offsetX,
    y: offsetY
  };
}
function getLockPixelOffsets(_ref2) {
  var height = _ref2.height,
      width = _ref2.width,
      lockOffset = _ref2.lockOffset;
  var offsets = Array.isArray(lockOffset) ? lockOffset : [lockOffset, lockOffset];
  invariant_1(offsets.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

  var _offsets = _slicedToArray(offsets, 2),
      minLockOffset = _offsets[0],
      maxLockOffset = _offsets[1];

  return [getLockPixelOffset({
    height: height,
    lockOffset: minLockOffset,
    width: width
  }), getLockPixelOffset({
    height: height,
    lockOffset: maxLockOffset,
    width: width
  })];
}

function isScrollable(el) {
  var computedStyle = window.getComputedStyle(el);
  var overflowRegex = /(auto|scroll)/;
  var properties = ['overflow', 'overflowX', 'overflowY'];
  return properties.find(function (property) {
    return overflowRegex.test(computedStyle[property]);
  });
}

function getScrollingParent(el) {
  if (!(el instanceof HTMLElement)) {
    return null;
  } else if (isScrollable(el)) {
    return el;
  } else {
    return getScrollingParent(el.parentNode);
  }
}
function getContainerGridGap(element) {
  var style = window.getComputedStyle(element);

  if (style.display === 'grid') {
    return {
      x: getPixelValue(style.gridColumnGap),
      y: getPixelValue(style.gridRowGap)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var KEYCODE = {
  TAB: 9,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
var NodeType = {
  Anchor: 'A',
  Button: 'BUTTON',
  Canvas: 'CANVAS',
  Input: 'INPUT',
  Option: 'OPTION',
  Textarea: 'TEXTAREA',
  Select: 'SELECT'
};
function cloneNode(node) {
  var selector = 'input, textarea, select, canvas, [contenteditable]';
  var fields = node.querySelectorAll(selector);
  var clonedNode = node.cloneNode(true);

  var clonedFields = _toConsumableArray(clonedNode.querySelectorAll(selector));

  clonedFields.forEach(function (field, i) {
    if (field.type !== 'file') {
      field.value = fields[i].value;
    }

    if (field.type === 'radio' && field.name) {
      field.name = "__sortableClone__".concat(field.name);
    }

    if (field.tagName === NodeType.Canvas && fields[i].width > 0 && fields[i].height > 0) {
      var destCtx = field.getContext('2d');
      destCtx.drawImage(fields[i], 0, 0);
    }
  });
  return clonedNode;
}

function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function (_React$Component) {
    _inherits(WithSortableHandle, _React$Component);

    function WithSortableHandle() {
      _classCallCheck(this, WithSortableHandle);

      return _possibleConstructorReturn(this, _getPrototypeOf(WithSortableHandle).apply(this, arguments));
    }

    _createClass(WithSortableHandle, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var node = findDOMNode(this);
        node.sortableHandle = true;
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        invariant_1(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: "render",
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;
        return createElement(WrappedComponent, _extends({
          ref: ref
        }, this.props));
      }
    }]);

    return WithSortableHandle;
  }(Component), _defineProperty(_class, "displayName", provideDisplayName('sortableHandle', WrappedComponent)), _temp;
}
function isSortableHandle(node) {
  return node.sortableHandle != null;
}

var AutoScroller = function () {
  function AutoScroller(container, onScrollCallback) {
    _classCallCheck(this, AutoScroller);

    this.container = container;
    this.onScrollCallback = onScrollCallback;
  }

  _createClass(AutoScroller, [{
    key: "clear",
    value: function clear() {
      if (this.interval == null) {
        return;
      }

      clearInterval(this.interval);
      this.interval = null;
    }
  }, {
    key: "update",
    value: function update(_ref) {
      var _this = this;

      var translate = _ref.translate,
          minTranslate = _ref.minTranslate,
          maxTranslate = _ref.maxTranslate,
          width = _ref.width,
          height = _ref.height;
      var direction = {
        x: 0,
        y: 0
      };
      var speed = {
        x: 1,
        y: 1
      };
      var acceleration = {
        x: 10,
        y: 10
      };
      var _this$container = this.container,
          scrollTop = _this$container.scrollTop,
          scrollLeft = _this$container.scrollLeft,
          scrollHeight = _this$container.scrollHeight,
          scrollWidth = _this$container.scrollWidth,
          clientHeight = _this$container.clientHeight,
          clientWidth = _this$container.clientWidth;
      var isTop = scrollTop === 0;
      var isBottom = scrollHeight - scrollTop - clientHeight === 0;
      var isLeft = scrollLeft === 0;
      var isRight = scrollWidth - scrollLeft - clientWidth === 0;

      if (translate.y >= maxTranslate.y - height / 2 && !isBottom) {
        direction.y = 1;
        speed.y = acceleration.y * Math.abs((maxTranslate.y - height / 2 - translate.y) / height);
      } else if (translate.x >= maxTranslate.x - width / 2 && !isRight) {
        direction.x = 1;
        speed.x = acceleration.x * Math.abs((maxTranslate.x - width / 2 - translate.x) / width);
      } else if (translate.y <= minTranslate.y + height / 2 && !isTop) {
        direction.y = -1;
        speed.y = acceleration.y * Math.abs((translate.y - height / 2 - minTranslate.y) / height);
      } else if (translate.x <= minTranslate.x + width / 2 && !isLeft) {
        direction.x = -1;
        speed.x = acceleration.x * Math.abs((translate.x - width / 2 - minTranslate.x) / width);
      }

      if (this.interval) {
        this.clear();
        this.isAutoScrolling = false;
      }

      if (direction.x !== 0 || direction.y !== 0) {
        this.interval = setInterval(function () {
          _this.isAutoScrolling = true;
          var offset = {
            left: speed.x * direction.x,
            top: speed.y * direction.y
          };
          _this.container.scrollTop += offset.top;
          _this.container.scrollLeft += offset.left;

          _this.onScrollCallback(offset);
        }, 5);
      }
    }
  }]);

  return AutoScroller;
}();

function defaultGetHelperDimensions(_ref) {
  var node = _ref.node;
  return {
    height: node.offsetHeight,
    width: node.offsetWidth
  };
}

function defaultShouldCancelStart(event) {
  var interactiveElements = [NodeType.Input, NodeType.Textarea, NodeType.Select, NodeType.Option, NodeType.Button];

  if (interactiveElements.indexOf(event.target.tagName) !== -1) {
    return true;
  }

  if (closest(event.target, function (el) {
    return el.contentEditable === 'true';
  })) {
    return true;
  }

  return false;
}

var propTypes = {
  axis: PropTypes.oneOf(['x', 'y', 'xy']),
  contentWindow: PropTypes.any,
  disableAutoscroll: PropTypes.bool,
  distance: PropTypes.number,
  getContainer: PropTypes.func,
  getHelperDimensions: PropTypes.func,
  helperClass: PropTypes.string,
  helperContainer: PropTypes.oneOfType([PropTypes.func, typeof HTMLElement === 'undefined' ? PropTypes.any : PropTypes.instanceOf(HTMLElement)]),
  hideSortableGhost: PropTypes.bool,
  keyboardSortingTransitionDuration: PropTypes.number,
  lockAxis: PropTypes.string,
  lockOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]),
  lockToContainerEdges: PropTypes.bool,
  onSortEnd: PropTypes.func,
  onSortMove: PropTypes.func,
  onSortOver: PropTypes.func,
  onSortStart: PropTypes.func,
  pressDelay: PropTypes.number,
  pressThreshold: PropTypes.number,
  keyCodes: PropTypes.shape({
    lift: PropTypes.arrayOf(PropTypes.number),
    drop: PropTypes.arrayOf(PropTypes.number),
    cancel: PropTypes.arrayOf(PropTypes.number),
    up: PropTypes.arrayOf(PropTypes.number),
    down: PropTypes.arrayOf(PropTypes.number)
  }),
  shouldCancelStart: PropTypes.func,
  transitionDuration: PropTypes.number,
  updateBeforeSortStart: PropTypes.func,
  useDragHandle: PropTypes.bool,
  useWindowAsScrollContainer: PropTypes.bool
};
var defaultKeyCodes = {
  lift: [KEYCODE.SPACE],
  drop: [KEYCODE.SPACE],
  cancel: [KEYCODE.ESC],
  up: [KEYCODE.UP, KEYCODE.LEFT],
  down: [KEYCODE.DOWN, KEYCODE.RIGHT]
};
var defaultProps = {
  axis: 'y',
  disableAutoscroll: false,
  distance: 0,
  getHelperDimensions: defaultGetHelperDimensions,
  hideSortableGhost: true,
  lockOffset: '50%',
  lockToContainerEdges: false,
  pressDelay: 0,
  pressThreshold: 5,
  keyCodes: defaultKeyCodes,
  shouldCancelStart: defaultShouldCancelStart,
  transitionDuration: 300,
  useWindowAsScrollContainer: false
};
var omittedProps = Object.keys(propTypes);
function validateProps(props) {
  invariant_1(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
}

function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, value);
}
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function (_React$Component) {
    _inherits(WithSortableContainer, _React$Component);

    function WithSortableContainer(props) {
      var _this;

      _classCallCheck(this, WithSortableContainer);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(WithSortableContainer).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleStart", function (event) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;

        if (event.button === 2 || shouldCancelStart(event)) {
          return;
        }

        _this.touched = true;
        _this.position = getPosition(event);
        var node = closest(event.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection,
              disabled = _node$sortableInfo.disabled;

          if (disabled) {
            return;
          }

          if (useDragHandle && !closest(event.target, isSortableHandle)) {
            return;
          }

          _this.manager.active = {
            collection: collection,
            index: index
          };

          if (!isTouchEvent(event) && event.target.tagName === NodeType.Anchor) {
            event.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(event);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(event);
              }, _this.props.pressDelay);
            }
          }
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "nodeIsChild", function (node) {
        return node.sortableInfo.manager === _this.manager;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMove", function (event) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;

        if (!_this.state.sorting && _this.touched && !_this._awaitingUpdateBeforeSortStart) {
          var position = getPosition(event);
          var delta = {
            x: _this.position.x - position.x,
            y: _this.position.y - position.y
          };
          var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
          _this.delta = delta;

          if (!distance && (!pressThreshold || combinedDelta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && combinedDelta >= distance && _this.manager.isActive()) {
            _this.handlePress(event);
          }
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEnd", function () {
        _this.touched = false;

        _this.cancel();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancel", function () {
        var distance = _this.props.distance;
        var sorting = _this.state.sorting;

        if (!sorting) {
          if (!distance) {
            clearTimeout(_this.pressTimer);
          }

          _this.manager.active = null;
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handlePress", function (event) {
        try {
          var active = _this.manager.getActive();

          var _temp6 = function () {
            if (active) {
              var _temp7 = function _temp7() {
                var index = _node.sortableInfo.index;
                var margin = getElementMargin(_node);
                var gridGap = getContainerGridGap(_this.container);

                var containerBoundingRect = _this.scrollContainer.getBoundingClientRect();

                var dimensions = _getHelperDimensions({
                  index: index,
                  node: _node,
                  collection: _collection
                });

                _this.node = _node;
                _this.margin = margin;
                _this.gridGap = gridGap;
                _this.width = dimensions.width;
                _this.height = dimensions.height;
                _this.marginOffset = {
                  x: _this.margin.left + _this.margin.right + _this.gridGap.x,
                  y: Math.max(_this.margin.top, _this.margin.bottom, _this.gridGap.y)
                };
                _this.boundingClientRect = _node.getBoundingClientRect();
                _this.containerBoundingRect = containerBoundingRect;
                _this.index = index;
                _this.newIndex = index;
                _this.axis = {
                  x: _axis.indexOf('x') >= 0,
                  y: _axis.indexOf('y') >= 0
                };
                _this.offsetEdge = getEdgeOffset(_node, _this.container);

                if (_isKeySorting) {
                  _this.initialOffset = getPosition(_objectSpread({}, event, {
                    pageX: _this.boundingClientRect.left,
                    pageY: _this.boundingClientRect.top
                  }));
                } else {
                  _this.initialOffset = getPosition(event);
                }

                _this.initialScroll = {
                  left: _this.scrollContainer.scrollLeft,
                  top: _this.scrollContainer.scrollTop
                };
                _this.initialWindowScroll = {
                  left: window.pageXOffset,
                  top: window.pageYOffset
                };
                _this.helper = _this.helperContainer.appendChild(cloneNode(_node));
                setInlineStyles(_this.helper, {
                  boxSizing: 'border-box',
                  height: "".concat(_this.height, "px"),
                  left: "".concat(_this.boundingClientRect.left - margin.left, "px"),
                  pointerEvents: 'none',
                  position: 'fixed',
                  top: "".concat(_this.boundingClientRect.top - margin.top, "px"),
                  width: "".concat(_this.width, "px")
                });

                if (_isKeySorting) {
                  _this.helper.focus();
                }

                if (_hideSortableGhost) {
                  _this.sortableGhost = _node;
                  setInlineStyles(_node, {
                    opacity: 0,
                    visibility: 'hidden'
                  });
                }

                _this.minTranslate = {};
                _this.maxTranslate = {};

                if (_isKeySorting) {
                  var _ref = _useWindowAsScrollContainer ? {
                    top: 0,
                    left: 0,
                    width: _this.contentWindow.innerWidth,
                    height: _this.contentWindow.innerHeight
                  } : _this.containerBoundingRect,
                      containerTop = _ref.top,
                      containerLeft = _ref.left,
                      containerWidth = _ref.width,
                      containerHeight = _ref.height;

                  var containerBottom = containerTop + containerHeight;
                  var containerRight = containerLeft + containerWidth;

                  if (_this.axis.x) {
                    _this.minTranslate.x = containerLeft - _this.boundingClientRect.left;
                    _this.maxTranslate.x = containerRight - (_this.boundingClientRect.left + _this.width);
                  }

                  if (_this.axis.y) {
                    _this.minTranslate.y = containerTop - _this.boundingClientRect.top;
                    _this.maxTranslate.y = containerBottom - (_this.boundingClientRect.top + _this.height);
                  }
                } else {
                  if (_this.axis.x) {
                    _this.minTranslate.x = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                    _this.maxTranslate.x = (_useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                  }

                  if (_this.axis.y) {
                    _this.minTranslate.y = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                    _this.maxTranslate.y = (_useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                  }
                }

                if (_helperClass) {
                  _helperClass.split(' ').forEach(function (className) {
                    return _this.helper.classList.add(className);
                  });
                }

                _this.listenerNode = event.touches ? _node : _this.contentWindow;

                if (_isKeySorting) {
                  _this.listenerNode.addEventListener('wheel', _this.handleKeyEnd, true);

                  _this.listenerNode.addEventListener('mousedown', _this.handleKeyEnd, true);

                  _this.listenerNode.addEventListener('keydown', _this.handleKeyDown);
                } else {
                  events.move.forEach(function (eventName) {
                    return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                  });
                  events.end.forEach(function (eventName) {
                    return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                  });
                }

                _this.setState({
                  sorting: true,
                  sortingIndex: index
                });

                if (_onSortStart) {
                  _onSortStart({
                    node: _node,
                    index: index,
                    collection: _collection,
                    isKeySorting: _isKeySorting,
                    nodes: _this.manager.getOrderedRefs(),
                    helper: _this.helper
                  }, event);
                }

                if (_isKeySorting) {
                  _this.keyMove(0);
                }
              };

              var _this$props3 = _this.props,
                  _axis = _this$props3.axis,
                  _getHelperDimensions = _this$props3.getHelperDimensions,
                  _helperClass = _this$props3.helperClass,
                  _hideSortableGhost = _this$props3.hideSortableGhost,
                  updateBeforeSortStart = _this$props3.updateBeforeSortStart,
                  _onSortStart = _this$props3.onSortStart,
                  _useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
              var _node = active.node,
                  _collection = active.collection;
              var _isKeySorting = _this.manager.isKeySorting;

              var _temp8 = function () {
                if (typeof updateBeforeSortStart === 'function') {
                  _this._awaitingUpdateBeforeSortStart = true;

                  var _temp9 = _finallyRethrows(function () {
                    var index = _node.sortableInfo.index;
                    return Promise.resolve(updateBeforeSortStart({
                      collection: _collection,
                      index: index,
                      node: _node,
                      isKeySorting: _isKeySorting
                    }, event)).then(function () {});
                  }, function (_wasThrown, _result) {
                    _this._awaitingUpdateBeforeSortStart = false;
                    if (_wasThrown) throw _result;
                    return _result;
                  });

                  if (_temp9 && _temp9.then) return _temp9.then(function () {});
                }
              }();

              return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
            }
          }();

          return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSortMove", function (event) {
        var onSortMove = _this.props.onSortMove;

        if (typeof event.preventDefault === 'function') {
          event.preventDefault();
        }

        _this.updateHelperPosition(event);

        _this.animateNodes();

        _this.autoscroll();

        if (onSortMove) {
          onSortMove(event);
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSortEnd", function (event) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var _this$manager = _this.manager,
            collection = _this$manager.active.collection,
            isKeySorting = _this$manager.isKeySorting;

        var nodes = _this.manager.getOrderedRefs();

        if (_this.listenerNode) {
          if (isKeySorting) {
            _this.listenerNode.removeEventListener('wheel', _this.handleKeyEnd, true);

            _this.listenerNode.removeEventListener('mousedown', _this.handleKeyEnd, true);

            _this.listenerNode.removeEventListener('keydown', _this.handleKeyDown);
          } else {
            events.move.forEach(function (eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
            });
            events.end.forEach(function (eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
            });
          }
        }

        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          setInlineStyles(_this.sortableGhost, {
            opacity: '',
            visibility: ''
          });
        }

        for (var i = 0, len = nodes.length; i < len; i++) {
          var _node2 = nodes[i];
          var el = _node2.node;
          _node2.edgeOffset = null;
          _node2.boundingClientRect = null;
          setTranslate3d(el, null);
          setTransitionDuration(el, null);
          _node2.translate = null;
        }

        _this.autoScroller.clear();

        _this.manager.active = null;
        _this.manager.isKeySorting = false;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            collection: collection,
            newIndex: _this.newIndex,
            oldIndex: _this.index,
            isKeySorting: isKeySorting,
            nodes: nodes
          }, event);
        }

        _this.touched = false;
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "autoscroll", function () {
        var disableAutoscroll = _this.props.disableAutoscroll;
        var isKeySorting = _this.manager.isKeySorting;

        if (disableAutoscroll) {
          _this.autoScroller.clear();

          return;
        }

        if (isKeySorting) {
          var translate = _objectSpread({}, _this.translate);

          var scrollX = 0;
          var scrollY = 0;

          if (_this.axis.x) {
            translate.x = Math.min(_this.maxTranslate.x, Math.max(_this.minTranslate.x, _this.translate.x));
            scrollX = _this.translate.x - translate.x;
          }

          if (_this.axis.y) {
            translate.y = Math.min(_this.maxTranslate.y, Math.max(_this.minTranslate.y, _this.translate.y));
            scrollY = _this.translate.y - translate.y;
          }

          _this.translate = translate;
          setTranslate3d(_this.helper, _this.translate);
          _this.scrollContainer.scrollLeft += scrollX;
          _this.scrollContainer.scrollTop += scrollY;
          return;
        }

        _this.autoScroller.update({
          height: _this.height,
          maxTranslate: _this.maxTranslate,
          minTranslate: _this.minTranslate,
          translate: _this.translate,
          width: _this.width
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onAutoScroll", function (offset) {
        _this.translate.x += offset.left;
        _this.translate.y += offset.top;

        _this.animateNodes();
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDown", function (event) {
        var keyCode = event.keyCode;
        var _this$props5 = _this.props,
            shouldCancelStart = _this$props5.shouldCancelStart,
            _this$props5$keyCodes = _this$props5.keyCodes,
            customKeyCodes = _this$props5$keyCodes === void 0 ? {} : _this$props5$keyCodes;

        var keyCodes = _objectSpread({}, defaultKeyCodes, customKeyCodes);

        if (_this.manager.active && !_this.manager.isKeySorting || !_this.manager.active && (!keyCodes.lift.includes(keyCode) || shouldCancelStart(event) || !_this.isValidSortingTarget(event))) {
          return;
        }

        event.stopPropagation();
        event.preventDefault();

        if (keyCodes.lift.includes(keyCode) && !_this.manager.active) {
          _this.keyLift(event);
        } else if (keyCodes.drop.includes(keyCode) && _this.manager.active) {
          _this.keyDrop(event);
        } else if (keyCodes.cancel.includes(keyCode)) {
          _this.newIndex = _this.manager.active.index;

          _this.keyDrop(event);
        } else if (keyCodes.up.includes(keyCode)) {
          _this.keyMove(-1);
        } else if (keyCodes.down.includes(keyCode)) {
          _this.keyMove(1);
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyLift", function (event) {
        var target = event.target;
        var node = closest(target, function (el) {
          return el.sortableInfo != null;
        });
        var _node$sortableInfo2 = node.sortableInfo,
            index = _node$sortableInfo2.index,
            collection = _node$sortableInfo2.collection;
        _this.initialFocusedNode = target;
        _this.manager.isKeySorting = true;
        _this.manager.active = {
          index: index,
          collection: collection
        };

        _this.handlePress(event);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyMove", function (shift) {
        var nodes = _this.manager.getOrderedRefs();

        var lastIndex = nodes[nodes.length - 1].node.sortableInfo.index;
        var newIndex = _this.newIndex + shift;
        var prevIndex = _this.newIndex;

        if (newIndex < 0 || newIndex > lastIndex) {
          return;
        }

        _this.prevIndex = prevIndex;
        _this.newIndex = newIndex;
        var targetIndex = getTargetIndex(_this.newIndex, _this.prevIndex, _this.index);
        var target = nodes.find(function (_ref2) {
          var node = _ref2.node;
          return node.sortableInfo.index === targetIndex;
        });
        var targetNode = target.node;
        var scrollDelta = _this.containerScrollDelta;
        var targetBoundingClientRect = target.boundingClientRect || getScrollAdjustedBoundingClientRect(targetNode, scrollDelta);
        var targetTranslate = target.translate || {
          x: 0,
          y: 0
        };
        var targetPosition = {
          top: targetBoundingClientRect.top + targetTranslate.y - scrollDelta.top,
          left: targetBoundingClientRect.left + targetTranslate.x - scrollDelta.left
        };
        var shouldAdjustForSize = prevIndex < newIndex;
        var sizeAdjustment = {
          x: shouldAdjustForSize && _this.axis.x ? targetNode.offsetWidth - _this.width : 0,
          y: shouldAdjustForSize && _this.axis.y ? targetNode.offsetHeight - _this.height : 0
        };

        _this.handleSortMove({
          pageX: targetPosition.left + sizeAdjustment.x,
          pageY: targetPosition.top + sizeAdjustment.y,
          ignoreTransition: shift === 0
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyDrop", function (event) {
        _this.handleSortEnd(event);

        if (_this.initialFocusedNode) {
          _this.initialFocusedNode.focus();
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyEnd", function (event) {
        if (_this.manager.active) {
          _this.keyDrop(event);
        }
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isValidSortingTarget", function (event) {
        var useDragHandle = _this.props.useDragHandle;
        var target = event.target;
        var node = closest(target, function (el) {
          return el.sortableInfo != null;
        });
        return node && node.sortableInfo && !node.sortableInfo.disabled && (useDragHandle ? isSortableHandle(target) : target.sortableInfo);
      });

      validateProps(props);
      _this.manager = new Manager();
      _this.events = {
        end: _this.handleEnd,
        move: _this.handleMove,
        start: _this.handleStart
      };
      return _this;
    }

    _createClass(WithSortableContainer, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
        var container = this.getContainer();
        Promise.resolve(container).then(function (containerNode) {
          _this2.container = containerNode;
          _this2.document = _this2.container.ownerDocument || document;
          var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
          _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
          _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : getScrollingParent(_this2.container) || _this2.container;
          _this2.autoScroller = new AutoScroller(_this2.scrollContainer, _this2.onAutoScroll);
          Object.keys(_this2.events).forEach(function (key) {
            return events[key].forEach(function (eventName) {
              return _this2.container.addEventListener(eventName, _this2.events[key], false);
            });
          });

          _this2.container.addEventListener('keydown', _this2.handleKeyDown);
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this3 = this;

        if (this.helper && this.helper.parentNode) {
          this.helper.parentNode.removeChild(this.helper);
        }

        if (!this.container) {
          return;
        }

        Object.keys(this.events).forEach(function (key) {
          return events[key].forEach(function (eventName) {
            return _this3.container.removeEventListener(eventName, _this3.events[key]);
          });
        });
        this.container.removeEventListener('keydown', this.handleKeyDown);
      }
    }, {
      key: "updateHelperPosition",
      value: function updateHelperPosition(event) {
        var _this$props6 = this.props,
            lockAxis = _this$props6.lockAxis,
            lockOffset = _this$props6.lockOffset,
            lockToContainerEdges = _this$props6.lockToContainerEdges,
            transitionDuration = _this$props6.transitionDuration,
            _this$props6$keyboard = _this$props6.keyboardSortingTransitionDuration,
            keyboardSortingTransitionDuration = _this$props6$keyboard === void 0 ? transitionDuration : _this$props6$keyboard;
        var isKeySorting = this.manager.isKeySorting;
        var ignoreTransition = event.ignoreTransition;
        var offset = getPosition(event);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;
        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = getLockPixelOffsets({
            height: this.height,
            lockOffset: lockOffset,
            width: this.width
          }),
              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };
          translate.x = limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        if (isKeySorting && keyboardSortingTransitionDuration && !ignoreTransition) {
          setTransitionDuration(this.helper, keyboardSortingTransitionDuration);
        }

        setTranslate3d(this.helper, translate);
      }
    }, {
      key: "animateNodes",
      value: function animateNodes() {
        var _this$props7 = this.props,
            transitionDuration = _this$props7.transitionDuration,
            hideSortableGhost = _this$props7.hideSortableGhost,
            onSortOver = _this$props7.onSortOver;
        var containerScrollDelta = this.containerScrollDelta,
            windowScrollDelta = this.windowScrollDelta;
        var nodes = this.manager.getOrderedRefs();
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
          top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
        };
        var isKeySorting = this.manager.isKeySorting;
        var prevIndex = this.newIndex;
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var _node3 = nodes[i].node;
          var index = _node3.sortableInfo.index;
          var width = _node3.offsetWidth;
          var height = _node3.offsetHeight;
          var offset = {
            height: this.height > height ? height / 2 : this.height / 2,
            width: this.width > width ? width / 2 : this.width / 2
          };
          var mustShiftBackward = isKeySorting && index > this.index && index <= prevIndex;
          var mustShiftForward = isKeySorting && index < this.index && index >= prevIndex;
          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          if (!edgeOffset) {
            edgeOffset = getEdgeOffset(_node3, this.container);
            nodes[i].edgeOffset = edgeOffset;

            if (isKeySorting) {
              nodes[i].boundingClientRect = getScrollAdjustedBoundingClientRect(_node3, containerScrollDelta);
            }
          }

          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = getEdgeOffset(nextNode.node, this.container);

            if (isKeySorting) {
              nextNode.boundingClientRect = getScrollAdjustedBoundingClientRect(nextNode.node, containerScrollDelta);
            }
          }

          if (index === this.index) {
            if (hideSortableGhost) {
              this.sortableGhost = _node3;
              setInlineStyles(_node3, {
                opacity: 0,
                visibility: 'hidden'
              });
            }

            continue;
          }

          if (transitionDuration) {
            setTransitionDuration(_node3, transitionDuration);
          }

          if (this.axis.x) {
            if (this.axis.y) {
              if (mustShiftForward || index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                translate.x = this.width + this.marginOffset.x;

                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  if (nextNode) {
                    translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                    translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                  }
                }

                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (mustShiftBackward || index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                translate.x = -(this.width + this.marginOffset.x);

                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  if (prevNode) {
                    translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                    translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                  }
                }

                this.newIndex = index;
              }
            } else {
              if (mustShiftBackward || index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (mustShiftForward || index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;

                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (mustShiftBackward || index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (mustShiftForward || index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;

              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }

          setTranslate3d(_node3, translate);
          nodes[i].translate = translate;
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }

        if (isKeySorting) {
          this.newIndex = prevIndex;
        }

        var oldIndex = isKeySorting ? this.prevIndex : prevIndex;

        if (onSortOver && this.newIndex !== oldIndex) {
          onSortOver({
            collection: this.manager.active.collection,
            index: this.index,
            newIndex: this.newIndex,
            oldIndex: oldIndex,
            isKeySorting: isKeySorting,
            nodes: nodes,
            helper: this.helper
          });
        }
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        invariant_1(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: "getContainer",
      value: function getContainer() {
        var getContainer = this.props.getContainer;

        if (typeof getContainer !== 'function') {
          return findDOMNode(this);
        }

        return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
      }
    }, {
      key: "render",
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;
        return createElement(WrappedComponent, _extends({
          ref: ref
        }, omit(this.props, omittedProps)));
      }
    }, {
      key: "helperContainer",
      get: function get() {
        var helperContainer = this.props.helperContainer;

        if (typeof helperContainer === 'function') {
          return helperContainer();
        }

        return this.props.helperContainer || this.document.body;
      }
    }, {
      key: "containerScrollDelta",
      get: function get() {
        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;

        if (useWindowAsScrollContainer) {
          return {
            left: 0,
            top: 0
          };
        }

        return {
          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
          top: this.scrollContainer.scrollTop - this.initialScroll.top
        };
      }
    }, {
      key: "windowScrollDelta",
      get: function get() {
        return {
          left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
          top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
        };
      }
    }]);

    return WithSortableContainer;
  }(Component), _defineProperty(_class, "displayName", provideDisplayName('sortableList', WrappedComponent)), _defineProperty(_class, "defaultProps", defaultProps), _defineProperty(_class, "propTypes", propTypes), _defineProperty(_class, "childContextTypes", {
    manager: PropTypes.object.isRequired
  }), _temp;
}

var propTypes$1 = {
  index: PropTypes.number.isRequired,
  collection: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool
};
var omittedProps$1 = Object.keys(propTypes$1);
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function (_React$Component) {
    _inherits(WithSortableElement, _React$Component);

    function WithSortableElement() {
      _classCallCheck(this, WithSortableElement);

      return _possibleConstructorReturn(this, _getPrototypeOf(WithSortableElement).apply(this, arguments));
    }

    _createClass(WithSortableElement, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.register();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.node) {
          if (prevProps.index !== this.props.index) {
            this.node.sortableInfo.index = this.props.index;
          }

          if (prevProps.disabled !== this.props.disabled) {
            this.node.sortableInfo.disabled = this.props.disabled;
          }
        }

        if (prevProps.collection !== this.props.collection) {
          this.unregister(prevProps.collection);
          this.register();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unregister();
      }
    }, {
      key: "register",
      value: function register() {
        var _this$props = this.props,
            collection = _this$props.collection,
            disabled = _this$props.disabled,
            index = _this$props.index;
        var node = findDOMNode(this);
        node.sortableInfo = {
          collection: collection,
          disabled: disabled,
          index: index,
          manager: this.context.manager
        };
        this.node = node;
        this.ref = {
          node: node
        };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: "unregister",
      value: function unregister() {
        var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.collection;
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        invariant_1(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: "render",
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;
        return createElement(WrappedComponent, _extends({
          ref: ref
        }, omit(this.props, omittedProps$1)));
      }
    }]);

    return WithSortableElement;
  }(Component), _defineProperty(_class, "displayName", provideDisplayName('sortableElement', WrappedComponent)), _defineProperty(_class, "contextTypes", {
    manager: PropTypes.object.isRequired
  }), _defineProperty(_class, "propTypes", propTypes$1), _defineProperty(_class, "defaultProps", {
    collection: 0
  }), _temp;
}

var modalWidth = "480px";
var zIndex = 999999999;
var ModalWrapper = styled(Box)({
  position: "fixed",
  top: "0",
  left: "0",
  width: "100vw",
  height: "100%",
  zIndex: zIndex + 10,
  overflow: "hidden",
  pointerEvents: "none"
});
var ModalOverlay = styled(Box)({
  position: "absolute",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  backgroundColor: "#000",
  opacity: "0",
  transition: "0.2s linear",
  pointerEvents: "auto",
  "&.modal-active": {
    opacity: "0.4 !important"
  }
});
var MoadlStyle = function MoadlStyle(props) {
  return {
    opacity: "0",
    position: "absolute",
    zIndex: 2,
    backgroundColor: props.theme.colors.grey.pastel,
    outline: "none",
    boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.15)",
    boxSizing: "border-box",
    transition: "0.5s cubic-bezier(0.175, 0.5, 0.12, 1)",
    transform: "translate3d(-50%, -45%, 0)",
    top: "50%",
    left: "50%",
    borderRadius: "5px",
    pointerEvents: "auto",
    "&.modal-active": {
      opacity: "1 !important",
      transform: "translate3d(-50%, -50%, 0) !important"
    },
    width: props.width,
    flexDirection: "column",
    alignItems: "center"
  };
};
var Modal = styled(Box)(MoadlStyle);
var IconBox = styled(Icon)({
  position: "absolute",
  top: "15px",
  right: "15px"
});
var ButtonStyle = function ButtonStyle(props) {
  return {
    margin: props.theme.space.sm,
    padding: "".concat(props.theme.space.md, "px ").concat(2 * props.theme.space.md, "px")
  };
};
var ButtonBox = styled(Button)(ButtonStyle);

var Dialog = function Dialog(_ref) {
  var active = _ref.active,
    onClose = _ref.onClose,
    onEnter = _ref.onEnter,
    title = _ref.title,
    subtitle = _ref.subtitle,
    primaryAction = _ref.primaryAction,
    primaryActionText = _ref.primaryActionText,
    primaryActionType = _ref.primaryActionType,
    secondaryAction = _ref.secondaryAction,
    secondaryActionText = _ref.secondaryActionText,
    secondaryActionType = _ref.secondaryActionType,
    children = _ref.children,
    dialogStyles = _ref.dialogStyles;
  var _useActivify = useActivify(active),
    enabled = _useActivify.enabled,
    visible = _useActivify.visible;
  var activeClassName = visible ? "modal-active" : "";
  useEscapeKey(onClose);
  useEnterKey(onEnter);
  if (!enabled) return null;

  /*
      we can only pass width & padding, any other style will be removed.
  */
  var width = dialogStyles.width,
    padding = dialogStyles.padding;
  var styles = {
    width: width,
    padding: padding
  };
  return /*#__PURE__*/React.createElement(Portal$3$1, null, /*#__PURE__*/React.createElement(ModalWrapper, {
    "data-testid": "modal-wrapper"
  }, /*#__PURE__*/React.createElement(ModalOverlay, {
    "data-testid": "modal-overlay",
    className: activeClassName,
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Modal, _extends$8({
    "data-testid": "modal",
    className: activeClassName
  }, styles), /*#__PURE__*/React.createElement(IconBox, {
    src: "closeV2",
    onClick: onClose
  }), title && /*#__PURE__*/React.createElement(Box, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    "data-testid": "title",
    variant: "display-2.semi-bold",
    color: "black.haptik",
    textAlign: "center",
    lineHeight: "29px"
  }, title)), subtitle && /*#__PURE__*/React.createElement(Box, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    "data-testid": "subtitle",
    variant: "body.lg",
    color: "black.haptik",
    textAlign: "center",
    lineHeight: "19px"
  }, subtitle)), children, /*#__PURE__*/React.createElement(Box, {
    justifyContent: "center"
  }, secondaryActionText && /*#__PURE__*/React.createElement(ButtonBox, {
    "data-testid": "secondary-action",
    themed: true,
    variant: secondaryActionType || "secondary",
    size: "regular",
    onClick: function onClick() {
      secondaryAction();
      onClose();
    }
  }, secondaryActionText), primaryActionText && /*#__PURE__*/React.createElement(ButtonBox, {
    "data-testid": "primary-action",
    themed: true,
    variant: primaryActionType || "primary",
    size: "regular",
    onClick: primaryAction
  }, primaryActionText)))));
};
Dialog.propTypes = {
  active: PropTypes.bool,
  onClose: PropTypes.func,
  onEnter: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  primaryAction: PropTypes.func,
  primaryActionText: PropTypes.string,
  secondaryAction: PropTypes.func,
  secondaryActionText: PropTypes.string,
  children: PropTypes.node,
  dialogStyles: PropTypes.object,
  primaryActionType: PropTypes.string,
  secondaryActionType: PropTypes.string
};
Dialog.defaultProps = {
  active: false,
  onClose: function onClose() {},
  onEnter: function onEnter() {},
  title: "",
  subtitle: "",
  primaryAction: function primaryAction() {},
  primaryActionText: "Yes",
  secondaryAction: function secondaryAction() {},
  secondaryActionText: "No",
  children: null,
  dialogStyles: {
    padding: "50px",
    width: modalWidth
  },
  primaryActionType: "",
  secondaryActionType: ""
};
Dialog.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Dialog",
  "props": {
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClose": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onEnter": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subtitle": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "primaryAction": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "primaryActionText": {
      "defaultValue": {
        "value": "\"Yes\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "secondaryAction": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "secondaryActionText": {
      "defaultValue": {
        "value": "\"No\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "dialogStyles": {
      "defaultValue": {
        "value": "{\n  padding: \"50px\",\n  width: modalWidth,\n}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "primaryActionType": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "secondaryActionType": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z = ".ConfirmationDialog_dialogHeader__3RZod {\n  padding: 16px;\n  border-bottom: 1px solid #ccc;\n  display: flex;\n  align-items: center;\n  justify-content: space-between; }\n\n.ConfirmationDialog_dialogHeaderText__Ov_Lq {\n  margin: 0;\n  font-size: 22px; }\n\n.ConfirmationDialog_dialogHeaderCloseIcon__1JYOP {\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.2 ease-out; }\n  .ConfirmationDialog_dialogHeaderCloseIcon__1JYOP:hover {\n    opacity: 1; }\n\n.ConfirmationDialog_dialogBody__3b_cs {\n  padding: 16px;\n  max-height: 300px;\n  overflow-y: auto; }\n\n.ConfirmationDialog_dialogText__1gkMH {\n  margin-bottom: 32px;\n  margin-top: 0;\n  font-size: 16px;\n  font-weight: 400;\n  opacity: 0.8; }\n\n.ConfirmationDialog_dialogButtons__1wyha {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-right: -16px; }\n\n.ConfirmationDialog_dialogButton__1YvmK {\n  outline: none;\n  padding: 6px 18px;\n  border: 2px solid #124fa0;\n  background-color: #124fa0;\n  color: #fff;\n  font-size: 16px;\n  border-radius: 4px;\n  margin-right: 16px;\n  transition: 0.2s ease-out;\n  cursor: pointer; }\n  .ConfirmationDialog_dialogButton__1YvmK:hover {\n    background-color: #0d3872; }\n\n.ConfirmationDialog_dialogButtonNegative__1N69K {\n  background-color: transparent;\n  color: #124fa0; }\n  .ConfirmationDialog_dialogButtonNegative__1N69K:hover {\n    background-color: rgba(18, 79, 160, 0.2); }\n";
var styles = {"dialogHeader":"ConfirmationDialog_dialogHeader__3RZod","dialogHeaderText":"ConfirmationDialog_dialogHeaderText__Ov_Lq","dialogHeaderCloseIcon":"ConfirmationDialog_dialogHeaderCloseIcon__1JYOP","dialogBody":"ConfirmationDialog_dialogBody__3b_cs","dialogText":"ConfirmationDialog_dialogText__1gkMH","dialogButtons":"ConfirmationDialog_dialogButtons__1wyha","dialogButton":"ConfirmationDialog_dialogButton__1YvmK","dialogButtonNegative":"ConfirmationDialog_dialogButtonNegative__1N69K"};
styleInject(css_248z);

var ConfirmationDialog = function ConfirmationDialog() {
  return function (WrappedComponent) {
    return function (props) {
      var _React$useState = React.useState(false),
        _React$useState2 = _slicedToArray$1(_React$useState, 2),
        modalActive = _React$useState2[0],
        setModalActive = _React$useState2[1];
      var _React$useState3 = React.useState({}),
        _React$useState4 = _slicedToArray$1(_React$useState3, 2),
        modalContent = _React$useState4[0],
        setModalContent = _React$useState4[1];
      var confirmationCallback = React.useRef(null);
      var activateConfirmationDialog = React.useCallback(function () {
        var modalContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        setModalActive(true);
        setModalContent(modalContent);
        confirmationCallback.current = callback;
      });
      var deactivateConfirmationDialog = React.useCallback(function (e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        confirmationCallback.current = null;
        setModalActive(false);
      });
      var deactivatePositive = React.useCallback(function () {
        if (confirmationCallback.current) confirmationCallback.current(true);
        deactivateConfirmationDialog();
      });
      var deactivateNegative = React.useCallback(function () {
        if (confirmationCallback.current) confirmationCallback.current(false);
        deactivateConfirmationDialog();
      });
      var _modalContent$title = modalContent.title,
        title = _modalContent$title === void 0 ? "Confirm" : _modalContent$title,
        _modalContent$message = modalContent.message,
        message = _modalContent$message === void 0 ? "You have unsaved changes, are you sure you want to continue ?" : _modalContent$message,
        _modalContent$positiv = modalContent.positiveText,
        positiveText = _modalContent$positiv === void 0 ? "Yes" : _modalContent$positiv,
        _modalContent$negativ = modalContent.negativeText,
        negativeText = _modalContent$negativ === void 0 ? "No" : _modalContent$negativ,
        _modalContent$primary = modalContent.primaryActionType,
        primaryActionType = _modalContent$primary === void 0 ? "primary" : _modalContent$primary,
        _modalContent$seconda = modalContent.secondaryActionType,
        secondaryActionType = _modalContent$seconda === void 0 ? "secondary" : _modalContent$seconda;
      var isMessageNode = typeof message !== "string";
      if (modalContent.themed) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WrappedComponent
        // eslint-disable-next-line react/jsx-props-no-spreading
        , _extends$8({}, props, {
          activateConfirmationDialog: activateConfirmationDialog,
          deactivateConfirmationDialog: deactivateConfirmationDialog,
          confirmationDialogActive: modalActive
        })), /*#__PURE__*/React.createElement(Dialog, {
          active: modalActive,
          onEnter: deactivatePositive,
          onClose: deactivateNegative,
          title: title,
          subtitle: !isMessageNode && message,
          primaryActionText: positiveText,
          secondaryActionText: negativeText,
          primaryAction: deactivatePositive,
          secondaryAction: deactivateNegative,
          primaryActionType: primaryActionType,
          secondaryActionType: secondaryActionType,
          dialogStyles: {
            padding: "32px 32px 24px 32px",
            width: "480px"
          }
        }, isMessageNode && message));
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WrappedComponent
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends$8({}, props, {
        activateConfirmationDialog: activateConfirmationDialog,
        deactivateConfirmationDialog: deactivateConfirmationDialog,
        confirmationDialogActive: modalActive
      })), /*#__PURE__*/React.createElement(Modal$1, {
        active: modalActive,
        onEnter: deactivatePositive,
        onOverlayClick: deactivateNegative
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.dialogHeader
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.dialogHeaderText
      }, title), /*#__PURE__*/React.createElement(Icon, {
        onClick: deactivateNegative,
        src: CloseIcon,
        className: styles.dialogHeaderCloseIcon
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.dialogBody
      }, /*#__PURE__*/React.createElement("p", {
        className: styles.dialogText
      }, message), /*#__PURE__*/React.createElement("div", {
        className: styles.dialogButtons
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: deactivatePositive,
        className: "".concat(styles.dialogButton, " ").concat(styles.dialogButtonPositive)
      }, positiveText), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: deactivateNegative,
        className: "".concat(styles.dialogButton, " ").concat(styles.dialogButtonNegative)
      }, negativeText)))));
    };
  };
};

// Non customizable CSS props
var headerStyle = function headerStyle(props) {
  return {
    justifyContent: "space-between",
    alignItems: "center",
    padding: props.theme.space.lg,
    borderBottom: "1px solid ".concat(props.theme.colors.grey.haptik)
  };
};
var iconStyle = function iconStyle(props) {
  return {
    transform: "rotate(180deg)",
    marginRight: props.theme.space.lg
  };
};
var BackIcon = styled(Icon)(iconStyle);
var ThemedDrawerHeader = styled(Box)(headerStyle);

var css_248z$1 = ".DrawerHeader_drawerHeader__1o6G2 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  border-bottom: 1px solid #eee; }\n\n.DrawerHeader_leftColumn__1x490,\n.DrawerHeader_rightColumn__3_Q2f {\n  display: flex;\n  align-items: center; }\n\n.DrawerHeader_icon__3tdAI {\n  margin-right: 8px;\n  cursor: pointer;\n  opacity: 0.7; }\n  .DrawerHeader_icon__3tdAI:hover {\n    opacity: 1; }\n\n.DrawerHeader_doneButton__1_U4P {\n  margin-right: 12px; }\n\n.DrawerHeader_saveButton__3s8Qp {\n  cursor: pointer;\n  padding: 6px 12px;\n  background-color: #124fa0;\n  color: #fff;\n  font-size: 14px;\n  border-radius: 5px;\n  font-weight: 400;\n  margin-left: 8px;\n  animation-delay: 0.2s;\n  animation: DrawerHeader_popin__2bMLr 0.3s ease-out;\n  animation-fill-mode: both; }\n\n.DrawerHeader_saveButtonDisabled__jJ6o_ {\n  cursor: pointer;\n  padding: 6px 12px;\n  background-color: #999;\n  color: #fff;\n  font-size: 14px;\n  border-radius: 5px;\n  font-weight: 400;\n  margin-left: 8px;\n  opacity: 0.4; }\n  .DrawerHeader_saveButtonDisabled__jJ6o_:hover {\n    background-color: #0d3872; }\n\n.DrawerHeader_copyButton__271qO {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: auto;\n  color: #000;\n  font-size: 14px;\n  border-radius: 5px;\n  font-weight: 400;\n  transition: 0.2s ease-out;\n  padding: 4px 0; }\n  .DrawerHeader_copyButton__271qO:after {\n    content: 'COPY JSON ';\n    font-size: 12px;\n    padding-left: 0px;\n    padding-right: 12px;\n    white-space: nowrap;\n    position: relative;\n    width: 0;\n    transition: 0.3s ease-out;\n    opacity: 0; }\n  .DrawerHeader_copyButton__271qO:hover {\n    background-color: #eee; }\n    .DrawerHeader_copyButton__271qO:hover:after {\n      opacity: 1;\n      width: 80px; }\n\n@keyframes DrawerHeader_popin__2bMLr {\n  0% {\n    background-color: #999; }\n  100% {\n    background-color: #124fa0; } }\n";
var styles$1 = {"drawerHeader":"DrawerHeader_drawerHeader__1o6G2","leftColumn":"DrawerHeader_leftColumn__1x490","rightColumn":"DrawerHeader_rightColumn__3_Q2f","icon":"DrawerHeader_icon__3tdAI","doneButton":"DrawerHeader_doneButton__1_U4P","saveButton":"DrawerHeader_saveButton__3s8Qp","popin":"DrawerHeader_popin__2bMLr","saveButtonDisabled":"DrawerHeader_saveButtonDisabled__jJ6o_","copyButton":"DrawerHeader_copyButton__271qO"};
styleInject(css_248z$1);

var ComponentDrawerHeader = function ComponentDrawerHeader(props) {
  var children = props.children,
    onClose = props.onClose,
    onBackButtonClick = props.onBackButtonClick,
    onSave = props.onSave,
    onCopy = props.onCopy,
    onDone = props.onDone,
    themed = props.themed;
  if (themed) {
    var drawerHeaderProps = _objectSpread2(_objectSpread2({}, props), {}, {
      "data-testid": "themedDrawerHeader"
    });
    return /*#__PURE__*/React.createElement(ThemedDrawerHeader, drawerHeaderProps, /*#__PURE__*/React.createElement(Box, {
      alignItems: "center",
      padding: "0"
    }, onBackButtonClick ? /*#__PURE__*/React.createElement(BackIcon, {
      onClick: onBackButtonClick,
      src: ArrowIcon
    }) : null, /*#__PURE__*/React.createElement(Text, {
      variant: "h3.semi-bold"
    }, props.children)), /*#__PURE__*/React.createElement(Icon, {
      onClick: onClose,
      src: CloseV2Icon
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$1.drawerHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.leftColumn
  }, onClose ? /*#__PURE__*/React.createElement(Icon, {
    onClick: onClose,
    className: styles$1.icon,
    src: CloseIcon
  }) : null, onDone ? /*#__PURE__*/React.createElement(Button, {
    onClick: onDone,
    className: styles$1.doneButton
  }, "Done") : null, children), /*#__PURE__*/React.createElement("div", {
    className: styles$1.rightColumn
  }, onCopy ? /*#__PURE__*/React.createElement(Icon, {
    onClick: onCopy,
    className: styles$1.copyButton,
    src: CloneIcon
  }) : null, onSave ? /*#__PURE__*/React.createElement("div", {
    onClick: onSave,
    className: styles$1.saveButton
  }, "Save") : null));
};
ComponentDrawerHeader.propTypes = {
  children: PropTypes.string,
  onBackButtonClick: PropTypes.func,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  onCopy: PropTypes.func,
  onDone: PropTypes.func,
  themed: PropTypes.bool
};
ComponentDrawerHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ComponentDrawerHeader",
  "props": {
    "children": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onBackButtonClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onSave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onCopy": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDone": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "themed": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

// Non customizable CSS props
var bodyStyle = function bodyStyle() {
  return {
    flexDirection: "column"
  };
};
var ThemedDrawerBody = styled(Box)(bodyStyle);

var css_248z$1$1 = ".Drawer_drawerWrapper__2PXad {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 999999999;\n  pointer-events: none; }\n  .Drawer_drawerWrapper__2PXad * {\n    -webkit-font-smoothing: antialiased; }\n\n.Drawer_drawerOverlay__x3BUj {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #000;\n  opacity: 0;\n  transition: 0.2s linear;\n  pointer-events: auto; }\n  .Drawer_drawerOverlay__x3BUj.Drawer_drawerActive__2N-mZ {\n    opacity: 0.8 !important; }\n\n.Drawer_drawer__34eUq {\n  opacity: 0;\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  right: 0;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  width: 360px;\n  background-color: #fff;\n  outline: none;\n  box-sizing: border-box;\n  transition: transform 0.5s cubic-bezier(0.175, 0.5, 0.12, 1), opacity 0.5s cubic-bezier(0.175, 0.5, 0.12, 1), width 0.2s cubic-bezier(0, 0, 0.58, 1);\n  transform: translate3d(360px, 0, 0);\n  pointer-events: auto; }\n  .Drawer_drawer__34eUq * {\n    font-family: \"Roboto\", sans-serif; }\n  .Drawer_drawer__34eUq.Drawer_drawerActive__2N-mZ {\n    opacity: 1 !important;\n    transform: translate3d(0, 0, 0) !important;\n    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1); }\n  .Drawer_drawer__34eUq.Drawer_noDisable__kjmIa {\n    opacity: 1 !important; }\n  .Drawer_drawer__34eUq.Drawer_left__Fihg0 {\n    right: auto;\n    left: 0;\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n    transform: translate3d(-360px, 0, 0); }\n";
var styles$1$1 = {"drawerWrapper":"Drawer_drawerWrapper__2PXad","drawerOverlay":"Drawer_drawerOverlay__x3BUj","drawerActive":"Drawer_drawerActive__2N-mZ","drawer":"Drawer_drawer__34eUq","noDisable":"Drawer_noDisable__kjmIa","left":"Drawer_left__Fihg0"};
styleInject(css_248z$1$1);

var Drawer = function Drawer(_ref) {
  var children = _ref.children,
    prefixClassName = _ref.prefixClassName,
    className = _ref.className,
    active = _ref.active,
    position = _ref.position,
    offset = _ref.offset,
    attachTo = _ref.attachTo,
    width = _ref.width,
    zIndex = _ref.zIndex,
    noDisable = _ref.noDisable,
    onClose = _ref.onClose,
    noOverlay = _ref.noOverlay;
  var _useActivify = useActivify(active),
    enabled = _useActivify.enabled,
    visible = _useActivify.visible;
  var activeClassName = visible ? styles$1$1.drawerActive : "";
  var placementClassName = position === "LEFT" ? styles$1$1.left : "";
  var noDisableClassName = noDisable ? styles$1$1.noDisable : "";
  var transformAmount = position === "LEFT" ? -1 * (width + offset) : width + offset;
  var style = {};
  style.zIndex = zIndex;
  style.left = position === "LEFT" ? offset : "auto";
  style.right = position === "LEFT" ? "auto" : offset;
  useEscapeKey(onClose);
  if (!enabled && !noDisable) return null;
  return /*#__PURE__*/React.createElement(Portal$3$1, {
    node: document && attachTo && document.getElementById(attachTo)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1$1.drawerWrapper, " ").concat(prefixClassName, " ").concat(className),
    style: style,
    "data-testid": "drawer"
  }, noOverlay ? null : /*#__PURE__*/React.createElement("div", {
    className: "\n                    ".concat(styles$1$1.drawerOverlay, "\n                    ").concat(activeClassName, "\n                    ").concat(prefixClassName, "-overlay\n                  "),
    onClick: onClose
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: width,
      transform: "translate3d(".concat(transformAmount, "px, 0, 0)")
    },
    className: "\n              ".concat(styles$1$1.drawer, "\n              ").concat(placementClassName, "\n              ").concat(activeClassName, "\n              ").concat(noDisableClassName, "\n              ").concat(prefixClassName, "-drawer\n            ")
  }, children)));
};
Drawer.Header = ComponentDrawerHeader;
Drawer.Body = ThemedDrawerBody;
Drawer.propTypes = {
  /** Children Nodes Passed down to the Drawer */
  children: PropTypes.node,
  /** onClose Callback */
  onClose: PropTypes.func,
  /** Active state for the Drawer */
  active: PropTypes.bool,
  /** Handles the functionality of making a drawer permanently enabled */
  noDisable: PropTypes.bool,
  /** Z-Index for the defining stack order of the Drawer */
  zIndex: PropTypes.number,
  /** Off Set for the drawer */
  offset: PropTypes.number,
  /** Prefixed CSS Classname passed to the Drawer */
  prefixClassName: PropTypes.string,
  /** CSS Classname passed to the Drawer */
  className: PropTypes.string,
  /** Positioning of the Drawer on the Webpage */
  position: PropTypes.string,
  /** Enables/Disables overlaying of the Drawer */
  noOverlay: PropTypes.bool,
  /** Width for the Drawer Element */
  width: PropTypes.number,
  /** The DOM Node to attach the Drawer to */
  attachTo: PropTypes.node
};
Drawer.defaultProps = {
  onClose: function onClose() {},
  active: false,
  noDisable: false,
  zIndex: 2,
  offset: 0,
  className: "",
  position: "RIGHT",
  noOverlay: false,
  width: "360px",
  attachTo: null
};
Drawer.classNames = {
  $prefix: "Applied to the Drawer Wrapper",
  "$prefix-overlay": "Applied to the Overlay for Drawer",
  "$prefix-drawer": "Applied to the Drawer Node"
};
Drawer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Drawer",
  "props": {
    "onClose": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "onClose Callback"
    },
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Active state for the Drawer"
    },
    "noDisable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Handles the functionality of making a drawer permanently enabled"
    },
    "zIndex": {
      "defaultValue": {
        "value": "2",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Z-Index for the defining stack order of the Drawer"
    },
    "offset": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Off Set for the drawer"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "CSS Classname passed to the Drawer"
    },
    "position": {
      "defaultValue": {
        "value": "\"RIGHT\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Positioning of the Drawer on the Webpage"
    },
    "noOverlay": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Enables/Disables overlaying of the Drawer"
    },
    "width": {
      "defaultValue": {
        "value": "\"360px\"",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Width for the Drawer Element"
    },
    "attachTo": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "The DOM Node to attach the Drawer to"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Children Nodes Passed down to the Drawer"
    },
    "prefixClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Prefixed CSS Classname passed to the Drawer"
    }
  }
};

var KEY_CODES = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  ESC: 27,
  BACKSPACE: 8
};

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var AddIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "9",
  fill: "#FFF",
  transform: "rotate(45 12 12)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 17.657V6.343v11.314zM6.343 12h11.314H6.343z",
  fill: "#DDD"
}))));

var DOCUMENT_MIME_TYPES = [{
  value: ["application/pdf"],
  text: "PDF"
}, {
  value: ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  text: "DOC"
}, {
  value: ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  text: "XLS"
}, {
  value: ["text/csv", "comma-separated-values"],
  text: "CSV"
}];

var VIDEO_MIME_TYPES = [{
  value: ["video/mp4"],
  text: "MP4"
}, {
  value: ["video/quicktime"],
  text: "MOV"
}];

var SCREEN_OPTIONS = [{
  value: "CAROUSEL_DETAIL",
  text: "Carousel Detail (With Text)",
  additionalFields: [{
    type: "POPUP",
    popupType: "CAROUSEL_DETAIL_WITH_TEXT",
    label: "Add Information",
    key: "carouselDetails"
  }]
}, {
  value: "CAROUSEL_DEFAULT",
  text: "Carousel Detail (With Button)",
  additionalFields: [{
    type: "POPUP",
    popupType: "CAROUSEL_DETAIL_WITH_BUTTON",
    label: "Add Information",
    key: "carouselDetails"
  }]
}, {
  value: "GALLERY_PICKER",
  text: "Upload / Take photo (For Native Apps)"
}, {
  value: "DOCUMENT_PICKER",
  text: "Upload document",
  additionalFields: [{
    type: "MULTI_DROPDOWN",
    label: "Select allowed file types",
    placeholder: "Add file types",
    key: "mimeTypes",
    options: DOCUMENT_MIME_TYPES
  }]
}, {
  value: "VIDEO_PICKER",
  text: "Upload video (For WebSDK)",
  additionalFields: [{
    type: "MULTI_DROPDOWN",
    label: "Select allowed file types",
    placeholder: "Add file types",
    key: "mimeTypes",
    options: VIDEO_MIME_TYPES
  }]
}, {
  value: "IMAGE_UPLOAD",
  text: "Upload / Take photo (For WebSDK)"
}, {
  value: "LAUNCH_CHANNEL",
  text: "Open Channel",
  additionalFields: [{
    type: "TEXT",
    label: "Via Name",
    placeholder: "Type here",
    key: "viaName"
  }, {
    type: "TEXT",
    label: "User Message (optional)",
    placeholder: "Type here",
    key: "message"
  }]
}, {
  value: "SEND_LOCATION",
  text: "Send Location",
  additionalFields: [{
    type: "POPUP",
    popupType: "SINGLE_LOCATION",
    label: "Advanced Location Options",
    key: "locationDetails"
  }, {
    type: "DROPDOWN",
    label: "Map Type",
    key: "mapType",
    defaultValue: "roadmap",
    options: ["roadmap", "satellite", "terrain", "hybrid"]
  }, {
    type: "TEXT",
    label: "Default lat",
    placeholder: "Enter default lat here..",
    key: "defaultLat"
  }, {
    type: "TEXT",
    label: "Default Lng",
    placeholder: "Enter default lng here..",
    key: "defaultLng"
  }, {
    type: "TEXT",
    label: "Default Pincode",
    placeholder: "Enter default Pincode here..",
    key: "defaultPincode"
  }, {
    type: "TOGGLE",
    label: "Show Zoom Buttons",
    key: "showZoomButton"
  }, {
    type: "TOGGLE",
    label: "Show Map Type Controls",
    key: "showMapTypeButton"
  }]
}, {
  text: "Link",
  value: "LINK",
  additionalFields: [{
    type: "TEXT",
    label: "Link to open",
    placeholder: "Type here",
    key: "url"
  }, {
    type: "TOGGLE",
    label: "Launch in same tab",
    placeholder: "Type here",
    key: "launchInSameTab"
  }, {
    type: "TOGGLE",
    label: "Launch in app",
    placeholder: "Type here",
    key: "launchInapp"
  }]
}, {
  text: "Webview",
  value: "SELF_SERVE_WEB",
  additionalFields: [{
    type: "TEXT",
    label: "Link to open",
    placeholder: "Type here",
    key: "url"
  }, {
    type: "TEXT",
    label: "Height (0 to 1)",
    placeholder: "Select Height...",
    key: "webview_height"
  }, {
    type: "TOGGLE",
    label: "Auto open webview",
    key: "auto_open_webview"
  }]
}];

var ACTIONABLE_OPTIONS = [{
  text: "Open Screen",
  value: "APP_ACTION",
  additionalFields: [{
    type: "DROPDOWN",
    options: SCREEN_OPTIONS,
    label: "Screen to open",
    placeholder: "Select screen to open",
    key: "uri"
  }]
}, {
  text: "Text",
  value: "TEXT_ONLY",
  additionalFields: [{
    type: "MULTITEXT",
    label: "Message to send",
    placeholder: "Type here",
    key: "message"
  }]
}, {
  text: "Call",
  value: "CALL",
  additionalFields: [{
    type: "TEXT",
    label: "Number to call",
    placeholder: "Type here",
    key: "number"
  }]
}, {
  text: "SMS",
  value: "SMS",
  additionalFields: [{
    type: "MULTITEXT",
    label: "Pre Filled SMS Message",
    placeholder: "Type here",
    key: "smsMessage"
  }]
}, {
  text: "Email",
  value: "EMAIL",
  additionalFields: [{
    type: "TEXT",
    label: "To",
    placeholder: "Type here",
    key: "emailTo"
  }, {
    type: "TEXT",
    label: "Subject",
    placeholder: "Type here",
    key: "emailSubject"
  }, {
    type: "MULTITEXT",
    label: "Email Message",
    placeholder: "Type here",
    key: "emailBody"
  }]
}, {
  text: "Date Picker",
  value: "DATE_PICKER",
  additionalFields: [{
    type: "TOGGLE",
    label: "Auto Open Date Picker",
    key: "autoOpenDatePicker"
  }]
}, {
  text: "List Picker",
  value: "LIST_PICKER",
  additionalFields: [{
    type: "MULTITEXT",
    label: "Picker Options",
    placeholder: "Enter comma separated options",
    key: "options"
  }, {
    type: "TOGGLE",
    label: "Auto Open List Picker",
    key: "autoOpenListPicker"
  }]
}, {
  text: "Feedback Flow",
  value: "APP_FEEDBACK"
}, {
  text: "Share",
  value: "SHARE",
  additionalFields: [{
    type: "IMAGE",
    label: "Image",
    key: "image"
  }, {
    type: "TEXT",
    label: "Share Message",
    placeholder: "Type here",
    key: "message"
  }, {
    type: "TEXT",
    label: "Whatsapp Share Message",
    placeholder: "Type here",
    key: "whatsappShareMessage"
  }, {
    type: "TEXT",
    label: "Payload Message",
    placeholder: "Type here",
    key: "gogo_message"
  }, {
    type: "TOGGLE",
    label: "Show share option",
    key: "showShareOption"
  }]
}];

var CAROUSEL_SIZE_OPTIONS = [{
  text: 'Thin',
  value: 'THIN'
}, {
  text: 'Medium',
  value: 'MEDIUM'
}, {
  text: 'Fat (Full Width)',
  value: 'FAT'
}, {
  text: 'Big',
  value: 'BIG'
}];

var CAROUSEL_RATIO_OPTIONS = [{
  text: 'Square(1:1)',
  value: '1'
}, {
  text: 'Wide(16:9)',
  value: '1.77'
}, {
  text: 'Custom',
  value: ''
}];

var ENDPOINTS = {
  BASE_URL: '/mogambo_api',
  POLICY_ENDPOINT: '/generate_s3_policy/',
  SYNTHESIS_ENDPOINT: '/integration/voice/synthesize'
};

var CONSTRAINTS = {
  MIN_BUTTONS: 1,
  MAX_BUTTONS: 7,
  MAX_BUTTON_CHARACTERS: 21,
  MAX_QUICK_REPLY_CHARACTERS: 27,
  MAX_QUICK_REPLIES: 11,
  MAX_LINES: 30,
  MAX_SECTIONS: 3,
  MAX_SECTION_ITEMS: 3
};

var BASE = {
  IMAGE_WIDTH: 268
};

var TEXT_VALIDATION_REGEX = [{
  title: "Any (No Validation)",
  value: "^(.|\\n)*$"
}, {
  title: "Alphabet (without whitespace)",
  value: "^[\\p{L}\\p{M}]*$"
}, {
  title: "Alphabet (with whitespace)",
  value: "^[\\p{L}\\p{M}\\p{Z}]*$"
}, {
  title: "Alphanumeric (without whitespace)",
  value: "^[\\p{L}\\p{M}\\p{N}]*$"
}, {
  title: "Alphanumeric (with whitespace)",
  value: "^[\\p{L}\\p{M}\\p{N}\\p{Z}]*$"
}];

// eslint-disable-next-line max-len
var EMAIL_VALIDATION_REGEX = "(?:[a-z0-9!#$%&\\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\\'*+/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])";

var FORM_FIELD_TYPES = [{
  name: "Text",
  type: "text",
  icon: "form_text",
  defaultFieldPlaceholder: "Enter any default text for this field here"
}, {
  name: "Picker",
  type: "picker",
  icon: "form_picker",
  defaultFieldPlaceholder: "Enter any one of the above options here"
}, {
  name: "Number",
  type: "number",
  icon: "form_number",
  defaultFieldPlaceholder: "Enter any default numeric value for this field here"
}, {
  name: "Email",
  type: "email",
  icon: "form_mail",
  defaultFieldPlaceholder: "Enter a default email value for this field here"
}, {
  name: "Date",
  type: "date",
  icon: "form_calendar",
  defaultFieldPlaceholder: "Enter a default date in this format YYYY-MM-DD"
}, {
  name: "Time",
  type: "time",
  icon: "form_time",
  defaultFieldPlaceholder: "Enter a default time in this format HH:MM AM/PM"
}, {
  name: "Search",
  type: "search",
  icon: "form_search"
}, {
  name: "Date Of Birth",
  type: "dob",
  icon: "form_birthday",
  defaultFieldPlaceholder: "Enter a default date in this format YYYY-MM-DD"
}, {
  name: "Multi Picker",
  type: "multiPicker",
  icon: "form_multi_picker",
  defaultFieldPlaceholder: "Enter comma seperated options"
}];

var FORM_ICON_LIST = [{
  name: "Agent",
  icon: "form_agent"
}, {
  name: "Account Balance",
  icon: "form_balance"
}, {
  name: "Bank",
  icon: "form_bank"
}, {
  name: "Birthday(DoB)",
  icon: "form_birthday"
}, {
  name: "Bug Report",
  icon: "form_bug"
}, {
  name: "Calender",
  icon: "form_calendar"
}, {
  name: "Call",
  icon: "form_call"
}, {
  name: "Cancel",
  icon: "form_cancel"
}, {
  name: "Cart",
  icon: "form_cart"
}, {
  name: "Desktop Mac",
  icon: "form_desktop_mac"
}, {
  name: "Desktop Windows",
  icon: "form_desktop_windows"
}, {
  name: "Error",
  icon: "form_error"
}, {
  name: "Flag",
  icon: "form_flags"
}, {
  name: "Flight",
  icon: "form_flight"
}, {
  name: "Flight(TakeOff)",
  icon: "form_flight_takeoff"
}, {
  name: "Flight(Landing)",
  icon: "form_flight_landing"
}, {
  name: "GiftCard",
  icon: "form_giftcard"
}, {
  name: "Home",
  icon: "form_home"
}, {
  name: "Hotel",
  icon: "form_hotel"
}, {
  name: "Info",
  icon: "form_info"
}, {
  name: "Key",
  icon: "form_key"
}, {
  name: "Language",
  icon: "form_language"
}, {
  name: "Laptop Mac",
  icon: "form_laptop_mac"
}, {
  name: "Laptop Windows",
  icon: "form_laptop_windows"
}, {
  name: "List",
  icon: "form_list"
}, {
  name: "Location",
  icon: "form_location"
}, {
  name: "Mail",
  icon: "form_mail"
}, {
  name: "Medical Services",
  icon: "form_medical"
}, {
  name: "Number",
  icon: "form_number"
}, {
  name: "Payment",
  icon: "form_payment"
}, {
  name: "Picker",
  icon: "form_picker"
}, {
  name: "Profile",
  icon: "form_profile"
}, {
  name: "Restraunt",
  icon: "form_restaurant"
}, {
  name: "Sentiment Satisfied",
  icon: "form_satisfied"
}, {
  name: "Search",
  icon: "form_search"
}, {
  name: "Schedule",
  icon: "form_schedule"
}, {
  name: "School",
  icon: "form_school"
}, {
  name: "Settings",
  icon: "form_settings"
}, {
  name: "Shipping",
  icon: "form_shipping"
}, {
  name: "Shopping",
  icon: "form_shopping"
}, {
  name: "Store",
  icon: "form_storefront"
}, {
  name: "Text",
  icon: "form_text"
}, {
  name: "Thumbs Up",
  icon: "form_thumb_up"
}, {
  name: "Thumbs Down",
  icon: "form_thumb_down"
}, {
  name: "Title",
  icon: "form_time"
}, {
  name: "Tool",
  icon: "form_tool"
}, {
  name: "Travel",
  icon: "form_travel"
}, {
  name: "Verified User",
  icon: "form_verified_user"
}, {
  name: "Wifi",
  icon: "form_wifi"
}, {
  name: "Work",
  icon: "form_work"
}, {
  name: "Multi Picker",
  icon: "form_multi_picker"
}];

var KEYS = {
  MINI_ACTIONABLE_INDEX: -3
};
var VIDEO_EXTENSIONS = ["mp4", "mov"];
var MIXPANEL_HSL_ELEMENTS = "CS_HSL_create_read_update_event";

function sendGoogleAnalyticsEvents(_ref) {
  var eventCategory = _ref.eventCategory,
    eventAction = _ref.eventAction,
    eventLabel = _ref.eventLabel,
    eventValue = _ref.eventValue;
  // ga is global var
  if ( window.ga) {
    window.ga("send", {
      hitType: "event",
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      eventValue: eventValue
    });
  }
}

var insertAtSelection = function insertAtSelection(_ref) {
  var selectionStart = _ref.selectionStart,
    selectionEnd = _ref.selectionEnd,
    value = _ref.value,
    _ref$insertString = _ref.insertString,
    insertString = _ref$insertString === void 0 ? '' : _ref$insertString,
    _ref$suffix = _ref.suffix,
    suffix = _ref$suffix === void 0 ? '' : _ref$suffix,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
  var before = value.substring(0, selectionStart);
  var after = value.substring(selectionEnd, value.length);
  var newInsertString = prefix + insertString + suffix;
  var newValue = before + newInsertString + after;
  var newSelectionEnd = selectionStart + newInsertString.length;
  var newSelectionStart = newSelectionEnd;
  return {
    newValue: newValue,
    newSelectionEnd: newSelectionEnd,
    newSelectionStart: newSelectionStart
  };
};
var insertWrapperAtSelection = function insertWrapperAtSelection(_ref2) {
  var selectionStart = _ref2.selectionStart,
    selectionEnd = _ref2.selectionEnd,
    value = _ref2.value,
    _ref2$suffix = _ref2.suffix,
    suffix = _ref2$suffix === void 0 ? '' : _ref2$suffix,
    _ref2$prefix = _ref2.prefix,
    prefix = _ref2$prefix === void 0 ? '' : _ref2$prefix;
  if (selectionStart === selectionEnd) {
    return {
      newValue: value,
      newSelectionEnd: selectionEnd,
      newSelectionStart: selectionStart
    };
  }
  var openingWrapperString = insertAtSelection({
    selectionStart: selectionStart,
    selectionEnd: selectionStart,
    value: value,
    insertString: prefix
  });
  var closingWrapperString = insertAtSelection({
    selectionStart: selectionEnd + prefix.length,
    selectionEnd: selectionEnd + prefix.length,
    value: openingWrapperString.newValue,
    insertString: suffix
  });
  return _objectSpread2$1({}, closingWrapperString);
};

var GA = {
  CATEGORIES: {
    RICH_TEXT_EDITOR: 'RICH_TEXT_EDITOR'
  },
  ACTIONS: {
    BOLD: 'BOLD',
    EMOJI: 'EMOJI',
    ENTITY: 'ENTITY'
  },
  LABEL: {
    SELECT_ENTITY: 'SELECT_ENTITY',
    APPLY_BOLD: 'APPLY_BOLD',
    SELECT_EMOJI: 'SELECT_EMOJI'
  }
};

var BoldAction = /*#__PURE__*/function (_React$Component) {
  function BoldAction() {
    var _this;
    _classCallCheck$4(this, BoldAction);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BoldAction, [].concat(args));
    _defineProperty$1(_this, "handleClick", function () {
      var _this$props = _this.props,
        elem = _this$props.elem,
        onSelect = _this$props.onSelect;
      var newElemObj = insertWrapperAtSelection({
        selectionStart: elem.current.selectionStart,
        selectionEnd: elem.current.selectionEnd,
        value: elem.current.value,
        insertString: "",
        suffix: "*",
        prefix: "*"
      });
      sendGoogleAnalyticsEvents({
        eventCategory: GA.CATEGORIES.RICH_TEXT_EDITOR,
        eventAction: GA.ACTIONS.BOLD,
        eventLabel: GA.LABEL.APPLY_BOLD,
        eventValue: 0
      });
      onSelect(newElemObj);
    });
    return _this;
  }
  _inherits$3(BoldAction, _React$Component);
  return _createClass$4(BoldAction, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("strong", {
        onClick: this.handleClick,
        style: {
          cursor: "pointer"
        }
      }, "B");
    }
  }]);
}(React.Component);
BoldAction.propTypes = {
  elem: PropTypes.shape({
    current: PropTypes.shape({
      selectionStart: PropTypes.number,
      selectionEnd: PropTypes.number,
      value: PropTypes.string
    })
  }),
  onSelect: PropTypes.func
};
BoldAction.defaultProps = {
  elem: {},
  onSelect: function onSelect() {}
};
BoldAction.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleClick",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "BoldAction",
  "props": {
    "elem": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "shape",
            "value": {
              "selectionStart": {
                "name": "number",
                "required": false
              },
              "selectionEnd": {
                "name": "number",
                "required": false
              },
              "value": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "onSelect": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var webfontloader = createCommonjsModule(function (module) {
/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return +new Date};function ca(a,b){this.a=a;this.o=b||a;this.c=this.o.document;}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild);}function v(a){a.parentNode&&a.parentNode.removeChild(a);}
function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e]);}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e]);}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"");}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return !0;return !1}
function ea(a){return a.o.location.hostname||a.a.location.hostname}function z(a,b,c){function d(){m&&e&&f&&(m(g),m=null);}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,m=c||null;da?(b.onload=function(){e=!0;d();},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d();}):setTimeout(function(){e=!0;d();},0);u(a,"head",b);}
function A(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f));};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")));},d||5E3);return f}return null}function B(){this.a=0;this.c=null;}function C(a){a.a++;return function(){a.a--;D(a);}}function E(a,b){a.c=b;D(a);}function D(a){0==a.a&&a.c&&(a.c(),a.c=null);}function F(a){this.a=a||"-";}F.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function G(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10));}function fa(a){return H(a)+" "+(a.f+"00")+" 300px "+I(a.c)}function I(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d);}return b.join(",")}function J(a){return a.a+a.f}function H(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b}function ha(a,b){this.c=a;this.f=a.o.document.documentElement;this.h=b;this.a=new F("-");this.j=!1!==b.events;this.g=!1!==b.classes;}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);K(a,"loading");}function L(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d);}K(a,"inactive");}function K(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,J(c));else a.h[b]();}function ja(){this.c={};}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c));}return d}function M(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f);}function N(a){u(a.c,"body",a.a);}function O(a){return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+I(a.c)+";"+("font-style:"+H(a)+";font-weight:"+(a.f+"00")+";")}function P(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0;}P.prototype.start=function(){var a=this.c.o.document,b=this,c=q(),d=new Promise(function(d,e){function f(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(f,25);},function(){e();});}f();}),e=null,f=new Promise(function(a,d){e=setTimeout(d,b.f);});Promise.race([f,d]).then(function(){e&&(clearTimeout(e),e=null);b.g(b.a);},function(){b.j(b.a);});};function Q(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.m=this.j=this.h=this.g=null;this.g=new M(this.c,this.s);this.h=new M(this.c,this.s);this.j=new M(this.c,this.s);this.m=new M(this.c,this.s);a=new G(this.a.c+",serif",J(this.a));a=O(a);this.g.a.style.cssText=a;a=new G(this.a.c+",sans-serif",J(this.a));a=O(a);this.h.a.style.cssText=a;a=new G("serif",J(this.a));a=O(a);this.j.a.style.cssText=a;a=new G("sans-serif",J(this.a));a=
O(a);this.m.a.style.cssText=a;N(this.g);N(this.h);N(this.j);N(this.m);}var R={D:"serif",C:"sans-serif"},S=null;function T(){if(null===S){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);S=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10));}return S}Q.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.m.a.offsetWidth;this.A=q();U(this);};
function la(a,b,c){for(var d in R)if(R.hasOwnProperty(d)&&b===a.f[R[d]]&&c===a.f[R[d]])return !0;return !1}function U(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=T()&&la(a,b,c));d?q()-a.A>=a.w?T()&&la(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):ma(a):V(a,a.v);}function ma(a){setTimeout(p(function(){U(this);},a),50);}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.m.a);b(this.a);},a),0);}function W(a,b,c){this.c=a;this.a=b;this.f=0;this.m=this.j=!1;this.s=c;}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,J(a).toString(),"active")],[b.a.c("wf",a.c,J(a).toString(),"loading"),b.a.c("wf",a.c,J(a).toString(),"inactive")]);K(b,"fontactive",a);this.m=!0;na(this);};
W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,J(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,J(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,J(a).toString(),"inactive"));w(b.f,d,e);}K(b,"fontinactive",a);na(this);};function na(a){0==--a.f&&a.j&&(a.m?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),K(a,"active")):L(a.a));}function oa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0;}oa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;pa(this,new ha(this.c,a),a);};
function qa(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,m=d||null||{};if(0===c.length&&f)L(b.a);else {b.f+=c.length;f&&(b.j=f);var h,l=[];for(h=0;h<c.length;h++){var k=c[h],n=m[k.c],r=b.a,x=k;r.g&&w(r.f,[r.a.c("wf",x.c,J(x).toString(),"loading")]);K(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),xa=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
X=x?42<parseInt(x[1],10):xa?!1:!0;}else X=!1;X?r=new P(p(b.g,b),p(b.h,b),b.c,k,b.s,n):r=new Q(p(b.g,b),p(b.h,b),b.c,k,b.s,a,n);l.push(r);}for(h=0;h<l.length;h++)l[h].start();}},0);}function pa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){qa(a,f,b,d,c);});}function ra(a,b){this.c=a;this.a=b;}
ra.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var l=0;l<c.length;l++){var k=c[l].fontfamily;void 0!=c[l].fontStyle&&void 0!=c[l].fontWeight?(h=c[l].fontStyle+c[l].fontWeight,e.push(new G(k,h))):e.push(new G(k));}a(e);}else setTimeout(function(){b();},50);}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.o;A(this.c,(c.a.api||"https://fast.fonts.net/jsapi")+"/"+d+".js"+(e?"?v="+e:""),function(e){e?a([]):(f["__MonotypeConfiguration__"+
d]=function(){return c.a},b());}).id="__MonotypeAPIScript__"+d;}else a([]);};function sa(a,b){this.c=a;this.a=b;}sa.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new B;b=0;for(c=d.length;b<c;b++)z(this.c,d[b],C(g));var m=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),l=0;l<h.length;l+=1)m.push(new G(d[0],h[l]));else m.push(new G(d[0]));E(g,function(){a(m,f);});};function ta(a,b){a?this.c=a:this.c=ua;this.a=[];this.f=[];this.g=b||"";}var ua="https://fonts.googleapis.com/css";function va(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f));}}
function wa(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b}function ya(a){this.f=a;this.a=[];this.c={};}
var za={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Aa={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ba={i:"i",italic:"i",n:"n",normal:"n"},
Ca=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
function Da(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var m=d[1];g=[];if(m)for(var m=m.split(","),h=m.length,l=0;l<h;l++){var k;k=m[l];if(k.match(/^[\w-]+$/)){var n=Ca.exec(k.toLowerCase());if(null==n)k="";else {k=n[2];k=null==k||""==k?"n":Ba[k];n=n[1];if(null==n||""==n)n="4";else var r=Aa[n],n=r?r:isNaN(n)?"4":n.substr(0,1);k=[k,n].join("");}}else k="";k&&g.push(k);}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
g,0<d.length&&(d=za[d[0]])&&(a.c[e]=d));}a.c[e]||(d=za[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new G(e,f[d]));}}function Ea(a,b){this.c=a;this.a=b;}var Fa={Arimo:!0,Cousine:!0,Tinos:!0};Ea.prototype.load=function(a){var b=new B,c=this.c,d=new ta(this.a.api,this.a.text),e=this.a.families;va(d,e);var f=new ya(e);Da(f);z(c,wa(d),C(b));E(b,function(){a(f.a,f.c,Fa);});};function Ga(a,b){this.c=a;this.a=b;}Ga.prototype.load=function(a){var b=this.a.id,c=this.c.o;b?A(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],m=b[f+1],h=0;h<m.length;h++)e.push(new G(g,m[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0});}catch(l){}a(e);}},2E3):a([]);};function Ha(a,b){this.c=a;this.f=b;this.a=[];}Ha.prototype.load=function(a){var b=this.f.id,c=this.c.o,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,m=c.fonts.length;g<m;++g){var h=c.fonts[g];d.a.push(new G(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)));}a(d.a);},A(this.c,(this.f.api||"https://f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([]);})):a([]);};var Y=new oa(window);Y.a.c.custom=function(a,b){return new sa(b,a)};Y.a.c.fontdeck=function(a,b){return new Ha(b,a)};Y.a.c.monotype=function(a,b){return new ra(b,a)};Y.a.c.typekit=function(a,b){return new Ga(b,a)};Y.a.c.google=function(a,b){return new Ea(b,a)};var Z={load:p(Y.load,Y)};module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());
});

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal = function (_React$Component) {
  _inherits$1(Portal, _React$Component);

  function Portal() {
    _classCallCheck$1(this, Portal);

    return _possibleConstructorReturn$1(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass$1(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM) {
        return null;
      }
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }
      return ReactDOM.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);

  return Portal;
}(React.Component);

Portal.propTypes = {
  children: PropTypes.node.isRequired,
  node: PropTypes.any
};

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal$1 = function (_React$Component) {
  _inherits$2(Portal, _React$Component);

  function Portal() {
    _classCallCheck$2(this, Portal);

    return _possibleConstructorReturn$2(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass$2(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(props) {
      this.renderPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      ReactDOM.unmountComponentAtNode(this.defaultNode || this.props.node);
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
      this.portal = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      var children = this.props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof this.props.children.type === 'function') {
        children = React.cloneElement(this.props.children);
      }

      this.portal = ReactDOM.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(React.Component);


Portal$1.propTypes = {
  children: PropTypes.node.isRequired,
  node: PropTypes.any
};

var Portal$2 = void 0;

if (ReactDOM.createPortal) {
  Portal$2 = Portal;
} else {
  Portal$2 = Portal$1;
}

var Portal$3 = Portal$2;

var fallbackCopyTextToClipboard = function fallbackCopyTextToClipboard(text, element) {
  //  referred to https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
  var textArea = document.createElement('textarea');
  textArea.value = text;
  element.appendChild(textArea);
  textArea.style.position = 'absolute';
  textArea.style.left = '0px';
  textArea.style.top = '0px';
  textArea.select();
  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log("Fallback: Copying text command was ".concat(msg));
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }
  element.removeChild(textArea);
};
var copyToClipboard = function copyToClipboard(text, element) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text, element);
    return;
  }
  navigator.clipboard.writeText(text).then(function () {
    console.log('Async: Copying to clipboard was successful!');
  }, function (err) {
    console.error('Async: Could not copy text: ', err);
  });
};

var css_248z$2 = ".Hsl_hsl__2sgII {\n  margin-bottom: 10px;\n  max-width: 100%; }\n  .Hsl_hsl__2sgII * {\n    font-family: \"Roboto\", sans-serif;\n    -webkit-font-smoothing: antialiased;\n    min-height: 0;\n    min-width: 0; }\n\n.input-margin {\n  margin-bottom: 16px; }\n\n.accordion-padding-body {\n  padding: 12px; }\n\n.drawer-body-overflow {\n  flex: 1;\n  overflow-y: auto; }\n\n.Hsl_popoutHSL__1doME {\n  position: fixed;\n  z-index: 1000000009;\n  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.2));\n  top: 50%;\n  left: calc(50% - 400px);\n  transform: translate3d(calc(-50% + 200px), -45%, 0);\n  animation: Hsl_show-in__16z74 0.5s cubic-bezier(0.175, 0.5, 0.12, 1);\n  animation-fill-mode: forwards; }\n\n@keyframes Hsl_show-in__16z74 {\n  0% {\n    opacity: 0;\n    transform: translate3d(calc(-50% + 200px), -45%, 0); }\n  100% {\n    opacity: 1;\n    transform: translate3d(calc(-50% + 200px), -50%, 0); } }\n";
var styles$2 = {"hsl":"Hsl_hsl__2sgII","popoutHSL":"Hsl_popoutHSL__1doME","show-in":"Hsl_show-in__16z74"};
styleInject$1(css_248z$2);

webfontloader.load({
  google: {
    families: ["Roboto:400, 600, 800"]
  }
});
var HSLWrapper = function HSLWrapper() {
  return function (WrappedComponent) {
    var _Class;
    return _Class = /*#__PURE__*/function (_React$Component) {
      function _Class() {
        var _this;
        _classCallCheck$4(this, _Class);
        _this = _callSuper(this, _Class);
        _defineProperty$1(_this, "pop", function () {
          var rect = _this._HSLWrapperDOM.getBoundingClientRect();
          _this.setState({
            popOut: true,
            containerRect: rect
          });
        });
        _defineProperty$1(_this, "removePop", function () {
          _this.setState({
            popOut: false
          });
        });
        _defineProperty$1(_this, "activateDrawer", function () {
          _this.setState({
            drawerActive: true
          }, _this.pop);
        });
        _defineProperty$1(_this, "deactivateDrawer", function (e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          _this.setState({
            drawerActive: false
          }, _this.removePop);
          _this._HSLChild.reset();
        });
        _defineProperty$1(_this, "copyToClipboard", function (HSL) {
          var stringToCopy = typeof HSL === "string" ? HSL : JSON.stringify(HSL);
          copyToClipboard(stringToCopy, _this._HSLWrapperDOM);
          _this.props.activateToastMessage({
            title: "Message Content copied to clipboard",
            type: "POSITIVE"
          });
          _this.deactivateDrawer();
        });
        _defineProperty$1(_this, "onStateChange", function () {
          _this.forceUpdate();
        });
        _defineProperty$1(_this, "onSave", function (HSL, e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          _this.setState({
            drawerActive: false
          }, _this.removePop);
          if (typeof HSL !== "string") {
            HSL.isNew = false;
          }
          if (_this.props.onChange) {
            _this.props.onChange(HSL);
          }
        });
        _defineProperty$1(_this, "_popOut", function (dontPop) {
          if (dontPop || !document.getElementById("popout-container") || !_this.state.popOut) return null;
          return /*#__PURE__*/React.createElement(Portal$3, {
            node: document && document.getElementById("popout-container")
          }, /*#__PURE__*/React.createElement("div", {
            className: styles$2.popoutHSL
          }, /*#__PURE__*/React.createElement("div", {
            className: styles$2.hsl
          }, /*#__PURE__*/React.createElement(WrappedComponent, {
            state: _this._HSLChild.state,
            isPopupElement: true,
            onReverseChange: _this._handleReverseChange
          }))));
        });
        _defineProperty$1(_this, "_createPopoutElement", function () {
          _this._el = document.getElementById("popout-container");
          if (!_this._el) {
            _this._el = document.createElement("div");
            _this._el.setAttribute("id", "popout-container");
            document.body.appendChild(_this._el);
          }
        });
        _defineProperty$1(_this, "_handleReverseChange", function (key, value, cb) {
          var state = _this._HSLChild.state;
          state[key] = value;
          state.changed = true;
          _this._HSLChild.setState(state, function () {
            _this.onStateChange();
            if (cb) cb();
          });
        });
        _this.state = {
          drawerActive: false,
          popOut: false
        };
        return _this;
      }
      _inherits$3(_Class, _React$Component);
      return _createClass$4(_Class, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;
          if (this.props.readOnly) {
            return;
          }
          this._createPopoutElement();
          if (this.props.isNew) setTimeout(function () {
            _this2.activateDrawer();
          }, 300);
        }
      }, {
        key: "render",
        value: function render() {
          var _this3 = this;
          return /*#__PURE__*/React.createElement("div", {
            ref: function ref(DOMElement) {
              _this3._HSLWrapperDOM = DOMElement;
            },
            className: styles$2.hsl
          }, /*#__PURE__*/React.createElement(WrappedComponent, _extends$9({}, this.props, {
            ref: function ref(HSLChild) {
              _this3._HSLChild = HSLChild;
            },
            value: this.props.value,
            onSave: this.onSave,
            copyToClipboard: this.copyToClipboard,
            activateDrawer: this.activateDrawer,
            deactivateDrawer: this.deactivateDrawer,
            drawerActive: this.state.drawerActive,
            onStateChange: this.onStateChange
          })), this._popOut());
        }
      }]);
    }(React.Component), _defineProperty$1(_Class, "propTypes", {
      value: PropTypes.object,
      readOnly: PropTypes.bool,
      isNew: PropTypes.bool,
      onChange: PropTypes.func,
      activateToastMessage: PropTypes.func
    }), _Class;
  };
};

var compressed = true;
var categories = [
	{
		id: "people",
		name: "Smileys & People",
		emojis: [
			"grinning",
			"grin",
			"joy",
			"rolling_on_the_floor_laughing",
			"smiley",
			"smile",
			"sweat_smile",
			"laughing",
			"wink",
			"blush",
			"yum",
			"sunglasses",
			"heart_eyes",
			"kissing_heart",
			"kissing",
			"kissing_smiling_eyes",
			"kissing_closed_eyes",
			"relaxed",
			"slightly_smiling_face",
			"hugging_face",
			"star-struck",
			"thinking_face",
			"face_with_raised_eyebrow",
			"neutral_face",
			"expressionless",
			"no_mouth",
			"face_with_rolling_eyes",
			"smirk",
			"persevere",
			"disappointed_relieved",
			"open_mouth",
			"zipper_mouth_face",
			"hushed",
			"sleepy",
			"tired_face",
			"sleeping",
			"relieved",
			"stuck_out_tongue",
			"stuck_out_tongue_winking_eye",
			"stuck_out_tongue_closed_eyes",
			"drooling_face",
			"unamused",
			"sweat",
			"pensive",
			"confused",
			"upside_down_face",
			"money_mouth_face",
			"astonished",
			"white_frowning_face",
			"slightly_frowning_face",
			"confounded",
			"disappointed",
			"worried",
			"triumph",
			"cry",
			"sob",
			"frowning",
			"anguished",
			"fearful",
			"weary",
			"exploding_head",
			"grimacing",
			"cold_sweat",
			"scream",
			"flushed",
			"zany_face",
			"dizzy_face",
			"rage",
			"angry",
			"face_with_symbols_on_mouth",
			"mask",
			"face_with_thermometer",
			"face_with_head_bandage",
			"nauseated_face",
			"face_vomiting",
			"sneezing_face",
			"innocent",
			"face_with_cowboy_hat",
			"clown_face",
			"lying_face",
			"shushing_face",
			"face_with_hand_over_mouth",
			"face_with_monocle",
			"nerd_face",
			"smiling_imp",
			"imp",
			"japanese_ogre",
			"japanese_goblin",
			"skull",
			"skull_and_crossbones",
			"ghost",
			"alien",
			"space_invader",
			"robot_face",
			"hankey",
			"smiley_cat",
			"smile_cat",
			"joy_cat",
			"heart_eyes_cat",
			"smirk_cat",
			"kissing_cat",
			"scream_cat",
			"crying_cat_face",
			"pouting_cat",
			"see_no_evil",
			"hear_no_evil",
			"speak_no_evil",
			"baby",
			"child",
			"boy",
			"girl",
			"adult",
			"man",
			"woman",
			"older_adult",
			"older_man",
			"older_woman",
			"male-doctor",
			"female-doctor",
			"male-student",
			"female-student",
			"male-teacher",
			"female-teacher",
			"male-judge",
			"female-judge",
			"male-farmer",
			"female-farmer",
			"male-cook",
			"female-cook",
			"male-mechanic",
			"female-mechanic",
			"male-factory-worker",
			"female-factory-worker",
			"male-office-worker",
			"female-office-worker",
			"male-scientist",
			"female-scientist",
			"male-technologist",
			"female-technologist",
			"male-singer",
			"female-singer",
			"male-artist",
			"female-artist",
			"male-pilot",
			"female-pilot",
			"male-astronaut",
			"female-astronaut",
			"male-firefighter",
			"female-firefighter",
			"cop",
			"male-police-officer",
			"female-police-officer",
			"sleuth_or_spy",
			"male-detective",
			"female-detective",
			"guardsman",
			"male-guard",
			"female-guard",
			"construction_worker",
			"male-construction-worker",
			"female-construction-worker",
			"prince",
			"princess",
			"man_with_turban",
			"man-wearing-turban",
			"woman-wearing-turban",
			"man_with_gua_pi_mao",
			"person_with_headscarf",
			"bearded_person",
			"person_with_blond_hair",
			"blond-haired-man",
			"blond-haired-woman",
			"man_in_tuxedo",
			"bride_with_veil",
			"pregnant_woman",
			"breast-feeding",
			"angel",
			"santa",
			"mrs_claus",
			"mage",
			"female_mage",
			"male_mage",
			"fairy",
			"female_fairy",
			"male_fairy",
			"vampire",
			"female_vampire",
			"male_vampire",
			"merperson",
			"mermaid",
			"merman",
			"elf",
			"female_elf",
			"male_elf",
			"genie",
			"female_genie",
			"male_genie",
			"zombie",
			"female_zombie",
			"male_zombie",
			"person_frowning",
			"man-frowning",
			"woman-frowning",
			"person_with_pouting_face",
			"man-pouting",
			"woman-pouting",
			"no_good",
			"man-gesturing-no",
			"woman-gesturing-no",
			"ok_woman",
			"man-gesturing-ok",
			"woman-gesturing-ok",
			"information_desk_person",
			"man-tipping-hand",
			"woman-tipping-hand",
			"raising_hand",
			"man-raising-hand",
			"woman-raising-hand",
			"bow",
			"man-bowing",
			"woman-bowing",
			"face_palm",
			"man-facepalming",
			"woman-facepalming",
			"shrug",
			"man-shrugging",
			"woman-shrugging",
			"massage",
			"man-getting-massage",
			"woman-getting-massage",
			"haircut",
			"man-getting-haircut",
			"woman-getting-haircut",
			"walking",
			"man-walking",
			"woman-walking",
			"runner",
			"man-running",
			"woman-running",
			"dancer",
			"man_dancing",
			"dancers",
			"man-with-bunny-ears-partying",
			"woman-with-bunny-ears-partying",
			"person_in_steamy_room",
			"woman_in_steamy_room",
			"man_in_steamy_room",
			"person_climbing",
			"woman_climbing",
			"man_climbing",
			"person_in_lotus_position",
			"woman_in_lotus_position",
			"man_in_lotus_position",
			"bath",
			"sleeping_accommodation",
			"man_in_business_suit_levitating",
			"speaking_head_in_silhouette",
			"bust_in_silhouette",
			"busts_in_silhouette",
			"fencer",
			"horse_racing",
			"skier",
			"snowboarder",
			"golfer",
			"man-golfing",
			"woman-golfing",
			"surfer",
			"man-surfing",
			"woman-surfing",
			"rowboat",
			"man-rowing-boat",
			"woman-rowing-boat",
			"swimmer",
			"man-swimming",
			"woman-swimming",
			"person_with_ball",
			"man-bouncing-ball",
			"woman-bouncing-ball",
			"weight_lifter",
			"man-lifting-weights",
			"woman-lifting-weights",
			"bicyclist",
			"man-biking",
			"woman-biking",
			"mountain_bicyclist",
			"man-mountain-biking",
			"woman-mountain-biking",
			"racing_car",
			"racing_motorcycle",
			"person_doing_cartwheel",
			"man-cartwheeling",
			"woman-cartwheeling",
			"wrestlers",
			"man-wrestling",
			"woman-wrestling",
			"water_polo",
			"man-playing-water-polo",
			"woman-playing-water-polo",
			"handball",
			"man-playing-handball",
			"woman-playing-handball",
			"juggling",
			"man-juggling",
			"woman-juggling",
			"couple",
			"two_men_holding_hands",
			"two_women_holding_hands",
			"couplekiss",
			"woman-kiss-man",
			"man-kiss-man",
			"woman-kiss-woman",
			"couple_with_heart",
			"woman-heart-man",
			"man-heart-man",
			"woman-heart-woman",
			"family",
			"man-woman-boy",
			"man-woman-girl",
			"man-woman-girl-boy",
			"man-woman-boy-boy",
			"man-woman-girl-girl",
			"man-man-boy",
			"man-man-girl",
			"man-man-girl-boy",
			"man-man-boy-boy",
			"man-man-girl-girl",
			"woman-woman-boy",
			"woman-woman-girl",
			"woman-woman-girl-boy",
			"woman-woman-boy-boy",
			"woman-woman-girl-girl",
			"man-boy",
			"man-boy-boy",
			"man-girl",
			"man-girl-boy",
			"man-girl-girl",
			"woman-boy",
			"woman-boy-boy",
			"woman-girl",
			"woman-girl-boy",
			"woman-girl-girl",
			"selfie",
			"muscle",
			"point_left",
			"point_right",
			"point_up",
			"point_up_2",
			"middle_finger",
			"point_down",
			"v",
			"crossed_fingers",
			"spock-hand",
			"the_horns",
			"call_me_hand",
			"raised_hand_with_fingers_splayed",
			"hand",
			"ok_hand",
			"+1",
			"-1",
			"fist",
			"facepunch",
			"left-facing_fist",
			"right-facing_fist",
			"raised_back_of_hand",
			"wave",
			"i_love_you_hand_sign",
			"writing_hand",
			"clap",
			"open_hands",
			"raised_hands",
			"palms_up_together",
			"pray",
			"handshake",
			"nail_care",
			"ear",
			"nose",
			"footprints",
			"eyes",
			"eye",
			"eye-in-speech-bubble",
			"brain",
			"tongue",
			"lips",
			"kiss",
			"cupid",
			"heart",
			"heartbeat",
			"broken_heart",
			"two_hearts",
			"sparkling_heart",
			"heartpulse",
			"blue_heart",
			"green_heart",
			"yellow_heart",
			"orange_heart",
			"purple_heart",
			"black_heart",
			"gift_heart",
			"revolving_hearts",
			"heart_decoration",
			"heavy_heart_exclamation_mark_ornament",
			"love_letter",
			"zzz",
			"anger",
			"bomb",
			"boom",
			"sweat_drops",
			"dash",
			"dizzy",
			"speech_balloon",
			"left_speech_bubble",
			"right_anger_bubble",
			"thought_balloon",
			"hole",
			"eyeglasses",
			"dark_sunglasses",
			"necktie",
			"shirt",
			"jeans",
			"scarf",
			"gloves",
			"coat",
			"socks",
			"dress",
			"kimono",
			"bikini",
			"womans_clothes",
			"purse",
			"handbag",
			"pouch",
			"shopping_bags",
			"school_satchel",
			"mans_shoe",
			"athletic_shoe",
			"high_heel",
			"sandal",
			"boot",
			"crown",
			"womans_hat",
			"tophat",
			"mortar_board",
			"billed_cap",
			"helmet_with_white_cross",
			"prayer_beads",
			"lipstick",
			"ring",
			"gem"
		]
	},
	{
		id: "nature",
		name: "Animals & Nature",
		emojis: [
			"monkey_face",
			"monkey",
			"gorilla",
			"dog",
			"dog2",
			"poodle",
			"wolf",
			"fox_face",
			"cat",
			"cat2",
			"lion_face",
			"tiger",
			"tiger2",
			"leopard",
			"horse",
			"racehorse",
			"unicorn_face",
			"zebra_face",
			"deer",
			"cow",
			"ox",
			"water_buffalo",
			"cow2",
			"pig",
			"pig2",
			"boar",
			"pig_nose",
			"ram",
			"sheep",
			"goat",
			"dromedary_camel",
			"camel",
			"giraffe_face",
			"elephant",
			"rhinoceros",
			"mouse",
			"mouse2",
			"rat",
			"hamster",
			"rabbit",
			"rabbit2",
			"chipmunk",
			"hedgehog",
			"bat",
			"bear",
			"koala",
			"panda_face",
			"feet",
			"turkey",
			"chicken",
			"rooster",
			"hatching_chick",
			"baby_chick",
			"hatched_chick",
			"bird",
			"penguin",
			"dove_of_peace",
			"eagle",
			"duck",
			"owl",
			"frog",
			"crocodile",
			"turtle",
			"lizard",
			"snake",
			"dragon_face",
			"dragon",
			"sauropod",
			"t-rex",
			"whale",
			"whale2",
			"dolphin",
			"fish",
			"tropical_fish",
			"blowfish",
			"shark",
			"octopus",
			"shell",
			"crab",
			"shrimp",
			"squid",
			"snail",
			"butterfly",
			"bug",
			"ant",
			"bee",
			"beetle",
			"cricket",
			"spider",
			"spider_web",
			"scorpion",
			"bouquet",
			"cherry_blossom",
			"white_flower",
			"rosette",
			"rose",
			"wilted_flower",
			"hibiscus",
			"sunflower",
			"blossom",
			"tulip",
			"seedling",
			"evergreen_tree",
			"deciduous_tree",
			"palm_tree",
			"cactus",
			"ear_of_rice",
			"herb",
			"shamrock",
			"four_leaf_clover",
			"maple_leaf",
			"fallen_leaf",
			"leaves"
		]
	},
	{
		id: "foods",
		name: "Food & Drink",
		emojis: [
			"grapes",
			"melon",
			"watermelon",
			"tangerine",
			"lemon",
			"banana",
			"pineapple",
			"apple",
			"green_apple",
			"pear",
			"peach",
			"cherries",
			"strawberry",
			"kiwifruit",
			"tomato",
			"coconut",
			"avocado",
			"eggplant",
			"potato",
			"carrot",
			"corn",
			"hot_pepper",
			"cucumber",
			"broccoli",
			"mushroom",
			"peanuts",
			"chestnut",
			"bread",
			"croissant",
			"baguette_bread",
			"pretzel",
			"pancakes",
			"cheese_wedge",
			"meat_on_bone",
			"poultry_leg",
			"cut_of_meat",
			"bacon",
			"hamburger",
			"fries",
			"pizza",
			"hotdog",
			"sandwich",
			"taco",
			"burrito",
			"stuffed_flatbread",
			"egg",
			"fried_egg",
			"shallow_pan_of_food",
			"stew",
			"bowl_with_spoon",
			"green_salad",
			"popcorn",
			"canned_food",
			"bento",
			"rice_cracker",
			"rice_ball",
			"rice",
			"curry",
			"ramen",
			"spaghetti",
			"sweet_potato",
			"oden",
			"sushi",
			"fried_shrimp",
			"fish_cake",
			"dango",
			"dumpling",
			"fortune_cookie",
			"takeout_box",
			"icecream",
			"shaved_ice",
			"ice_cream",
			"doughnut",
			"cookie",
			"birthday",
			"cake",
			"pie",
			"chocolate_bar",
			"candy",
			"lollipop",
			"custard",
			"honey_pot",
			"baby_bottle",
			"glass_of_milk",
			"coffee",
			"tea",
			"sake",
			"champagne",
			"wine_glass",
			"cocktail",
			"tropical_drink",
			"beer",
			"beers",
			"clinking_glasses",
			"tumbler_glass",
			"cup_with_straw",
			"chopsticks",
			"knife_fork_plate",
			"fork_and_knife",
			"spoon",
			"hocho",
			"amphora"
		]
	},
	{
		id: "activity",
		name: "Activities",
		emojis: [
			"jack_o_lantern",
			"christmas_tree",
			"fireworks",
			"sparkler",
			"sparkles",
			"balloon",
			"tada",
			"confetti_ball",
			"tanabata_tree",
			"bamboo",
			"dolls",
			"flags",
			"wind_chime",
			"rice_scene",
			"ribbon",
			"gift",
			"reminder_ribbon",
			"admission_tickets",
			"ticket",
			"medal",
			"trophy",
			"sports_medal",
			"first_place_medal",
			"second_place_medal",
			"third_place_medal",
			"soccer",
			"baseball",
			"basketball",
			"volleyball",
			"football",
			"rugby_football",
			"tennis",
			"8ball",
			"bowling",
			"cricket_bat_and_ball",
			"field_hockey_stick_and_ball",
			"ice_hockey_stick_and_puck",
			"table_tennis_paddle_and_ball",
			"badminton_racquet_and_shuttlecock",
			"boxing_glove",
			"martial_arts_uniform",
			"goal_net",
			"dart",
			"golf",
			"ice_skate",
			"fishing_pole_and_fish",
			"running_shirt_with_sash",
			"ski",
			"sled",
			"curling_stone",
			"video_game",
			"joystick",
			"game_die",
			"spades",
			"hearts",
			"diamonds",
			"clubs",
			"black_joker",
			"mahjong",
			"flower_playing_cards"
		]
	},
	{
		id: "places",
		name: "Travel & Places",
		emojis: [
			"earth_africa",
			"earth_americas",
			"earth_asia",
			"globe_with_meridians",
			"world_map",
			"japan",
			"snow_capped_mountain",
			"mountain",
			"volcano",
			"mount_fuji",
			"camping",
			"beach_with_umbrella",
			"desert",
			"desert_island",
			"national_park",
			"stadium",
			"classical_building",
			"building_construction",
			"house_buildings",
			"cityscape",
			"derelict_house_building",
			"house",
			"house_with_garden",
			"office",
			"post_office",
			"european_post_office",
			"hospital",
			"bank",
			"hotel",
			"love_hotel",
			"convenience_store",
			"school",
			"department_store",
			"factory",
			"japanese_castle",
			"european_castle",
			"wedding",
			"tokyo_tower",
			"statue_of_liberty",
			"church",
			"mosque",
			"synagogue",
			"shinto_shrine",
			"kaaba",
			"fountain",
			"tent",
			"foggy",
			"night_with_stars",
			"sunrise_over_mountains",
			"sunrise",
			"city_sunset",
			"city_sunrise",
			"bridge_at_night",
			"hotsprings",
			"milky_way",
			"carousel_horse",
			"ferris_wheel",
			"roller_coaster",
			"barber",
			"circus_tent",
			"performing_arts",
			"frame_with_picture",
			"art",
			"slot_machine",
			"steam_locomotive",
			"railway_car",
			"bullettrain_side",
			"bullettrain_front",
			"train2",
			"metro",
			"light_rail",
			"station",
			"tram",
			"monorail",
			"mountain_railway",
			"train",
			"bus",
			"oncoming_bus",
			"trolleybus",
			"minibus",
			"ambulance",
			"fire_engine",
			"police_car",
			"oncoming_police_car",
			"taxi",
			"oncoming_taxi",
			"car",
			"oncoming_automobile",
			"blue_car",
			"truck",
			"articulated_lorry",
			"tractor",
			"bike",
			"scooter",
			"motor_scooter",
			"busstop",
			"motorway",
			"railway_track",
			"fuelpump",
			"rotating_light",
			"traffic_light",
			"vertical_traffic_light",
			"construction",
			"octagonal_sign",
			"anchor",
			"boat",
			"canoe",
			"speedboat",
			"passenger_ship",
			"ferry",
			"motor_boat",
			"ship",
			"airplane",
			"small_airplane",
			"airplane_departure",
			"airplane_arriving",
			"seat",
			"helicopter",
			"suspension_railway",
			"mountain_cableway",
			"aerial_tramway",
			"satellite",
			"rocket",
			"flying_saucer",
			"bellhop_bell",
			"door",
			"bed",
			"couch_and_lamp",
			"toilet",
			"shower",
			"bathtub",
			"hourglass",
			"hourglass_flowing_sand",
			"watch",
			"alarm_clock",
			"stopwatch",
			"timer_clock",
			"mantelpiece_clock",
			"clock12",
			"clock1230",
			"clock1",
			"clock130",
			"clock2",
			"clock230",
			"clock3",
			"clock330",
			"clock4",
			"clock430",
			"clock5",
			"clock530",
			"clock6",
			"clock630",
			"clock7",
			"clock730",
			"clock8",
			"clock830",
			"clock9",
			"clock930",
			"clock10",
			"clock1030",
			"clock11",
			"clock1130",
			"new_moon",
			"waxing_crescent_moon",
			"first_quarter_moon",
			"moon",
			"full_moon",
			"waning_gibbous_moon",
			"last_quarter_moon",
			"waning_crescent_moon",
			"crescent_moon",
			"new_moon_with_face",
			"first_quarter_moon_with_face",
			"last_quarter_moon_with_face",
			"thermometer",
			"sunny",
			"full_moon_with_face",
			"sun_with_face",
			"star",
			"star2",
			"stars",
			"cloud",
			"partly_sunny",
			"thunder_cloud_and_rain",
			"mostly_sunny",
			"barely_sunny",
			"partly_sunny_rain",
			"rain_cloud",
			"snow_cloud",
			"lightning",
			"tornado",
			"fog",
			"wind_blowing_face",
			"cyclone",
			"rainbow",
			"closed_umbrella",
			"umbrella",
			"umbrella_with_rain_drops",
			"umbrella_on_ground",
			"zap",
			"snowflake",
			"snowman",
			"snowman_without_snow",
			"comet",
			"fire",
			"droplet",
			"ocean"
		]
	},
	{
		id: "objects",
		name: "Objects",
		emojis: [
			"mute",
			"speaker",
			"sound",
			"loud_sound",
			"loudspeaker",
			"mega",
			"postal_horn",
			"bell",
			"no_bell",
			"musical_score",
			"musical_note",
			"notes",
			"studio_microphone",
			"level_slider",
			"control_knobs",
			"microphone",
			"headphones",
			"radio",
			"saxophone",
			"guitar",
			"musical_keyboard",
			"trumpet",
			"violin",
			"drum_with_drumsticks",
			"iphone",
			"calling",
			"phone",
			"telephone_receiver",
			"pager",
			"fax",
			"battery",
			"electric_plug",
			"computer",
			"desktop_computer",
			"printer",
			"keyboard",
			"three_button_mouse",
			"trackball",
			"minidisc",
			"floppy_disk",
			"cd",
			"dvd",
			"movie_camera",
			"film_frames",
			"film_projector",
			"clapper",
			"tv",
			"camera",
			"camera_with_flash",
			"video_camera",
			"vhs",
			"mag",
			"mag_right",
			"microscope",
			"telescope",
			"satellite_antenna",
			"candle",
			"bulb",
			"flashlight",
			"izakaya_lantern",
			"notebook_with_decorative_cover",
			"closed_book",
			"book",
			"green_book",
			"blue_book",
			"orange_book",
			"books",
			"notebook",
			"ledger",
			"page_with_curl",
			"scroll",
			"page_facing_up",
			"newspaper",
			"rolled_up_newspaper",
			"bookmark_tabs",
			"bookmark",
			"label",
			"moneybag",
			"yen",
			"dollar",
			"euro",
			"pound",
			"money_with_wings",
			"credit_card",
			"chart",
			"currency_exchange",
			"heavy_dollar_sign",
			"email",
			"e-mail",
			"incoming_envelope",
			"envelope_with_arrow",
			"outbox_tray",
			"inbox_tray",
			"package",
			"mailbox",
			"mailbox_closed",
			"mailbox_with_mail",
			"mailbox_with_no_mail",
			"postbox",
			"ballot_box_with_ballot",
			"pencil2",
			"black_nib",
			"lower_left_fountain_pen",
			"lower_left_ballpoint_pen",
			"lower_left_paintbrush",
			"lower_left_crayon",
			"memo",
			"briefcase",
			"file_folder",
			"open_file_folder",
			"card_index_dividers",
			"date",
			"calendar",
			"spiral_note_pad",
			"spiral_calendar_pad",
			"card_index",
			"chart_with_upwards_trend",
			"chart_with_downwards_trend",
			"bar_chart",
			"clipboard",
			"pushpin",
			"round_pushpin",
			"paperclip",
			"linked_paperclips",
			"straight_ruler",
			"triangular_ruler",
			"scissors",
			"card_file_box",
			"file_cabinet",
			"wastebasket",
			"lock",
			"unlock",
			"lock_with_ink_pen",
			"closed_lock_with_key",
			"key",
			"old_key",
			"hammer",
			"pick",
			"hammer_and_pick",
			"hammer_and_wrench",
			"dagger_knife",
			"crossed_swords",
			"gun",
			"bow_and_arrow",
			"shield",
			"wrench",
			"nut_and_bolt",
			"gear",
			"compression",
			"alembic",
			"scales",
			"link",
			"chains",
			"syringe",
			"pill",
			"smoking",
			"coffin",
			"funeral_urn",
			"moyai",
			"oil_drum",
			"crystal_ball",
			"shopping_trolley"
		]
	},
	{
		id: "symbols",
		name: "Symbols",
		emojis: [
			"atm",
			"put_litter_in_its_place",
			"potable_water",
			"wheelchair",
			"mens",
			"womens",
			"restroom",
			"baby_symbol",
			"wc",
			"passport_control",
			"customs",
			"baggage_claim",
			"left_luggage",
			"warning",
			"children_crossing",
			"no_entry",
			"no_entry_sign",
			"no_bicycles",
			"no_smoking",
			"do_not_litter",
			"non-potable_water",
			"no_pedestrians",
			"no_mobile_phones",
			"underage",
			"radioactive_sign",
			"biohazard_sign",
			"arrow_up",
			"arrow_upper_right",
			"arrow_right",
			"arrow_lower_right",
			"arrow_down",
			"arrow_lower_left",
			"arrow_left",
			"arrow_upper_left",
			"arrow_up_down",
			"left_right_arrow",
			"leftwards_arrow_with_hook",
			"arrow_right_hook",
			"arrow_heading_up",
			"arrow_heading_down",
			"arrows_clockwise",
			"arrows_counterclockwise",
			"back",
			"end",
			"on",
			"soon",
			"top",
			"place_of_worship",
			"atom_symbol",
			"om_symbol",
			"star_of_david",
			"wheel_of_dharma",
			"yin_yang",
			"latin_cross",
			"orthodox_cross",
			"star_and_crescent",
			"peace_symbol",
			"menorah_with_nine_branches",
			"six_pointed_star",
			"aries",
			"taurus",
			"gemini",
			"cancer",
			"leo",
			"virgo",
			"libra",
			"scorpius",
			"sagittarius",
			"capricorn",
			"aquarius",
			"pisces",
			"ophiuchus",
			"twisted_rightwards_arrows",
			"repeat",
			"repeat_one",
			"arrow_forward",
			"fast_forward",
			"black_right_pointing_double_triangle_with_vertical_bar",
			"black_right_pointing_triangle_with_double_vertical_bar",
			"arrow_backward",
			"rewind",
			"black_left_pointing_double_triangle_with_vertical_bar",
			"arrow_up_small",
			"arrow_double_up",
			"arrow_down_small",
			"arrow_double_down",
			"double_vertical_bar",
			"black_square_for_stop",
			"black_circle_for_record",
			"eject",
			"cinema",
			"low_brightness",
			"high_brightness",
			"signal_strength",
			"vibration_mode",
			"mobile_phone_off",
			"female_sign",
			"male_sign",
			"medical_symbol",
			"recycle",
			"fleur_de_lis",
			"trident",
			"name_badge",
			"beginner",
			"o",
			"white_check_mark",
			"ballot_box_with_check",
			"heavy_check_mark",
			"heavy_multiplication_x",
			"x",
			"negative_squared_cross_mark",
			"heavy_plus_sign",
			"heavy_minus_sign",
			"heavy_division_sign",
			"curly_loop",
			"loop",
			"part_alternation_mark",
			"eight_spoked_asterisk",
			"eight_pointed_black_star",
			"sparkle",
			"bangbang",
			"interrobang",
			"question",
			"grey_question",
			"grey_exclamation",
			"exclamation",
			"wavy_dash",
			"copyright",
			"registered",
			"tm",
			"hash",
			"keycap_star",
			"zero",
			"one",
			"two",
			"three",
			"four",
			"five",
			"six",
			"seven",
			"eight",
			"nine",
			"keycap_ten",
			"100",
			"capital_abcd",
			"abcd",
			"1234",
			"symbols",
			"abc",
			"a",
			"ab",
			"b",
			"cl",
			"cool",
			"free",
			"information_source",
			"id",
			"m",
			"new",
			"ng",
			"o2",
			"ok",
			"parking",
			"sos",
			"up",
			"vs",
			"koko",
			"sa",
			"u6708",
			"u6709",
			"u6307",
			"ideograph_advantage",
			"u5272",
			"u7121",
			"u7981",
			"accept",
			"u7533",
			"u5408",
			"u7a7a",
			"congratulations",
			"secret",
			"u55b6",
			"u6e80",
			"black_small_square",
			"white_small_square",
			"white_medium_square",
			"black_medium_square",
			"white_medium_small_square",
			"black_medium_small_square",
			"black_large_square",
			"white_large_square",
			"large_orange_diamond",
			"large_blue_diamond",
			"small_orange_diamond",
			"small_blue_diamond",
			"small_red_triangle",
			"small_red_triangle_down",
			"diamond_shape_with_a_dot_inside",
			"radio_button",
			"black_square_button",
			"white_square_button",
			"white_circle",
			"black_circle",
			"red_circle",
			"large_blue_circle"
		]
	},
	{
		id: "flags",
		name: "Flags",
		emojis: [
			"checkered_flag",
			"cn",
			"crossed_flags",
			"de",
			"es",
			"flag-ac",
			"flag-ad",
			"flag-ae",
			"flag-af",
			"flag-ag",
			"flag-ai",
			"flag-al",
			"flag-am",
			"flag-ao",
			"flag-aq",
			"flag-ar",
			"flag-as",
			"flag-at",
			"flag-au",
			"flag-aw",
			"flag-ax",
			"flag-az",
			"flag-ba",
			"flag-bb",
			"flag-bd",
			"flag-be",
			"flag-bf",
			"flag-bg",
			"flag-bh",
			"flag-bi",
			"flag-bj",
			"flag-bl",
			"flag-bm",
			"flag-bn",
			"flag-bo",
			"flag-bq",
			"flag-br",
			"flag-bs",
			"flag-bt",
			"flag-bv",
			"flag-bw",
			"flag-by",
			"flag-bz",
			"flag-ca",
			"flag-cc",
			"flag-cd",
			"flag-cf",
			"flag-cg",
			"flag-ch",
			"flag-ci",
			"flag-ck",
			"flag-cl",
			"flag-cm",
			"flag-co",
			"flag-cp",
			"flag-cr",
			"flag-cu",
			"flag-cv",
			"flag-cw",
			"flag-cx",
			"flag-cy",
			"flag-cz",
			"flag-dg",
			"flag-dj",
			"flag-dk",
			"flag-dm",
			"flag-do",
			"flag-dz",
			"flag-ea",
			"flag-ec",
			"flag-ee",
			"flag-eg",
			"flag-eh",
			"flag-england",
			"flag-er",
			"flag-et",
			"flag-eu",
			"flag-fi",
			"flag-fj",
			"flag-fk",
			"flag-fm",
			"flag-fo",
			"flag-ga",
			"flag-gd",
			"flag-ge",
			"flag-gf",
			"flag-gg",
			"flag-gh",
			"flag-gi",
			"flag-gl",
			"flag-gm",
			"flag-gn",
			"flag-gp",
			"flag-gq",
			"flag-gr",
			"flag-gs",
			"flag-gt",
			"flag-gu",
			"flag-gw",
			"flag-gy",
			"flag-hk",
			"flag-hm",
			"flag-hn",
			"flag-hr",
			"flag-ht",
			"flag-hu",
			"flag-ic",
			"flag-id",
			"flag-ie",
			"flag-il",
			"flag-im",
			"flag-in",
			"flag-io",
			"flag-iq",
			"flag-ir",
			"flag-is",
			"flag-je",
			"flag-jm",
			"flag-jo",
			"flag-ke",
			"flag-kg",
			"flag-kh",
			"flag-ki",
			"flag-km",
			"flag-kn",
			"flag-kp",
			"flag-kw",
			"flag-ky",
			"flag-kz",
			"flag-la",
			"flag-lb",
			"flag-lc",
			"flag-li",
			"flag-lk",
			"flag-lr",
			"flag-ls",
			"flag-lt",
			"flag-lu",
			"flag-lv",
			"flag-ly",
			"flag-ma",
			"flag-mc",
			"flag-md",
			"flag-me",
			"flag-mf",
			"flag-mg",
			"flag-mh",
			"flag-mk",
			"flag-ml",
			"flag-mm",
			"flag-mn",
			"flag-mo",
			"flag-mp",
			"flag-mq",
			"flag-mr",
			"flag-ms",
			"flag-mt",
			"flag-mu",
			"flag-mv",
			"flag-mw",
			"flag-mx",
			"flag-my",
			"flag-mz",
			"flag-na",
			"flag-nc",
			"flag-ne",
			"flag-nf",
			"flag-ng",
			"flag-ni",
			"flag-nl",
			"flag-no",
			"flag-np",
			"flag-nr",
			"flag-nu",
			"flag-nz",
			"flag-om",
			"flag-pa",
			"flag-pe",
			"flag-pf",
			"flag-pg",
			"flag-ph",
			"flag-pk",
			"flag-pl",
			"flag-pm",
			"flag-pn",
			"flag-pr",
			"flag-ps",
			"flag-pt",
			"flag-pw",
			"flag-py",
			"flag-qa",
			"flag-re",
			"flag-ro",
			"flag-rs",
			"flag-rw",
			"flag-sa",
			"flag-sb",
			"flag-sc",
			"flag-scotland",
			"flag-sd",
			"flag-se",
			"flag-sg",
			"flag-sh",
			"flag-si",
			"flag-sj",
			"flag-sk",
			"flag-sl",
			"flag-sm",
			"flag-sn",
			"flag-so",
			"flag-sr",
			"flag-ss",
			"flag-st",
			"flag-sv",
			"flag-sx",
			"flag-sy",
			"flag-sz",
			"flag-ta",
			"flag-tc",
			"flag-td",
			"flag-tf",
			"flag-tg",
			"flag-th",
			"flag-tj",
			"flag-tk",
			"flag-tl",
			"flag-tm",
			"flag-tn",
			"flag-to",
			"flag-tr",
			"flag-tt",
			"flag-tv",
			"flag-tw",
			"flag-tz",
			"flag-ua",
			"flag-ug",
			"flag-um",
			"flag-uy",
			"flag-uz",
			"flag-va",
			"flag-vc",
			"flag-ve",
			"flag-vg",
			"flag-vi",
			"flag-vn",
			"flag-vu",
			"flag-wales",
			"flag-wf",
			"flag-ws",
			"flag-xk",
			"flag-ye",
			"flag-yt",
			"flag-za",
			"flag-zm",
			"flag-zw",
			"fr",
			"gb",
			"it",
			"jp",
			"kr",
			"rainbow-flag",
			"ru",
			"triangular_flag_on_post",
			"us",
			"waving_black_flag",
			"waving_white_flag"
		]
	}
];
var emojis = {
	"100": {
		a: "Hundred Points Symbol",
		b: "1F4AF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"score",
			"perfect",
			"numbers",
			"century",
			"exam",
			"quiz",
			"test",
			"pass",
			"hundred"
		],
		k: [
			25,
			26
		]
	},
	"1234": {
		a: "Input Symbol for Numbers",
		b: "1F522",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"numbers",
			"blue-square"
		],
		k: [
			27,
			36
		]
	},
	monkey_face: {
		a: "Monkey Face",
		b: "1F435",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"circus"
		],
		k: [
			13,
			31
		],
		l: [
			":o)"
		]
	},
	grinning: {
		a: "Grinning Face",
		b: "1F600",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"smile",
			"happy",
			"joy",
			":D",
			"grin"
		],
		k: [
			30,
			24
		],
		m: ":D"
	},
	earth_africa: {
		a: "Earth Globe Europe-Africa",
		b: "1F30D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"globe",
			"world",
			"international"
		],
		k: [
			6,
			5
		]
	},
	checkered_flag: {
		a: "Chequered Flag",
		b: "1F3C1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"contest",
			"finishline",
			"race",
			"gokart"
		],
		k: [
			9,
			27
		]
	},
	mute: {
		a: "Speaker with Cancellation Stroke",
		b: "1F507",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sound",
			"volume",
			"silence",
			"quiet"
		],
		k: [
			27,
			9
		]
	},
	jack_o_lantern: {
		a: "Jack-O-Lantern",
		b: "1F383",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"halloween",
			"light",
			"pumpkin",
			"creepy",
			"fall"
		],
		k: [
			8,
			17
		]
	},
	atm: {
		a: "Automated Teller Machine",
		b: "1F3E7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"money",
			"sales",
			"cash",
			"blue-square",
			"payment",
			"bank"
		],
		k: [
			12,
			4
		]
	},
	grapes: {
		a: "Grapes",
		b: "1F347",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"food",
			"wine"
		],
		k: [
			7,
			9
		]
	},
	earth_americas: {
		a: "Earth Globe Americas",
		b: "1F30E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"globe",
			"world",
			"USA",
			"international"
		],
		k: [
			6,
			6
		]
	},
	grin: {
		a: "Grinning Face with Smiling Eyes",
		b: "1F601",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"happy",
			"smile",
			"joy",
			"kawaii"
		],
		k: [
			30,
			25
		]
	},
	melon: {
		a: "Melon",
		b: "1F348",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"nature",
			"food"
		],
		k: [
			7,
			10
		]
	},
	triangular_flag_on_post: {
		a: "Triangular Flag on Post",
		b: "1F6A9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"mark",
			"milestone",
			"place"
		],
		k: [
			35,
			14
		]
	},
	monkey: {
		a: "Monkey",
		b: "1F412",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"banana",
			"circus"
		],
		k: [
			12,
			48
		]
	},
	christmas_tree: {
		a: "Christmas Tree",
		b: "1F384",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"festival",
			"vacation",
			"december",
			"xmas",
			"celebration"
		],
		k: [
			8,
			18
		]
	},
	put_litter_in_its_place: {
		a: "Put Litter in Its Place Symbol",
		b: "1F6AE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"sign",
			"human",
			"info"
		],
		k: [
			35,
			19
		]
	},
	speaker: {
		a: "Speaker",
		b: "1F508",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sound",
			"volume",
			"silence",
			"broadcast"
		],
		k: [
			27,
			10
		]
	},
	earth_asia: {
		a: "Earth Globe Asia-Australia",
		b: "1F30F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"globe",
			"world",
			"east",
			"international"
		],
		k: [
			6,
			7
		]
	},
	crossed_flags: {
		a: "Crossed Flags",
		b: "1F38C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"japanese",
			"nation",
			"country",
			"border"
		],
		k: [
			8,
			31
		]
	},
	joy: {
		a: "Face with Tears of Joy",
		b: "1F602",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"cry",
			"tears",
			"weep",
			"happy",
			"happytears",
			"haha"
		],
		k: [
			30,
			26
		]
	},
	sound: {
		a: "Speaker with One Sound Wave",
		b: "1F509",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"volume",
			"speaker",
			"broadcast"
		],
		k: [
			27,
			11
		]
	},
	watermelon: {
		a: "Watermelon",
		b: "1F349",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"food",
			"picnic",
			"summer"
		],
		k: [
			7,
			11
		]
	},
	gorilla: {
		a: "Gorilla",
		b: "1F98D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"circus"
		],
		k: [
			42,
			37
		],
		o: 9
	},
	fireworks: {
		a: "Fireworks",
		b: "1F386",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"festival",
			"carnival",
			"congratulations"
		],
		k: [
			8,
			25
		]
	},
	potable_water: {
		a: "Potable Water Symbol",
		b: "1F6B0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"liquid",
			"restroom",
			"cleaning",
			"faucet"
		],
		k: [
			35,
			21
		]
	},
	wheelchair: {
		a: "Wheelchair Symbol",
		b: "267F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"disabled",
			"a11y",
			"accessibility"
		],
		k: [
			48,
			10
		],
		o: 4
	},
	rolling_on_the_floor_laughing: {
		a: "Rolling on the Floor Laughing",
		b: "1F923",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			38,
			26
		],
		o: 9
	},
	loud_sound: {
		a: "Speaker with Three Sound Waves",
		b: "1F50A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"volume",
			"noise",
			"noisy",
			"speaker",
			"broadcast"
		],
		k: [
			27,
			12
		]
	},
	waving_black_flag: {
		a: "Waving Black Flag",
		b: "1F3F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			12,
			19
		],
		o: 7
	},
	tangerine: {
		a: "Tangerine",
		b: "1F34A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"fruit",
			"nature",
			"orange"
		],
		k: [
			7,
			12
		]
	},
	dog: {
		a: "Dog Face",
		b: "1F436",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"friend",
			"nature",
			"woof",
			"puppy",
			"pet",
			"faithful"
		],
		k: [
			13,
			32
		]
	},
	sparkler: {
		a: "Firework Sparkler",
		b: "1F387",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stars",
			"night",
			"shine"
		],
		k: [
			8,
			26
		]
	},
	globe_with_meridians: {
		a: "Globe with Meridians",
		b: "1F310",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"earth",
			"international",
			"world",
			"internet",
			"interweb",
			"i18n"
		],
		k: [
			6,
			8
		]
	},
	smiley: {
		a: "Smiling Face with Open Mouth",
		b: "1F603",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"happy",
			"joy",
			"haha",
			":D",
			":)",
			"smile",
			"funny"
		],
		k: [
			30,
			27
		],
		l: [
			"=)",
			"=-)"
		],
		m: ":)"
	},
	loudspeaker: {
		a: "Public Address Loudspeaker",
		b: "1F4E2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"volume",
			"sound"
		],
		k: [
			26,
			25
		]
	},
	sparkles: {
		a: "Sparkles",
		b: "2728",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stars",
			"shine",
			"shiny",
			"cool",
			"awesome",
			"good",
			"magic"
		],
		k: [
			49,
			48
		]
	},
	dog2: {
		a: "Dog",
		b: "1F415",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"friend",
			"doge",
			"pet",
			"faithful"
		],
		k: [
			12,
			51
		]
	},
	waving_white_flag: {
		a: "Waving White Flag",
		b: "1F3F3-FE0F",
		c: "1F3F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			12,
			15
		],
		o: 7
	},
	world_map: {
		a: "World Map",
		b: "1F5FA-FE0F",
		c: "1F5FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"location",
			"direction"
		],
		k: [
			30,
			18
		],
		o: 7
	},
	lemon: {
		a: "Lemon",
		b: "1F34B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"nature"
		],
		k: [
			7,
			13
		]
	},
	mens: {
		a: "Mens Symbol",
		b: "1F6B9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"toilet",
			"restroom",
			"wc",
			"blue-square",
			"gender",
			"male"
		],
		k: [
			36,
			29
		]
	},
	womens: {
		a: "Womens Symbol",
		b: "1F6BA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"purple-square",
			"woman",
			"female",
			"toilet",
			"loo",
			"restroom",
			"gender"
		],
		k: [
			36,
			30
		]
	},
	"rainbow-flag": {
		a: "Rainbow Flag",
		b: "1F3F3-FE0F-200D-1F308",
		c: "1F3F3-200D-1F308",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			12,
			14
		],
		o: 7
	},
	smile: {
		a: "Smiling Face with Open Mouth and Smiling Eyes",
		b: "1F604",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"happy",
			"joy",
			"funny",
			"haha",
			"laugh",
			"like",
			":D",
			":)"
		],
		k: [
			30,
			28
		],
		l: [
			"C:",
			"c:",
			":D",
			":-D"
		],
		m: ":)"
	},
	banana: {
		a: "Banana",
		b: "1F34C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"food",
			"monkey"
		],
		k: [
			7,
			14
		]
	},
	mega: {
		a: "Cheering Megaphone",
		b: "1F4E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sound",
			"speaker",
			"volume"
		],
		k: [
			26,
			26
		]
	},
	japan: {
		a: "Silhouette of Japan",
		b: "1F5FE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nation",
			"country",
			"japanese",
			"asia"
		],
		k: [
			30,
			22
		]
	},
	poodle: {
		a: "Poodle",
		b: "1F429",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"dog",
			"animal",
			"101",
			"nature",
			"pet"
		],
		k: [
			13,
			19
		]
	},
	balloon: {
		a: "Balloon",
		b: "1F388",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"party",
			"celebration",
			"birthday",
			"circus"
		],
		k: [
			8,
			27
		]
	},
	"flag-ac": {
		a: "Ascension Island Flag",
		b: "1F1E6-1F1E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			31
		]
	},
	sweat_smile: {
		a: "Smiling Face with Open Mouth and Cold Sweat",
		b: "1F605",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"hot",
			"happy",
			"laugh",
			"sweat",
			"smile",
			"relief"
		],
		k: [
			30,
			29
		]
	},
	pineapple: {
		a: "Pineapple",
		b: "1F34D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"nature",
			"food"
		],
		k: [
			7,
			15
		]
	},
	restroom: {
		a: "Restroom",
		b: "1F6BB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"toilet",
			"refresh",
			"wc",
			"gender"
		],
		k: [
			36,
			31
		]
	},
	postal_horn: {
		a: "Postal Horn",
		b: "1F4EF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"instrument",
			"music"
		],
		k: [
			26,
			38
		]
	},
	wolf: {
		a: "Wolf Face",
		b: "1F43A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"wild"
		],
		k: [
			13,
			36
		]
	},
	tada: {
		a: "Party Popper",
		b: "1F389",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"party",
			"congratulations",
			"birthday",
			"magic",
			"circus",
			"celebration"
		],
		k: [
			8,
			28
		]
	},
	snow_capped_mountain: {
		a: "Snow Capped Mountain",
		b: "1F3D4-FE0F",
		c: "1F3D4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			11,
			37
		],
		o: 7
	},
	laughing: {
		a: "Smiling Face with Open Mouth and Tightly-Closed Eyes",
		b: "1F606",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"happy",
			"joy",
			"lol",
			"satisfied",
			"haha",
			"face",
			"glad",
			"XD",
			"laugh"
		],
		k: [
			30,
			30
		],
		l: [
			":>",
			":->"
		],
		n: [
			"satisfied"
		]
	},
	apple: {
		a: "Red Apple",
		b: "1F34E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"mac",
			"school"
		],
		k: [
			7,
			16
		]
	},
	"flag-ad": {
		a: "Andorra Flag",
		b: "1F1E6-1F1E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			32
		]
	},
	fox_face: {
		a: "Fox Face",
		b: "1F98A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"face"
		],
		k: [
			42,
			34
		],
		o: 9
	},
	confetti_ball: {
		a: "Confetti Ball",
		b: "1F38A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"festival",
			"party",
			"birthday",
			"circus"
		],
		k: [
			8,
			29
		]
	},
	bell: {
		a: "Bell",
		b: "1F514",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sound",
			"notification",
			"christmas",
			"xmas",
			"chime"
		],
		k: [
			27,
			22
		]
	},
	mountain: {
		a: "Mountain",
		b: "26F0-FE0F",
		c: "26F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"photo",
			"nature",
			"environment"
		],
		k: [
			48,
			38
		],
		o: 5
	},
	baby_symbol: {
		a: "Baby Symbol",
		b: "1F6BC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"orange-square",
			"child"
		],
		k: [
			36,
			32
		]
	},
	wc: {
		a: "Water Closet",
		b: "1F6BE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"toilet",
			"restroom",
			"blue-square"
		],
		k: [
			36,
			34
		]
	},
	wink: {
		a: "Winking Face",
		b: "1F609",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"happy",
			"mischievous",
			"secret",
			";)",
			"smile",
			"eye"
		],
		k: [
			30,
			33
		],
		l: [
			";)",
			";-)"
		],
		m: ";)"
	},
	no_bell: {
		a: "Bell with Cancellation Stroke",
		b: "1F515",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sound",
			"volume",
			"mute",
			"quiet",
			"silent"
		],
		k: [
			27,
			23
		]
	},
	green_apple: {
		a: "Green Apple",
		b: "1F34F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"nature"
		],
		k: [
			7,
			17
		]
	},
	tanabata_tree: {
		a: "Tanabata Tree",
		b: "1F38B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"plant",
			"nature",
			"branch",
			"summer"
		],
		k: [
			8,
			30
		]
	},
	"flag-ae": {
		a: "United Arab Emirates Flag",
		b: "1F1E6-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			33
		]
	},
	volcano: {
		a: "Volcano",
		b: "1F30B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"nature",
			"disaster"
		],
		k: [
			6,
			3
		]
	},
	cat: {
		a: "Cat Face",
		b: "1F431",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"meow",
			"nature",
			"pet",
			"kitten"
		],
		k: [
			13,
			27
		]
	},
	"flag-af": {
		a: "Afghanistan Flag",
		b: "1F1E6-1F1EB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			34
		]
	},
	musical_score: {
		a: "Musical Score",
		b: "1F3BC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"treble",
			"clef",
			"compose"
		],
		k: [
			9,
			22
		]
	},
	blush: {
		a: "Smiling Face with Smiling Eyes",
		b: "1F60A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"smile",
			"happy",
			"flushed",
			"crush",
			"embarrassed",
			"shy",
			"joy"
		],
		k: [
			30,
			34
		],
		m: ":)"
	},
	pear: {
		a: "Pear",
		b: "1F350",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"nature",
			"food"
		],
		k: [
			7,
			18
		]
	},
	bamboo: {
		a: "Pine Decoration",
		b: "1F38D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"plant",
			"nature",
			"vegetable",
			"panda",
			"pine_decoration"
		],
		k: [
			8,
			32
		]
	},
	passport_control: {
		a: "Passport Control",
		b: "1F6C2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"custom",
			"blue-square"
		],
		k: [
			36,
			43
		]
	},
	mount_fuji: {
		a: "Mount Fuji",
		b: "1F5FB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"mountain",
			"nature",
			"japanese"
		],
		k: [
			30,
			19
		]
	},
	cat2: {
		a: "Cat",
		b: "1F408",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"meow",
			"pet",
			"cats"
		],
		k: [
			12,
			38
		]
	},
	musical_note: {
		a: "Musical Note",
		b: "1F3B5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"score",
			"tone",
			"sound"
		],
		k: [
			9,
			15
		]
	},
	dolls: {
		a: "Japanese Dolls",
		b: "1F38E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"japanese",
			"toy",
			"kimono"
		],
		k: [
			8,
			33
		]
	},
	lion_face: {
		a: "Lion Face",
		b: "1F981",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			25
		],
		o: 8
	},
	camping: {
		a: "Camping",
		b: "1F3D5-FE0F",
		c: "1F3D5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"photo",
			"outdoors",
			"tent"
		],
		k: [
			11,
			38
		],
		o: 7
	},
	"flag-ag": {
		a: "Antigua & Barbuda Flag",
		b: "1F1E6-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			35
		]
	},
	customs: {
		a: "Customs",
		b: "1F6C3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"passport",
			"border",
			"blue-square"
		],
		k: [
			36,
			44
		]
	},
	yum: {
		a: "Face Savouring Delicious Food",
		b: "1F60B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"happy",
			"joy",
			"tongue",
			"smile",
			"face",
			"silly",
			"yummy",
			"nom",
			"delicious",
			"savouring"
		],
		k: [
			30,
			35
		]
	},
	peach: {
		a: "Peach",
		b: "1F351",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"nature",
			"food"
		],
		k: [
			7,
			19
		]
	},
	tiger: {
		a: "Tiger Face",
		b: "1F42F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"cat",
			"danger",
			"wild",
			"nature",
			"roar"
		],
		k: [
			13,
			25
		]
	},
	notes: {
		a: "Multiple Musical Notes",
		b: "1F3B6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"music",
			"score"
		],
		k: [
			9,
			16
		]
	},
	flags: {
		a: "Carp Streamer",
		b: "1F38F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fish",
			"japanese",
			"koinobori",
			"carp",
			"banner"
		],
		k: [
			8,
			34
		]
	},
	beach_with_umbrella: {
		a: "Beach with Umbrella",
		b: "1F3D6-FE0F",
		c: "1F3D6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			11,
			39
		],
		o: 7
	},
	cherries: {
		a: "Cherries",
		b: "1F352",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"fruit"
		],
		k: [
			7,
			20
		]
	},
	"flag-ai": {
		a: "Anguilla Flag",
		b: "1F1E6-1F1EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			36
		]
	},
	baggage_claim: {
		a: "Baggage Claim",
		b: "1F6C4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"airport",
			"transport"
		],
		k: [
			36,
			45
		]
	},
	sunglasses: {
		a: "Smiling Face with Sunglasses",
		b: "1F60E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"cool",
			"smile",
			"summer",
			"beach",
			"sunglass"
		],
		k: [
			30,
			38
		],
		l: [
			"8)"
		]
	},
	left_luggage: {
		a: "Left Luggage",
		b: "1F6C5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"travel"
		],
		k: [
			36,
			46
		]
	},
	wind_chime: {
		a: "Wind Chime",
		b: "1F390",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"ding",
			"spring",
			"bell"
		],
		k: [
			8,
			35
		]
	},
	strawberry: {
		a: "Strawberry",
		b: "1F353",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"food",
			"nature"
		],
		k: [
			7,
			21
		]
	},
	desert: {
		a: "Desert",
		b: "1F3DC-FE0F",
		c: "1F3DC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"photo",
			"warm",
			"saharah"
		],
		k: [
			11,
			45
		],
		o: 7
	},
	studio_microphone: {
		a: "Studio Microphone",
		b: "1F399-FE0F",
		c: "1F399",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sing",
			"recording",
			"artist",
			"talkshow"
		],
		k: [
			8,
			41
		],
		o: 7
	},
	"flag-al": {
		a: "Albania Flag",
		b: "1F1E6-1F1F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			37
		]
	},
	tiger2: {
		a: "Tiger",
		b: "1F405",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"roar"
		],
		k: [
			12,
			35
		]
	},
	heart_eyes: {
		a: "Smiling Face with Heart-Shaped Eyes",
		b: "1F60D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"crush",
			"heart"
		],
		k: [
			30,
			37
		]
	},
	desert_island: {
		a: "Desert Island",
		b: "1F3DD-FE0F",
		c: "1F3DD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"photo",
			"tropical",
			"mojito"
		],
		k: [
			11,
			46
		],
		o: 7
	},
	kiwifruit: {
		a: "Kiwifruit",
		b: "1F95D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			9
		],
		o: 9
	},
	rice_scene: {
		a: "Moon Viewing Ceremony",
		b: "1F391",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"japan",
			"asia",
			"tsukimi"
		],
		k: [
			8,
			36
		]
	},
	kissing_heart: {
		a: "Face Throwing a Kiss",
		b: "1F618",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"kiss"
		],
		k: [
			30,
			48
		],
		l: [
			":*",
			":-*"
		]
	},
	warning: {
		a: "Warning Sign",
		b: "26A0-FE0F",
		c: "26A0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"exclamation",
			"wip",
			"alert",
			"error",
			"problem",
			"issue"
		],
		k: [
			48,
			20
		],
		o: 4
	},
	"flag-am": {
		a: "Armenia Flag",
		b: "1F1E6-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			38
		]
	},
	leopard: {
		a: "Leopard",
		b: "1F406",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			12,
			36
		]
	},
	level_slider: {
		a: "Level Slider",
		b: "1F39A-FE0F",
		c: "1F39A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"scale"
		],
		k: [
			8,
			42
		],
		o: 7
	},
	horse: {
		a: "Horse Face",
		b: "1F434",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"brown",
			"nature"
		],
		k: [
			13,
			30
		]
	},
	children_crossing: {
		a: "Children Crossing",
		b: "1F6B8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"school",
			"warning",
			"danger",
			"sign",
			"driving",
			"yellow-diamond"
		],
		k: [
			36,
			28
		]
	},
	ribbon: {
		a: "Ribbon",
		b: "1F380",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"decoration",
			"pink",
			"girl",
			"bowtie"
		],
		k: [
			8,
			14
		]
	},
	national_park: {
		a: "National Park",
		b: "1F3DE-FE0F",
		c: "1F3DE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"photo",
			"environment",
			"nature"
		],
		k: [
			11,
			47
		],
		o: 7
	},
	control_knobs: {
		a: "Control Knobs",
		b: "1F39B-FE0F",
		c: "1F39B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"dial"
		],
		k: [
			8,
			43
		],
		o: 7
	},
	kissing: {
		a: "Kissing Face",
		b: "1F617",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"face",
			"3",
			"valentines",
			"infatuation",
			"kiss"
		],
		k: [
			30,
			47
		]
	},
	tomato: {
		a: "Tomato",
		b: "1F345",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fruit",
			"vegetable",
			"nature",
			"food"
		],
		k: [
			7,
			7
		]
	},
	"flag-ao": {
		a: "Angola Flag",
		b: "1F1E6-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			39
		]
	},
	stadium: {
		a: "Stadium",
		b: "1F3DF-FE0F",
		c: "1F3DF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"photo",
			"place",
			"sports",
			"concert",
			"venue"
		],
		k: [
			11,
			48
		],
		o: 7
	},
	"flag-aq": {
		a: "Antarctica Flag",
		b: "1F1E6-1F1F6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			40
		]
	},
	gift: {
		a: "Wrapped Present",
		b: "1F381",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"present",
			"birthday",
			"christmas",
			"xmas"
		],
		k: [
			8,
			15
		]
	},
	no_entry: {
		a: "No Entry",
		b: "26D4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"limit",
			"security",
			"privacy",
			"bad",
			"denied",
			"stop",
			"circle"
		],
		k: [
			48,
			35
		],
		o: 5
	},
	kissing_smiling_eyes: {
		a: "Kissing Face with Smiling Eyes",
		b: "1F619",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"affection",
			"valentines",
			"infatuation",
			"kiss"
		],
		k: [
			30,
			49
		]
	},
	coconut: {
		a: "Coconut",
		b: "1F965",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			17
		],
		o: 10
	},
	racehorse: {
		a: "Horse",
		b: "1F40E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"gamble",
			"luck"
		],
		k: [
			12,
			44
		]
	},
	microphone: {
		a: "Microphone",
		b: "1F3A4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sound",
			"music",
			"PA",
			"sing",
			"talkshow"
		],
		k: [
			8,
			50
		]
	},
	classical_building: {
		a: "Classical Building",
		b: "1F3DB-FE0F",
		c: "1F3DB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"art",
			"culture",
			"history"
		],
		k: [
			11,
			44
		],
		o: 7
	},
	no_entry_sign: {
		a: "No Entry Sign",
		b: "1F6AB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"forbid",
			"stop",
			"limit",
			"denied",
			"disallow",
			"circle"
		],
		k: [
			35,
			16
		]
	},
	reminder_ribbon: {
		a: "Reminder Ribbon",
		b: "1F397-FE0F",
		c: "1F397",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sports",
			"cause",
			"support",
			"awareness"
		],
		k: [
			8,
			40
		],
		o: 7
	},
	kissing_closed_eyes: {
		a: "Kissing Face with Closed Eyes",
		b: "1F61A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"kiss"
		],
		k: [
			30,
			50
		]
	},
	unicorn_face: {
		a: "Unicorn Face",
		b: "1F984",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			28
		],
		o: 8
	},
	"flag-ar": {
		a: "Argentina Flag",
		b: "1F1E6-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			41
		]
	},
	headphones: {
		a: "Headphone",
		b: "1F3A7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"music",
			"score",
			"gadgets"
		],
		k: [
			9,
			1
		]
	},
	avocado: {
		a: "Avocado",
		b: "1F951",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"fruit",
			"food"
		],
		k: [
			41,
			49
		],
		o: 9
	},
	relaxed: {
		a: "White Smiling Face",
		b: "263A-FE0F",
		c: "263A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"blush",
			"massage",
			"happiness"
		],
		k: [
			47,
			41
		],
		o: 1
	},
	zebra_face: {
		a: "Zebra Face",
		b: "1F993",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			43
		],
		o: 10
	},
	eggplant: {
		a: "Aubergine",
		b: "1F346",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vegetable",
			"nature",
			"food",
			"aubergine"
		],
		k: [
			7,
			8
		]
	},
	radio: {
		a: "Radio",
		b: "1F4FB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"communication",
			"music",
			"podcast",
			"program"
		],
		k: [
			26,
			50
		]
	},
	building_construction: {
		a: "Building Construction",
		b: "1F3D7-FE0F",
		c: "1F3D7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"wip",
			"working",
			"progress"
		],
		k: [
			11,
			40
		],
		o: 7
	},
	"flag-as": {
		a: "American Samoa Flag",
		b: "1F1E6-1F1F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			42
		]
	},
	admission_tickets: {
		a: "Admission Tickets",
		b: "1F39F-FE0F",
		c: "1F39F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			8,
			45
		],
		o: 7
	},
	no_bicycles: {
		a: "No Bicycles",
		b: "1F6B3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"cyclist",
			"prohibited",
			"circle"
		],
		k: [
			35,
			24
		]
	},
	no_smoking: {
		a: "No Smoking Symbol",
		b: "1F6AD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"cigarette",
			"blue-square",
			"smell",
			"smoke"
		],
		k: [
			35,
			18
		]
	},
	slightly_smiling_face: {
		a: "Slightly Smiling Face",
		b: "1F642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"smile"
		],
		k: [
			31,
			38
		],
		l: [
			":)",
			"(:",
			":-)"
		],
		o: 7
	},
	"flag-at": {
		a: "Austria Flag",
		b: "1F1E6-1F1F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			43
		]
	},
	ticket: {
		a: "Ticket",
		b: "1F3AB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"event",
			"concert",
			"pass"
		],
		k: [
			9,
			5
		]
	},
	saxophone: {
		a: "Saxophone",
		b: "1F3B7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"music",
			"instrument",
			"jazz",
			"blues"
		],
		k: [
			9,
			17
		]
	},
	deer: {
		a: "Deer",
		b: "1F98C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"horns",
			"venison"
		],
		k: [
			42,
			36
		],
		o: 9
	},
	house_buildings: {
		a: "House Buildings",
		b: "1F3D8-FE0F",
		c: "1F3D8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			11,
			41
		],
		o: 7
	},
	potato: {
		a: "Potato",
		b: "1F954",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"tuber",
			"vegatable",
			"starch"
		],
		k: [
			42,
			0
		],
		o: 9
	},
	guitar: {
		a: "Guitar",
		b: "1F3B8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"music",
			"instrument"
		],
		k: [
			9,
			18
		]
	},
	carrot: {
		a: "Carrot",
		b: "1F955",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"vegetable",
			"food",
			"orange"
		],
		k: [
			42,
			1
		],
		o: 9
	},
	cityscape: {
		a: "Cityscape",
		b: "1F3D9-FE0F",
		c: "1F3D9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"photo",
			"night life",
			"urban"
		],
		k: [
			11,
			42
		],
		o: 7
	},
	"flag-au": {
		a: "Australia Flag",
		b: "1F1E6-1F1FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			44
		]
	},
	do_not_litter: {
		a: "Do Not Litter Symbol",
		b: "1F6AF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"trash",
			"bin",
			"garbage",
			"circle"
		],
		k: [
			35,
			20
		]
	},
	hugging_face: {
		a: "Hugging Face",
		b: "1F917",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			31
		],
		o: 8
	},
	cow: {
		a: "Cow Face",
		b: "1F42E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"beef",
			"ox",
			"animal",
			"nature",
			"moo",
			"milk"
		],
		k: [
			13,
			24
		]
	},
	medal: {
		a: "Medal",
		b: "1F396-FE0F",
		c: "1F396",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			8,
			39
		],
		o: 7
	},
	musical_keyboard: {
		a: "Musical Keyboard",
		b: "1F3B9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"piano",
			"instrument",
			"compose"
		],
		k: [
			9,
			19
		]
	},
	corn: {
		a: "Ear of Maize",
		b: "1F33D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"vegetable",
			"plant"
		],
		k: [
			6,
			51
		]
	},
	derelict_house_building: {
		a: "Derelict House Building",
		b: "1F3DA-FE0F",
		c: "1F3DA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			11,
			43
		],
		o: 7
	},
	"non-potable_water": {
		a: "Non-Potable Water Symbol",
		b: "1F6B1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"drink",
			"faucet",
			"tap",
			"circle"
		],
		k: [
			35,
			22
		]
	},
	trophy: {
		a: "Trophy",
		b: "1F3C6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"win",
			"award",
			"contest",
			"place",
			"ftw",
			"ceremony"
		],
		k: [
			10,
			19
		]
	},
	"flag-aw": {
		a: "Aruba Flag",
		b: "1F1E6-1F1FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			45
		]
	},
	"star-struck": {
		a: "Grinning Face with Star Eyes",
		b: "1F929",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			38,
			49
		],
		n: [
			"grinning_face_with_star_eyes"
		],
		o: 10
	},
	ox: {
		a: "Ox",
		b: "1F402",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"cow",
			"beef"
		],
		k: [
			12,
			32
		]
	},
	trumpet: {
		a: "Trumpet",
		b: "1F3BA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"music",
			"brass"
		],
		k: [
			9,
			20
		]
	},
	hot_pepper: {
		a: "Hot Pepper",
		b: "1F336-FE0F",
		c: "1F336",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"spicy",
			"chilli",
			"chili"
		],
		k: [
			6,
			44
		],
		o: 7
	},
	sports_medal: {
		a: "Sports Medal",
		b: "1F3C5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			10,
			18
		],
		o: 7
	},
	"flag-ax": {
		a: "Åland Islands Flag",
		b: "1F1E6-1F1FD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			46
		]
	},
	water_buffalo: {
		a: "Water Buffalo",
		b: "1F403",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"ox",
			"cow"
		],
		k: [
			12,
			33
		]
	},
	no_pedestrians: {
		a: "No Pedestrians",
		b: "1F6B7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"rules",
			"crossing",
			"walking",
			"circle"
		],
		k: [
			36,
			27
		]
	},
	thinking_face: {
		a: "Thinking Face",
		b: "1F914",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			28
		],
		o: 8
	},
	house: {
		a: "House Building",
		b: "1F3E0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"home"
		],
		k: [
			11,
			49
		]
	},
	no_mobile_phones: {
		a: "No Mobile Phones",
		b: "1F4F5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"iphone",
			"mute",
			"circle"
		],
		k: [
			26,
			44
		]
	},
	"flag-az": {
		a: "Azerbaijan Flag",
		b: "1F1E6-1F1FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			47
		]
	},
	first_place_medal: {
		a: "First Place Medal",
		b: "1F947",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			41,
			42
		],
		o: 9
	},
	house_with_garden: {
		a: "House with Garden",
		b: "1F3E1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"home",
			"plant",
			"nature"
		],
		k: [
			11,
			50
		]
	},
	violin: {
		a: "Violin",
		b: "1F3BB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"music",
			"instrument",
			"orchestra",
			"symphony"
		],
		k: [
			9,
			21
		]
	},
	face_with_raised_eyebrow: {
		a: "Face with One Eyebrow Raised",
		b: "1F928",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			38,
			48
		],
		n: [
			"face_with_one_eyebrow_raised"
		],
		o: 10
	},
	cucumber: {
		a: "Cucumber",
		b: "1F952",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"fruit",
			"food",
			"pickle"
		],
		k: [
			41,
			50
		],
		o: 9
	},
	cow2: {
		a: "Cow",
		b: "1F404",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"beef",
			"ox",
			"animal",
			"nature",
			"moo",
			"milk"
		],
		k: [
			12,
			34
		]
	},
	"flag-ba": {
		a: "Bosnia & Herzegovina Flag",
		b: "1F1E7-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			0,
			48
		]
	},
	pig: {
		a: "Pig Face",
		b: "1F437",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"oink",
			"nature"
		],
		k: [
			13,
			33
		]
	},
	drum_with_drumsticks: {
		a: "Drum with Drumsticks",
		b: "1F941",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			41,
			37
		],
		o: 9
	},
	underage: {
		a: "No One Under Eighteen Symbol",
		b: "1F51E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"18",
			"drink",
			"pub",
			"night",
			"minor",
			"circle"
		],
		k: [
			27,
			32
		]
	},
	broccoli: {
		a: "Broccoli",
		b: "1F966",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			18
		],
		o: 10
	},
	office: {
		a: "Office Building",
		b: "1F3E2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"bureau",
			"work"
		],
		k: [
			11,
			51
		]
	},
	second_place_medal: {
		a: "Second Place Medal",
		b: "1F948",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			41,
			43
		],
		o: 9
	},
	neutral_face: {
		a: "Neutral Face",
		b: "1F610",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"indifference",
			"meh",
			":|",
			"neutral"
		],
		k: [
			30,
			40
		],
		l: [
			":|",
			":-|"
		]
	},
	third_place_medal: {
		a: "Third Place Medal",
		b: "1F949",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			41,
			44
		],
		o: 9
	},
	mushroom: {
		a: "Mushroom",
		b: "1F344",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"plant",
			"vegetable"
		],
		k: [
			7,
			6
		]
	},
	"flag-bb": {
		a: "Barbados Flag",
		b: "1F1E7-1F1E7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			49
		]
	},
	radioactive_sign: {
		a: "Radioactive Sign",
		b: "2622-FE0F",
		c: "2622",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			47,
			33
		],
		o: 1
	},
	pig2: {
		a: "Pig",
		b: "1F416",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			13,
			0
		]
	},
	expressionless: {
		a: "Expressionless Face",
		b: "1F611",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"indifferent",
			"-_-",
			"meh",
			"deadpan"
		],
		k: [
			30,
			41
		]
	},
	iphone: {
		a: "Mobile Phone",
		b: "1F4F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"technology",
			"apple",
			"gadgets",
			"dial"
		],
		k: [
			26,
			40
		]
	},
	post_office: {
		a: "Japanese Post Office",
		b: "1F3E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"envelope",
			"communication"
		],
		k: [
			12,
			0
		]
	},
	european_post_office: {
		a: "European Post Office",
		b: "1F3E4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"email"
		],
		k: [
			12,
			1
		]
	},
	soccer: {
		a: "Soccer Ball",
		b: "26BD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sports",
			"football"
		],
		k: [
			48,
			26
		],
		o: 5
	},
	boar: {
		a: "Boar",
		b: "1F417",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			13,
			1
		]
	},
	peanuts: {
		a: "Peanuts",
		b: "1F95C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"nut"
		],
		k: [
			42,
			8
		],
		o: 9
	},
	calling: {
		a: "Mobile Phone with Rightwards Arrow at Left",
		b: "1F4F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"iphone",
			"incoming"
		],
		k: [
			26,
			41
		]
	},
	biohazard_sign: {
		a: "Biohazard Sign",
		b: "2623-FE0F",
		c: "2623",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			47,
			34
		],
		o: 1
	},
	"flag-bd": {
		a: "Bangladesh Flag",
		b: "1F1E7-1F1E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			50
		]
	},
	no_mouth: {
		a: "Face Without Mouth",
		b: "1F636",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"hellokitty"
		],
		k: [
			31,
			26
		]
	},
	face_with_rolling_eyes: {
		a: "Face with Rolling Eyes",
		b: "1F644",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			31,
			40
		],
		o: 8
	},
	phone: {
		a: "Black Telephone",
		b: "260E-FE0F",
		c: "260E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"technology",
			"communication",
			"dial",
			"telephone"
		],
		k: [
			47,
			21
		],
		n: [
			"telephone"
		],
		o: 1
	},
	pig_nose: {
		a: "Pig Nose",
		b: "1F43D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"oink"
		],
		k: [
			13,
			39
		]
	},
	chestnut: {
		a: "Chestnut",
		b: "1F330",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"squirrel"
		],
		k: [
			6,
			38
		]
	},
	arrow_up: {
		a: "Upwards Black Arrow",
		b: "2B06-FE0F",
		c: "2B06",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"continue",
			"top",
			"direction"
		],
		k: [
			50,
			18
		],
		o: 4
	},
	hospital: {
		a: "Hospital",
		b: "1F3E5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"health",
			"surgery",
			"doctor"
		],
		k: [
			12,
			2
		]
	},
	"flag-be": {
		a: "Belgium Flag",
		b: "1F1E7-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			0,
			51
		]
	},
	baseball: {
		a: "Baseball",
		b: "26BE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sports",
			"balls"
		],
		k: [
			48,
			27
		],
		o: 5
	},
	smirk: {
		a: "Smirking Face",
		b: "1F60F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"smile",
			"mean",
			"prank",
			"smug",
			"sarcasm"
		],
		k: [
			30,
			39
		]
	},
	arrow_upper_right: {
		a: "North East Arrow",
		b: "2197-FE0F",
		c: "2197",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"point",
			"direction",
			"diagonal",
			"northeast"
		],
		k: [
			46,
			36
		],
		o: 1
	},
	"flag-bf": {
		a: "Burkina Faso Flag",
		b: "1F1E7-1F1EB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			0
		]
	},
	basketball: {
		a: "Basketball and Hoop",
		b: "1F3C0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sports",
			"balls",
			"NBA"
		],
		k: [
			9,
			26
		]
	},
	ram: {
		a: "Ram",
		b: "1F40F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"sheep",
			"nature"
		],
		k: [
			12,
			45
		]
	},
	bank: {
		a: "Bank",
		b: "1F3E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"money",
			"sales",
			"cash",
			"business",
			"enterprise"
		],
		k: [
			12,
			3
		]
	},
	bread: {
		a: "Bread",
		b: "1F35E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"wheat",
			"breakfast",
			"toast"
		],
		k: [
			7,
			32
		]
	},
	telephone_receiver: {
		a: "Telephone Receiver",
		b: "1F4DE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"technology",
			"communication",
			"dial"
		],
		k: [
			26,
			21
		]
	},
	croissant: {
		a: "Croissant",
		b: "1F950",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"bread",
			"french"
		],
		k: [
			41,
			48
		],
		o: 9
	},
	pager: {
		a: "Pager",
		b: "1F4DF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"bbcall",
			"oldschool",
			"90s"
		],
		k: [
			26,
			22
		]
	},
	sheep: {
		a: "Sheep",
		b: "1F411",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"wool",
			"shipit"
		],
		k: [
			12,
			47
		]
	},
	arrow_right: {
		a: "Black Rightwards Arrow",
		b: "27A1-FE0F",
		c: "27A1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"next"
		],
		k: [
			50,
			12
		],
		o: 1
	},
	persevere: {
		a: "Persevering Face",
		b: "1F623",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"sick",
			"no",
			"upset",
			"oops"
		],
		k: [
			31,
			7
		]
	},
	"flag-bg": {
		a: "Bulgaria Flag",
		b: "1F1E7-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			1
		]
	},
	volleyball: {
		a: "Volleyball",
		b: "1F3D0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sports",
			"balls"
		],
		k: [
			11,
			33
		],
		o: 8
	},
	hotel: {
		a: "Hotel",
		b: "1F3E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"accomodation",
			"checkin"
		],
		k: [
			12,
			5
		]
	},
	arrow_lower_right: {
		a: "South East Arrow",
		b: "2198-FE0F",
		c: "2198",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"direction",
			"diagonal",
			"southeast"
		],
		k: [
			46,
			37
		],
		o: 1
	},
	goat: {
		a: "Goat",
		b: "1F410",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			12,
			46
		]
	},
	"flag-bh": {
		a: "Bahrain Flag",
		b: "1F1E7-1F1ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			2
		]
	},
	love_hotel: {
		a: "Love Hotel",
		b: "1F3E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"like",
			"affection",
			"dating"
		],
		k: [
			12,
			6
		]
	},
	disappointed_relieved: {
		a: "Disappointed but Relieved Face",
		b: "1F625",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"phew",
			"sweat",
			"nervous"
		],
		k: [
			31,
			9
		]
	},
	baguette_bread: {
		a: "Baguette Bread",
		b: "1F956",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"bread",
			"french"
		],
		k: [
			42,
			2
		],
		o: 9
	},
	football: {
		a: "American Football",
		b: "1F3C8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sports",
			"balls",
			"NFL"
		],
		k: [
			10,
			26
		]
	},
	fax: {
		a: "Fax Machine",
		b: "1F4E0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"communication",
			"technology"
		],
		k: [
			26,
			23
		]
	},
	convenience_store: {
		a: "Convenience Store",
		b: "1F3EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"shopping",
			"groceries"
		],
		k: [
			12,
			7
		]
	},
	dromedary_camel: {
		a: "Dromedary Camel",
		b: "1F42A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"hot",
			"desert",
			"hump"
		],
		k: [
			13,
			20
		]
	},
	arrow_down: {
		a: "Downwards Black Arrow",
		b: "2B07-FE0F",
		c: "2B07",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"direction",
			"bottom"
		],
		k: [
			50,
			19
		],
		o: 4
	},
	battery: {
		a: "Battery",
		b: "1F50B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"power",
			"energy",
			"sustain"
		],
		k: [
			27,
			13
		]
	},
	rugby_football: {
		a: "Rugby Football",
		b: "1F3C9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sports",
			"team"
		],
		k: [
			10,
			27
		]
	},
	pretzel: {
		a: "Pretzel",
		b: "1F968",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			20
		],
		o: 10
	},
	open_mouth: {
		a: "Face with Open Mouth",
		b: "1F62E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"surprise",
			"impressed",
			"wow",
			"whoa",
			":O"
		],
		k: [
			31,
			18
		],
		l: [
			":o",
			":-o",
			":O",
			":-O"
		]
	},
	"flag-bi": {
		a: "Burundi Flag",
		b: "1F1E7-1F1EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			3
		]
	},
	"flag-bj": {
		a: "Benin Flag",
		b: "1F1E7-1F1EF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			4
		]
	},
	pancakes: {
		a: "Pancakes",
		b: "1F95E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"breakfast",
			"flapjacks",
			"hotcakes"
		],
		k: [
			42,
			10
		],
		o: 9
	},
	school: {
		a: "School",
		b: "1F3EB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"student",
			"education",
			"learn",
			"teach"
		],
		k: [
			12,
			8
		]
	},
	tennis: {
		a: "Tennis Racquet and Ball",
		b: "1F3BE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sports",
			"balls",
			"green"
		],
		k: [
			9,
			24
		]
	},
	zipper_mouth_face: {
		a: "Zipper-Mouth Face",
		b: "1F910",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face",
			"sealed",
			"zipper",
			"secret"
		],
		k: [
			37,
			24
		],
		o: 8
	},
	camel: {
		a: "Bactrian Camel",
		b: "1F42B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"hot",
			"desert",
			"hump"
		],
		k: [
			13,
			21
		]
	},
	arrow_lower_left: {
		a: "South West Arrow",
		b: "2199-FE0F",
		c: "2199",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"direction",
			"diagonal",
			"southwest"
		],
		k: [
			46,
			38
		],
		o: 1
	},
	electric_plug: {
		a: "Electric Plug",
		b: "1F50C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"charger",
			"power"
		],
		k: [
			27,
			14
		]
	},
	cheese_wedge: {
		a: "Cheese Wedge",
		b: "1F9C0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			48
		],
		o: 8
	},
	hushed: {
		a: "Hushed Face",
		b: "1F62F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"woo",
			"shh"
		],
		k: [
			31,
			19
		]
	},
	computer: {
		a: "Personal Computer",
		b: "1F4BB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"technology",
			"laptop",
			"screen",
			"display",
			"monitor"
		],
		k: [
			25,
			38
		]
	},
	giraffe_face: {
		a: "Giraffe Face",
		b: "1F992",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			42
		],
		o: 10
	},
	"8ball": {
		a: "Billiards",
		b: "1F3B1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"pool",
			"hobby",
			"game",
			"luck",
			"magic"
		],
		k: [
			9,
			11
		]
	},
	"flag-bl": {
		a: "St. Barthélemy Flag",
		b: "1F1E7-1F1F1",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			5
		]
	},
	arrow_left: {
		a: "Leftwards Black Arrow",
		b: "2B05-FE0F",
		c: "2B05",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"previous",
			"back"
		],
		k: [
			50,
			17
		],
		o: 4
	},
	department_store: {
		a: "Department Store",
		b: "1F3EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"shopping",
			"mall"
		],
		k: [
			12,
			9
		]
	},
	meat_on_bone: {
		a: "Meat on Bone",
		b: "1F356",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"good",
			"food",
			"drumstick"
		],
		k: [
			7,
			24
		]
	},
	arrow_upper_left: {
		a: "North West Arrow",
		b: "2196-FE0F",
		c: "2196",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"point",
			"direction",
			"diagonal",
			"northwest"
		],
		k: [
			46,
			35
		],
		o: 1
	},
	"flag-bm": {
		a: "Bermuda Flag",
		b: "1F1E7-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			6
		]
	},
	sleepy: {
		a: "Sleepy Face",
		b: "1F62A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"tired",
			"rest",
			"nap"
		],
		k: [
			31,
			14
		]
	},
	bowling: {
		a: "Bowling",
		b: "1F3B3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sports",
			"fun",
			"play"
		],
		k: [
			9,
			13
		]
	},
	factory: {
		a: "Factory",
		b: "1F3ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"industry",
			"pollution",
			"smoke"
		],
		k: [
			12,
			10
		]
	},
	desktop_computer: {
		a: "Desktop Computer",
		b: "1F5A5-FE0F",
		c: "1F5A5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"technology",
			"computing",
			"screen"
		],
		k: [
			29,
			51
		],
		o: 7
	},
	elephant: {
		a: "Elephant",
		b: "1F418",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"nose",
			"th",
			"circus"
		],
		k: [
			13,
			2
		]
	},
	rhinoceros: {
		a: "Rhinoceros",
		b: "1F98F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"horn"
		],
		k: [
			42,
			39
		],
		o: 9
	},
	arrow_up_down: {
		a: "Up Down Arrow",
		b: "2195-FE0F",
		c: "2195",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"direction",
			"way",
			"vertical"
		],
		k: [
			46,
			34
		],
		o: 1
	},
	cricket_bat_and_ball: {
		a: "Cricket Bat and Ball",
		b: "1F3CF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			11,
			32
		],
		o: 8
	},
	printer: {
		a: "Printer",
		b: "1F5A8-FE0F",
		c: "1F5A8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"paper",
			"ink"
		],
		k: [
			30,
			0
		],
		o: 7
	},
	poultry_leg: {
		a: "Poultry Leg",
		b: "1F357",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"meat",
			"drumstick",
			"bird",
			"chicken",
			"turkey"
		],
		k: [
			7,
			25
		]
	},
	tired_face: {
		a: "Tired Face",
		b: "1F62B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sick",
			"whine",
			"upset",
			"frustrated"
		],
		k: [
			31,
			15
		]
	},
	japanese_castle: {
		a: "Japanese Castle",
		b: "1F3EF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"building"
		],
		k: [
			12,
			12
		]
	},
	"flag-bn": {
		a: "Brunei Flag",
		b: "1F1E7-1F1F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			1,
			7
		]
	},
	field_hockey_stick_and_ball: {
		a: "Field Hockey Stick and Ball",
		b: "1F3D1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			11,
			34
		],
		o: 8
	},
	sleeping: {
		a: "Sleeping Face",
		b: "1F634",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"tired",
			"sleepy",
			"night",
			"zzz"
		],
		k: [
			31,
			24
		]
	},
	left_right_arrow: {
		a: "Left Right Arrow",
		b: "2194-FE0F",
		c: "2194",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"direction",
			"horizontal",
			"sideways"
		],
		k: [
			46,
			33
		],
		o: 1
	},
	keyboard: {
		a: "Keyboard",
		b: "2328-FE0F",
		c: "2328",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"technology",
			"computer",
			"type",
			"input",
			"text"
		],
		k: [
			46,
			43
		],
		o: 1
	},
	european_castle: {
		a: "European Castle",
		b: "1F3F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"royalty",
			"history"
		],
		k: [
			12,
			13
		]
	},
	mouse: {
		a: "Mouse Face",
		b: "1F42D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"cheese_wedge",
			"rodent"
		],
		k: [
			13,
			23
		]
	},
	"flag-bo": {
		a: "Bolivia Flag",
		b: "1F1E7-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			8
		]
	},
	cut_of_meat: {
		a: "Cut of Meat",
		b: "1F969",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			21
		],
		o: 10
	},
	ice_hockey_stick_and_puck: {
		a: "Ice Hockey Stick and Puck",
		b: "1F3D2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			11,
			35
		],
		o: 8
	},
	mouse2: {
		a: "Mouse",
		b: "1F401",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"rodent"
		],
		k: [
			12,
			31
		]
	},
	three_button_mouse: {
		a: "Three Button Mouse",
		b: "1F5B1-FE0F",
		c: "1F5B1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			30,
			1
		],
		o: 7
	},
	leftwards_arrow_with_hook: {
		a: "Leftwards Arrow with Hook",
		b: "21A9-FE0F",
		c: "21A9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"back",
			"return",
			"blue-square",
			"undo",
			"enter"
		],
		k: [
			46,
			39
		],
		o: 1
	},
	bacon: {
		a: "Bacon",
		b: "1F953",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"breakfast",
			"pork",
			"pig",
			"meat"
		],
		k: [
			41,
			51
		],
		o: 9
	},
	relieved: {
		a: "Relieved Face",
		b: "1F60C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"relaxed",
			"phew",
			"massage",
			"happiness"
		],
		k: [
			30,
			36
		]
	},
	"flag-bq": {
		a: "Caribbean Netherlands Flag",
		b: "1F1E7-1F1F6",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			9
		]
	},
	wedding: {
		a: "Wedding",
		b: "1F492",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"affection",
			"couple",
			"marriage",
			"bride",
			"groom"
		],
		k: [
			24,
			44
		]
	},
	tokyo_tower: {
		a: "Tokyo Tower",
		b: "1F5FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"japanese"
		],
		k: [
			30,
			20
		]
	},
	arrow_right_hook: {
		a: "Rightwards Arrow with Hook",
		b: "21AA-FE0F",
		c: "21AA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"return",
			"rotate",
			"direction"
		],
		k: [
			46,
			40
		],
		o: 1
	},
	hamburger: {
		a: "Hamburger",
		b: "1F354",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"meat",
			"fast food",
			"beef",
			"cheeseburger",
			"mcdonalds",
			"burger king"
		],
		k: [
			7,
			22
		]
	},
	stuck_out_tongue: {
		a: "Face with Stuck-out Tongue",
		b: "1F61B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"prank",
			"childish",
			"playful",
			"mischievous",
			"smile",
			"tongue"
		],
		k: [
			30,
			51
		],
		l: [
			":p",
			":-p",
			":P",
			":-P",
			":b",
			":-b"
		],
		m: ":p"
	},
	trackball: {
		a: "Trackball",
		b: "1F5B2-FE0F",
		c: "1F5B2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"technology",
			"trackpad"
		],
		k: [
			30,
			2
		],
		o: 7
	},
	"flag-br": {
		a: "Brazil Flag",
		b: "1F1E7-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			10
		]
	},
	rat: {
		a: "Rat",
		b: "1F400",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"mouse",
			"rodent"
		],
		k: [
			12,
			30
		]
	},
	table_tennis_paddle_and_ball: {
		a: "Table Tennis Paddle and Ball",
		b: "1F3D3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			11,
			36
		],
		o: 8
	},
	minidisc: {
		a: "Minidisc",
		b: "1F4BD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"technology",
			"record",
			"data",
			"disk",
			"90s"
		],
		k: [
			25,
			40
		]
	},
	stuck_out_tongue_winking_eye: {
		a: "Face with Stuck-out Tongue and Winking Eye",
		b: "1F61C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"prank",
			"childish",
			"playful",
			"mischievous",
			"smile",
			"wink",
			"tongue"
		],
		k: [
			31,
			0
		],
		l: [
			";p",
			";-p",
			";b",
			";-b",
			";P",
			";-P"
		],
		m: ";p"
	},
	fries: {
		a: "French Fries",
		b: "1F35F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"chips",
			"snack",
			"fast food"
		],
		k: [
			7,
			33
		]
	},
	badminton_racquet_and_shuttlecock: {
		a: "Badminton Racquet and Shuttlecock",
		b: "1F3F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			12,
			22
		],
		o: 8
	},
	statue_of_liberty: {
		a: "Statue of Liberty",
		b: "1F5FD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"american",
			"newyork"
		],
		k: [
			30,
			21
		]
	},
	"flag-bs": {
		a: "Bahamas Flag",
		b: "1F1E7-1F1F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			11
		]
	},
	arrow_heading_up: {
		a: "Arrow Pointing Rightwards Then Curving Upwards",
		b: "2934-FE0F",
		c: "2934",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"direction",
			"top"
		],
		k: [
			50,
			15
		],
		o: 3
	},
	hamster: {
		a: "Hamster Face",
		b: "1F439",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			13,
			35
		]
	},
	stuck_out_tongue_closed_eyes: {
		a: "Face with Stuck-out Tongue and Tightly-Closed Eyes",
		b: "1F61D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"prank",
			"playful",
			"mischievous",
			"smile",
			"tongue"
		],
		k: [
			31,
			1
		]
	},
	pizza: {
		a: "Slice of Pizza",
		b: "1F355",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"party"
		],
		k: [
			7,
			23
		]
	},
	boxing_glove: {
		a: "Boxing Glove",
		b: "1F94A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sports",
			"fighting"
		],
		k: [
			41,
			45
		],
		o: 9
	},
	floppy_disk: {
		a: "Floppy Disk",
		b: "1F4BE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"oldschool",
			"technology",
			"save",
			"90s",
			"80s"
		],
		k: [
			25,
			41
		]
	},
	arrow_heading_down: {
		a: "Arrow Pointing Rightwards Then Curving Downwards",
		b: "2935-FE0F",
		c: "2935",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"direction",
			"bottom"
		],
		k: [
			50,
			16
		],
		o: 3
	},
	"flag-bt": {
		a: "Bhutan Flag",
		b: "1F1E7-1F1F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			12
		]
	},
	rabbit: {
		a: "Rabbit Face",
		b: "1F430",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"pet",
			"spring",
			"magic",
			"bunny"
		],
		k: [
			13,
			26
		]
	},
	church: {
		a: "Church",
		b: "26EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"building",
			"religion",
			"christ"
		],
		k: [
			48,
			37
		],
		o: 5
	},
	drooling_face: {
		a: "Drooling Face",
		b: "1F924",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face"
		],
		k: [
			38,
			27
		],
		o: 9
	},
	"flag-bv": {
		a: "Bouvet Island Flag",
		b: "1F1E7-1F1FB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			13
		]
	},
	mosque: {
		a: "Mosque",
		b: "1F54C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"islam",
			"worship",
			"minaret"
		],
		k: [
			28,
			15
		],
		o: 8
	},
	rabbit2: {
		a: "Rabbit",
		b: "1F407",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"pet",
			"magic",
			"spring"
		],
		k: [
			12,
			37
		]
	},
	hotdog: {
		a: "Hot Dog",
		b: "1F32D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"frankfurter"
		],
		k: [
			6,
			35
		],
		o: 8
	},
	martial_arts_uniform: {
		a: "Martial Arts Uniform",
		b: "1F94B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"judo",
			"karate",
			"taekwondo"
		],
		k: [
			41,
			46
		],
		o: 9
	},
	arrows_clockwise: {
		a: "Clockwise Downwards and Upwards Open Circle Arrows",
		b: "1F503",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sync",
			"cycle",
			"round",
			"repeat"
		],
		k: [
			27,
			5
		]
	},
	cd: {
		a: "Optical Disc",
		b: "1F4BF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"technology",
			"dvd",
			"disk",
			"disc",
			"90s"
		],
		k: [
			25,
			42
		]
	},
	arrows_counterclockwise: {
		a: "Anticlockwise Downwards and Upwards Open Circle Arrows",
		b: "1F504",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"sync",
			"cycle"
		],
		k: [
			27,
			6
		]
	},
	sandwich: {
		a: "Sandwich",
		b: "1F96A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			22
		],
		o: 10
	},
	chipmunk: {
		a: "Chipmunk",
		b: "1F43F-FE0F",
		c: "1F43F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"rodent",
			"squirrel"
		],
		k: [
			13,
			41
		],
		o: 7
	},
	synagogue: {
		a: "Synagogue",
		b: "1F54D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"judaism",
			"worship",
			"temple",
			"jewish"
		],
		k: [
			28,
			16
		],
		o: 8
	},
	unamused: {
		a: "Unamused Face",
		b: "1F612",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"indifference",
			"bored",
			"straight face",
			"serious",
			"sarcasm"
		],
		k: [
			30,
			42
		],
		m: ":("
	},
	goal_net: {
		a: "Goal Net",
		b: "1F945",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sports"
		],
		k: [
			41,
			41
		],
		o: 9
	},
	"flag-bw": {
		a: "Botswana Flag",
		b: "1F1E7-1F1FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			14
		]
	},
	dvd: {
		a: "Dvd",
		b: "1F4C0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"cd",
			"disk",
			"disc"
		],
		k: [
			25,
			43
		]
	},
	hedgehog: {
		a: "Hedgehog",
		b: "1F994",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			44
		],
		o: 10
	},
	dart: {
		a: "Direct Hit",
		b: "1F3AF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"game",
			"play",
			"bar"
		],
		k: [
			9,
			9
		]
	},
	taco: {
		a: "Taco",
		b: "1F32E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"mexican"
		],
		k: [
			6,
			36
		],
		o: 8
	},
	back: {
		a: "Back with Leftwards Arrow Above",
		b: "1F519",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"arrow",
			"words",
			"return"
		],
		k: [
			27,
			27
		]
	},
	"flag-by": {
		a: "Belarus Flag",
		b: "1F1E7-1F1FE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			15
		]
	},
	shinto_shrine: {
		a: "Shinto Shrine",
		b: "26E9-FE0F",
		c: "26E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"temple",
			"japan",
			"kyoto"
		],
		k: [
			48,
			36
		],
		o: 5
	},
	movie_camera: {
		a: "Movie Camera",
		b: "1F3A5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"film",
			"record"
		],
		k: [
			8,
			51
		]
	},
	sweat: {
		a: "Face with Cold Sweat",
		b: "1F613",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"hot",
			"sad",
			"tired",
			"exercise"
		],
		k: [
			30,
			43
		]
	},
	burrito: {
		a: "Burrito",
		b: "1F32F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"mexican"
		],
		k: [
			6,
			37
		],
		o: 8
	},
	"flag-bz": {
		a: "Belize Flag",
		b: "1F1E7-1F1FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			16
		]
	},
	pensive: {
		a: "Pensive Face",
		b: "1F614",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"sad",
			"depressed",
			"upset"
		],
		k: [
			30,
			44
		]
	},
	kaaba: {
		a: "Kaaba",
		b: "1F54B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"mecca",
			"mosque",
			"islam"
		],
		k: [
			28,
			14
		],
		o: 8
	},
	film_frames: {
		a: "Film Frames",
		b: "1F39E-FE0F",
		c: "1F39E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			8,
			44
		],
		o: 7
	},
	bat: {
		a: "Bat",
		b: "1F987",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"blind",
			"vampire"
		],
		k: [
			42,
			31
		],
		o: 9
	},
	golf: {
		a: "Flag in Hole",
		b: "26F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sports",
			"business",
			"flag",
			"hole",
			"summer"
		],
		k: [
			48,
			41
		],
		o: 5
	},
	end: {
		a: "End with Leftwards Arrow Above",
		b: "1F51A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"words",
			"arrow"
		],
		k: [
			27,
			28
		]
	},
	film_projector: {
		a: "Film Projector",
		b: "1F4FD-FE0F",
		c: "1F4FD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"video",
			"tape",
			"record",
			"movie"
		],
		k: [
			27,
			0
		],
		o: 7
	},
	bear: {
		a: "Bear Face",
		b: "1F43B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"wild"
		],
		k: [
			13,
			37
		]
	},
	ice_skate: {
		a: "Ice Skate",
		b: "26F8-FE0F",
		c: "26F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sports"
		],
		k: [
			48,
			45
		],
		o: 5
	},
	fountain: {
		a: "Fountain",
		b: "26F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"summer",
			"water",
			"fresh"
		],
		k: [
			48,
			40
		],
		o: 5
	},
	confused: {
		a: "Confused Face",
		b: "1F615",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"indifference",
			"huh",
			"weird",
			"hmmm",
			":/"
		],
		k: [
			30,
			45
		],
		l: [
			":\\",
			":-\\",
			":/",
			":-/"
		]
	},
	"flag-ca": {
		a: "Canada Flag",
		b: "1F1E8-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			17
		]
	},
	on: {
		a: "On with Exclamation Mark with Left Right Arrow Above",
		b: "1F51B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"arrow",
			"words"
		],
		k: [
			27,
			29
		]
	},
	stuffed_flatbread: {
		a: "Stuffed Flatbread",
		b: "1F959",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"flatbread",
			"stuffed",
			"gyro"
		],
		k: [
			42,
			5
		],
		o: 9
	},
	soon: {
		a: "Soon with Rightwards Arrow Above",
		b: "1F51C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"arrow",
			"words"
		],
		k: [
			27,
			30
		]
	},
	upside_down_face: {
		a: "Upside-Down Face",
		b: "1F643",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face",
			"flipped",
			"silly",
			"smile"
		],
		k: [
			31,
			39
		],
		o: 8
	},
	fishing_pole_and_fish: {
		a: "Fishing Pole and Fish",
		b: "1F3A3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"hobby",
			"summer"
		],
		k: [
			8,
			49
		]
	},
	tent: {
		a: "Tent",
		b: "26FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"camping",
			"outdoors"
		],
		k: [
			49,
			12
		],
		o: 5
	},
	clapper: {
		a: "Clapper Board",
		b: "1F3AC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"movie",
			"film",
			"record"
		],
		k: [
			9,
			6
		]
	},
	egg: {
		a: "Egg",
		b: "1F95A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"chicken",
			"breakfast"
		],
		k: [
			42,
			6
		],
		o: 9
	},
	"flag-cc": {
		a: "Cocos (keeling) Islands Flag",
		b: "1F1E8-1F1E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			18
		]
	},
	koala: {
		a: "Koala",
		b: "1F428",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			13,
			18
		]
	},
	foggy: {
		a: "Foggy",
		b: "1F301",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"mountain"
		],
		k: [
			5,
			45
		]
	},
	tv: {
		a: "Television",
		b: "1F4FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"technology",
			"program",
			"oldschool",
			"show",
			"television"
		],
		k: [
			26,
			49
		]
	},
	panda_face: {
		a: "Panda Face",
		b: "1F43C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"panda"
		],
		k: [
			13,
			38
		]
	},
	fried_egg: {
		a: "Cooking",
		b: "1F373",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"breakfast",
			"kitchen",
			"egg"
		],
		k: [
			8,
			1
		],
		n: [
			"cooking"
		]
	},
	top: {
		a: "Top with Upwards Arrow Above",
		b: "1F51D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"words",
			"blue-square"
		],
		k: [
			27,
			31
		]
	},
	"flag-cd": {
		a: "Congo - Kinshasa Flag",
		b: "1F1E8-1F1E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			19
		]
	},
	money_mouth_face: {
		a: "Money-Mouth Face",
		b: "1F911",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face",
			"rich",
			"dollar",
			"money"
		],
		k: [
			37,
			25
		],
		o: 8
	},
	running_shirt_with_sash: {
		a: "Running Shirt with Sash",
		b: "1F3BD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"play",
			"pageant"
		],
		k: [
			9,
			23
		]
	},
	astonished: {
		a: "Astonished Face",
		b: "1F632",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"xox",
			"surprised",
			"poisoned"
		],
		k: [
			31,
			22
		]
	},
	feet: {
		a: "Paw Prints",
		b: "1F43E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			13,
			40
		],
		n: [
			"paw_prints"
		]
	},
	camera: {
		a: "Camera",
		b: "1F4F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"gadgets",
			"photography"
		],
		k: [
			26,
			46
		]
	},
	"flag-cf": {
		a: "Central African Republic Flag",
		b: "1F1E8-1F1EB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			20
		]
	},
	place_of_worship: {
		a: "Place of Worship",
		b: "1F6D0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"religion",
			"church",
			"temple",
			"prayer"
		],
		k: [
			37,
			5
		],
		o: 8
	},
	night_with_stars: {
		a: "Night with Stars",
		b: "1F303",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"evening",
			"city",
			"downtown"
		],
		k: [
			5,
			47
		]
	},
	ski: {
		a: "Ski and Ski Boot",
		b: "1F3BF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sports",
			"winter",
			"cold",
			"snow"
		],
		k: [
			9,
			25
		]
	},
	shallow_pan_of_food: {
		a: "Shallow Pan of Food",
		b: "1F958",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"cooking",
			"casserole",
			"paella"
		],
		k: [
			42,
			4
		],
		o: 9
	},
	camera_with_flash: {
		a: "Camera with Flash",
		b: "1F4F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			26,
			47
		],
		o: 7
	},
	sunrise_over_mountains: {
		a: "Sunrise over Mountains",
		b: "1F304",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"view",
			"vacation",
			"photo"
		],
		k: [
			5,
			48
		]
	},
	turkey: {
		a: "Turkey",
		b: "1F983",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"bird"
		],
		k: [
			42,
			27
		],
		o: 8
	},
	white_frowning_face: {
		a: "White Frowning Face",
		b: "2639-FE0F",
		c: "2639",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			47,
			40
		],
		o: 1
	},
	"flag-cg": {
		a: "Congo - Brazzaville Flag",
		b: "1F1E8-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			21
		]
	},
	stew: {
		a: "Pot of Food",
		b: "1F372",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"meat",
			"soup"
		],
		k: [
			8,
			0
		]
	},
	sled: {
		a: "Sled",
		b: "1F6F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			22
		],
		o: 10
	},
	atom_symbol: {
		a: "Atom Symbol",
		b: "269B-FE0F",
		c: "269B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"science",
			"physics",
			"chemistry"
		],
		k: [
			48,
			18
		],
		o: 4
	},
	curling_stone: {
		a: "Curling Stone",
		b: "1F94C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			41,
			47
		],
		o: 10
	},
	slightly_frowning_face: {
		a: "Slightly Frowning Face",
		b: "1F641",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face",
			"frowning",
			"disappointed",
			"sad",
			"upset"
		],
		k: [
			31,
			37
		],
		o: 7
	},
	sunrise: {
		a: "Sunrise",
		b: "1F305",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"morning",
			"view",
			"vacation",
			"photo"
		],
		k: [
			5,
			49
		]
	},
	om_symbol: {
		a: "Om Symbol",
		b: "1F549-FE0F",
		c: "1F549",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			28,
			12
		],
		o: 7
	},
	chicken: {
		a: "Chicken",
		b: "1F414",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"cluck",
			"nature",
			"bird"
		],
		k: [
			12,
			50
		]
	},
	bowl_with_spoon: {
		a: "Bowl with Spoon",
		b: "1F963",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			15
		],
		o: 10
	},
	"flag-ch": {
		a: "Switzerland Flag",
		b: "1F1E8-1F1ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			22
		]
	},
	video_camera: {
		a: "Video Camera",
		b: "1F4F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"film",
			"record"
		],
		k: [
			26,
			48
		]
	},
	video_game: {
		a: "Video Game",
		b: "1F3AE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"play",
			"console",
			"PS4",
			"controller"
		],
		k: [
			9,
			8
		]
	},
	rooster: {
		a: "Rooster",
		b: "1F413",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"chicken"
		],
		k: [
			12,
			49
		]
	},
	vhs: {
		a: "Videocassette",
		b: "1F4FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"record",
			"video",
			"oldschool",
			"90s",
			"80s"
		],
		k: [
			26,
			51
		]
	},
	city_sunset: {
		a: "Cityscape at Dusk",
		b: "1F306",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"evening",
			"sky",
			"buildings"
		],
		k: [
			5,
			50
		]
	},
	confounded: {
		a: "Confounded Face",
		b: "1F616",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"confused",
			"sick",
			"unwell",
			"oops",
			":S"
		],
		k: [
			30,
			46
		]
	},
	green_salad: {
		a: "Green Salad",
		b: "1F957",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"healthy",
			"lettuce"
		],
		k: [
			42,
			3
		],
		o: 9
	},
	star_of_david: {
		a: "Star of David",
		b: "2721-FE0F",
		c: "2721",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"judaism"
		],
		k: [
			49,
			47
		],
		o: 1
	},
	"flag-ci": {
		a: "Côte D’ivoire Flag",
		b: "1F1E8-1F1EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			23
		]
	},
	popcorn: {
		a: "Popcorn",
		b: "1F37F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"food",
			"movie theater",
			"films",
			"snack"
		],
		k: [
			8,
			13
		],
		o: 8
	},
	city_sunrise: {
		a: "Sunset over Buildings",
		b: "1F307",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"good morning",
			"dawn"
		],
		k: [
			5,
			51
		]
	},
	disappointed: {
		a: "Disappointed Face",
		b: "1F61E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"sad",
			"upset",
			"depressed",
			":("
		],
		k: [
			31,
			2
		],
		l: [
			"):",
			":(",
			":-("
		],
		m: ":("
	},
	mag: {
		a: "Left-Pointing Magnifying Glass",
		b: "1F50D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"search",
			"zoom",
			"find",
			"detective"
		],
		k: [
			27,
			15
		]
	},
	hatching_chick: {
		a: "Hatching Chick",
		b: "1F423",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"chicken",
			"egg",
			"born",
			"baby",
			"bird"
		],
		k: [
			13,
			13
		]
	},
	joystick: {
		a: "Joystick",
		b: "1F579-FE0F",
		c: "1F579",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"game",
			"play"
		],
		k: [
			29,
			20
		],
		o: 7
	},
	wheel_of_dharma: {
		a: "Wheel of Dharma",
		b: "2638-FE0F",
		c: "2638",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"hinduism",
			"buddhism",
			"sikhism",
			"jainism"
		],
		k: [
			47,
			39
		],
		o: 1
	},
	"flag-ck": {
		a: "Cook Islands Flag",
		b: "1F1E8-1F1F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			24
		]
	},
	canned_food: {
		a: "Canned Food",
		b: "1F96B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			23
		],
		o: 10
	},
	worried: {
		a: "Worried Face",
		b: "1F61F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"concern",
			"nervous",
			":("
		],
		k: [
			31,
			3
		]
	},
	baby_chick: {
		a: "Baby Chick",
		b: "1F424",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"chicken",
			"bird"
		],
		k: [
			13,
			14
		]
	},
	"flag-cl": {
		a: "Chile Flag",
		b: "1F1E8-1F1F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			25
		]
	},
	game_die: {
		a: "Game Die",
		b: "1F3B2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"dice",
			"random",
			"tabletop",
			"play",
			"luck"
		],
		k: [
			9,
			12
		]
	},
	mag_right: {
		a: "Right-Pointing Magnifying Glass",
		b: "1F50E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"search",
			"zoom",
			"find",
			"detective"
		],
		k: [
			27,
			16
		]
	},
	yin_yang: {
		a: "Yin Yang",
		b: "262F-FE0F",
		c: "262F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"balance"
		],
		k: [
			47,
			38
		],
		o: 1
	},
	bridge_at_night: {
		a: "Bridge at Night",
		b: "1F309",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"sanfrancisco"
		],
		k: [
			6,
			1
		]
	},
	spades: {
		a: "Black Spade Suit",
		b: "2660-FE0F",
		c: "2660",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"poker",
			"cards",
			"suits",
			"magic"
		],
		k: [
			48,
			4
		],
		o: 1
	},
	hatched_chick: {
		a: "Front-Facing Baby Chick",
		b: "1F425",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"chicken",
			"baby",
			"bird"
		],
		k: [
			13,
			15
		]
	},
	"flag-cm": {
		a: "Cameroon Flag",
		b: "1F1E8-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			26
		]
	},
	latin_cross: {
		a: "Latin Cross",
		b: "271D-FE0F",
		c: "271D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"christianity"
		],
		k: [
			49,
			46
		],
		o: 1
	},
	triumph: {
		a: "Face with Look of Triumph",
		b: "1F624",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"gas",
			"phew",
			"proud",
			"pride"
		],
		k: [
			31,
			8
		]
	},
	hotsprings: {
		a: "Hot Springs",
		b: "2668-FE0F",
		c: "2668",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"bath",
			"warm",
			"relax"
		],
		k: [
			48,
			8
		],
		o: 1
	},
	bento: {
		a: "Bento Box",
		b: "1F371",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"japanese",
			"box"
		],
		k: [
			7,
			51
		]
	},
	microscope: {
		a: "Microscope",
		b: "1F52C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"laboratory",
			"experiment",
			"zoomin",
			"science",
			"study"
		],
		k: [
			27,
			46
		]
	},
	cry: {
		a: "Crying Face",
		b: "1F622",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"tears",
			"sad",
			"depressed",
			"upset",
			":'("
		],
		k: [
			31,
			6
		],
		l: [
			":'("
		],
		m: ":'("
	},
	bird: {
		a: "Bird",
		b: "1F426",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"fly",
			"tweet",
			"spring"
		],
		k: [
			13,
			16
		]
	},
	cn: {
		a: "China Flag",
		b: "1F1E8-1F1F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"china",
			"chinese",
			"prc",
			"flag",
			"country",
			"nation",
			"banner"
		],
		k: [
			1,
			27
		],
		n: [
			"flag-cn"
		]
	},
	telescope: {
		a: "Telescope",
		b: "1F52D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stars",
			"space",
			"zoom",
			"science",
			"astronomy"
		],
		k: [
			27,
			47
		]
	},
	rice_cracker: {
		a: "Rice Cracker",
		b: "1F358",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"japanese"
		],
		k: [
			7,
			26
		]
	},
	hearts: {
		a: "Black Heart Suit",
		b: "2665-FE0F",
		c: "2665",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"poker",
			"cards",
			"magic",
			"suits"
		],
		k: [
			48,
			6
		],
		o: 1
	},
	orthodox_cross: {
		a: "Orthodox Cross",
		b: "2626-FE0F",
		c: "2626",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"suppedaneum",
			"religion"
		],
		k: [
			47,
			35
		],
		o: 1
	},
	milky_way: {
		a: "Milky Way",
		b: "1F30C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"space",
			"stars"
		],
		k: [
			6,
			4
		]
	},
	rice_ball: {
		a: "Rice Ball",
		b: "1F359",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"japanese"
		],
		k: [
			7,
			27
		]
	},
	satellite_antenna: {
		a: "Satellite Antenna",
		b: "1F4E1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			26,
			24
		]
	},
	"flag-co": {
		a: "Colombia Flag",
		b: "1F1E8-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			28
		]
	},
	carousel_horse: {
		a: "Carousel Horse",
		b: "1F3A0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"carnival"
		],
		k: [
			8,
			46
		]
	},
	sob: {
		a: "Loudly Crying Face",
		b: "1F62D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"cry",
			"tears",
			"sad",
			"upset",
			"depressed"
		],
		k: [
			31,
			17
		],
		m: ":'("
	},
	diamonds: {
		a: "Black Diamond Suit",
		b: "2666-FE0F",
		c: "2666",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"poker",
			"cards",
			"magic",
			"suits"
		],
		k: [
			48,
			7
		],
		o: 1
	},
	star_and_crescent: {
		a: "Star and Crescent",
		b: "262A-FE0F",
		c: "262A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"islam"
		],
		k: [
			47,
			36
		],
		o: 1
	},
	penguin: {
		a: "Penguin",
		b: "1F427",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature"
		],
		k: [
			13,
			17
		]
	},
	dove_of_peace: {
		a: "Dove of Peace",
		b: "1F54A-FE0F",
		c: "1F54A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			28,
			13
		],
		o: 7
	},
	"flag-cp": {
		a: "Clipperton Island Flag",
		b: "1F1E8-1F1F5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			1,
			29
		]
	},
	ferris_wheel: {
		a: "Ferris Wheel",
		b: "1F3A1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"photo",
			"carnival",
			"londoneye"
		],
		k: [
			8,
			47
		]
	},
	clubs: {
		a: "Black Club Suit",
		b: "2663-FE0F",
		c: "2663",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"poker",
			"cards",
			"magic",
			"suits"
		],
		k: [
			48,
			5
		],
		o: 1
	},
	peace_symbol: {
		a: "Peace Symbol",
		b: "262E-FE0F",
		c: "262E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"hippie"
		],
		k: [
			47,
			37
		],
		o: 1
	},
	candle: {
		a: "Candle",
		b: "1F56F-FE0F",
		c: "1F56F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"fire",
			"wax"
		],
		k: [
			28,
			42
		],
		o: 7
	},
	frowning: {
		a: "Frowning Face with Open Mouth",
		b: "1F626",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"aw",
			"what"
		],
		k: [
			31,
			10
		]
	},
	rice: {
		a: "Cooked Rice",
		b: "1F35A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"china",
			"asian"
		],
		k: [
			7,
			28
		]
	},
	"flag-cr": {
		a: "Costa Rica Flag",
		b: "1F1E8-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			30
		]
	},
	roller_coaster: {
		a: "Roller Coaster",
		b: "1F3A2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"carnival",
			"playground",
			"photo",
			"fun"
		],
		k: [
			8,
			48
		]
	},
	menorah_with_nine_branches: {
		a: "Menorah with Nine Branches",
		b: "1F54E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			28,
			17
		],
		o: 8
	},
	black_joker: {
		a: "Playing Card Black Joker",
		b: "1F0CF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"poker",
			"cards",
			"game",
			"play",
			"magic"
		],
		k: [
			0,
			15
		]
	},
	eagle: {
		a: "Eagle",
		b: "1F985",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"bird"
		],
		k: [
			42,
			29
		],
		o: 9
	},
	curry: {
		a: "Curry and Rice",
		b: "1F35B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"spicy",
			"hot",
			"indian"
		],
		k: [
			7,
			29
		]
	},
	bulb: {
		a: "Electric Light Bulb",
		b: "1F4A1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"light",
			"electricity",
			"idea"
		],
		k: [
			25,
			7
		]
	},
	anguished: {
		a: "Anguished Face",
		b: "1F627",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"stunned",
			"nervous"
		],
		k: [
			31,
			11
		],
		l: [
			"D:"
		]
	},
	"flag-cu": {
		a: "Cuba Flag",
		b: "1F1E8-1F1FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			31
		]
	},
	barber: {
		a: "Barber Pole",
		b: "1F488",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"hair",
			"salon",
			"style"
		],
		k: [
			24,
			34
		]
	},
	duck: {
		a: "Duck",
		b: "1F986",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"bird",
			"mallard"
		],
		k: [
			42,
			30
		],
		o: 9
	},
	six_pointed_star: {
		a: "Six Pointed Star with Middle Dot",
		b: "1F52F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"purple-square",
			"religion",
			"jewish",
			"hexagram"
		],
		k: [
			27,
			49
		]
	},
	ramen: {
		a: "Steaming Bowl",
		b: "1F35C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"japanese",
			"noodle",
			"chopsticks"
		],
		k: [
			7,
			30
		]
	},
	flashlight: {
		a: "Electric Torch",
		b: "1F526",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"dark",
			"camping",
			"sight",
			"night"
		],
		k: [
			27,
			40
		]
	},
	mahjong: {
		a: "Mahjong Tile Red Dragon",
		b: "1F004",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"game",
			"play",
			"chinese",
			"kanji"
		],
		k: [
			0,
			14
		],
		o: 5
	},
	fearful: {
		a: "Fearful Face",
		b: "1F628",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"scared",
			"terrified",
			"nervous",
			"oops",
			"huh"
		],
		k: [
			31,
			12
		]
	},
	aries: {
		a: "Aries",
		b: "2648",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sign",
			"purple-square",
			"zodiac",
			"astrology"
		],
		k: [
			47,
			44
		],
		o: 1
	},
	spaghetti: {
		a: "Spaghetti",
		b: "1F35D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"italian",
			"noodle"
		],
		k: [
			7,
			31
		]
	},
	circus_tent: {
		a: "Circus Tent",
		b: "1F3AA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"festival",
			"carnival",
			"party"
		],
		k: [
			9,
			4
		]
	},
	izakaya_lantern: {
		a: "Izakaya Lantern",
		b: "1F3EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"light",
			"paper",
			"halloween",
			"spooky"
		],
		k: [
			12,
			11
		],
		n: [
			"lantern"
		]
	},
	"flag-cv": {
		a: "Cape Verde Flag",
		b: "1F1E8-1F1FB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			32
		]
	},
	weary: {
		a: "Weary Face",
		b: "1F629",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"tired",
			"sleepy",
			"sad",
			"frustrated",
			"upset"
		],
		k: [
			31,
			13
		]
	},
	flower_playing_cards: {
		a: "Flower Playing Cards",
		b: "1F3B4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"game",
			"sunset",
			"red"
		],
		k: [
			9,
			14
		]
	},
	owl: {
		a: "Owl",
		b: "1F989",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"bird",
			"hoot"
		],
		k: [
			42,
			33
		],
		o: 9
	},
	performing_arts: {
		a: "Performing Arts",
		b: "1F3AD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"acting",
			"theater",
			"drama"
		],
		k: [
			9,
			7
		]
	},
	frog: {
		a: "Frog Face",
		b: "1F438",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"croak",
			"toad"
		],
		k: [
			13,
			34
		]
	},
	"flag-cw": {
		a: "Curaçao Flag",
		b: "1F1E8-1F1FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			33
		]
	},
	notebook_with_decorative_cover: {
		a: "Notebook with Decorative Cover",
		b: "1F4D4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"classroom",
			"notes",
			"record",
			"paper",
			"study"
		],
		k: [
			26,
			11
		]
	},
	exploding_head: {
		a: "Shocked Face with Exploding Head",
		b: "1F92F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			39,
			3
		],
		n: [
			"shocked_face_with_exploding_head"
		],
		o: 10
	},
	taurus: {
		a: "Taurus",
		b: "2649",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"purple-square",
			"sign",
			"zodiac",
			"astrology"
		],
		k: [
			47,
			45
		],
		o: 1
	},
	sweet_potato: {
		a: "Roasted Sweet Potato",
		b: "1F360",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"nature"
		],
		k: [
			7,
			34
		]
	},
	closed_book: {
		a: "Closed Book",
		b: "1F4D5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"read",
			"library",
			"knowledge",
			"textbook",
			"learn"
		],
		k: [
			26,
			12
		]
	},
	gemini: {
		a: "Gemini",
		b: "264A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology"
		],
		k: [
			47,
			46
		],
		o: 1
	},
	frame_with_picture: {
		a: "Frame with Picture",
		b: "1F5BC-FE0F",
		c: "1F5BC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			30,
			3
		],
		o: 7
	},
	"flag-cx": {
		a: "Christmas Island Flag",
		b: "1F1E8-1F1FD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			34
		]
	},
	grimacing: {
		a: "Grimacing Face",
		b: "1F62C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"grimace",
			"teeth"
		],
		k: [
			31,
			16
		]
	},
	crocodile: {
		a: "Crocodile",
		b: "1F40A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"reptile",
			"lizard",
			"alligator"
		],
		k: [
			12,
			40
		]
	},
	oden: {
		a: "Oden",
		b: "1F362",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"japanese"
		],
		k: [
			7,
			36
		]
	},
	"flag-cy": {
		a: "Cyprus Flag",
		b: "1F1E8-1F1FE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			35
		]
	},
	book: {
		a: "Open Book",
		b: "1F4D6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			26,
			13
		],
		n: [
			"open_book"
		]
	},
	turtle: {
		a: "Turtle",
		b: "1F422",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"slow",
			"nature",
			"tortoise"
		],
		k: [
			13,
			12
		]
	},
	art: {
		a: "Artist Palette",
		b: "1F3A8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"design",
			"paint",
			"draw",
			"colors"
		],
		k: [
			9,
			2
		]
	},
	sushi: {
		a: "Sushi",
		b: "1F363",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"fish",
			"japanese",
			"rice"
		],
		k: [
			7,
			37
		]
	},
	cold_sweat: {
		a: "Face with Open Mouth and Cold Sweat",
		b: "1F630",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"nervous",
			"sweat"
		],
		k: [
			31,
			20
		]
	},
	cancer: {
		a: "Cancer",
		b: "264B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology"
		],
		k: [
			47,
			47
		],
		o: 1
	},
	fried_shrimp: {
		a: "Fried Shrimp",
		b: "1F364",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"animal",
			"appetizer",
			"summer"
		],
		k: [
			7,
			38
		]
	},
	slot_machine: {
		a: "Slot Machine",
		b: "1F3B0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"bet",
			"gamble",
			"vegas",
			"fruit machine",
			"luck",
			"casino"
		],
		k: [
			9,
			10
		]
	},
	scream: {
		a: "Face Screaming in Fear",
		b: "1F631",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"munch",
			"scared",
			"omg"
		],
		k: [
			31,
			21
		]
	},
	green_book: {
		a: "Green Book",
		b: "1F4D7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"read",
			"library",
			"knowledge",
			"study"
		],
		k: [
			26,
			14
		]
	},
	leo: {
		a: "Leo",
		b: "264C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sign",
			"purple-square",
			"zodiac",
			"astrology"
		],
		k: [
			47,
			48
		],
		o: 1
	},
	"flag-cz": {
		a: "Czechia Flag",
		b: "1F1E8-1F1FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			36
		]
	},
	lizard: {
		a: "Lizard",
		b: "1F98E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"reptile"
		],
		k: [
			42,
			38
		],
		o: 9
	},
	virgo: {
		a: "Virgo",
		b: "264D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology"
		],
		k: [
			47,
			49
		],
		o: 1
	},
	steam_locomotive: {
		a: "Steam Locomotive",
		b: "1F682",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle",
			"train"
		],
		k: [
			34,
			10
		]
	},
	de: {
		a: "Germany Flag",
		b: "1F1E9-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"german",
			"nation",
			"flag",
			"country",
			"banner"
		],
		k: [
			1,
			37
		],
		n: [
			"flag-de"
		]
	},
	flushed: {
		a: "Flushed Face",
		b: "1F633",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"blush",
			"shy",
			"flattered"
		],
		k: [
			31,
			23
		]
	},
	blue_book: {
		a: "Blue Book",
		b: "1F4D8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"read",
			"library",
			"knowledge",
			"learn",
			"study"
		],
		k: [
			26,
			15
		]
	},
	snake: {
		a: "Snake",
		b: "1F40D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"evil",
			"nature",
			"hiss",
			"python"
		],
		k: [
			12,
			43
		]
	},
	fish_cake: {
		a: "Fish Cake with Swirl Design",
		b: "1F365",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"japan",
			"sea",
			"beach",
			"narutomaki",
			"pink",
			"swirl",
			"kamaboko",
			"surimi",
			"ramen"
		],
		k: [
			7,
			39
		]
	},
	railway_car: {
		a: "Railway Car",
		b: "1F683",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			11
		]
	},
	dango: {
		a: "Dango",
		b: "1F361",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"dessert",
			"sweet",
			"japanese",
			"barbecue",
			"meat"
		],
		k: [
			7,
			35
		]
	},
	orange_book: {
		a: "Orange Book",
		b: "1F4D9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"read",
			"library",
			"knowledge",
			"textbook",
			"study"
		],
		k: [
			26,
			16
		]
	},
	libra: {
		a: "Libra",
		b: "264E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sign",
			"purple-square",
			"zodiac",
			"astrology"
		],
		k: [
			47,
			50
		],
		o: 1
	},
	dragon_face: {
		a: "Dragon Face",
		b: "1F432",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"myth",
			"nature",
			"chinese",
			"green"
		],
		k: [
			13,
			28
		]
	},
	"flag-dg": {
		a: "Diego Garcia Flag",
		b: "1F1E9-1F1EC",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			38
		]
	},
	zany_face: {
		a: "Grinning Face with One Large and One Small Eye",
		b: "1F92A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			38,
			50
		],
		n: [
			"grinning_face_with_one_large_and_one_small_eye"
		],
		o: 10
	},
	books: {
		a: "Books",
		b: "1F4DA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"literature",
			"library",
			"study"
		],
		k: [
			26,
			17
		]
	},
	dragon: {
		a: "Dragon",
		b: "1F409",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"myth",
			"nature",
			"chinese",
			"green"
		],
		k: [
			12,
			39
		]
	},
	"flag-dj": {
		a: "Djibouti Flag",
		b: "1F1E9-1F1EF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			39
		]
	},
	dumpling: {
		a: "Dumpling",
		b: "1F95F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			11
		],
		o: 10
	},
	dizzy_face: {
		a: "Dizzy Face",
		b: "1F635",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"spent",
			"unconscious",
			"xox",
			"dizzy"
		],
		k: [
			31,
			25
		]
	},
	scorpius: {
		a: "Scorpius",
		b: "264F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology",
			"scorpio"
		],
		k: [
			47,
			51
		],
		o: 1
	},
	bullettrain_side: {
		a: "High-Speed Train",
		b: "1F684",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			12
		]
	},
	bullettrain_front: {
		a: "High-Speed Train with Bullet Nose",
		b: "1F685",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle",
			"speed",
			"fast",
			"public",
			"travel"
		],
		k: [
			34,
			13
		]
	},
	notebook: {
		a: "Notebook",
		b: "1F4D3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stationery",
			"record",
			"notes",
			"paper",
			"study"
		],
		k: [
			26,
			10
		]
	},
	fortune_cookie: {
		a: "Fortune Cookie",
		b: "1F960",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			12
		],
		o: 10
	},
	sagittarius: {
		a: "Sagittarius",
		b: "2650",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology"
		],
		k: [
			48,
			0
		],
		o: 1
	},
	sauropod: {
		a: "Sauropod",
		b: "1F995",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			45
		],
		o: 10
	},
	"flag-dk": {
		a: "Denmark Flag",
		b: "1F1E9-1F1F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			40
		]
	},
	rage: {
		a: "Pouting Face",
		b: "1F621",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"angry",
			"mad",
			"hate",
			"despise"
		],
		k: [
			31,
			5
		]
	},
	ledger: {
		a: "Ledger",
		b: "1F4D2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"notes",
			"paper"
		],
		k: [
			26,
			9
		]
	},
	angry: {
		a: "Angry Face",
		b: "1F620",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"mad",
			"face",
			"annoyed",
			"frustrated"
		],
		k: [
			31,
			4
		],
		l: [
			">:(",
			">:-("
		]
	},
	"t-rex": {
		a: "T-Rex",
		b: "1F996",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			46
		],
		o: 10
	},
	capricorn: {
		a: "Capricorn",
		b: "2651",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sign",
			"zodiac",
			"purple-square",
			"astrology"
		],
		k: [
			48,
			1
		],
		o: 1
	},
	takeout_box: {
		a: "Takeout Box",
		b: "1F961",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			13
		],
		o: 10
	},
	"flag-dm": {
		a: "Dominica Flag",
		b: "1F1E9-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			41
		]
	},
	train2: {
		a: "Train",
		b: "1F686",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			14
		]
	},
	page_with_curl: {
		a: "Page with Curl",
		b: "1F4C3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"documents",
			"office",
			"paper"
		],
		k: [
			25,
			46
		]
	},
	whale: {
		a: "Spouting Whale",
		b: "1F433",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"sea",
			"ocean"
		],
		k: [
			13,
			29
		]
	},
	face_with_symbols_on_mouth: {
		a: "Serious Face with Symbols Covering Mouth",
		b: "1F92C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			39,
			0
		],
		n: [
			"serious_face_with_symbols_covering_mouth"
		],
		o: 10
	},
	"flag-do": {
		a: "Dominican Republic Flag",
		b: "1F1E9-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			42
		]
	},
	metro: {
		a: "Metro",
		b: "1F687",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"blue-square",
			"mrt",
			"underground",
			"tube"
		],
		k: [
			34,
			15
		]
	},
	icecream: {
		a: "Soft Ice Cream",
		b: "1F366",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"hot",
			"dessert",
			"summer"
		],
		k: [
			7,
			40
		]
	},
	aquarius: {
		a: "Aquarius",
		b: "2652",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sign",
			"purple-square",
			"zodiac",
			"astrology"
		],
		k: [
			48,
			2
		],
		o: 1
	},
	"flag-dz": {
		a: "Algeria Flag",
		b: "1F1E9-1F1FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			43
		]
	},
	whale2: {
		a: "Whale",
		b: "1F40B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"sea",
			"ocean"
		],
		k: [
			12,
			41
		]
	},
	mask: {
		a: "Face with Medical Mask",
		b: "1F637",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"sick",
			"ill",
			"disease"
		],
		k: [
			31,
			27
		]
	},
	scroll: {
		a: "Scroll",
		b: "1F4DC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"documents",
			"ancient",
			"history",
			"paper"
		],
		k: [
			26,
			19
		]
	},
	shaved_ice: {
		a: "Shaved Ice",
		b: "1F367",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"hot",
			"dessert",
			"summer"
		],
		k: [
			7,
			41
		]
	},
	pisces: {
		a: "Pisces",
		b: "2653",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"purple-square",
			"sign",
			"zodiac",
			"astrology"
		],
		k: [
			48,
			3
		],
		o: 1
	},
	light_rail: {
		a: "Light Rail",
		b: "1F688",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			16
		]
	},
	dolphin: {
		a: "Dolphin",
		b: "1F42C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"fish",
			"sea",
			"ocean",
			"flipper",
			"fins",
			"beach"
		],
		k: [
			13,
			22
		],
		n: [
			"flipper"
		]
	},
	face_with_thermometer: {
		a: "Face with Thermometer",
		b: "1F912",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sick",
			"temperature",
			"thermometer",
			"cold",
			"fever"
		],
		k: [
			37,
			26
		],
		o: 8
	},
	"flag-ea": {
		a: "Ceuta & Melilla Flag",
		b: "1F1EA-1F1E6",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			44
		]
	},
	ophiuchus: {
		a: "Ophiuchus",
		b: "26CE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sign",
			"purple-square",
			"constellation",
			"astrology"
		],
		k: [
			48,
			31
		]
	},
	station: {
		a: "Station",
		b: "1F689",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle",
			"public"
		],
		k: [
			34,
			17
		]
	},
	ice_cream: {
		a: "Ice Cream",
		b: "1F368",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"hot",
			"dessert"
		],
		k: [
			7,
			42
		]
	},
	page_facing_up: {
		a: "Page Facing Up",
		b: "1F4C4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"documents",
			"office",
			"paper",
			"information"
		],
		k: [
			25,
			47
		]
	},
	doughnut: {
		a: "Doughnut",
		b: "1F369",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"dessert",
			"snack",
			"sweet",
			"donut"
		],
		k: [
			7,
			43
		]
	},
	face_with_head_bandage: {
		a: "Face with Head-Bandage",
		b: "1F915",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"injured",
			"clumsy",
			"bandage",
			"hurt"
		],
		k: [
			37,
			29
		],
		o: 8
	},
	fish: {
		a: "Fish",
		b: "1F41F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"food",
			"nature"
		],
		k: [
			13,
			9
		]
	},
	newspaper: {
		a: "Newspaper",
		b: "1F4F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"press",
			"headline"
		],
		k: [
			26,
			39
		]
	},
	tram: {
		a: "Tram",
		b: "1F68A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			18
		]
	},
	"flag-ec": {
		a: "Ecuador Flag",
		b: "1F1EA-1F1E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			45
		]
	},
	twisted_rightwards_arrows: {
		a: "Twisted Rightwards Arrows",
		b: "1F500",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"shuffle",
			"music",
			"random"
		],
		k: [
			27,
			2
		]
	},
	"flag-ee": {
		a: "Estonia Flag",
		b: "1F1EA-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			46
		]
	},
	cookie: {
		a: "Cookie",
		b: "1F36A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"snack",
			"oreo",
			"chocolate",
			"sweet",
			"dessert"
		],
		k: [
			7,
			44
		]
	},
	monorail: {
		a: "Monorail",
		b: "1F69D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			37
		]
	},
	tropical_fish: {
		a: "Tropical Fish",
		b: "1F420",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"swim",
			"ocean",
			"beach",
			"nemo"
		],
		k: [
			13,
			10
		]
	},
	rolled_up_newspaper: {
		a: "Rolled Up Newspaper",
		b: "1F5DE-FE0F",
		c: "1F5DE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			30,
			12
		],
		o: 7
	},
	nauseated_face: {
		a: "Nauseated Face",
		b: "1F922",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face",
			"vomit",
			"gross",
			"green",
			"sick",
			"throw up",
			"ill"
		],
		k: [
			38,
			25
		],
		o: 9
	},
	repeat: {
		a: "Clockwise Rightwards and Leftwards Open Circle Arrows",
		b: "1F501",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"loop",
			"record"
		],
		k: [
			27,
			3
		]
	},
	bookmark_tabs: {
		a: "Bookmark Tabs",
		b: "1F4D1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"favorite",
			"save",
			"order",
			"tidy"
		],
		k: [
			26,
			8
		]
	},
	repeat_one: {
		a: "Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay",
		b: "1F502",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"loop"
		],
		k: [
			27,
			4
		]
	},
	"flag-eg": {
		a: "Egypt Flag",
		b: "1F1EA-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			47
		]
	},
	mountain_railway: {
		a: "Mountain Railway",
		b: "1F69E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			38
		]
	},
	birthday: {
		a: "Birthday Cake",
		b: "1F382",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"dessert",
			"cake"
		],
		k: [
			8,
			16
		]
	},
	blowfish: {
		a: "Blowfish",
		b: "1F421",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"nature",
			"food",
			"sea",
			"ocean"
		],
		k: [
			13,
			11
		]
	},
	face_vomiting: {
		a: "Face with Open Mouth Vomiting",
		b: "1F92E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			39,
			2
		],
		n: [
			"face_with_open_mouth_vomiting"
		],
		o: 10
	},
	arrow_forward: {
		a: "Black Right-Pointing Triangle",
		b: "25B6-FE0F",
		c: "25B6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"right",
			"direction",
			"play"
		],
		k: [
			47,
			10
		],
		o: 1
	},
	bookmark: {
		a: "Bookmark",
		b: "1F516",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"favorite",
			"label",
			"save"
		],
		k: [
			27,
			24
		]
	},
	"flag-eh": {
		a: "Western Sahara Flag",
		b: "1F1EA-1F1ED",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			48
		]
	},
	shark: {
		a: "Shark",
		b: "1F988",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"fish",
			"sea",
			"ocean",
			"jaws",
			"fins",
			"beach"
		],
		k: [
			42,
			32
		],
		o: 9
	},
	train: {
		a: "Tram Car",
		b: "1F68B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle",
			"carriage",
			"public",
			"travel"
		],
		k: [
			34,
			19
		]
	},
	sneezing_face: {
		a: "Sneezing Face",
		b: "1F927",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face",
			"gesundheit",
			"sneeze",
			"sick",
			"allergy"
		],
		k: [
			38,
			47
		],
		o: 9
	},
	cake: {
		a: "Shortcake",
		b: "1F370",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"dessert"
		],
		k: [
			7,
			50
		]
	},
	bus: {
		a: "Bus",
		b: "1F68C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"car",
			"vehicle",
			"transportation"
		],
		k: [
			34,
			20
		]
	},
	pie: {
		a: "Pie",
		b: "1F967",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			19
		],
		o: 10
	},
	innocent: {
		a: "Smiling Face with Halo",
		b: "1F607",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"angel",
			"heaven",
			"halo"
		],
		k: [
			30,
			31
		]
	},
	fast_forward: {
		a: "Black Right-Pointing Double Triangle",
		b: "23E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"play",
			"speed",
			"continue"
		],
		k: [
			46,
			45
		]
	},
	label: {
		a: "Label",
		b: "1F3F7-FE0F",
		c: "1F3F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sale",
			"tag"
		],
		k: [
			12,
			21
		],
		o: 7
	},
	octopus: {
		a: "Octopus",
		b: "1F419",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"creature",
			"ocean",
			"sea",
			"nature",
			"beach"
		],
		k: [
			13,
			3
		]
	},
	"flag-er": {
		a: "Eritrea Flag",
		b: "1F1EA-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			49
		]
	},
	black_right_pointing_double_triangle_with_vertical_bar: {
		a: "Black Right Pointing Double Triangle with Vertical Bar",
		b: "23ED-FE0F",
		c: "23ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			49
		]
	},
	chocolate_bar: {
		a: "Chocolate Bar",
		b: "1F36B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"snack",
			"dessert",
			"sweet"
		],
		k: [
			7,
			45
		]
	},
	oncoming_bus: {
		a: "Oncoming Bus",
		b: "1F68D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vehicle",
			"transportation"
		],
		k: [
			34,
			21
		]
	},
	shell: {
		a: "Spiral Shell",
		b: "1F41A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"sea",
			"beach"
		],
		k: [
			13,
			4
		]
	},
	face_with_cowboy_hat: {
		a: "Face with Cowboy Hat",
		b: "1F920",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			38,
			23
		],
		o: 9
	},
	moneybag: {
		a: "Money Bag",
		b: "1F4B0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"dollar",
			"payment",
			"coins",
			"sale"
		],
		k: [
			25,
			27
		]
	},
	es: {
		a: "Spain Flag",
		b: "1F1EA-1F1F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"spain",
			"flag",
			"nation",
			"country",
			"banner"
		],
		k: [
			1,
			50
		],
		n: [
			"flag-es"
		]
	},
	crab: {
		a: "Crab",
		b: "1F980",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"crustacean"
		],
		k: [
			42,
			24
		],
		o: 8
	},
	yen: {
		a: "Banknote with Yen Sign",
		b: "1F4B4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"money",
			"sales",
			"japanese",
			"dollar",
			"currency"
		],
		k: [
			25,
			31
		]
	},
	"flag-et": {
		a: "Ethiopia Flag",
		b: "1F1EA-1F1F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			1,
			51
		]
	},
	clown_face: {
		a: "Clown Face",
		b: "1F921",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face"
		],
		k: [
			38,
			24
		],
		o: 9
	},
	black_right_pointing_triangle_with_double_vertical_bar: {
		a: "Black Right Pointing Triangle with Double Vertical Bar",
		b: "23EF-FE0F",
		c: "23EF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			51
		]
	},
	trolleybus: {
		a: "Trolleybus",
		b: "1F68E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"bart",
			"transportation",
			"vehicle"
		],
		k: [
			34,
			22
		]
	},
	candy: {
		a: "Candy",
		b: "1F36C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"snack",
			"dessert",
			"sweet",
			"lolly"
		],
		k: [
			7,
			46
		]
	},
	lying_face: {
		a: "Lying Face",
		b: "1F925",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face",
			"lie",
			"pinocchio"
		],
		k: [
			38,
			28
		],
		o: 9
	},
	arrow_backward: {
		a: "Black Left-Pointing Triangle",
		b: "25C0-FE0F",
		c: "25C0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"left",
			"direction"
		],
		k: [
			47,
			11
		],
		o: 1
	},
	dollar: {
		a: "Banknote with Dollar Sign",
		b: "1F4B5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"money",
			"sales",
			"bill",
			"currency"
		],
		k: [
			25,
			32
		]
	},
	shrimp: {
		a: "Shrimp",
		b: "1F990",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"ocean",
			"nature",
			"seafood"
		],
		k: [
			42,
			40
		],
		o: 9
	},
	minibus: {
		a: "Minibus",
		b: "1F690",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vehicle",
			"car",
			"transportation"
		],
		k: [
			34,
			24
		]
	},
	"flag-eu": {
		a: "European Union Flag",
		b: "1F1EA-1F1FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			0
		]
	},
	lollipop: {
		a: "Lollipop",
		b: "1F36D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"snack",
			"candy",
			"sweet"
		],
		k: [
			7,
			47
		]
	},
	squid: {
		a: "Squid",
		b: "1F991",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"nature",
			"ocean",
			"sea"
		],
		k: [
			42,
			41
		],
		o: 9
	},
	euro: {
		a: "Banknote with Euro Sign",
		b: "1F4B6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"money",
			"sales",
			"dollar",
			"currency"
		],
		k: [
			25,
			33
		]
	},
	"flag-fi": {
		a: "Finland Flag",
		b: "1F1EB-1F1EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			1
		]
	},
	ambulance: {
		a: "Ambulance",
		b: "1F691",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"health",
			"911",
			"hospital"
		],
		k: [
			34,
			25
		]
	},
	custard: {
		a: "Custard",
		b: "1F36E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"dessert",
			"food"
		],
		k: [
			7,
			48
		]
	},
	shushing_face: {
		a: "Face with Finger Covering Closed Lips",
		b: "1F92B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			38,
			51
		],
		n: [
			"face_with_finger_covering_closed_lips"
		],
		o: 10
	},
	rewind: {
		a: "Black Left-Pointing Double Triangle",
		b: "23EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"play",
			"blue-square"
		],
		k: [
			46,
			46
		]
	},
	black_left_pointing_double_triangle_with_vertical_bar: {
		a: "Black Left Pointing Double Triangle with Vertical Bar",
		b: "23EE-FE0F",
		c: "23EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			50
		]
	},
	face_with_hand_over_mouth: {
		a: "Smiling Face with Smiling Eyes and Hand Covering Mouth",
		b: "1F92D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			39,
			1
		],
		n: [
			"smiling_face_with_smiling_eyes_and_hand_covering_mouth"
		],
		o: 10
	},
	"flag-fj": {
		a: "Fiji Flag",
		b: "1F1EB-1F1EF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			2
		]
	},
	honey_pot: {
		a: "Honey Pot",
		b: "1F36F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"bees",
			"sweet",
			"kitchen"
		],
		k: [
			7,
			49
		]
	},
	snail: {
		a: "Snail",
		b: "1F40C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"slow",
			"animal",
			"shell"
		],
		k: [
			12,
			42
		]
	},
	pound: {
		a: "Banknote with Pound Sign",
		b: "1F4B7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"british",
			"sterling",
			"money",
			"sales",
			"bills",
			"uk",
			"england",
			"currency"
		],
		k: [
			25,
			34
		]
	},
	fire_engine: {
		a: "Fire Engine",
		b: "1F692",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"cars",
			"vehicle"
		],
		k: [
			34,
			26
		]
	},
	baby_bottle: {
		a: "Baby Bottle",
		b: "1F37C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"food",
			"container",
			"milk"
		],
		k: [
			8,
			10
		]
	},
	"flag-fk": {
		a: "Falkland Islands Flag",
		b: "1F1EB-1F1F0",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			3
		]
	},
	butterfly: {
		a: "Butterfly",
		b: "1F98B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"insect",
			"nature",
			"caterpillar"
		],
		k: [
			42,
			35
		],
		o: 9
	},
	money_with_wings: {
		a: "Money with Wings",
		b: "1F4B8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"dollar",
			"bills",
			"payment",
			"sale"
		],
		k: [
			25,
			35
		]
	},
	face_with_monocle: {
		a: "Face with Monocle",
		b: "1F9D0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			49
		],
		o: 10
	},
	police_car: {
		a: "Police Car",
		b: "1F693",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vehicle",
			"cars",
			"transportation",
			"law",
			"legal",
			"enforcement"
		],
		k: [
			34,
			27
		]
	},
	arrow_up_small: {
		a: "Up-Pointing Small Red Triangle",
		b: "1F53C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"triangle",
			"direction",
			"point",
			"forward",
			"top"
		],
		k: [
			28,
			10
		]
	},
	"flag-fm": {
		a: "Micronesia Flag",
		b: "1F1EB-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			4
		]
	},
	glass_of_milk: {
		a: "Glass of Milk",
		b: "1F95B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			7
		],
		o: 9
	},
	credit_card: {
		a: "Credit Card",
		b: "1F4B3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"money",
			"sales",
			"dollar",
			"bill",
			"payment",
			"shopping"
		],
		k: [
			25,
			30
		]
	},
	oncoming_police_car: {
		a: "Oncoming Police Car",
		b: "1F694",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vehicle",
			"law",
			"legal",
			"enforcement",
			"911"
		],
		k: [
			34,
			28
		]
	},
	bug: {
		a: "Bug",
		b: "1F41B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"insect",
			"nature",
			"worm"
		],
		k: [
			13,
			5
		]
	},
	nerd_face: {
		a: "Nerd Face",
		b: "1F913",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face",
			"nerdy",
			"geek",
			"dork"
		],
		k: [
			37,
			27
		],
		o: 8
	},
	arrow_double_up: {
		a: "Black Up-Pointing Double Triangle",
		b: "23EB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"direction",
			"top"
		],
		k: [
			46,
			47
		]
	},
	chart: {
		a: "Chart with Upwards Trend and Yen Sign",
		b: "1F4B9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"green-square",
			"graph",
			"presentation",
			"stats"
		],
		k: [
			25,
			36
		]
	},
	"flag-fo": {
		a: "Faroe Islands Flag",
		b: "1F1EB-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			5
		]
	},
	ant: {
		a: "Ant",
		b: "1F41C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"insect",
			"nature",
			"bug"
		],
		k: [
			13,
			6
		]
	},
	arrow_down_small: {
		a: "Down-Pointing Small Red Triangle",
		b: "1F53D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"direction",
			"bottom"
		],
		k: [
			28,
			11
		]
	},
	smiling_imp: {
		a: "Smiling Face with Horns",
		b: "1F608",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"devil",
			"horns"
		],
		k: [
			30,
			32
		]
	},
	taxi: {
		a: "Taxi",
		b: "1F695",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"uber",
			"vehicle",
			"cars",
			"transportation"
		],
		k: [
			34,
			29
		]
	},
	coffee: {
		a: "Hot Beverage",
		b: "2615",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"beverage",
			"caffeine",
			"latte",
			"espresso"
		],
		k: [
			47,
			24
		],
		o: 4
	},
	fr: {
		a: "France Flag",
		b: "1F1EB-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"banner",
			"flag",
			"nation",
			"france",
			"french",
			"country"
		],
		k: [
			2,
			6
		],
		n: [
			"flag-fr"
		]
	},
	oncoming_taxi: {
		a: "Oncoming Taxi",
		b: "1F696",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vehicle",
			"cars",
			"uber"
		],
		k: [
			34,
			30
		]
	},
	arrow_double_down: {
		a: "Black Down-Pointing Double Triangle",
		b: "23EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"direction",
			"bottom"
		],
		k: [
			46,
			48
		]
	},
	imp: {
		a: "Imp",
		b: "1F47F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"devil",
			"angry",
			"horns"
		],
		k: [
			22,
			51
		]
	},
	currency_exchange: {
		a: "Currency Exchange",
		b: "1F4B1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"money",
			"sales",
			"dollar",
			"travel"
		],
		k: [
			25,
			28
		]
	},
	tea: {
		a: "Teacup Without Handle",
		b: "1F375",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"drink",
			"bowl",
			"breakfast",
			"green",
			"british"
		],
		k: [
			8,
			3
		]
	},
	bee: {
		a: "Honeybee",
		b: "1F41D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			13,
			7
		],
		n: [
			"honeybee"
		]
	},
	heavy_dollar_sign: {
		a: "Heavy Dollar Sign",
		b: "1F4B2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"money",
			"sales",
			"payment",
			"currency",
			"buck"
		],
		k: [
			25,
			29
		]
	},
	car: {
		a: "Automobile",
		b: "1F697",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			34,
			31
		],
		n: [
			"red_car"
		]
	},
	sake: {
		a: "Sake Bottle and Cup",
		b: "1F376",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"wine",
			"drink",
			"drunk",
			"beverage",
			"japanese",
			"alcohol",
			"booze"
		],
		k: [
			8,
			4
		]
	},
	"flag-ga": {
		a: "Gabon Flag",
		b: "1F1EC-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			7
		]
	},
	beetle: {
		a: "Lady Beetle",
		b: "1F41E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"insect",
			"nature",
			"ladybug"
		],
		k: [
			13,
			8
		]
	},
	japanese_ogre: {
		a: "Japanese Ogre",
		b: "1F479",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"monster",
			"red",
			"mask",
			"halloween",
			"scary",
			"creepy",
			"devil",
			"demon",
			"japanese",
			"ogre"
		],
		k: [
			22,
			40
		]
	},
	double_vertical_bar: {
		a: "Double Vertical Bar",
		b: "23F8-FE0F",
		c: "23F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			47,
			4
		],
		o: 7
	},
	champagne: {
		a: "Bottle with Popping Cork",
		b: "1F37E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"drink",
			"wine",
			"bottle",
			"celebration"
		],
		k: [
			8,
			12
		],
		o: 8
	},
	japanese_goblin: {
		a: "Japanese Goblin",
		b: "1F47A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"red",
			"evil",
			"mask",
			"monster",
			"scary",
			"creepy",
			"japanese",
			"goblin"
		],
		k: [
			22,
			41
		]
	},
	black_square_for_stop: {
		a: "Black Square for Stop",
		b: "23F9-FE0F",
		c: "23F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			47,
			5
		],
		o: 7
	},
	oncoming_automobile: {
		a: "Oncoming Automobile",
		b: "1F698",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"car",
			"vehicle",
			"transportation"
		],
		k: [
			34,
			32
		]
	},
	email: {
		a: "Envelope",
		b: "2709-FE0F",
		c: "2709",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"letter",
			"postal",
			"inbox",
			"communication"
		],
		k: [
			49,
			17
		],
		n: [
			"envelope"
		],
		o: 1
	},
	cricket: {
		a: "Cricket",
		b: "1F997",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sports"
		],
		k: [
			42,
			47
		],
		o: 10
	},
	gb: {
		a: "United Kingdom Flag",
		b: "1F1EC-1F1E7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			8
		],
		n: [
			"uk",
			"flag-gb"
		]
	},
	black_circle_for_record: {
		a: "Black Circle for Record",
		b: "23FA-FE0F",
		c: "23FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			47,
			6
		],
		o: 7
	},
	"flag-gd": {
		a: "Grenada Flag",
		b: "1F1EC-1F1E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			9
		]
	},
	spider: {
		a: "Spider",
		b: "1F577-FE0F",
		c: "1F577",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"arachnid"
		],
		k: [
			29,
			18
		],
		o: 7
	},
	blue_car: {
		a: "Recreational Vehicle",
		b: "1F699",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle"
		],
		k: [
			34,
			33
		]
	},
	skull: {
		a: "Skull",
		b: "1F480",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"dead",
			"skeleton",
			"creepy",
			"death"
		],
		k: [
			23,
			0
		]
	},
	"e-mail": {
		a: "E-Mail Symbol",
		b: "1F4E7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"communication",
			"inbox"
		],
		k: [
			26,
			30
		]
	},
	wine_glass: {
		a: "Wine Glass",
		b: "1F377",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"drink",
			"beverage",
			"drunk",
			"alcohol",
			"booze"
		],
		k: [
			8,
			5
		]
	},
	spider_web: {
		a: "Spider Web",
		b: "1F578-FE0F",
		c: "1F578",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"insect",
			"arachnid",
			"silk"
		],
		k: [
			29,
			19
		],
		o: 7
	},
	cocktail: {
		a: "Cocktail Glass",
		b: "1F378",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"drink",
			"drunk",
			"alcohol",
			"beverage",
			"booze",
			"mojito"
		],
		k: [
			8,
			6
		]
	},
	skull_and_crossbones: {
		a: "Skull and Crossbones",
		b: "2620-FE0F",
		c: "2620",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"poison",
			"danger",
			"deadly",
			"scary",
			"death",
			"pirate",
			"evil"
		],
		k: [
			47,
			32
		],
		o: 1
	},
	"flag-ge": {
		a: "Georgia Flag",
		b: "1F1EC-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			10
		]
	},
	eject: {
		a: "Eject",
		b: "23CF-FE0F",
		c: "23CF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			44
		],
		o: 4
	},
	truck: {
		a: "Delivery Truck",
		b: "1F69A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"cars",
			"transportation"
		],
		k: [
			34,
			34
		]
	},
	incoming_envelope: {
		a: "Incoming Envelope",
		b: "1F4E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"email",
			"inbox"
		],
		k: [
			26,
			31
		]
	},
	tropical_drink: {
		a: "Tropical Drink",
		b: "1F379",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"beverage",
			"cocktail",
			"summer",
			"beach",
			"alcohol",
			"booze",
			"mojito"
		],
		k: [
			8,
			7
		]
	},
	scorpion: {
		a: "Scorpion",
		b: "1F982",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"animal",
			"arachnid"
		],
		k: [
			42,
			26
		],
		o: 8
	},
	cinema: {
		a: "Cinema",
		b: "1F3A6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"record",
			"film",
			"movie",
			"curtain",
			"stage",
			"theater"
		],
		k: [
			9,
			0
		]
	},
	articulated_lorry: {
		a: "Articulated Lorry",
		b: "1F69B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vehicle",
			"cars",
			"transportation",
			"express"
		],
		k: [
			34,
			35
		]
	},
	envelope_with_arrow: {
		a: "Envelope with Downwards Arrow Above",
		b: "1F4E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"email",
			"communication"
		],
		k: [
			26,
			32
		]
	},
	ghost: {
		a: "Ghost",
		b: "1F47B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"halloween",
			"spooky",
			"scary"
		],
		k: [
			22,
			42
		]
	},
	"flag-gf": {
		a: "French Guiana Flag",
		b: "1F1EC-1F1EB",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			11
		]
	},
	bouquet: {
		a: "Bouquet",
		b: "1F490",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"flowers",
			"nature",
			"spring"
		],
		k: [
			24,
			42
		]
	},
	tractor: {
		a: "Tractor",
		b: "1F69C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vehicle",
			"car",
			"farming",
			"agriculture"
		],
		k: [
			34,
			36
		]
	},
	beer: {
		a: "Beer Mug",
		b: "1F37A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"relax",
			"beverage",
			"drink",
			"drunk",
			"party",
			"pub",
			"summer",
			"alcohol",
			"booze"
		],
		k: [
			8,
			8
		]
	},
	outbox_tray: {
		a: "Outbox Tray",
		b: "1F4E4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"inbox",
			"email"
		],
		k: [
			26,
			27
		]
	},
	low_brightness: {
		a: "Low Brightness Symbol",
		b: "1F505",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sun",
			"afternoon",
			"warm",
			"summer"
		],
		k: [
			27,
			7
		]
	},
	alien: {
		a: "Extraterrestrial Alien",
		b: "1F47D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"UFO",
			"paul",
			"weird",
			"outer_space"
		],
		k: [
			22,
			49
		]
	},
	"flag-gg": {
		a: "Guernsey Flag",
		b: "1F1EC-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			12
		]
	},
	cherry_blossom: {
		a: "Cherry Blossom",
		b: "1F338",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"plant",
			"spring",
			"flower"
		],
		k: [
			6,
			46
		]
	},
	inbox_tray: {
		a: "Inbox Tray",
		b: "1F4E5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"email",
			"documents"
		],
		k: [
			26,
			28
		]
	},
	"flag-gh": {
		a: "Ghana Flag",
		b: "1F1EC-1F1ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			13
		]
	},
	bike: {
		a: "Bicycle",
		b: "1F6B2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sports",
			"bicycle",
			"exercise",
			"hipster"
		],
		k: [
			35,
			23
		]
	},
	space_invader: {
		a: "Alien Monster",
		b: "1F47E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"game",
			"arcade",
			"play"
		],
		k: [
			22,
			50
		]
	},
	beers: {
		a: "Clinking Beer Mugs",
		b: "1F37B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"relax",
			"beverage",
			"drink",
			"drunk",
			"party",
			"pub",
			"summer",
			"alcohol",
			"booze"
		],
		k: [
			8,
			9
		]
	},
	high_brightness: {
		a: "High Brightness Symbol",
		b: "1F506",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sun",
			"light"
		],
		k: [
			27,
			8
		]
	},
	"package": {
		a: "Package",
		b: "1F4E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"mail",
			"gift",
			"cardboard",
			"box",
			"moving"
		],
		k: [
			26,
			29
		]
	},
	scooter: {
		a: "Scooter",
		b: "1F6F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			19
		],
		o: 9
	},
	white_flower: {
		a: "White Flower",
		b: "1F4AE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"japanese",
			"spring"
		],
		k: [
			25,
			25
		]
	},
	clinking_glasses: {
		a: "Clinking Glasses",
		b: "1F942",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"beverage",
			"drink",
			"party",
			"alcohol",
			"celebrate",
			"cheers"
		],
		k: [
			41,
			38
		],
		o: 9
	},
	robot_face: {
		a: "Robot Face",
		b: "1F916",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			30
		],
		o: 8
	},
	signal_strength: {
		a: "Antenna with Bars",
		b: "1F4F6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"reception",
			"phone",
			"internet",
			"connection",
			"wifi",
			"bluetooth",
			"bars"
		],
		k: [
			26,
			45
		]
	},
	"flag-gi": {
		a: "Gibraltar Flag",
		b: "1F1EC-1F1EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			14
		]
	},
	"flag-gl": {
		a: "Greenland Flag",
		b: "1F1EC-1F1F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			15
		]
	},
	motor_scooter: {
		a: "Motor Scooter",
		b: "1F6F5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"vehicle",
			"vespa",
			"sasha"
		],
		k: [
			37,
			20
		],
		o: 9
	},
	mailbox: {
		a: "Closed Mailbox with Raised Flag",
		b: "1F4EB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"email",
			"inbox",
			"communication"
		],
		k: [
			26,
			34
		]
	},
	vibration_mode: {
		a: "Vibration Mode",
		b: "1F4F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"orange-square",
			"phone"
		],
		k: [
			26,
			42
		]
	},
	hankey: {
		a: "Pile of Poo",
		b: "1F4A9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			25,
			15
		],
		n: [
			"poop",
			"shit"
		]
	},
	rosette: {
		a: "Rosette",
		b: "1F3F5-FE0F",
		c: "1F3F5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"flower",
			"decoration",
			"military"
		],
		k: [
			12,
			20
		],
		o: 7
	},
	tumbler_glass: {
		a: "Tumbler Glass",
		b: "1F943",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"drink",
			"beverage",
			"drunk",
			"alcohol",
			"liquor",
			"booze",
			"bourbon",
			"scotch",
			"whisky",
			"glass",
			"shot"
		],
		k: [
			41,
			39
		],
		o: 9
	},
	cup_with_straw: {
		a: "Cup with Straw",
		b: "1F964",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			16
		],
		o: 10
	},
	"flag-gm": {
		a: "Gambia Flag",
		b: "1F1EC-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			16
		]
	},
	mailbox_closed: {
		a: "Closed Mailbox with Lowered Flag",
		b: "1F4EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"email",
			"communication",
			"inbox"
		],
		k: [
			26,
			33
		]
	},
	mobile_phone_off: {
		a: "Mobile Phone off",
		b: "1F4F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"mute",
			"orange-square",
			"silence",
			"quiet"
		],
		k: [
			26,
			43
		]
	},
	busstop: {
		a: "Bus Stop",
		b: "1F68F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"wait"
		],
		k: [
			34,
			23
		]
	},
	smiley_cat: {
		a: "Smiling Cat Face with Open Mouth",
		b: "1F63A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"cats",
			"happy",
			"smile"
		],
		k: [
			31,
			30
		]
	},
	rose: {
		a: "Rose",
		b: "1F339",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"flowers",
			"valentines",
			"love",
			"spring"
		],
		k: [
			6,
			47
		]
	},
	motorway: {
		a: "Motorway",
		b: "1F6E3-FE0F",
		c: "1F6E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"road",
			"cupertino",
			"interstate",
			"highway"
		],
		k: [
			37,
			11
		],
		o: 7
	},
	smile_cat: {
		a: "Grinning Cat Face with Smiling Eyes",
		b: "1F638",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"cats",
			"smile"
		],
		k: [
			31,
			28
		]
	},
	"flag-gn": {
		a: "Guinea Flag",
		b: "1F1EC-1F1F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			17
		]
	},
	wilted_flower: {
		a: "Wilted Flower",
		b: "1F940",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"plant",
			"nature",
			"flower"
		],
		k: [
			41,
			36
		],
		o: 9
	},
	mailbox_with_mail: {
		a: "Open Mailbox with Raised Flag",
		b: "1F4EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"email",
			"inbox",
			"communication"
		],
		k: [
			26,
			35
		]
	},
	chopsticks: {
		a: "Chopsticks",
		b: "1F962",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			14
		],
		o: 10
	},
	female_sign: {
		a: "Female Sign",
		b: "2640-FE0F",
		c: "2640",
		d: false,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			47,
			42
		],
		o: 1
	},
	mailbox_with_no_mail: {
		a: "Open Mailbox with Lowered Flag",
		b: "1F4ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"email",
			"inbox"
		],
		k: [
			26,
			36
		]
	},
	knife_fork_plate: {
		a: "Knife Fork Plate",
		b: "1F37D-FE0F",
		c: "1F37D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			8,
			11
		],
		o: 7
	},
	hibiscus: {
		a: "Hibiscus",
		b: "1F33A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"plant",
			"vegetable",
			"flowers",
			"beach"
		],
		k: [
			6,
			48
		]
	},
	"flag-gp": {
		a: "Guadeloupe Flag",
		b: "1F1EC-1F1F5",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			18
		]
	},
	railway_track: {
		a: "Railway Track",
		b: "1F6E4-FE0F",
		c: "1F6E4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"train",
			"transportation"
		],
		k: [
			37,
			12
		],
		o: 7
	},
	male_sign: {
		a: "Male Sign",
		b: "2642-FE0F",
		c: "2642",
		d: false,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			47,
			43
		],
		o: 1
	},
	joy_cat: {
		a: "Cat Face with Tears of Joy",
		b: "1F639",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"cats",
			"haha",
			"happy",
			"tears"
		],
		k: [
			31,
			29
		]
	},
	fuelpump: {
		a: "Fuel Pump",
		b: "26FD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"gas station",
			"petroleum"
		],
		k: [
			49,
			13
		],
		o: 5
	},
	sunflower: {
		a: "Sunflower",
		b: "1F33B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"plant",
			"fall"
		],
		k: [
			6,
			49
		]
	},
	postbox: {
		a: "Postbox",
		b: "1F4EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"email",
			"letter",
			"envelope"
		],
		k: [
			26,
			37
		]
	},
	"flag-gq": {
		a: "Equatorial Guinea Flag",
		b: "1F1EC-1F1F6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			19
		]
	},
	heart_eyes_cat: {
		a: "Smiling Cat Face with Heart-Shaped Eyes",
		b: "1F63B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"love",
			"like",
			"affection",
			"cats",
			"valentines",
			"heart"
		],
		k: [
			31,
			31
		]
	},
	fork_and_knife: {
		a: "Fork and Knife",
		b: "1F374",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"cutlery",
			"kitchen"
		],
		k: [
			8,
			2
		]
	},
	medical_symbol: {
		a: "Medical Symbol",
		b: "2695-FE0F",
		c: "2695",
		d: false,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			48,
			14
		],
		n: [
			"staff_of_aesculapius"
		],
		o: 4
	},
	recycle: {
		a: "Black Universal Recycling Symbol",
		b: "267B-FE0F",
		c: "267B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"arrow",
			"environment",
			"garbage",
			"trash"
		],
		k: [
			48,
			9
		],
		o: 3
	},
	spoon: {
		a: "Spoon",
		b: "1F944",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"cutlery",
			"kitchen",
			"tableware"
		],
		k: [
			41,
			40
		],
		o: 9
	},
	blossom: {
		a: "Blossom",
		b: "1F33C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"flowers",
			"yellow"
		],
		k: [
			6,
			50
		]
	},
	rotating_light: {
		a: "Police Cars Revolving Light",
		b: "1F6A8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"police",
			"ambulance",
			"911",
			"emergency",
			"alert",
			"error",
			"pinged",
			"law",
			"legal"
		],
		k: [
			35,
			13
		]
	},
	smirk_cat: {
		a: "Cat Face with Wry Smile",
		b: "1F63C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"cats",
			"smirk"
		],
		k: [
			31,
			32
		]
	},
	ballot_box_with_ballot: {
		a: "Ballot Box with Ballot",
		b: "1F5F3-FE0F",
		c: "1F5F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			30,
			17
		],
		o: 7
	},
	"flag-gr": {
		a: "Greece Flag",
		b: "1F1EC-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			20
		]
	},
	kissing_cat: {
		a: "Kissing Cat Face with Closed Eyes",
		b: "1F63D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"cats",
			"kiss"
		],
		k: [
			31,
			33
		]
	},
	pencil2: {
		a: "Pencil",
		b: "270F-FE0F",
		c: "270F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stationery",
			"write",
			"paper",
			"writing",
			"school",
			"study"
		],
		k: [
			49,
			42
		],
		o: 1
	},
	traffic_light: {
		a: "Horizontal Traffic Light",
		b: "1F6A5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"signal"
		],
		k: [
			35,
			10
		]
	},
	fleur_de_lis: {
		a: "Fleur De Lis",
		b: "269C-FE0F",
		c: "269C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"decorative",
			"scout"
		],
		k: [
			48,
			19
		],
		o: 4
	},
	tulip: {
		a: "Tulip",
		b: "1F337",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"flowers",
			"plant",
			"nature",
			"summer",
			"spring"
		],
		k: [
			6,
			45
		]
	},
	hocho: {
		a: "Hocho",
		b: "1F52A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"knife",
			"blade",
			"cutlery",
			"kitchen",
			"weapon"
		],
		k: [
			27,
			44
		],
		n: [
			"knife"
		]
	},
	"flag-gs": {
		a: "South Georgia & South Sandwich Islands Flag",
		b: "1F1EC-1F1F8",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			21
		]
	},
	seedling: {
		a: "Seedling",
		b: "1F331",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"plant",
			"nature",
			"grass",
			"lawn",
			"spring"
		],
		k: [
			6,
			39
		]
	},
	amphora: {
		a: "Amphora",
		b: "1F3FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"vase",
			"jar"
		],
		k: [
			12,
			24
		],
		o: 8
	},
	scream_cat: {
		a: "Weary Cat Face",
		b: "1F640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"cats",
			"munch",
			"scared",
			"scream"
		],
		k: [
			31,
			36
		]
	},
	vertical_traffic_light: {
		a: "Vertical Traffic Light",
		b: "1F6A6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"driving"
		],
		k: [
			35,
			11
		]
	},
	black_nib: {
		a: "Black Nib",
		b: "2712-FE0F",
		c: "2712",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"pen",
			"stationery",
			"writing",
			"write"
		],
		k: [
			49,
			43
		],
		o: 1
	},
	"flag-gt": {
		a: "Guatemala Flag",
		b: "1F1EC-1F1F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			22
		]
	},
	trident: {
		a: "Trident Emblem",
		b: "1F531",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"weapon",
			"spear"
		],
		k: [
			27,
			51
		]
	},
	"flag-gu": {
		a: "Guam Flag",
		b: "1F1EC-1F1FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			23
		]
	},
	name_badge: {
		a: "Name Badge",
		b: "1F4DB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fire",
			"forbid"
		],
		k: [
			26,
			18
		]
	},
	construction: {
		a: "Construction Sign",
		b: "1F6A7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"wip",
			"progress",
			"caution",
			"warning"
		],
		k: [
			35,
			12
		]
	},
	lower_left_fountain_pen: {
		a: "Lower Left Fountain Pen",
		b: "1F58B-FE0F",
		c: "1F58B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			29,
			29
		],
		o: 7
	},
	evergreen_tree: {
		a: "Evergreen Tree",
		b: "1F332",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"plant",
			"nature"
		],
		k: [
			6,
			40
		]
	},
	crying_cat_face: {
		a: "Crying Cat Face",
		b: "1F63F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"tears",
			"weep",
			"sad",
			"cats",
			"upset",
			"cry"
		],
		k: [
			31,
			35
		]
	},
	"flag-gw": {
		a: "Guinea-Bissau Flag",
		b: "1F1EC-1F1FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			24
		]
	},
	lower_left_ballpoint_pen: {
		a: "Lower Left Ballpoint Pen",
		b: "1F58A-FE0F",
		c: "1F58A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			29,
			28
		],
		o: 7
	},
	pouting_cat: {
		a: "Pouting Cat Face",
		b: "1F63E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"cats"
		],
		k: [
			31,
			34
		]
	},
	deciduous_tree: {
		a: "Deciduous Tree",
		b: "1F333",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"plant",
			"nature"
		],
		k: [
			6,
			41
		]
	},
	octagonal_sign: {
		a: "Octagonal Sign",
		b: "1F6D1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			6
		],
		o: 9
	},
	beginner: {
		a: "Japanese Symbol for Beginner",
		b: "1F530",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"badge",
			"shield"
		],
		k: [
			27,
			50
		]
	},
	"flag-gy": {
		a: "Guyana Flag",
		b: "1F1EC-1F1FE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			25
		]
	},
	lower_left_paintbrush: {
		a: "Lower Left Paintbrush",
		b: "1F58C-FE0F",
		c: "1F58C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			29,
			30
		],
		o: 7
	},
	o: {
		a: "Heavy Large Circle",
		b: "2B55",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"circle",
			"round"
		],
		k: [
			50,
			23
		],
		o: 5
	},
	palm_tree: {
		a: "Palm Tree",
		b: "1F334",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"plant",
			"vegetable",
			"nature",
			"summer",
			"beach",
			"mojito",
			"tropical"
		],
		k: [
			6,
			42
		]
	},
	anchor: {
		a: "Anchor",
		b: "2693",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"ship",
			"ferry",
			"sea",
			"boat"
		],
		k: [
			48,
			12
		],
		o: 4
	},
	see_no_evil: {
		a: "See-No-Evil Monkey",
		b: "1F648",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"monkey",
			"animal",
			"nature",
			"haha"
		],
		k: [
			32,
			43
		]
	},
	boat: {
		a: "Sailboat",
		b: "26F5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			48,
			43
		],
		n: [
			"sailboat"
		],
		o: 5
	},
	white_check_mark: {
		a: "White Heavy Check Mark",
		b: "2705",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"green-square",
			"ok",
			"agree",
			"vote",
			"election",
			"answer",
			"tick"
		],
		k: [
			49,
			15
		]
	},
	"flag-hk": {
		a: "Hong Kong Sar China Flag",
		b: "1F1ED-1F1F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			26
		]
	},
	lower_left_crayon: {
		a: "Lower Left Crayon",
		b: "1F58D-FE0F",
		c: "1F58D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			29,
			31
		],
		o: 7
	},
	hear_no_evil: {
		a: "Hear-No-Evil Monkey",
		b: "1F649",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"monkey",
			"nature"
		],
		k: [
			32,
			44
		]
	},
	cactus: {
		a: "Cactus",
		b: "1F335",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vegetable",
			"plant",
			"nature"
		],
		k: [
			6,
			43
		]
	},
	ear_of_rice: {
		a: "Ear of Rice",
		b: "1F33E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"plant"
		],
		k: [
			7,
			0
		]
	},
	speak_no_evil: {
		a: "Speak-No-Evil Monkey",
		b: "1F64A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"monkey",
			"animal",
			"nature",
			"omg"
		],
		k: [
			32,
			45
		]
	},
	"flag-hm": {
		a: "Heard & Mcdonald Islands Flag",
		b: "1F1ED-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			27
		]
	},
	ballot_box_with_check: {
		a: "Ballot Box with Check",
		b: "2611-FE0F",
		c: "2611",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"ok",
			"agree",
			"confirm",
			"black-square",
			"vote",
			"election",
			"yes",
			"tick"
		],
		k: [
			47,
			22
		],
		o: 1
	},
	canoe: {
		a: "Canoe",
		b: "1F6F6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"boat",
			"paddle",
			"water",
			"ship"
		],
		k: [
			37,
			21
		],
		o: 9
	},
	memo: {
		a: "Memo",
		b: "1F4DD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"write",
			"documents",
			"stationery",
			"pencil",
			"paper",
			"writing",
			"legal",
			"exam",
			"quiz",
			"test",
			"study",
			"compose"
		],
		k: [
			26,
			20
		],
		n: [
			"pencil"
		]
	},
	herb: {
		a: "Herb",
		b: "1F33F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vegetable",
			"plant",
			"medicine",
			"weed",
			"grass",
			"lawn"
		],
		k: [
			7,
			1
		]
	},
	"flag-hn": {
		a: "Honduras Flag",
		b: "1F1ED-1F1F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			28
		]
	},
	heavy_check_mark: {
		a: "Heavy Check Mark",
		b: "2714-FE0F",
		c: "2714",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"ok",
			"nike",
			"answer",
			"yes",
			"tick"
		],
		k: [
			49,
			44
		],
		o: 1
	},
	briefcase: {
		a: "Briefcase",
		b: "1F4BC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"business",
			"documents",
			"work",
			"law",
			"legal",
			"job",
			"career"
		],
		k: [
			25,
			39
		]
	},
	speedboat: {
		a: "Speedboat",
		b: "1F6A4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"ship",
			"transportation",
			"vehicle",
			"summer"
		],
		k: [
			35,
			9
		]
	},
	baby: {
		skin_variations: {
			"1F3FB": {
				unified: "1F476-1F3FB",
				non_qualified: null,
				image: "1f476-1f3fb.png",
				sheet_x: 22,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F476-1F3FC",
				non_qualified: null,
				image: "1f476-1f3fc.png",
				sheet_x: 22,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F476-1F3FD",
				non_qualified: null,
				image: "1f476-1f3fd.png",
				sheet_x: 22,
				sheet_y: 13,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F476-1F3FE",
				non_qualified: null,
				image: "1f476-1f3fe.png",
				sheet_x: 22,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F476-1F3FF",
				non_qualified: null,
				image: "1f476-1f3ff.png",
				sheet_x: 22,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Baby",
		b: "1F476",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"child",
			"boy",
			"girl",
			"toddler"
		],
		k: [
			22,
			10
		]
	},
	heavy_multiplication_x: {
		a: "Heavy Multiplication X",
		b: "2716-FE0F",
		c: "2716",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"math",
			"calculation"
		],
		k: [
			49,
			45
		],
		o: 1
	},
	child: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D2-1F3FB",
				non_qualified: null,
				image: "1f9d2-1f3fb.png",
				sheet_x: 43,
				sheet_y: 5,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9D2-1F3FC",
				non_qualified: null,
				image: "1f9d2-1f3fc.png",
				sheet_x: 43,
				sheet_y: 6,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9D2-1F3FD",
				non_qualified: null,
				image: "1f9d2-1f3fd.png",
				sheet_x: 43,
				sheet_y: 7,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9D2-1F3FE",
				non_qualified: null,
				image: "1f9d2-1f3fe.png",
				sheet_x: 43,
				sheet_y: 8,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9D2-1F3FF",
				non_qualified: null,
				image: "1f9d2-1f3ff.png",
				sheet_x: 43,
				sheet_y: 9,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Child",
		b: "1F9D2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			43,
			4
		],
		o: 10
	},
	shamrock: {
		a: "Shamrock",
		b: "2618-FE0F",
		c: "2618",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"vegetable",
			"plant",
			"nature",
			"irish",
			"clover"
		],
		k: [
			47,
			25
		],
		o: 4
	},
	passenger_ship: {
		a: "Passenger Ship",
		b: "1F6F3-FE0F",
		c: "1F6F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"yacht",
			"cruise",
			"ferry"
		],
		k: [
			37,
			18
		],
		o: 7
	},
	"flag-hr": {
		a: "Croatia Flag",
		b: "1F1ED-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			29
		]
	},
	file_folder: {
		a: "File Folder",
		b: "1F4C1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"documents",
			"business",
			"office"
		],
		k: [
			25,
			44
		]
	},
	x: {
		a: "Cross Mark",
		b: "274C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"no",
			"delete",
			"remove",
			"cancel"
		],
		k: [
			50,
			1
		]
	},
	four_leaf_clover: {
		a: "Four Leaf Clover",
		b: "1F340",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vegetable",
			"plant",
			"nature",
			"lucky",
			"irish"
		],
		k: [
			7,
			2
		]
	},
	open_file_folder: {
		a: "Open File Folder",
		b: "1F4C2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"documents",
			"load"
		],
		k: [
			25,
			45
		]
	},
	boy: {
		skin_variations: {
			"1F3FB": {
				unified: "1F466-1F3FB",
				non_qualified: null,
				image: "1f466-1f3fb.png",
				sheet_x: 15,
				sheet_y: 43,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F466-1F3FC",
				non_qualified: null,
				image: "1f466-1f3fc.png",
				sheet_x: 15,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F466-1F3FD",
				non_qualified: null,
				image: "1f466-1f3fd.png",
				sheet_x: 15,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F466-1F3FE",
				non_qualified: null,
				image: "1f466-1f3fe.png",
				sheet_x: 15,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F466-1F3FF",
				non_qualified: null,
				image: "1f466-1f3ff.png",
				sheet_x: 15,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Boy",
		b: "1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"man",
			"male",
			"guy",
			"teenager"
		],
		k: [
			15,
			42
		]
	},
	ferry: {
		a: "Ferry",
		b: "26F4-FE0F",
		c: "26F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"boat",
			"ship",
			"yacht"
		],
		k: [
			48,
			42
		],
		o: 5
	},
	"flag-ht": {
		a: "Haiti Flag",
		b: "1F1ED-1F1F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			30
		]
	},
	girl: {
		skin_variations: {
			"1F3FB": {
				unified: "1F467-1F3FB",
				non_qualified: null,
				image: "1f467-1f3fb.png",
				sheet_x: 15,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F467-1F3FC",
				non_qualified: null,
				image: "1f467-1f3fc.png",
				sheet_x: 15,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F467-1F3FD",
				non_qualified: null,
				image: "1f467-1f3fd.png",
				sheet_x: 15,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F467-1F3FE",
				non_qualified: null,
				image: "1f467-1f3fe.png",
				sheet_x: 16,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F467-1F3FF",
				non_qualified: null,
				image: "1f467-1f3ff.png",
				sheet_x: 16,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Girl",
		b: "1F467",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"female",
			"woman",
			"teenager"
		],
		k: [
			15,
			48
		]
	},
	negative_squared_cross_mark: {
		a: "Negative Squared Cross Mark",
		b: "274E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"x",
			"green-square",
			"no",
			"deny"
		],
		k: [
			50,
			2
		]
	},
	"flag-hu": {
		a: "Hungary Flag",
		b: "1F1ED-1F1FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			31
		]
	},
	card_index_dividers: {
		a: "Card Index Dividers",
		b: "1F5C2-FE0F",
		c: "1F5C2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"organizing",
			"business",
			"stationery"
		],
		k: [
			30,
			4
		],
		o: 7
	},
	maple_leaf: {
		a: "Maple Leaf",
		b: "1F341",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"plant",
			"vegetable",
			"ca",
			"fall"
		],
		k: [
			7,
			3
		]
	},
	motor_boat: {
		a: "Motor Boat",
		b: "1F6E5-FE0F",
		c: "1F6E5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"ship"
		],
		k: [
			37,
			13
		],
		o: 7
	},
	"flag-ic": {
		a: "Canary Islands Flag",
		b: "1F1EE-1F1E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			32
		]
	},
	fallen_leaf: {
		a: "Fallen Leaf",
		b: "1F342",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"plant",
			"vegetable",
			"leaves"
		],
		k: [
			7,
			4
		]
	},
	adult: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D1-1F3FB",
				non_qualified: null,
				image: "1f9d1-1f3fb.png",
				sheet_x: 42,
				sheet_y: 51,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9D1-1F3FC",
				non_qualified: null,
				image: "1f9d1-1f3fc.png",
				sheet_x: 43,
				sheet_y: 0,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9D1-1F3FD",
				non_qualified: null,
				image: "1f9d1-1f3fd.png",
				sheet_x: 43,
				sheet_y: 1,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9D1-1F3FE",
				non_qualified: null,
				image: "1f9d1-1f3fe.png",
				sheet_x: 43,
				sheet_y: 2,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9D1-1F3FF",
				non_qualified: null,
				image: "1f9d1-1f3ff.png",
				sheet_x: 43,
				sheet_y: 3,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Adult",
		b: "1F9D1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			42,
			50
		],
		o: 10
	},
	ship: {
		a: "Ship",
		b: "1F6A2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"titanic",
			"deploy"
		],
		k: [
			34,
			42
		]
	},
	heavy_plus_sign: {
		a: "Heavy Plus Sign",
		b: "2795",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"math",
			"calculation",
			"addition",
			"more",
			"increase"
		],
		k: [
			50,
			9
		]
	},
	date: {
		a: "Calendar",
		b: "1F4C5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"calendar",
			"schedule"
		],
		k: [
			25,
			48
		]
	},
	man: {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB",
				non_qualified: null,
				image: "1f468-1f3fb.png",
				sheet_x: 18,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F468-1F3FC",
				non_qualified: null,
				image: "1f468-1f3fc.png",
				sheet_x: 18,
				sheet_y: 13,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F468-1F3FD",
				non_qualified: null,
				image: "1f468-1f3fd.png",
				sheet_x: 18,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F468-1F3FE",
				non_qualified: null,
				image: "1f468-1f3fe.png",
				sheet_x: 18,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F468-1F3FF",
				non_qualified: null,
				image: "1f468-1f3ff.png",
				sheet_x: 18,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Man",
		b: "1F468",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"mustache",
			"father",
			"dad",
			"guy",
			"classy",
			"sir",
			"moustache"
		],
		k: [
			18,
			11
		]
	},
	"flag-id": {
		a: "Indonesia Flag",
		b: "1F1EE-1F1E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			33
		]
	},
	leaves: {
		a: "Leaf Fluttering in Wind",
		b: "1F343",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"plant",
			"tree",
			"vegetable",
			"grass",
			"lawn",
			"spring"
		],
		k: [
			7,
			5
		]
	},
	heavy_minus_sign: {
		a: "Heavy Minus Sign",
		b: "2796",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"math",
			"calculation",
			"subtract",
			"less"
		],
		k: [
			50,
			10
		]
	},
	calendar: {
		a: "Tear-off Calendar",
		b: "1F4C6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"schedule",
			"date",
			"planning"
		],
		k: [
			25,
			49
		]
	},
	airplane: {
		a: "Airplane",
		b: "2708-FE0F",
		c: "2708",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vehicle",
			"transportation",
			"flight",
			"fly"
		],
		k: [
			49,
			16
		],
		o: 1
	},
	spiral_note_pad: {
		a: "Spiral Note Pad",
		b: "1F5D2-FE0F",
		c: "1F5D2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			30,
			8
		],
		o: 7
	},
	heavy_division_sign: {
		a: "Heavy Division Sign",
		b: "2797",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"divide",
			"math",
			"calculation"
		],
		k: [
			50,
			11
		]
	},
	small_airplane: {
		a: "Small Airplane",
		b: "1F6E9-FE0F",
		c: "1F6E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"flight",
			"transportation",
			"fly",
			"vehicle"
		],
		k: [
			37,
			14
		],
		o: 7
	},
	woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB",
				non_qualified: null,
				image: "1f469-1f3fb.png",
				sheet_x: 20,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F469-1F3FC",
				non_qualified: null,
				image: "1f469-1f3fc.png",
				sheet_x: 20,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F469-1F3FD",
				non_qualified: null,
				image: "1f469-1f3fd.png",
				sheet_x: 20,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F469-1F3FE",
				non_qualified: null,
				image: "1f469-1f3fe.png",
				sheet_x: 20,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F469-1F3FF",
				non_qualified: null,
				image: "1f469-1f3ff.png",
				sheet_x: 20,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Woman",
		b: "1F469",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"female",
			"girls",
			"lady"
		],
		k: [
			20,
			23
		]
	},
	"flag-ie": {
		a: "Ireland Flag",
		b: "1F1EE-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			34
		]
	},
	curly_loop: {
		a: "Curly Loop",
		b: "27B0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"scribble",
			"draw",
			"shape",
			"squiggle"
		],
		k: [
			50,
			13
		]
	},
	"flag-il": {
		a: "Israel Flag",
		b: "1F1EE-1F1F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			35
		]
	},
	airplane_departure: {
		a: "Airplane Departure",
		b: "1F6EB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			15
		],
		o: 7
	},
	spiral_calendar_pad: {
		a: "Spiral Calendar Pad",
		b: "1F5D3-FE0F",
		c: "1F5D3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			30,
			9
		],
		o: 7
	},
	older_adult: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D3-1F3FB",
				non_qualified: null,
				image: "1f9d3-1f3fb.png",
				sheet_x: 43,
				sheet_y: 11,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9D3-1F3FC",
				non_qualified: null,
				image: "1f9d3-1f3fc.png",
				sheet_x: 43,
				sheet_y: 12,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9D3-1F3FD",
				non_qualified: null,
				image: "1f9d3-1f3fd.png",
				sheet_x: 43,
				sheet_y: 13,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9D3-1F3FE",
				non_qualified: null,
				image: "1f9d3-1f3fe.png",
				sheet_x: 43,
				sheet_y: 14,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9D3-1F3FF",
				non_qualified: null,
				image: "1f9d3-1f3ff.png",
				sheet_x: 43,
				sheet_y: 15,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Older Adult",
		b: "1F9D3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			43,
			10
		],
		o: 10
	},
	airplane_arriving: {
		a: "Airplane Arriving",
		b: "1F6EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			16
		],
		o: 7
	},
	card_index: {
		a: "Card Index",
		b: "1F4C7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"business",
			"stationery"
		],
		k: [
			25,
			50
		]
	},
	loop: {
		a: "Double Curly Loop",
		b: "27BF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"tape",
			"cassette"
		],
		k: [
			50,
			14
		]
	},
	older_man: {
		skin_variations: {
			"1F3FB": {
				unified: "1F474-1F3FB",
				non_qualified: null,
				image: "1f474-1f3fb.png",
				sheet_x: 21,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F474-1F3FC",
				non_qualified: null,
				image: "1f474-1f3fc.png",
				sheet_x: 22,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F474-1F3FD",
				non_qualified: null,
				image: "1f474-1f3fd.png",
				sheet_x: 22,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F474-1F3FE",
				non_qualified: null,
				image: "1f474-1f3fe.png",
				sheet_x: 22,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F474-1F3FF",
				non_qualified: null,
				image: "1f474-1f3ff.png",
				sheet_x: 22,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Older Man",
		b: "1F474",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"human",
			"male",
			"men",
			"old",
			"elder",
			"senior"
		],
		k: [
			21,
			50
		]
	},
	"flag-im": {
		a: "Isle of Man Flag",
		b: "1F1EE-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			36
		]
	},
	"flag-in": {
		a: "India Flag",
		b: "1F1EE-1F1F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			37
		]
	},
	chart_with_upwards_trend: {
		a: "Chart with Upwards Trend",
		b: "1F4C8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"graph",
			"presentation",
			"stats",
			"recovery",
			"business",
			"economics",
			"money",
			"sales",
			"good",
			"success"
		],
		k: [
			25,
			51
		]
	},
	part_alternation_mark: {
		a: "Part Alternation Mark",
		b: "303D-FE0F",
		c: "303D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"graph",
			"presentation",
			"stats",
			"business",
			"economics",
			"bad"
		],
		k: [
			50,
			25
		],
		o: 3
	},
	seat: {
		a: "Seat",
		b: "1F4BA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sit",
			"airplane",
			"transport",
			"bus",
			"flight",
			"fly"
		],
		k: [
			25,
			37
		]
	},
	older_woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F475-1F3FB",
				non_qualified: null,
				image: "1f475-1f3fb.png",
				sheet_x: 22,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F475-1F3FC",
				non_qualified: null,
				image: "1f475-1f3fc.png",
				sheet_x: 22,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F475-1F3FD",
				non_qualified: null,
				image: "1f475-1f3fd.png",
				sheet_x: 22,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F475-1F3FE",
				non_qualified: null,
				image: "1f475-1f3fe.png",
				sheet_x: 22,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F475-1F3FF",
				non_qualified: null,
				image: "1f475-1f3ff.png",
				sheet_x: 22,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Older Woman",
		b: "1F475",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"human",
			"female",
			"women",
			"lady",
			"old",
			"elder",
			"senior"
		],
		k: [
			22,
			4
		]
	},
	eight_spoked_asterisk: {
		a: "Eight Spoked Asterisk",
		b: "2733-FE0F",
		c: "2733",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"star",
			"sparkle",
			"green-square"
		],
		k: [
			49,
			49
		],
		o: 1
	},
	chart_with_downwards_trend: {
		a: "Chart with Downwards Trend",
		b: "1F4C9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"graph",
			"presentation",
			"stats",
			"recession",
			"business",
			"economics",
			"money",
			"sales",
			"bad",
			"failure"
		],
		k: [
			26,
			0
		]
	},
	"flag-io": {
		a: "British Indian Ocean Territory Flag",
		b: "1F1EE-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			38
		]
	},
	"male-doctor": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-2695-FE0F",
				non_qualified: "1F468-1F3FB-200D-2695",
				image: "1f468-1f3fb-200d-2695-fe0f.png",
				sheet_x: 17,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-2695-FE0F",
				non_qualified: "1F468-1F3FC-200D-2695",
				image: "1f468-1f3fc-200d-2695-fe0f.png",
				sheet_x: 17,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-2695-FE0F",
				non_qualified: "1F468-1F3FD-200D-2695",
				image: "1f468-1f3fd-200d-2695-fe0f.png",
				sheet_x: 17,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-2695-FE0F",
				non_qualified: "1F468-1F3FE-200D-2695",
				image: "1f468-1f3fe-200d-2695-fe0f.png",
				sheet_x: 17,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-2695-FE0F",
				non_qualified: "1F468-1F3FF-200D-2695",
				image: "1f468-1f3ff-200d-2695-fe0f.png",
				sheet_x: 17,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Male Doctor",
		b: "1F468-200D-2695-FE0F",
		c: "1F468-200D-2695",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			17,
			43
		]
	},
	helicopter: {
		a: "Helicopter",
		b: "1F681",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle",
			"fly"
		],
		k: [
			34,
			9
		]
	},
	"female-doctor": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-2695-FE0F",
				non_qualified: "1F469-1F3FB-200D-2695",
				image: "1f469-1f3fb-200d-2695-fe0f.png",
				sheet_x: 20,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-2695-FE0F",
				non_qualified: "1F469-1F3FC-200D-2695",
				image: "1f469-1f3fc-200d-2695-fe0f.png",
				sheet_x: 20,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-2695-FE0F",
				non_qualified: "1F469-1F3FD-200D-2695",
				image: "1f469-1f3fd-200d-2695-fe0f.png",
				sheet_x: 20,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-2695-FE0F",
				non_qualified: "1F469-1F3FE-200D-2695",
				image: "1f469-1f3fe-200d-2695-fe0f.png",
				sheet_x: 20,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-2695-FE0F",
				non_qualified: "1F469-1F3FF-200D-2695",
				image: "1f469-1f3ff-200d-2695-fe0f.png",
				sheet_x: 20,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Female Doctor",
		b: "1F469-200D-2695-FE0F",
		c: "1F469-200D-2695",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			20,
			1
		]
	},
	suspension_railway: {
		a: "Suspension Railway",
		b: "1F69F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"vehicle",
			"transportation"
		],
		k: [
			34,
			39
		]
	},
	bar_chart: {
		a: "Bar Chart",
		b: "1F4CA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"graph",
			"presentation",
			"stats"
		],
		k: [
			26,
			1
		]
	},
	"flag-iq": {
		a: "Iraq Flag",
		b: "1F1EE-1F1F6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			39
		]
	},
	eight_pointed_black_star: {
		a: "Eight Pointed Black Star",
		b: "2734-FE0F",
		c: "2734",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"orange-square",
			"shape",
			"polygon"
		],
		k: [
			49,
			50
		],
		o: 1
	},
	mountain_cableway: {
		a: "Mountain Cableway",
		b: "1F6A0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle",
			"ski"
		],
		k: [
			34,
			40
		]
	},
	"male-student": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F393",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f393.png",
				sheet_x: 16,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F393",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f393.png",
				sheet_x: 16,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F393",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f393.png",
				sheet_x: 16,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F393",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f393.png",
				sheet_x: 16,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F393",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f393.png",
				sheet_x: 16,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Student",
		b: "1F468-200D-1F393",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			14
		]
	},
	clipboard: {
		a: "Clipboard",
		b: "1F4CB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stationery",
			"documents"
		],
		k: [
			26,
			2
		]
	},
	"flag-ir": {
		a: "Iran Flag",
		b: "1F1EE-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			40
		]
	},
	sparkle: {
		a: "Sparkle",
		b: "2747-FE0F",
		c: "2747",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stars",
			"green-square",
			"awesome",
			"good",
			"fireworks"
		],
		k: [
			50,
			0
		],
		o: 1
	},
	"female-student": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F393",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f393.png",
				sheet_x: 18,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F393",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f393.png",
				sheet_x: 18,
				sheet_y: 31,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F393",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f393.png",
				sheet_x: 18,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F393",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f393.png",
				sheet_x: 18,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F393",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f393.png",
				sheet_x: 18,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Student",
		b: "1F469-200D-1F393",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			18,
			29
		]
	},
	pushpin: {
		a: "Pushpin",
		b: "1F4CC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stationery",
			"mark",
			"here"
		],
		k: [
			26,
			3
		]
	},
	aerial_tramway: {
		a: "Aerial Tramway",
		b: "1F6A1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"transportation",
			"vehicle",
			"ski"
		],
		k: [
			34,
			41
		]
	},
	"flag-is": {
		a: "Iceland Flag",
		b: "1F1EE-1F1F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			41
		]
	},
	bangbang: {
		a: "Double Exclamation Mark",
		b: "203C-FE0F",
		c: "203C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"exclamation",
			"surprise"
		],
		k: [
			46,
			29
		],
		o: 1
	},
	interrobang: {
		a: "Exclamation Question Mark",
		b: "2049-FE0F",
		c: "2049",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"wat",
			"punctuation",
			"surprise"
		],
		k: [
			46,
			30
		],
		o: 3
	},
	satellite: {
		a: "Satellite",
		b: "1F6F0-FE0F",
		c: "1F6F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"communication",
			"future",
			"radio",
			"space"
		],
		k: [
			37,
			17
		],
		o: 7
	},
	it: {
		a: "Italy Flag",
		b: "1F1EE-1F1F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"italy",
			"flag",
			"nation",
			"country",
			"banner"
		],
		k: [
			2,
			42
		],
		n: [
			"flag-it"
		]
	},
	"male-teacher": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F3EB",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f3eb.png",
				sheet_x: 16,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F3EB",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f3eb.png",
				sheet_x: 16,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F3EB",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f3eb.png",
				sheet_x: 16,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F3EB",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f3eb.png",
				sheet_x: 16,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F3EB",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f3eb.png",
				sheet_x: 16,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Teacher",
		b: "1F468-200D-1F3EB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			32
		]
	},
	round_pushpin: {
		a: "Round Pushpin",
		b: "1F4CD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stationery",
			"location",
			"map",
			"here"
		],
		k: [
			26,
			4
		]
	},
	"flag-je": {
		a: "Jersey Flag",
		b: "1F1EF-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			43
		]
	},
	question: {
		a: "Black Question Mark Ornament",
		b: "2753",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"doubt",
			"confused"
		],
		k: [
			50,
			3
		]
	},
	rocket: {
		a: "Rocket",
		b: "1F680",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"launch",
			"ship",
			"staffmode",
			"NASA",
			"outer space",
			"outer_space",
			"fly"
		],
		k: [
			34,
			8
		]
	},
	"female-teacher": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F3EB",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f3eb.png",
				sheet_x: 18,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F3EB",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f3eb.png",
				sheet_x: 18,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F3EB",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f3eb.png",
				sheet_x: 18,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F3EB",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f3eb.png",
				sheet_x: 18,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F3EB",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f3eb.png",
				sheet_x: 19,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Teacher",
		b: "1F469-200D-1F3EB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			18,
			47
		]
	},
	paperclip: {
		a: "Paperclip",
		b: "1F4CE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"documents",
			"stationery"
		],
		k: [
			26,
			5
		]
	},
	linked_paperclips: {
		a: "Linked Paperclips",
		b: "1F587-FE0F",
		c: "1F587",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			29,
			27
		],
		o: 7
	},
	flying_saucer: {
		a: "Flying Saucer",
		b: "1F6F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			23
		],
		o: 10
	},
	"male-judge": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-2696-FE0F",
				non_qualified: "1F468-1F3FB-200D-2696",
				image: "1f468-1f3fb-200d-2696-fe0f.png",
				sheet_x: 17,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-2696-FE0F",
				non_qualified: "1F468-1F3FC-200D-2696",
				image: "1f468-1f3fc-200d-2696-fe0f.png",
				sheet_x: 17,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-2696-FE0F",
				non_qualified: "1F468-1F3FD-200D-2696",
				image: "1f468-1f3fd-200d-2696-fe0f.png",
				sheet_x: 18,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-2696-FE0F",
				non_qualified: "1F468-1F3FE-200D-2696",
				image: "1f468-1f3fe-200d-2696-fe0f.png",
				sheet_x: 18,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-2696-FE0F",
				non_qualified: "1F468-1F3FF-200D-2696",
				image: "1f468-1f3ff-200d-2696-fe0f.png",
				sheet_x: 18,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Male Judge",
		b: "1F468-200D-2696-FE0F",
		c: "1F468-200D-2696",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			17,
			49
		]
	},
	grey_question: {
		a: "White Question Mark Ornament",
		b: "2754",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"doubts",
			"gray",
			"huh",
			"confused"
		],
		k: [
			50,
			4
		]
	},
	"flag-jm": {
		a: "Jamaica Flag",
		b: "1F1EF-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			44
		]
	},
	bellhop_bell: {
		a: "Bellhop Bell",
		b: "1F6CE-FE0F",
		c: "1F6CE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"service"
		],
		k: [
			37,
			3
		],
		o: 7
	},
	straight_ruler: {
		a: "Straight Ruler",
		b: "1F4CF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stationery",
			"calculate",
			"length",
			"math",
			"school",
			"drawing",
			"architect",
			"sketch"
		],
		k: [
			26,
			6
		]
	},
	"flag-jo": {
		a: "Jordan Flag",
		b: "1F1EF-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			45
		]
	},
	"female-judge": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-2696-FE0F",
				non_qualified: "1F469-1F3FB-200D-2696",
				image: "1f469-1f3fb-200d-2696-fe0f.png",
				sheet_x: 20,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-2696-FE0F",
				non_qualified: "1F469-1F3FC-200D-2696",
				image: "1f469-1f3fc-200d-2696-fe0f.png",
				sheet_x: 20,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-2696-FE0F",
				non_qualified: "1F469-1F3FD-200D-2696",
				image: "1f469-1f3fd-200d-2696-fe0f.png",
				sheet_x: 20,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-2696-FE0F",
				non_qualified: "1F469-1F3FE-200D-2696",
				image: "1f469-1f3fe-200d-2696-fe0f.png",
				sheet_x: 20,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-2696-FE0F",
				non_qualified: "1F469-1F3FF-200D-2696",
				image: "1f469-1f3ff-200d-2696-fe0f.png",
				sheet_x: 20,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Female Judge",
		b: "1F469-200D-2696-FE0F",
		c: "1F469-200D-2696",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			20,
			7
		]
	},
	grey_exclamation: {
		a: "White Exclamation Mark Ornament",
		b: "2755",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"surprise",
			"punctuation",
			"gray",
			"wow",
			"warning"
		],
		k: [
			50,
			5
		]
	},
	door: {
		a: "Door",
		b: "1F6AA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"house",
			"entry",
			"exit"
		],
		k: [
			35,
			15
		]
	},
	"male-farmer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F33E",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f33e.png",
				sheet_x: 16,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F33E",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f33e.png",
				sheet_x: 16,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F33E",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f33e.png",
				sheet_x: 16,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F33E",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f33e.png",
				sheet_x: 16,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F33E",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f33e.png",
				sheet_x: 16,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Farmer",
		b: "1F468-200D-1F33E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			2
		]
	},
	jp: {
		a: "Japan Flag",
		b: "1F1EF-1F1F5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"japanese",
			"nation",
			"flag",
			"country",
			"banner"
		],
		k: [
			2,
			46
		],
		n: [
			"flag-jp"
		]
	},
	triangular_ruler: {
		a: "Triangular Ruler",
		b: "1F4D0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stationery",
			"math",
			"architect",
			"sketch"
		],
		k: [
			26,
			7
		]
	},
	exclamation: {
		a: "Heavy Exclamation Mark Symbol",
		b: "2757",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"heavy_exclamation_mark",
			"danger",
			"surprise",
			"punctuation",
			"wow",
			"warning"
		],
		k: [
			50,
			6
		],
		n: [
			"heavy_exclamation_mark"
		],
		o: 5
	},
	bed: {
		a: "Bed",
		b: "1F6CF-FE0F",
		c: "1F6CF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sleep",
			"rest"
		],
		k: [
			37,
			4
		],
		o: 7
	},
	"female-farmer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F33E",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f33e.png",
				sheet_x: 18,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F33E",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f33e.png",
				sheet_x: 18,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F33E",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f33e.png",
				sheet_x: 18,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F33E",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f33e.png",
				sheet_x: 18,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F33E",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f33e.png",
				sheet_x: 18,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Farmer",
		b: "1F469-200D-1F33E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			18,
			17
		]
	},
	scissors: {
		a: "Black Scissors",
		b: "2702-FE0F",
		c: "2702",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"stationery",
			"cut"
		],
		k: [
			49,
			14
		],
		o: 1
	},
	wavy_dash: {
		a: "Wavy Dash",
		b: "3030-FE0F",
		c: "3030",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"draw",
			"line",
			"moustache",
			"mustache",
			"squiggle",
			"scribble"
		],
		k: [
			50,
			24
		],
		o: 1
	},
	"flag-ke": {
		a: "Kenya Flag",
		b: "1F1F0-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			47
		]
	},
	"flag-kg": {
		a: "Kyrgyzstan Flag",
		b: "1F1F0-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			48
		]
	},
	couch_and_lamp: {
		a: "Couch and Lamp",
		b: "1F6CB-FE0F",
		c: "1F6CB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"read",
			"chill"
		],
		k: [
			36,
			47
		],
		o: 7
	},
	"male-cook": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F373",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f373.png",
				sheet_x: 16,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F373",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f373.png",
				sheet_x: 16,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F373",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f373.png",
				sheet_x: 16,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F373",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f373.png",
				sheet_x: 16,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F373",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f373.png",
				sheet_x: 16,
				sheet_y: 13,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Cook",
		b: "1F468-200D-1F373",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			8
		]
	},
	card_file_box: {
		a: "Card File Box",
		b: "1F5C3-FE0F",
		c: "1F5C3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"business",
			"stationery"
		],
		k: [
			30,
			5
		],
		o: 7
	},
	copyright: {
		a: "Copyright Sign",
		b: "00A9-FE0F",
		c: "00A9",
		d: true,
		e: true,
		f: false,
		g: true,
		h: false,
		i: false,
		j: [
			"ip",
			"license",
			"circle",
			"law",
			"legal"
		],
		k: [
			0,
			12
		],
		o: 1
	},
	file_cabinet: {
		a: "File Cabinet",
		b: "1F5C4-FE0F",
		c: "1F5C4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"filing",
			"organizing"
		],
		k: [
			30,
			6
		],
		o: 7
	},
	registered: {
		a: "Registered Sign",
		b: "00AE-FE0F",
		c: "00AE",
		d: true,
		e: true,
		f: false,
		g: true,
		h: false,
		i: false,
		j: [
			"alphabet",
			"circle"
		],
		k: [
			0,
			13
		],
		o: 1
	},
	"flag-kh": {
		a: "Cambodia Flag",
		b: "1F1F0-1F1ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			49
		]
	},
	"female-cook": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F373",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f373.png",
				sheet_x: 18,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F373",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f373.png",
				sheet_x: 18,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F373",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f373.png",
				sheet_x: 18,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F373",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f373.png",
				sheet_x: 18,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F373",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f373.png",
				sheet_x: 18,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Cook",
		b: "1F469-200D-1F373",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			18,
			23
		]
	},
	toilet: {
		a: "Toilet",
		b: "1F6BD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"restroom",
			"wc",
			"washroom",
			"bathroom",
			"potty"
		],
		k: [
			36,
			33
		]
	},
	wastebasket: {
		a: "Wastebasket",
		b: "1F5D1-FE0F",
		c: "1F5D1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"bin",
			"trash",
			"rubbish",
			"garbage",
			"toss"
		],
		k: [
			30,
			7
		],
		o: 7
	},
	"flag-ki": {
		a: "Kiribati Flag",
		b: "1F1F0-1F1EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			50
		]
	},
	shower: {
		a: "Shower",
		b: "1F6BF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"clean",
			"water",
			"bathroom"
		],
		k: [
			36,
			35
		]
	},
	"male-mechanic": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F527",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f527.png",
				sheet_x: 17,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F527",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f527.png",
				sheet_x: 17,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F527",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f527.png",
				sheet_x: 17,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F527",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f527.png",
				sheet_x: 17,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F527",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f527.png",
				sheet_x: 17,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Mechanic",
		b: "1F468-200D-1F527",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			17,
			19
		]
	},
	tm: {
		a: "Trade Mark Sign",
		b: "2122-FE0F",
		c: "2122",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"trademark",
			"brand",
			"law",
			"legal"
		],
		k: [
			46,
			31
		],
		o: 1
	},
	hash: {
		a: "Hash Key",
		b: "0023-FE0F-20E3",
		c: "0023-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		j: [
			"symbol",
			"blue-square",
			"twitter"
		],
		k: [
			0,
			0
		],
		o: 3
	},
	"flag-km": {
		a: "Comoros Flag",
		b: "1F1F0-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			2,
			51
		]
	},
	bathtub: {
		a: "Bathtub",
		b: "1F6C1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"clean",
			"shower",
			"bathroom"
		],
		k: [
			36,
			42
		]
	},
	"female-mechanic": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F527",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f527.png",
				sheet_x: 19,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F527",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f527.png",
				sheet_x: 19,
				sheet_y: 31,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F527",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f527.png",
				sheet_x: 19,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F527",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f527.png",
				sheet_x: 19,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F527",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f527.png",
				sheet_x: 19,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Mechanic",
		b: "1F469-200D-1F527",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			29
		]
	},
	lock: {
		a: "Lock",
		b: "1F512",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"security",
			"password",
			"padlock"
		],
		k: [
			27,
			20
		]
	},
	"male-factory-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F3ED",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f3ed.png",
				sheet_x: 16,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F3ED",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f3ed.png",
				sheet_x: 16,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F3ED",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f3ed.png",
				sheet_x: 16,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F3ED",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f3ed.png",
				sheet_x: 16,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F3ED",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f3ed.png",
				sheet_x: 16,
				sheet_y: 43,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Factory Worker",
		b: "1F468-200D-1F3ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			38
		]
	},
	"flag-kn": {
		a: "St. Kitts & Nevis Flag",
		b: "1F1F0-1F1F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			0
		]
	},
	hourglass: {
		a: "Hourglass",
		b: "231B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"clock",
			"oldschool",
			"limit",
			"exam",
			"quiz",
			"test"
		],
		k: [
			46,
			42
		],
		o: 1
	},
	keycap_star: {
		a: "Keycap Star",
		b: "002A-FE0F-20E3",
		c: "002A-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			0,
			1
		],
		o: 3
	},
	unlock: {
		a: "Open Lock",
		b: "1F513",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"privacy",
			"security"
		],
		k: [
			27,
			21
		]
	},
	"flag-kp": {
		a: "North Korea Flag",
		b: "1F1F0-1F1F5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			1
		]
	},
	"female-factory-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F3ED",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f3ed.png",
				sheet_x: 19,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F3ED",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f3ed.png",
				sheet_x: 19,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F3ED",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f3ed.png",
				sheet_x: 19,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F3ED",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f3ed.png",
				sheet_x: 19,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F3ED",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f3ed.png",
				sheet_x: 19,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Factory Worker",
		b: "1F469-200D-1F3ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			1
		]
	},
	zero: {
		a: "Keycap 0",
		b: "0030-FE0F-20E3",
		c: "0030-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		j: [
			"0",
			"numbers",
			"blue-square",
			"null"
		],
		k: [
			0,
			2
		],
		o: 3
	},
	lock_with_ink_pen: {
		a: "Lock with Ink Pen",
		b: "1F50F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"security",
			"secret"
		],
		k: [
			27,
			17
		]
	},
	hourglass_flowing_sand: {
		a: "Hourglass with Flowing Sand",
		b: "23F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"oldschool",
			"time",
			"countdown"
		],
		k: [
			47,
			3
		]
	},
	one: {
		a: "Keycap 1",
		b: "0031-FE0F-20E3",
		c: "0031-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		j: [
			"blue-square",
			"numbers",
			"1"
		],
		k: [
			0,
			3
		],
		o: 3
	},
	kr: {
		a: "South Korea Flag",
		b: "1F1F0-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"south",
			"korea",
			"nation",
			"flag",
			"country",
			"banner"
		],
		k: [
			3,
			2
		],
		n: [
			"flag-kr"
		]
	},
	watch: {
		a: "Watch",
		b: "231A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"accessories"
		],
		k: [
			46,
			41
		],
		o: 1
	},
	"male-office-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F4BC",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f4bc.png",
				sheet_x: 17,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F4BC",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f4bc.png",
				sheet_x: 17,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F4BC",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f4bc.png",
				sheet_x: 17,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F4BC",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f4bc.png",
				sheet_x: 17,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F4BC",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f4bc.png",
				sheet_x: 17,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Office Worker",
		b: "1F468-200D-1F4BC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			17,
			13
		]
	},
	closed_lock_with_key: {
		a: "Closed Lock with Key",
		b: "1F510",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"security",
			"privacy"
		],
		k: [
			27,
			18
		]
	},
	"female-office-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F4BC",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f4bc.png",
				sheet_x: 19,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F4BC",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f4bc.png",
				sheet_x: 19,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F4BC",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f4bc.png",
				sheet_x: 19,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F4BC",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f4bc.png",
				sheet_x: 19,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F4BC",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f4bc.png",
				sheet_x: 19,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Office Worker",
		b: "1F469-200D-1F4BC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			23
		]
	},
	two: {
		a: "Keycap 2",
		b: "0032-FE0F-20E3",
		c: "0032-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		j: [
			"numbers",
			"2",
			"prime",
			"blue-square"
		],
		k: [
			0,
			4
		],
		o: 3
	},
	alarm_clock: {
		a: "Alarm Clock",
		b: "23F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"wake"
		],
		k: [
			47,
			0
		]
	},
	key: {
		a: "Key",
		b: "1F511",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"lock",
			"door",
			"password"
		],
		k: [
			27,
			19
		]
	},
	"flag-kw": {
		a: "Kuwait Flag",
		b: "1F1F0-1F1FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			3
		]
	},
	stopwatch: {
		a: "Stopwatch",
		b: "23F1-FE0F",
		c: "23F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"time",
			"deadline"
		],
		k: [
			47,
			1
		]
	},
	"male-scientist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F52C",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f52c.png",
				sheet_x: 17,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F52C",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f52c.png",
				sheet_x: 17,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F52C",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f52c.png",
				sheet_x: 17,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F52C",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f52c.png",
				sheet_x: 17,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F52C",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f52c.png",
				sheet_x: 17,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Scientist",
		b: "1F468-200D-1F52C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			17,
			25
		]
	},
	three: {
		a: "Keycap 3",
		b: "0033-FE0F-20E3",
		c: "0033-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		j: [
			"3",
			"numbers",
			"prime",
			"blue-square"
		],
		k: [
			0,
			5
		],
		o: 3
	},
	"flag-ky": {
		a: "Cayman Islands Flag",
		b: "1F1F0-1F1FE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			4
		]
	},
	old_key: {
		a: "Old Key",
		b: "1F5DD-FE0F",
		c: "1F5DD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"lock",
			"door",
			"password"
		],
		k: [
			30,
			11
		],
		o: 7
	},
	"flag-kz": {
		a: "Kazakhstan Flag",
		b: "1F1F0-1F1FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			5
		]
	},
	hammer: {
		a: "Hammer",
		b: "1F528",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"tools",
			"build",
			"create"
		],
		k: [
			27,
			42
		]
	},
	"female-scientist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F52C",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f52c.png",
				sheet_x: 19,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F52C",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f52c.png",
				sheet_x: 19,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F52C",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f52c.png",
				sheet_x: 19,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F52C",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f52c.png",
				sheet_x: 19,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F52C",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f52c.png",
				sheet_x: 19,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Scientist",
		b: "1F469-200D-1F52C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			35
		]
	},
	timer_clock: {
		a: "Timer Clock",
		b: "23F2-FE0F",
		c: "23F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"alarm"
		],
		k: [
			47,
			2
		]
	},
	four: {
		a: "Keycap 4",
		b: "0034-FE0F-20E3",
		c: "0034-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		j: [
			"4",
			"numbers",
			"blue-square"
		],
		k: [
			0,
			6
		],
		o: 3
	},
	"male-technologist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F4BB",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f4bb.png",
				sheet_x: 17,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F4BB",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f4bb.png",
				sheet_x: 17,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F4BB",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f4bb.png",
				sheet_x: 17,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F4BB",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f4bb.png",
				sheet_x: 17,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F4BB",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f4bb.png",
				sheet_x: 17,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Technologist",
		b: "1F468-200D-1F4BB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			17,
			7
		]
	},
	mantelpiece_clock: {
		a: "Mantelpiece Clock",
		b: "1F570-FE0F",
		c: "1F570",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"time"
		],
		k: [
			28,
			43
		],
		o: 7
	},
	five: {
		a: "Keycap 5",
		b: "0035-FE0F-20E3",
		c: "0035-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		j: [
			"5",
			"numbers",
			"blue-square",
			"prime"
		],
		k: [
			0,
			7
		],
		o: 3
	},
	"flag-la": {
		a: "Laos Flag",
		b: "1F1F1-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			6
		]
	},
	pick: {
		a: "Pick",
		b: "26CF-FE0F",
		c: "26CF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"tools",
			"dig"
		],
		k: [
			48,
			32
		],
		o: 5
	},
	"flag-lb": {
		a: "Lebanon Flag",
		b: "1F1F1-1F1E7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			7
		]
	},
	clock12: {
		a: "Clock Face Twelve Oclock",
		b: "1F55B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"noon",
			"midnight",
			"midday",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			29
		]
	},
	hammer_and_pick: {
		a: "Hammer and Pick",
		b: "2692-FE0F",
		c: "2692",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"tools",
			"build",
			"create"
		],
		k: [
			48,
			11
		],
		o: 4
	},
	six: {
		a: "Keycap 6",
		b: "0036-FE0F-20E3",
		c: "0036-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		j: [
			"6",
			"numbers",
			"blue-square"
		],
		k: [
			0,
			8
		],
		o: 3
	},
	"female-technologist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F4BB",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f4bb.png",
				sheet_x: 19,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F4BB",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f4bb.png",
				sheet_x: 19,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F4BB",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f4bb.png",
				sheet_x: 19,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F4BB",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f4bb.png",
				sheet_x: 19,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F4BB",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f4bb.png",
				sheet_x: 19,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Technologist",
		b: "1F469-200D-1F4BB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			17
		]
	},
	hammer_and_wrench: {
		a: "Hammer and Wrench",
		b: "1F6E0-FE0F",
		c: "1F6E0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"tools",
			"build",
			"create"
		],
		k: [
			37,
			8
		],
		o: 7
	},
	"flag-lc": {
		a: "St. Lucia Flag",
		b: "1F1F1-1F1E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			8
		]
	},
	clock1230: {
		a: "Clock Face Twelve-Thirty",
		b: "1F567",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			41
		]
	},
	seven: {
		a: "Keycap 7",
		b: "0037-FE0F-20E3",
		c: "0037-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		j: [
			"7",
			"numbers",
			"blue-square",
			"prime"
		],
		k: [
			0,
			9
		],
		o: 3
	},
	"male-singer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F3A4",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f3a4.png",
				sheet_x: 16,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F3A4",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f3a4.png",
				sheet_x: 16,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F3A4",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f3a4.png",
				sheet_x: 16,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F3A4",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f3a4.png",
				sheet_x: 16,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F3A4",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f3a4.png",
				sheet_x: 16,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Singer",
		b: "1F468-200D-1F3A4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			20
		]
	},
	eight: {
		a: "Keycap 8",
		b: "0038-FE0F-20E3",
		c: "0038-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		j: [
			"8",
			"blue-square",
			"numbers"
		],
		k: [
			0,
			10
		],
		o: 3
	},
	"flag-li": {
		a: "Liechtenstein Flag",
		b: "1F1F1-1F1EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			9
		]
	},
	dagger_knife: {
		a: "Dagger Knife",
		b: "1F5E1-FE0F",
		c: "1F5E1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			30,
			13
		],
		o: 7
	},
	clock1: {
		a: "Clock Face One Oclock",
		b: "1F550",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			18
		]
	},
	"female-singer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F3A4",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f3a4.png",
				sheet_x: 18,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F3A4",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f3a4.png",
				sheet_x: 18,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F3A4",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f3a4.png",
				sheet_x: 18,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F3A4",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f3a4.png",
				sheet_x: 18,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F3A4",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f3a4.png",
				sheet_x: 18,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Singer",
		b: "1F469-200D-1F3A4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			18,
			35
		]
	},
	"male-artist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F3A8",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f3a8.png",
				sheet_x: 16,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F3A8",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f3a8.png",
				sheet_x: 16,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F3A8",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f3a8.png",
				sheet_x: 16,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F3A8",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f3a8.png",
				sheet_x: 16,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F3A8",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f3a8.png",
				sheet_x: 16,
				sheet_y: 31,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Artist",
		b: "1F468-200D-1F3A8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			26
		]
	},
	crossed_swords: {
		a: "Crossed Swords",
		b: "2694-FE0F",
		c: "2694",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"weapon"
		],
		k: [
			48,
			13
		],
		o: 4
	},
	nine: {
		a: "Keycap 9",
		b: "0039-FE0F-20E3",
		c: "0039-20E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		j: [
			"blue-square",
			"numbers",
			"9"
		],
		k: [
			0,
			11
		],
		o: 3
	},
	"flag-lk": {
		a: "Sri Lanka Flag",
		b: "1F1F1-1F1F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			10
		]
	},
	clock130: {
		a: "Clock Face One-Thirty",
		b: "1F55C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			30
		]
	},
	clock2: {
		a: "Clock Face Two Oclock",
		b: "1F551",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			19
		]
	},
	gun: {
		a: "Pistol",
		b: "1F52B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"violence",
			"weapon",
			"pistol",
			"revolver"
		],
		k: [
			27,
			45
		]
	},
	keycap_ten: {
		a: "Keycap Ten",
		b: "1F51F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"numbers",
			"10",
			"blue-square"
		],
		k: [
			27,
			33
		]
	},
	"female-artist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F3A8",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f3a8.png",
				sheet_x: 18,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F3A8",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f3a8.png",
				sheet_x: 18,
				sheet_y: 43,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F3A8",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f3a8.png",
				sheet_x: 18,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F3A8",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f3a8.png",
				sheet_x: 18,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F3A8",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f3a8.png",
				sheet_x: 18,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Artist",
		b: "1F469-200D-1F3A8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			18,
			41
		]
	},
	"flag-lr": {
		a: "Liberia Flag",
		b: "1F1F1-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			11
		]
	},
	clock230: {
		a: "Clock Face Two-Thirty",
		b: "1F55D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			31
		]
	},
	bow_and_arrow: {
		a: "Bow and Arrow",
		b: "1F3F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sports"
		],
		k: [
			12,
			23
		],
		o: 8
	},
	"male-pilot": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-2708-FE0F",
				non_qualified: "1F468-1F3FB-200D-2708",
				image: "1f468-1f3fb-200d-2708-fe0f.png",
				sheet_x: 18,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-2708-FE0F",
				non_qualified: "1F468-1F3FC-200D-2708",
				image: "1f468-1f3fc-200d-2708-fe0f.png",
				sheet_x: 18,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-2708-FE0F",
				non_qualified: "1F468-1F3FD-200D-2708",
				image: "1f468-1f3fd-200d-2708-fe0f.png",
				sheet_x: 18,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-2708-FE0F",
				non_qualified: "1F468-1F3FE-200D-2708",
				image: "1f468-1f3fe-200d-2708-fe0f.png",
				sheet_x: 18,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-2708-FE0F",
				non_qualified: "1F468-1F3FF-200D-2708",
				image: "1f468-1f3ff-200d-2708-fe0f.png",
				sheet_x: 18,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Male Pilot",
		b: "1F468-200D-2708-FE0F",
		c: "1F468-200D-2708",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			18,
			3
		]
	},
	"flag-ls": {
		a: "Lesotho Flag",
		b: "1F1F1-1F1F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			12
		]
	},
	"flag-lt": {
		a: "Lithuania Flag",
		b: "1F1F1-1F1F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			13
		]
	},
	capital_abcd: {
		a: "Input Symbol for Latin Capital Letters",
		b: "1F520",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"alphabet",
			"words",
			"blue-square"
		],
		k: [
			27,
			34
		]
	},
	"female-pilot": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-2708-FE0F",
				non_qualified: "1F469-1F3FB-200D-2708",
				image: "1f469-1f3fb-200d-2708-fe0f.png",
				sheet_x: 20,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-2708-FE0F",
				non_qualified: "1F469-1F3FC-200D-2708",
				image: "1f469-1f3fc-200d-2708-fe0f.png",
				sheet_x: 20,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-2708-FE0F",
				non_qualified: "1F469-1F3FD-200D-2708",
				image: "1f469-1f3fd-200d-2708-fe0f.png",
				sheet_x: 20,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-2708-FE0F",
				non_qualified: "1F469-1F3FE-200D-2708",
				image: "1f469-1f3fe-200d-2708-fe0f.png",
				sheet_x: 20,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-2708-FE0F",
				non_qualified: "1F469-1F3FF-200D-2708",
				image: "1f469-1f3ff-200d-2708-fe0f.png",
				sheet_x: 20,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Female Pilot",
		b: "1F469-200D-2708-FE0F",
		c: "1F469-200D-2708",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			20,
			13
		]
	},
	clock3: {
		a: "Clock Face Three Oclock",
		b: "1F552",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			20
		]
	},
	shield: {
		a: "Shield",
		b: "1F6E1-FE0F",
		c: "1F6E1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"protection",
			"security"
		],
		k: [
			37,
			9
		],
		o: 7
	},
	"male-astronaut": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F680",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f680.png",
				sheet_x: 17,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F680",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f680.png",
				sheet_x: 17,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F680",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f680.png",
				sheet_x: 17,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F680",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f680.png",
				sheet_x: 17,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F680",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f680.png",
				sheet_x: 17,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Astronaut",
		b: "1F468-200D-1F680",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			17,
			31
		]
	},
	abcd: {
		a: "Input Symbol for Latin Small Letters",
		b: "1F521",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"alphabet"
		],
		k: [
			27,
			35
		]
	},
	clock330: {
		a: "Clock Face Three-Thirty",
		b: "1F55E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			32
		]
	},
	"flag-lu": {
		a: "Luxembourg Flag",
		b: "1F1F1-1F1FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			14
		]
	},
	wrench: {
		a: "Wrench",
		b: "1F527",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"tools",
			"diy",
			"ikea",
			"fix",
			"maintainer"
		],
		k: [
			27,
			41
		]
	},
	nut_and_bolt: {
		a: "Nut and Bolt",
		b: "1F529",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"handy",
			"tools",
			"fix"
		],
		k: [
			27,
			43
		]
	},
	clock4: {
		a: "Clock Face Four Oclock",
		b: "1F553",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			21
		]
	},
	"female-astronaut": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F680",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f680.png",
				sheet_x: 19,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F680",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f680.png",
				sheet_x: 19,
				sheet_y: 43,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F680",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f680.png",
				sheet_x: 19,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F680",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f680.png",
				sheet_x: 19,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F680",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f680.png",
				sheet_x: 19,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Astronaut",
		b: "1F469-200D-1F680",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			41
		]
	},
	"flag-lv": {
		a: "Latvia Flag",
		b: "1F1F1-1F1FB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			15
		]
	},
	gear: {
		a: "Gear",
		b: "2699-FE0F",
		c: "2699",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"cog"
		],
		k: [
			48,
			17
		],
		o: 4
	},
	"male-firefighter": {
		skin_variations: {
			"1F3FB": {
				unified: "1F468-1F3FB-200D-1F692",
				non_qualified: null,
				image: "1f468-1f3fb-200d-1f692.png",
				sheet_x: 17,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F468-1F3FC-200D-1F692",
				non_qualified: null,
				image: "1f468-1f3fc-200d-1f692.png",
				sheet_x: 17,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F468-1F3FD-200D-1F692",
				non_qualified: null,
				image: "1f468-1f3fd-200d-1f692.png",
				sheet_x: 17,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F468-1F3FE-200D-1F692",
				non_qualified: null,
				image: "1f468-1f3fe-200d-1f692.png",
				sheet_x: 17,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F468-1F3FF-200D-1F692",
				non_qualified: null,
				image: "1f468-1f3ff-200d-1f692.png",
				sheet_x: 17,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Male Firefighter",
		b: "1F468-200D-1F692",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			17,
			37
		]
	},
	"flag-ly": {
		a: "Libya Flag",
		b: "1F1F1-1F1FE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			16
		]
	},
	symbols: {
		a: "Input Symbol for Symbols",
		b: "1F523",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"music",
			"note",
			"ampersand",
			"percent",
			"glyphs",
			"characters"
		],
		k: [
			27,
			37
		]
	},
	clock430: {
		a: "Clock Face Four-Thirty",
		b: "1F55F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			33
		]
	},
	"flag-ma": {
		a: "Morocco Flag",
		b: "1F1F2-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			17
		]
	},
	compression: {
		a: "Compression",
		b: "1F5DC-FE0F",
		c: "1F5DC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			30,
			10
		],
		o: 7
	},
	"female-firefighter": {
		skin_variations: {
			"1F3FB": {
				unified: "1F469-1F3FB-200D-1F692",
				non_qualified: null,
				image: "1f469-1f3fb-200d-1f692.png",
				sheet_x: 19,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F469-1F3FC-200D-1F692",
				non_qualified: null,
				image: "1f469-1f3fc-200d-1f692.png",
				sheet_x: 19,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F469-1F3FD-200D-1F692",
				non_qualified: null,
				image: "1f469-1f3fd-200d-1f692.png",
				sheet_x: 19,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F469-1F3FE-200D-1F692",
				non_qualified: null,
				image: "1f469-1f3fe-200d-1f692.png",
				sheet_x: 19,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F469-1F3FF-200D-1F692",
				non_qualified: null,
				image: "1f469-1f3ff-200d-1f692.png",
				sheet_x: 20,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Female Firefighter",
		b: "1F469-200D-1F692",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			47
		]
	},
	abc: {
		a: "Input Symbol for Latin Letters",
		b: "1F524",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"alphabet"
		],
		k: [
			27,
			38
		]
	},
	clock5: {
		a: "Clock Face Five Oclock",
		b: "1F554",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			22
		]
	},
	clock530: {
		a: "Clock Face Five-Thirty",
		b: "1F560",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			34
		]
	},
	a: {
		a: "Negative Squared Latin Capital Letter a",
		b: "1F170-FE0F",
		c: "1F170",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"red-square",
			"alphabet",
			"letter"
		],
		k: [
			0,
			16
		]
	},
	alembic: {
		a: "Alembic",
		b: "2697-FE0F",
		c: "2697",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"distilling",
			"science",
			"experiment",
			"chemistry"
		],
		k: [
			48,
			16
		],
		o: 4
	},
	"flag-mc": {
		a: "Monaco Flag",
		b: "1F1F2-1F1E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			18
		]
	},
	cop: {
		skin_variations: {
			"1F3FB": {
				unified: "1F46E-1F3FB",
				non_qualified: null,
				image: "1f46e-1f3fb.png",
				sheet_x: 20,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F46E-1F3FC",
				non_qualified: null,
				image: "1f46e-1f3fc.png",
				sheet_x: 20,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F46E-1F3FD",
				non_qualified: null,
				image: "1f46e-1f3fd.png",
				sheet_x: 20,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F46E-1F3FE",
				non_qualified: null,
				image: "1f46e-1f3fe.png",
				sheet_x: 20,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F46E-1F3FF",
				non_qualified: null,
				image: "1f46e-1f3ff.png",
				sheet_x: 20,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F46E-200D-2642-FE0F",
		a: "Police Officer",
		b: "1F46E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			20,
			45
		]
	},
	scales: {
		a: "Scales",
		b: "2696-FE0F",
		c: "2696",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			48,
			15
		],
		o: 4
	},
	clock6: {
		a: "Clock Face Six Oclock",
		b: "1F555",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule",
			"dawn",
			"dusk"
		],
		k: [
			28,
			23
		]
	},
	"flag-md": {
		a: "Moldova Flag",
		b: "1F1F2-1F1E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			19
		]
	},
	ab: {
		a: "Negative Squared Ab",
		b: "1F18E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"red-square",
			"alphabet"
		],
		k: [
			0,
			20
		]
	},
	"male-police-officer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F46E-1F3FB-200D-2642-FE0F",
				non_qualified: "1F46E-1F3FB-200D-2642",
				image: "1f46e-1f3fb-200d-2642-fe0f.png",
				sheet_x: 20,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F46E-1F3FC-200D-2642-FE0F",
				non_qualified: "1F46E-1F3FC-200D-2642",
				image: "1f46e-1f3fc-200d-2642-fe0f.png",
				sheet_x: 20,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F46E-1F3FD-200D-2642-FE0F",
				non_qualified: "1F46E-1F3FD-200D-2642",
				image: "1f46e-1f3fd-200d-2642-fe0f.png",
				sheet_x: 20,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F46E-1F3FE-200D-2642-FE0F",
				non_qualified: "1F46E-1F3FE-200D-2642",
				image: "1f46e-1f3fe-200d-2642-fe0f.png",
				sheet_x: 20,
				sheet_y: 43,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F46E-1F3FF-200D-2642-FE0F",
				non_qualified: "1F46E-1F3FF-200D-2642",
				image: "1f46e-1f3ff-200d-2642-fe0f.png",
				sheet_x: 20,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F46E",
		a: "Male Police Officer",
		b: "1F46E-200D-2642-FE0F",
		c: "1F46E-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			20,
			39
		]
	},
	link: {
		a: "Link Symbol",
		b: "1F517",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"rings",
			"url"
		],
		k: [
			27,
			25
		]
	},
	"flag-me": {
		a: "Montenegro Flag",
		b: "1F1F2-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			20
		]
	},
	clock630: {
		a: "Clock Face Six-Thirty",
		b: "1F561",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			35
		]
	},
	b: {
		a: "Negative Squared Latin Capital Letter B",
		b: "1F171-FE0F",
		c: "1F171",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"red-square",
			"alphabet",
			"letter"
		],
		k: [
			0,
			17
		]
	},
	"female-police-officer": {
		skin_variations: {
			"1F3FB": {
				unified: "1F46E-1F3FB-200D-2640-FE0F",
				non_qualified: "1F46E-1F3FB-200D-2640",
				image: "1f46e-1f3fb-200d-2640-fe0f.png",
				sheet_x: 20,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F46E-1F3FC-200D-2640-FE0F",
				non_qualified: "1F46E-1F3FC-200D-2640",
				image: "1f46e-1f3fc-200d-2640-fe0f.png",
				sheet_x: 20,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F46E-1F3FD-200D-2640-FE0F",
				non_qualified: "1F46E-1F3FD-200D-2640",
				image: "1f46e-1f3fd-200d-2640-fe0f.png",
				sheet_x: 20,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F46E-1F3FE-200D-2640-FE0F",
				non_qualified: "1F46E-1F3FE-200D-2640",
				image: "1f46e-1f3fe-200d-2640-fe0f.png",
				sheet_x: 20,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F46E-1F3FF-200D-2640-FE0F",
				non_qualified: "1F46E-1F3FF-200D-2640",
				image: "1f46e-1f3ff-200d-2640-fe0f.png",
				sheet_x: 20,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Female Police Officer",
		b: "1F46E-200D-2640-FE0F",
		c: "1F46E-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			20,
			33
		]
	},
	clock7: {
		a: "Clock Face Seven Oclock",
		b: "1F556",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			24
		]
	},
	cl: {
		a: "Squared Cl",
		b: "1F191",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"alphabet",
			"words",
			"red-square"
		],
		k: [
			0,
			21
		]
	},
	sleuth_or_spy: {
		skin_variations: {
			"1F3FB": {
				unified: "1F575-1F3FB",
				non_qualified: null,
				image: "1f575-1f3fb.png",
				sheet_x: 29,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F575-1F3FC",
				non_qualified: null,
				image: "1f575-1f3fc.png",
				sheet_x: 29,
				sheet_y: 13,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F575-1F3FD",
				non_qualified: null,
				image: "1f575-1f3fd.png",
				sheet_x: 29,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F575-1F3FE",
				non_qualified: null,
				image: "1f575-1f3fe.png",
				sheet_x: 29,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F575-1F3FF",
				non_qualified: null,
				image: "1f575-1f3ff.png",
				sheet_x: 29,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoleted_by: "1F575-FE0F-200D-2642-FE0F",
		a: "Sleuth or Spy",
		b: "1F575-FE0F",
		c: "1F575",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			29,
			11
		],
		o: 7
	},
	"flag-mf": {
		a: "St. Martin Flag",
		b: "1F1F2-1F1EB",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			21
		]
	},
	chains: {
		a: "Chains",
		b: "26D3-FE0F",
		c: "26D3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"lock",
			"arrest"
		],
		k: [
			48,
			34
		],
		o: 5
	},
	syringe: {
		a: "Syringe",
		b: "1F489",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"health",
			"hospital",
			"drugs",
			"blood",
			"medicine",
			"needle",
			"doctor",
			"nurse"
		],
		k: [
			24,
			35
		]
	},
	"male-detective": {
		skin_variations: {
			"1F3FB": {
				unified: "1F575-1F3FB-200D-2642-FE0F",
				non_qualified: "1F575-1F3FB-200D-2642",
				image: "1f575-1f3fb-200d-2642-fe0f.png",
				sheet_x: 29,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F575-1F3FC-200D-2642-FE0F",
				non_qualified: "1F575-1F3FC-200D-2642",
				image: "1f575-1f3fc-200d-2642-fe0f.png",
				sheet_x: 29,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F575-1F3FD-200D-2642-FE0F",
				non_qualified: "1F575-1F3FD-200D-2642",
				image: "1f575-1f3fd-200d-2642-fe0f.png",
				sheet_x: 29,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F575-1F3FE-200D-2642-FE0F",
				non_qualified: "1F575-1F3FE-200D-2642",
				image: "1f575-1f3fe-200d-2642-fe0f.png",
				sheet_x: 29,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F575-1F3FF-200D-2642-FE0F",
				non_qualified: "1F575-1F3FF-200D-2642",
				image: "1f575-1f3ff-200d-2642-fe0f.png",
				sheet_x: 29,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F575-FE0F",
		a: "Male Detective",
		b: "1F575-FE0F-200D-2642-FE0F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			29,
			5
		],
		o: 7
	},
	cool: {
		a: "Squared Cool",
		b: "1F192",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"words",
			"blue-square"
		],
		k: [
			0,
			22
		]
	},
	clock730: {
		a: "Clock Face Seven-Thirty",
		b: "1F562",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			36
		]
	},
	"flag-mg": {
		a: "Madagascar Flag",
		b: "1F1F2-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			22
		]
	},
	free: {
		a: "Squared Free",
		b: "1F193",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"words"
		],
		k: [
			0,
			23
		]
	},
	"flag-mh": {
		a: "Marshall Islands Flag",
		b: "1F1F2-1F1ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			23
		]
	},
	clock8: {
		a: "Clock Face Eight Oclock",
		b: "1F557",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			25
		]
	},
	pill: {
		a: "Pill",
		b: "1F48A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"health",
			"medicine",
			"doctor",
			"pharmacy",
			"drug"
		],
		k: [
			24,
			36
		]
	},
	"female-detective": {
		skin_variations: {
			"1F3FB": {
				unified: "1F575-1F3FB-200D-2640-FE0F",
				non_qualified: "1F575-1F3FB-200D-2640",
				image: "1f575-1f3fb-200d-2640-fe0f.png",
				sheet_x: 29,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F575-1F3FC-200D-2640-FE0F",
				non_qualified: "1F575-1F3FC-200D-2640",
				image: "1f575-1f3fc-200d-2640-fe0f.png",
				sheet_x: 29,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F575-1F3FD-200D-2640-FE0F",
				non_qualified: "1F575-1F3FD-200D-2640",
				image: "1f575-1f3fd-200d-2640-fe0f.png",
				sheet_x: 29,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F575-1F3FE-200D-2640-FE0F",
				non_qualified: "1F575-1F3FE-200D-2640",
				image: "1f575-1f3fe-200d-2640-fe0f.png",
				sheet_x: 29,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F575-1F3FF-200D-2640-FE0F",
				non_qualified: "1F575-1F3FF-200D-2640",
				image: "1f575-1f3ff-200d-2640-fe0f.png",
				sheet_x: 29,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Female Detective",
		b: "1F575-FE0F-200D-2640-FE0F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			28,
			51
		],
		o: 7
	},
	clock830: {
		a: "Clock Face Eight-Thirty",
		b: "1F563",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			37
		]
	},
	guardsman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F482-1F3FB",
				non_qualified: null,
				image: "1f482-1f3fb.png",
				sheet_x: 23,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F482-1F3FC",
				non_qualified: null,
				image: "1f482-1f3fc.png",
				sheet_x: 23,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F482-1F3FD",
				non_qualified: null,
				image: "1f482-1f3fd.png",
				sheet_x: 23,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F482-1F3FE",
				non_qualified: null,
				image: "1f482-1f3fe.png",
				sheet_x: 23,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F482-1F3FF",
				non_qualified: null,
				image: "1f482-1f3ff.png",
				sheet_x: 23,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F482-200D-2642-FE0F",
		a: "Guardsman",
		b: "1F482",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		j: [
			"uk",
			"gb",
			"british",
			"male",
			"guy",
			"royal"
		],
		k: [
			23,
			31
		]
	},
	information_source: {
		a: "Information Source",
		b: "2139-FE0F",
		c: "2139",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"alphabet",
			"letter"
		],
		k: [
			46,
			32
		],
		o: 3
	},
	"flag-mk": {
		a: "Macedonia Flag",
		b: "1F1F2-1F1F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			24
		]
	},
	smoking: {
		a: "Smoking Symbol",
		b: "1F6AC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"kills",
			"tobacco",
			"cigarette",
			"joint",
			"smoke"
		],
		k: [
			35,
			17
		]
	},
	id: {
		a: "Squared Id",
		b: "1F194",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"purple-square",
			"words"
		],
		k: [
			0,
			24
		]
	},
	clock9: {
		a: "Clock Face Nine Oclock",
		b: "1F558",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			26
		]
	},
	"flag-ml": {
		a: "Mali Flag",
		b: "1F1F2-1F1F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			25
		]
	},
	coffin: {
		a: "Coffin",
		b: "26B0-FE0F",
		c: "26B0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"vampire",
			"dead",
			"die",
			"death",
			"rip",
			"graveyard",
			"cemetery",
			"casket",
			"funeral",
			"box"
		],
		k: [
			48,
			24
		],
		o: 4
	},
	"male-guard": {
		skin_variations: {
			"1F3FB": {
				unified: "1F482-1F3FB-200D-2642-FE0F",
				non_qualified: "1F482-1F3FB-200D-2642",
				image: "1f482-1f3fb-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F482-1F3FC-200D-2642-FE0F",
				non_qualified: "1F482-1F3FC-200D-2642",
				image: "1f482-1f3fc-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F482-1F3FD-200D-2642-FE0F",
				non_qualified: "1F482-1F3FD-200D-2642",
				image: "1f482-1f3fd-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F482-1F3FE-200D-2642-FE0F",
				non_qualified: "1F482-1F3FE-200D-2642",
				image: "1f482-1f3fe-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F482-1F3FF-200D-2642-FE0F",
				non_qualified: "1F482-1F3FF-200D-2642",
				image: "1f482-1f3ff-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F482",
		a: "Male Guard",
		b: "1F482-200D-2642-FE0F",
		c: "1F482-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			23,
			25
		]
	},
	m: {
		a: "Circled Latin Capital Letter M",
		b: "24C2-FE0F",
		c: "24C2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"alphabet",
			"blue-circle",
			"letter"
		],
		k: [
			47,
			7
		],
		o: 1
	},
	funeral_urn: {
		a: "Funeral Urn",
		b: "26B1-FE0F",
		c: "26B1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"dead",
			"die",
			"death",
			"rip",
			"ashes"
		],
		k: [
			48,
			25
		],
		o: 4
	},
	"female-guard": {
		skin_variations: {
			"1F3FB": {
				unified: "1F482-1F3FB-200D-2640-FE0F",
				non_qualified: "1F482-1F3FB-200D-2640",
				image: "1f482-1f3fb-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F482-1F3FC-200D-2640-FE0F",
				non_qualified: "1F482-1F3FC-200D-2640",
				image: "1f482-1f3fc-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F482-1F3FD-200D-2640-FE0F",
				non_qualified: "1F482-1F3FD-200D-2640",
				image: "1f482-1f3fd-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F482-1F3FE-200D-2640-FE0F",
				non_qualified: "1F482-1F3FE-200D-2640",
				image: "1f482-1f3fe-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F482-1F3FF-200D-2640-FE0F",
				non_qualified: "1F482-1F3FF-200D-2640",
				image: "1f482-1f3ff-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Female Guard",
		b: "1F482-200D-2640-FE0F",
		c: "1F482-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			23,
			19
		]
	},
	"flag-mm": {
		a: "Myanmar (burma) Flag",
		b: "1F1F2-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			26
		]
	},
	clock930: {
		a: "Clock Face Nine-Thirty",
		b: "1F564",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			38
		]
	},
	moyai: {
		a: "Moyai",
		b: "1F5FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"rock",
			"easter island",
			"moai"
		],
		k: [
			30,
			23
		]
	},
	"new": {
		a: "Squared New",
		b: "1F195",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"words",
			"start"
		],
		k: [
			0,
			25
		]
	},
	"flag-mn": {
		a: "Mongolia Flag",
		b: "1F1F2-1F1F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			27
		]
	},
	construction_worker: {
		skin_variations: {
			"1F3FB": {
				unified: "1F477-1F3FB",
				non_qualified: null,
				image: "1f477-1f3fb.png",
				sheet_x: 22,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F477-1F3FC",
				non_qualified: null,
				image: "1f477-1f3fc.png",
				sheet_x: 22,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F477-1F3FD",
				non_qualified: null,
				image: "1f477-1f3fd.png",
				sheet_x: 22,
				sheet_y: 31,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F477-1F3FE",
				non_qualified: null,
				image: "1f477-1f3fe.png",
				sheet_x: 22,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F477-1F3FF",
				non_qualified: null,
				image: "1f477-1f3ff.png",
				sheet_x: 22,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F477-200D-2642-FE0F",
		a: "Construction Worker",
		b: "1F477",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			22,
			28
		]
	},
	clock10: {
		a: "Clock Face Ten Oclock",
		b: "1F559",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			27
		]
	},
	clock1030: {
		a: "Clock Face Ten-Thirty",
		b: "1F565",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			39
		]
	},
	ng: {
		a: "Squared Ng",
		b: "1F196",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"words",
			"shape",
			"icon"
		],
		k: [
			0,
			26
		]
	},
	"male-construction-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F477-1F3FB-200D-2642-FE0F",
				non_qualified: "1F477-1F3FB-200D-2642",
				image: "1f477-1f3fb-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F477-1F3FC-200D-2642-FE0F",
				non_qualified: "1F477-1F3FC-200D-2642",
				image: "1f477-1f3fc-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F477-1F3FD-200D-2642-FE0F",
				non_qualified: "1F477-1F3FD-200D-2642",
				image: "1f477-1f3fd-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F477-1F3FE-200D-2642-FE0F",
				non_qualified: "1F477-1F3FE-200D-2642",
				image: "1f477-1f3fe-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F477-1F3FF-200D-2642-FE0F",
				non_qualified: "1F477-1F3FF-200D-2642",
				image: "1f477-1f3ff-200d-2642-fe0f.png",
				sheet_x: 22,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F477",
		a: "Male Construction Worker",
		b: "1F477-200D-2642-FE0F",
		c: "1F477-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			22,
			22
		]
	},
	"flag-mo": {
		a: "Macau Sar China Flag",
		b: "1F1F2-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			28
		]
	},
	oil_drum: {
		a: "Oil Drum",
		b: "1F6E2-FE0F",
		c: "1F6E2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"barrell"
		],
		k: [
			37,
			10
		],
		o: 7
	},
	o2: {
		a: "Negative Squared Latin Capital Letter O",
		b: "1F17E-FE0F",
		c: "1F17E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"alphabet",
			"red-square",
			"letter"
		],
		k: [
			0,
			18
		]
	},
	"female-construction-worker": {
		skin_variations: {
			"1F3FB": {
				unified: "1F477-1F3FB-200D-2640-FE0F",
				non_qualified: "1F477-1F3FB-200D-2640",
				image: "1f477-1f3fb-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F477-1F3FC-200D-2640-FE0F",
				non_qualified: "1F477-1F3FC-200D-2640",
				image: "1f477-1f3fc-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F477-1F3FD-200D-2640-FE0F",
				non_qualified: "1F477-1F3FD-200D-2640",
				image: "1f477-1f3fd-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F477-1F3FE-200D-2640-FE0F",
				non_qualified: "1F477-1F3FE-200D-2640",
				image: "1f477-1f3fe-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F477-1F3FF-200D-2640-FE0F",
				non_qualified: "1F477-1F3FF-200D-2640",
				image: "1f477-1f3ff-200d-2640-fe0f.png",
				sheet_x: 22,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Female Construction Worker",
		b: "1F477-200D-2640-FE0F",
		c: "1F477-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			22,
			16
		]
	},
	clock11: {
		a: "Clock Face Eleven Oclock",
		b: "1F55A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			28
		]
	},
	crystal_ball: {
		a: "Crystal Ball",
		b: "1F52E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"disco",
			"party",
			"magic",
			"circus",
			"fortune_teller"
		],
		k: [
			27,
			48
		]
	},
	"flag-mp": {
		a: "Northern Mariana Islands Flag",
		b: "1F1F2-1F1F5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			29
		]
	},
	"flag-mq": {
		a: "Martinique Flag",
		b: "1F1F2-1F1F6",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			30
		]
	},
	prince: {
		skin_variations: {
			"1F3FB": {
				unified: "1F934-1F3FB",
				non_qualified: null,
				image: "1f934-1f3fb.png",
				sheet_x: 39,
				sheet_y: 29,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F934-1F3FC",
				non_qualified: null,
				image: "1f934-1f3fc.png",
				sheet_x: 39,
				sheet_y: 30,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F934-1F3FD",
				non_qualified: null,
				image: "1f934-1f3fd.png",
				sheet_x: 39,
				sheet_y: 31,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F934-1F3FE",
				non_qualified: null,
				image: "1f934-1f3fe.png",
				sheet_x: 39,
				sheet_y: 32,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F934-1F3FF",
				non_qualified: null,
				image: "1f934-1f3ff.png",
				sheet_x: 39,
				sheet_y: 33,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Prince",
		b: "1F934",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"boy",
			"man",
			"male",
			"crown",
			"royal",
			"king"
		],
		k: [
			39,
			28
		],
		o: 9
	},
	ok: {
		a: "Squared Ok",
		b: "1F197",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"good",
			"agree",
			"yes",
			"blue-square"
		],
		k: [
			0,
			27
		]
	},
	clock1130: {
		a: "Clock Face Eleven-Thirty",
		b: "1F566",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"time",
			"late",
			"early",
			"schedule"
		],
		k: [
			28,
			40
		]
	},
	shopping_trolley: {
		a: "Shopping Trolley",
		b: "1F6D2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			7
		],
		o: 9
	},
	"flag-mr": {
		a: "Mauritania Flag",
		b: "1F1F2-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			31
		]
	},
	princess: {
		skin_variations: {
			"1F3FB": {
				unified: "1F478-1F3FB",
				non_qualified: null,
				image: "1f478-1f3fb.png",
				sheet_x: 22,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F478-1F3FC",
				non_qualified: null,
				image: "1f478-1f3fc.png",
				sheet_x: 22,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F478-1F3FD",
				non_qualified: null,
				image: "1f478-1f3fd.png",
				sheet_x: 22,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F478-1F3FE",
				non_qualified: null,
				image: "1f478-1f3fe.png",
				sheet_x: 22,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F478-1F3FF",
				non_qualified: null,
				image: "1f478-1f3ff.png",
				sheet_x: 22,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Princess",
		b: "1F478",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"girl",
			"woman",
			"female",
			"blond",
			"crown",
			"royal",
			"queen"
		],
		k: [
			22,
			34
		]
	},
	new_moon: {
		a: "New Moon Symbol",
		b: "1F311",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			6,
			9
		]
	},
	parking: {
		a: "Negative Squared Latin Capital Letter P",
		b: "1F17F-FE0F",
		c: "1F17F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"cars",
			"blue-square",
			"alphabet",
			"letter"
		],
		k: [
			0,
			19
		],
		o: 5
	},
	sos: {
		a: "Squared Sos",
		b: "1F198",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"help",
			"red-square",
			"words",
			"emergency",
			"911"
		],
		k: [
			0,
			28
		]
	},
	man_with_turban: {
		skin_variations: {
			"1F3FB": {
				unified: "1F473-1F3FB",
				non_qualified: null,
				image: "1f473-1f3fb.png",
				sheet_x: 21,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F473-1F3FC",
				non_qualified: null,
				image: "1f473-1f3fc.png",
				sheet_x: 21,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F473-1F3FD",
				non_qualified: null,
				image: "1f473-1f3fd.png",
				sheet_x: 21,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F473-1F3FE",
				non_qualified: null,
				image: "1f473-1f3fe.png",
				sheet_x: 21,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F473-1F3FF",
				non_qualified: null,
				image: "1f473-1f3ff.png",
				sheet_x: 21,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F473-200D-2642-FE0F",
		a: "Man with Turban",
		b: "1F473",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		j: [
			"male",
			"indian",
			"hinduism",
			"arabs"
		],
		k: [
			21,
			44
		]
	},
	"flag-ms": {
		a: "Montserrat Flag",
		b: "1F1F2-1F1F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			32
		]
	},
	waxing_crescent_moon: {
		a: "Waxing Crescent Moon Symbol",
		b: "1F312",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			6,
			10
		]
	},
	up: {
		a: "Squared Up with Exclamation Mark",
		b: "1F199",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"above",
			"high"
		],
		k: [
			0,
			29
		]
	},
	first_quarter_moon: {
		a: "First Quarter Moon Symbol",
		b: "1F313",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			6,
			11
		]
	},
	"flag-mt": {
		a: "Malta Flag",
		b: "1F1F2-1F1F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			33
		]
	},
	"man-wearing-turban": {
		skin_variations: {
			"1F3FB": {
				unified: "1F473-1F3FB-200D-2642-FE0F",
				non_qualified: "1F473-1F3FB-200D-2642",
				image: "1f473-1f3fb-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F473-1F3FC-200D-2642-FE0F",
				non_qualified: "1F473-1F3FC-200D-2642",
				image: "1f473-1f3fc-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F473-1F3FD-200D-2642-FE0F",
				non_qualified: "1F473-1F3FD-200D-2642",
				image: "1f473-1f3fd-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F473-1F3FE-200D-2642-FE0F",
				non_qualified: "1F473-1F3FE-200D-2642",
				image: "1f473-1f3fe-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F473-1F3FF-200D-2642-FE0F",
				non_qualified: "1F473-1F3FF-200D-2642",
				image: "1f473-1f3ff-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 43,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F473",
		a: "Man Wearing Turban",
		b: "1F473-200D-2642-FE0F",
		c: "1F473-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			21,
			38
		]
	},
	moon: {
		a: "Waxing Gibbous Moon Symbol",
		b: "1F314",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			6,
			12
		],
		n: [
			"waxing_gibbous_moon"
		]
	},
	"woman-wearing-turban": {
		skin_variations: {
			"1F3FB": {
				unified: "1F473-1F3FB-200D-2640-FE0F",
				non_qualified: "1F473-1F3FB-200D-2640",
				image: "1f473-1f3fb-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F473-1F3FC-200D-2640-FE0F",
				non_qualified: "1F473-1F3FC-200D-2640",
				image: "1f473-1f3fc-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F473-1F3FD-200D-2640-FE0F",
				non_qualified: "1F473-1F3FD-200D-2640",
				image: "1f473-1f3fd-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F473-1F3FE-200D-2640-FE0F",
				non_qualified: "1F473-1F3FE-200D-2640",
				image: "1f473-1f3fe-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F473-1F3FF-200D-2640-FE0F",
				non_qualified: "1F473-1F3FF-200D-2640",
				image: "1f473-1f3ff-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Wearing Turban",
		b: "1F473-200D-2640-FE0F",
		c: "1F473-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			21,
			32
		]
	},
	vs: {
		a: "Squared Vs",
		b: "1F19A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"words",
			"orange-square"
		],
		k: [
			0,
			30
		]
	},
	"flag-mu": {
		a: "Mauritius Flag",
		b: "1F1F2-1F1FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			34
		]
	},
	man_with_gua_pi_mao: {
		skin_variations: {
			"1F3FB": {
				unified: "1F472-1F3FB",
				non_qualified: null,
				image: "1f472-1f3fb.png",
				sheet_x: 21,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F472-1F3FC",
				non_qualified: null,
				image: "1f472-1f3fc.png",
				sheet_x: 21,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F472-1F3FD",
				non_qualified: null,
				image: "1f472-1f3fd.png",
				sheet_x: 21,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F472-1F3FE",
				non_qualified: null,
				image: "1f472-1f3fe.png",
				sheet_x: 21,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F472-1F3FF",
				non_qualified: null,
				image: "1f472-1f3ff.png",
				sheet_x: 21,
				sheet_y: 31,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Man with Gua Pi Mao",
		b: "1F472",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"male",
			"boy",
			"chinese"
		],
		k: [
			21,
			26
		]
	},
	koko: {
		a: "Squared Katakana Koko",
		b: "1F201",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue-square",
			"here",
			"katakana",
			"japanese",
			"destination"
		],
		k: [
			5,
			29
		]
	},
	full_moon: {
		a: "Full Moon Symbol",
		b: "1F315",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"yellow",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			6,
			13
		]
	},
	"flag-mv": {
		a: "Maldives Flag",
		b: "1F1F2-1F1FB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			35
		]
	},
	person_with_headscarf: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D5-1F3FB",
				non_qualified: null,
				image: "1f9d5-1f3fb.png",
				sheet_x: 43,
				sheet_y: 23,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9D5-1F3FC",
				non_qualified: null,
				image: "1f9d5-1f3fc.png",
				sheet_x: 43,
				sheet_y: 24,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9D5-1F3FD",
				non_qualified: null,
				image: "1f9d5-1f3fd.png",
				sheet_x: 43,
				sheet_y: 25,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9D5-1F3FE",
				non_qualified: null,
				image: "1f9d5-1f3fe.png",
				sheet_x: 43,
				sheet_y: 26,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9D5-1F3FF",
				non_qualified: null,
				image: "1f9d5-1f3ff.png",
				sheet_x: 43,
				sheet_y: 27,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Person with Headscarf",
		b: "1F9D5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			43,
			22
		],
		o: 10
	},
	waning_gibbous_moon: {
		a: "Waning Gibbous Moon Symbol",
		b: "1F316",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep",
			"waxing_gibbous_moon"
		],
		k: [
			6,
			14
		]
	},
	sa: {
		a: "Squared Katakana Sa",
		b: "1F202-FE0F",
		c: "1F202",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"japanese",
			"blue-square",
			"katakana"
		],
		k: [
			5,
			30
		]
	},
	"flag-mw": {
		a: "Malawi Flag",
		b: "1F1F2-1F1FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			36
		]
	},
	last_quarter_moon: {
		a: "Last Quarter Moon Symbol",
		b: "1F317",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			6,
			15
		]
	},
	u6708: {
		a: "Squared Cjk Unified Ideograph-6708",
		b: "1F237-FE0F",
		c: "1F237",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"chinese",
			"month",
			"moon",
			"japanese",
			"orange-square",
			"kanji"
		],
		k: [
			5,
			38
		]
	},
	bearded_person: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D4-1F3FB",
				non_qualified: null,
				image: "1f9d4-1f3fb.png",
				sheet_x: 43,
				sheet_y: 17,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9D4-1F3FC",
				non_qualified: null,
				image: "1f9d4-1f3fc.png",
				sheet_x: 43,
				sheet_y: 18,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9D4-1F3FD",
				non_qualified: null,
				image: "1f9d4-1f3fd.png",
				sheet_x: 43,
				sheet_y: 19,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9D4-1F3FE",
				non_qualified: null,
				image: "1f9d4-1f3fe.png",
				sheet_x: 43,
				sheet_y: 20,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9D4-1F3FF",
				non_qualified: null,
				image: "1f9d4-1f3ff.png",
				sheet_x: 43,
				sheet_y: 21,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Bearded Person",
		b: "1F9D4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			43,
			16
		],
		o: 10
	},
	"flag-mx": {
		a: "Mexico Flag",
		b: "1F1F2-1F1FD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			37
		]
	},
	u6709: {
		a: "Squared Cjk Unified Ideograph-6709",
		b: "1F236",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"orange-square",
			"chinese",
			"have",
			"kanji"
		],
		k: [
			5,
			37
		]
	},
	person_with_blond_hair: {
		skin_variations: {
			"1F3FB": {
				unified: "1F471-1F3FB",
				non_qualified: null,
				image: "1f471-1f3fb.png",
				sheet_x: 21,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F471-1F3FC",
				non_qualified: null,
				image: "1f471-1f3fc.png",
				sheet_x: 21,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F471-1F3FD",
				non_qualified: null,
				image: "1f471-1f3fd.png",
				sheet_x: 21,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F471-1F3FE",
				non_qualified: null,
				image: "1f471-1f3fe.png",
				sheet_x: 21,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F471-1F3FF",
				non_qualified: null,
				image: "1f471-1f3ff.png",
				sheet_x: 21,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F471-200D-2642-FE0F",
		a: "Person with Blond Hair",
		b: "1F471",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			21,
			20
		]
	},
	waning_crescent_moon: {
		a: "Waning Crescent Moon Symbol",
		b: "1F318",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			6,
			16
		]
	},
	"flag-my": {
		a: "Malaysia Flag",
		b: "1F1F2-1F1FE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			38
		]
	},
	u6307: {
		a: "Squared Cjk Unified Ideograph-6307",
		b: "1F22F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"chinese",
			"point",
			"green-square",
			"kanji"
		],
		k: [
			5,
			32
		],
		o: 5
	},
	"blond-haired-man": {
		skin_variations: {
			"1F3FB": {
				unified: "1F471-1F3FB-200D-2642-FE0F",
				non_qualified: "1F471-1F3FB-200D-2642",
				image: "1f471-1f3fb-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F471-1F3FC-200D-2642-FE0F",
				non_qualified: "1F471-1F3FC-200D-2642",
				image: "1f471-1f3fc-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F471-1F3FD-200D-2642-FE0F",
				non_qualified: "1F471-1F3FD-200D-2642",
				image: "1f471-1f3fd-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F471-1F3FE-200D-2642-FE0F",
				non_qualified: "1F471-1F3FE-200D-2642",
				image: "1f471-1f3fe-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F471-1F3FF-200D-2642-FE0F",
				non_qualified: "1F471-1F3FF-200D-2642",
				image: "1f471-1f3ff-200d-2642-fe0f.png",
				sheet_x: 21,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F471",
		a: "Blond Haired Man",
		b: "1F471-200D-2642-FE0F",
		c: "1F471-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			21,
			14
		]
	},
	crescent_moon: {
		a: "Crescent Moon",
		b: "1F319",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"night",
			"sleep",
			"sky",
			"evening",
			"magic"
		],
		k: [
			6,
			17
		]
	},
	"flag-mz": {
		a: "Mozambique Flag",
		b: "1F1F2-1F1FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			39
		]
	},
	new_moon_with_face: {
		a: "New Moon with Face",
		b: "1F31A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			6,
			18
		]
	},
	"flag-na": {
		a: "Namibia Flag",
		b: "1F1F3-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			40
		]
	},
	"blond-haired-woman": {
		skin_variations: {
			"1F3FB": {
				unified: "1F471-1F3FB-200D-2640-FE0F",
				non_qualified: "1F471-1F3FB-200D-2640",
				image: "1f471-1f3fb-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F471-1F3FC-200D-2640-FE0F",
				non_qualified: "1F471-1F3FC-200D-2640",
				image: "1f471-1f3fc-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F471-1F3FD-200D-2640-FE0F",
				non_qualified: "1F471-1F3FD-200D-2640",
				image: "1f471-1f3fd-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F471-1F3FE-200D-2640-FE0F",
				non_qualified: "1F471-1F3FE-200D-2640",
				image: "1f471-1f3fe-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F471-1F3FF-200D-2640-FE0F",
				non_qualified: "1F471-1F3FF-200D-2640",
				image: "1f471-1f3ff-200d-2640-fe0f.png",
				sheet_x: 21,
				sheet_y: 13,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Blond Haired Woman",
		b: "1F471-200D-2640-FE0F",
		c: "1F471-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			21,
			8
		]
	},
	ideograph_advantage: {
		a: "Circled Ideograph Advantage",
		b: "1F250",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"chinese",
			"kanji",
			"obtain",
			"get",
			"circle"
		],
		k: [
			5,
			42
		]
	},
	first_quarter_moon_with_face: {
		a: "First Quarter Moon with Face",
		b: "1F31B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			6,
			19
		]
	},
	man_in_tuxedo: {
		skin_variations: {
			"1F3FB": {
				unified: "1F935-1F3FB",
				non_qualified: null,
				image: "1f935-1f3fb.png",
				sheet_x: 39,
				sheet_y: 35,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F935-1F3FC",
				non_qualified: null,
				image: "1f935-1f3fc.png",
				sheet_x: 39,
				sheet_y: 36,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F935-1F3FD",
				non_qualified: null,
				image: "1f935-1f3fd.png",
				sheet_x: 39,
				sheet_y: 37,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F935-1F3FE",
				non_qualified: null,
				image: "1f935-1f3fe.png",
				sheet_x: 39,
				sheet_y: 38,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F935-1F3FF",
				non_qualified: null,
				image: "1f935-1f3ff.png",
				sheet_x: 39,
				sheet_y: 39,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Man in Tuxedo",
		b: "1F935",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"couple",
			"marriage",
			"wedding",
			"groom"
		],
		k: [
			39,
			34
		],
		o: 9
	},
	"flag-nc": {
		a: "New Caledonia Flag",
		b: "1F1F3-1F1E8",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			41
		]
	},
	u5272: {
		a: "Squared Cjk Unified Ideograph-5272",
		b: "1F239",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"cut",
			"divide",
			"chinese",
			"kanji",
			"pink-square"
		],
		k: [
			5,
			40
		]
	},
	"flag-ne": {
		a: "Niger Flag",
		b: "1F1F3-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			42
		]
	},
	last_quarter_moon_with_face: {
		a: "Last Quarter Moon with Face",
		b: "1F31C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			6,
			20
		]
	},
	u7121: {
		a: "Squared Cjk Unified Ideograph-7121",
		b: "1F21A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nothing",
			"chinese",
			"kanji",
			"japanese",
			"orange-square"
		],
		k: [
			5,
			31
		],
		o: 5
	},
	bride_with_veil: {
		skin_variations: {
			"1F3FB": {
				unified: "1F470-1F3FB",
				non_qualified: null,
				image: "1f470-1f3fb.png",
				sheet_x: 21,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F470-1F3FC",
				non_qualified: null,
				image: "1f470-1f3fc.png",
				sheet_x: 21,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F470-1F3FD",
				non_qualified: null,
				image: "1f470-1f3fd.png",
				sheet_x: 21,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F470-1F3FE",
				non_qualified: null,
				image: "1f470-1f3fe.png",
				sheet_x: 21,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F470-1F3FF",
				non_qualified: null,
				image: "1f470-1f3ff.png",
				sheet_x: 21,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Bride with Veil",
		b: "1F470",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"couple",
			"marriage",
			"wedding",
			"woman",
			"bride"
		],
		k: [
			21,
			2
		]
	},
	u7981: {
		a: "Squared Cjk Unified Ideograph-7981",
		b: "1F232",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"kanji",
			"japanese",
			"chinese",
			"forbidden",
			"limit",
			"restricted",
			"red-square"
		],
		k: [
			5,
			33
		]
	},
	pregnant_woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F930-1F3FB",
				non_qualified: null,
				image: "1f930-1f3fb.png",
				sheet_x: 39,
				sheet_y: 5,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F930-1F3FC",
				non_qualified: null,
				image: "1f930-1f3fc.png",
				sheet_x: 39,
				sheet_y: 6,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F930-1F3FD",
				non_qualified: null,
				image: "1f930-1f3fd.png",
				sheet_x: 39,
				sheet_y: 7,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F930-1F3FE",
				non_qualified: null,
				image: "1f930-1f3fe.png",
				sheet_x: 39,
				sheet_y: 8,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F930-1F3FF",
				non_qualified: null,
				image: "1f930-1f3ff.png",
				sheet_x: 39,
				sheet_y: 9,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Pregnant Woman",
		b: "1F930",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"baby"
		],
		k: [
			39,
			4
		],
		o: 9
	},
	thermometer: {
		a: "Thermometer",
		b: "1F321-FE0F",
		c: "1F321",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"weather",
			"temperature",
			"hot",
			"cold"
		],
		k: [
			6,
			25
		],
		o: 7
	},
	"flag-nf": {
		a: "Norfolk Island Flag",
		b: "1F1F3-1F1EB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			43
		]
	},
	sunny: {
		a: "Black Sun with Rays",
		b: "2600-FE0F",
		c: "2600",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"weather",
			"nature",
			"brightness",
			"summer",
			"beach",
			"spring"
		],
		k: [
			47,
			16
		],
		o: 1
	},
	accept: {
		a: "Circled Ideograph Accept",
		b: "1F251",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"ok",
			"good",
			"chinese",
			"kanji",
			"agree",
			"yes",
			"orange-circle"
		],
		k: [
			5,
			43
		]
	},
	"flag-ng": {
		a: "Nigeria Flag",
		b: "1F1F3-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			44
		]
	},
	"breast-feeding": {
		skin_variations: {
			"1F3FB": {
				unified: "1F931-1F3FB",
				non_qualified: null,
				image: "1f931-1f3fb.png",
				sheet_x: 39,
				sheet_y: 11,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F931-1F3FC",
				non_qualified: null,
				image: "1f931-1f3fc.png",
				sheet_x: 39,
				sheet_y: 12,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F931-1F3FD",
				non_qualified: null,
				image: "1f931-1f3fd.png",
				sheet_x: 39,
				sheet_y: 13,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F931-1F3FE",
				non_qualified: null,
				image: "1f931-1f3fe.png",
				sheet_x: 39,
				sheet_y: 14,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F931-1F3FF",
				non_qualified: null,
				image: "1f931-1f3ff.png",
				sheet_x: 39,
				sheet_y: 15,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Breast-Feeding",
		b: "1F931",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			39,
			10
		],
		o: 10
	},
	full_moon_with_face: {
		a: "Full Moon with Face",
		b: "1F31D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		k: [
			6,
			21
		]
	},
	"flag-ni": {
		a: "Nicaragua Flag",
		b: "1F1F3-1F1EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			45
		]
	},
	u7533: {
		a: "Squared Cjk Unified Ideograph-7533",
		b: "1F238",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"chinese",
			"japanese",
			"kanji",
			"orange-square"
		],
		k: [
			5,
			39
		]
	},
	angel: {
		skin_variations: {
			"1F3FB": {
				unified: "1F47C-1F3FB",
				non_qualified: null,
				image: "1f47c-1f3fb.png",
				sheet_x: 22,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F47C-1F3FC",
				non_qualified: null,
				image: "1f47c-1f3fc.png",
				sheet_x: 22,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F47C-1F3FD",
				non_qualified: null,
				image: "1f47c-1f3fd.png",
				sheet_x: 22,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F47C-1F3FE",
				non_qualified: null,
				image: "1f47c-1f3fe.png",
				sheet_x: 22,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F47C-1F3FF",
				non_qualified: null,
				image: "1f47c-1f3ff.png",
				sheet_x: 22,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Baby Angel",
		b: "1F47C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"heaven",
			"wings",
			"halo"
		],
		k: [
			22,
			43
		]
	},
	sun_with_face: {
		a: "Sun with Face",
		b: "1F31E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"morning",
			"sky"
		],
		k: [
			6,
			22
		]
	},
	santa: {
		skin_variations: {
			"1F3FB": {
				unified: "1F385-1F3FB",
				non_qualified: null,
				image: "1f385-1f3fb.png",
				sheet_x: 8,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F385-1F3FC",
				non_qualified: null,
				image: "1f385-1f3fc.png",
				sheet_x: 8,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F385-1F3FD",
				non_qualified: null,
				image: "1f385-1f3fd.png",
				sheet_x: 8,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F385-1F3FE",
				non_qualified: null,
				image: "1f385-1f3fe.png",
				sheet_x: 8,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F385-1F3FF",
				non_qualified: null,
				image: "1f385-1f3ff.png",
				sheet_x: 8,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Father Christmas",
		b: "1F385",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"festival",
			"man",
			"male",
			"xmas",
			"father christmas"
		],
		k: [
			8,
			19
		]
	},
	u5408: {
		a: "Squared Cjk Unified Ideograph-5408",
		b: "1F234",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"japanese",
			"chinese",
			"join",
			"kanji",
			"red-square"
		],
		k: [
			5,
			35
		]
	},
	"flag-nl": {
		a: "Netherlands Flag",
		b: "1F1F3-1F1F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			46
		]
	},
	mrs_claus: {
		skin_variations: {
			"1F3FB": {
				unified: "1F936-1F3FB",
				non_qualified: null,
				image: "1f936-1f3fb.png",
				sheet_x: 39,
				sheet_y: 41,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F936-1F3FC",
				non_qualified: null,
				image: "1f936-1f3fc.png",
				sheet_x: 39,
				sheet_y: 42,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F936-1F3FD",
				non_qualified: null,
				image: "1f936-1f3fd.png",
				sheet_x: 39,
				sheet_y: 43,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F936-1F3FE",
				non_qualified: null,
				image: "1f936-1f3fe.png",
				sheet_x: 39,
				sheet_y: 44,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F936-1F3FF",
				non_qualified: null,
				image: "1f936-1f3ff.png",
				sheet_x: 39,
				sheet_y: 45,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Mother Christmas",
		b: "1F936",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"woman",
			"female",
			"xmas",
			"mother christmas"
		],
		k: [
			39,
			40
		],
		n: [
			"mother_christmas"
		],
		o: 9
	},
	u7a7a: {
		a: "Squared Cjk Unified Ideograph-7a7a",
		b: "1F233",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"kanji",
			"japanese",
			"chinese",
			"empty",
			"sky",
			"blue-square"
		],
		k: [
			5,
			34
		]
	},
	star: {
		a: "White Medium Star",
		b: "2B50",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"night",
			"yellow"
		],
		k: [
			50,
			22
		],
		o: 5
	},
	"flag-no": {
		a: "Norway Flag",
		b: "1F1F3-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			47
		]
	},
	mage: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D9-1F3FB",
				non_qualified: null,
				image: "1f9d9-1f3fb.png",
				sheet_x: 44,
				sheet_y: 43,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D9-1F3FB-200D-2640-FE0F"
			},
			"1F3FC": {
				unified: "1F9D9-1F3FC",
				non_qualified: null,
				image: "1f9d9-1f3fc.png",
				sheet_x: 44,
				sheet_y: 44,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D9-1F3FC-200D-2640-FE0F"
			},
			"1F3FD": {
				unified: "1F9D9-1F3FD",
				non_qualified: null,
				image: "1f9d9-1f3fd.png",
				sheet_x: 44,
				sheet_y: 45,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D9-1F3FD-200D-2640-FE0F"
			},
			"1F3FE": {
				unified: "1F9D9-1F3FE",
				non_qualified: null,
				image: "1f9d9-1f3fe.png",
				sheet_x: 44,
				sheet_y: 46,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D9-1F3FE-200D-2640-FE0F"
			},
			"1F3FF": {
				unified: "1F9D9-1F3FF",
				non_qualified: null,
				image: "1f9d9-1f3ff.png",
				sheet_x: 44,
				sheet_y: 47,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D9-1F3FF-200D-2640-FE0F"
			}
		},
		obsoleted_by: "1F9D9-200D-2640-FE0F",
		a: "Mage",
		b: "1F9D9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			44,
			42
		],
		o: 10
	},
	star2: {
		a: "Glowing Star",
		b: "1F31F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"night",
			"sparkle",
			"awesome",
			"good",
			"magic"
		],
		k: [
			6,
			23
		]
	},
	"flag-np": {
		a: "Nepal Flag",
		b: "1F1F3-1F1F5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			48
		]
	},
	congratulations: {
		a: "Circled Ideograph Congratulation",
		b: "3297-FE0F",
		c: "3297",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"chinese",
			"kanji",
			"japanese",
			"red-circle"
		],
		k: [
			50,
			26
		],
		o: 1
	},
	"flag-nr": {
		a: "Nauru Flag",
		b: "1F1F3-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			49
		]
	},
	stars: {
		a: "Shooting Star",
		b: "1F320",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"night",
			"photo"
		],
		k: [
			6,
			24
		]
	},
	female_mage: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D9-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9D9-1F3FB-200D-2640",
				image: "1f9d9-1f3fb-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 31,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D9-1F3FB"
			},
			"1F3FC": {
				unified: "1F9D9-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9D9-1F3FC-200D-2640",
				image: "1f9d9-1f3fc-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 32,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D9-1F3FC"
			},
			"1F3FD": {
				unified: "1F9D9-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9D9-1F3FD-200D-2640",
				image: "1f9d9-1f3fd-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 33,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D9-1F3FD"
			},
			"1F3FE": {
				unified: "1F9D9-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9D9-1F3FE-200D-2640",
				image: "1f9d9-1f3fe-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 34,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D9-1F3FE"
			},
			"1F3FF": {
				unified: "1F9D9-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9D9-1F3FF-200D-2640",
				image: "1f9d9-1f3ff-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 35,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D9-1F3FF"
			}
		},
		obsoletes: "1F9D9",
		a: "Female Mage",
		b: "1F9D9-200D-2640-FE0F",
		c: "1F9D9-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			44,
			30
		],
		o: 10
	},
	secret: {
		a: "Circled Ideograph Secret",
		b: "3299-FE0F",
		c: "3299",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"privacy",
			"chinese",
			"sshh",
			"kanji",
			"red-circle"
		],
		k: [
			50,
			27
		],
		o: 1
	},
	"flag-nu": {
		a: "Niue Flag",
		b: "1F1F3-1F1FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			50
		]
	},
	u55b6: {
		a: "Squared Cjk Unified Ideograph-55b6",
		b: "1F23A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"japanese",
			"opening hours",
			"orange-square"
		],
		k: [
			5,
			41
		]
	},
	male_mage: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D9-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9D9-1F3FB-200D-2642",
				image: "1f9d9-1f3fb-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 37,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9D9-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9D9-1F3FC-200D-2642",
				image: "1f9d9-1f3fc-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 38,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9D9-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9D9-1F3FD-200D-2642",
				image: "1f9d9-1f3fd-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 39,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9D9-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9D9-1F3FE-200D-2642",
				image: "1f9d9-1f3fe-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 40,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9D9-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9D9-1F3FF-200D-2642",
				image: "1f9d9-1f3ff-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 41,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Male Mage",
		b: "1F9D9-200D-2642-FE0F",
		c: "1F9D9-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			44,
			36
		],
		o: 10
	},
	cloud: {
		a: "Cloud",
		b: "2601-FE0F",
		c: "2601",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"weather",
			"sky"
		],
		k: [
			47,
			17
		],
		o: 1
	},
	"flag-nz": {
		a: "New Zealand Flag",
		b: "1F1F3-1F1FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			3,
			51
		]
	},
	partly_sunny: {
		a: "Sun Behind Cloud",
		b: "26C5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"weather",
			"nature",
			"cloudy",
			"morning",
			"fall",
			"spring"
		],
		k: [
			48,
			29
		],
		o: 5
	},
	fairy: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DA-1F3FB",
				non_qualified: null,
				image: "1f9da-1f3fb.png",
				sheet_x: 45,
				sheet_y: 9,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoleted_by: "1F9DA-1F3FB-200D-2640-FE0F"
			},
			"1F3FC": {
				unified: "1F9DA-1F3FC",
				non_qualified: null,
				image: "1f9da-1f3fc.png",
				sheet_x: 45,
				sheet_y: 10,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoleted_by: "1F9DA-1F3FC-200D-2640-FE0F"
			},
			"1F3FD": {
				unified: "1F9DA-1F3FD",
				non_qualified: null,
				image: "1f9da-1f3fd.png",
				sheet_x: 45,
				sheet_y: 11,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoleted_by: "1F9DA-1F3FD-200D-2640-FE0F"
			},
			"1F3FE": {
				unified: "1F9DA-1F3FE",
				non_qualified: null,
				image: "1f9da-1f3fe.png",
				sheet_x: 45,
				sheet_y: 12,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoleted_by: "1F9DA-1F3FE-200D-2640-FE0F"
			},
			"1F3FF": {
				unified: "1F9DA-1F3FF",
				non_qualified: null,
				image: "1f9da-1f3ff.png",
				sheet_x: 45,
				sheet_y: 13,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoleted_by: "1F9DA-1F3FF-200D-2640-FE0F"
			}
		},
		obsoleted_by: "1F9DA-200D-2640-FE0F",
		a: "Fairy",
		b: "1F9DA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			45,
			8
		],
		o: 10
	},
	u6e80: {
		a: "Squared Cjk Unified Ideograph-6e80",
		b: "1F235",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"full",
			"chinese",
			"japanese",
			"red-square",
			"kanji"
		],
		k: [
			5,
			36
		]
	},
	black_small_square: {
		a: "Black Small Square",
		b: "25AA-FE0F",
		c: "25AA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"icon"
		],
		k: [
			47,
			8
		],
		o: 1
	},
	thunder_cloud_and_rain: {
		a: "Thunder Cloud and Rain",
		b: "26C8-FE0F",
		c: "26C8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			48,
			30
		],
		o: 5
	},
	female_fairy: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DA-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9DA-1F3FB-200D-2640",
				image: "1f9da-1f3fb-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 49,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DA-1F3FB"
			},
			"1F3FC": {
				unified: "1F9DA-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9DA-1F3FC-200D-2640",
				image: "1f9da-1f3fc-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 50,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DA-1F3FC"
			},
			"1F3FD": {
				unified: "1F9DA-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9DA-1F3FD-200D-2640",
				image: "1f9da-1f3fd-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 51,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DA-1F3FD"
			},
			"1F3FE": {
				unified: "1F9DA-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9DA-1F3FE-200D-2640",
				image: "1f9da-1f3fe-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 0,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DA-1F3FE"
			},
			"1F3FF": {
				unified: "1F9DA-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9DA-1F3FF-200D-2640",
				image: "1f9da-1f3ff-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 1,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DA-1F3FF"
			}
		},
		obsoletes: "1F9DA",
		a: "Female Fairy",
		b: "1F9DA-200D-2640-FE0F",
		c: "1F9DA-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			44,
			48
		],
		o: 10
	},
	"flag-om": {
		a: "Oman Flag",
		b: "1F1F4-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			0
		]
	},
	white_small_square: {
		a: "White Small Square",
		b: "25AB-FE0F",
		c: "25AB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"icon"
		],
		k: [
			47,
			9
		],
		o: 1
	},
	"flag-pa": {
		a: "Panama Flag",
		b: "1F1F5-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			1
		]
	},
	mostly_sunny: {
		a: "Mostly Sunny",
		b: "1F324-FE0F",
		c: "1F324",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			6,
			26
		],
		n: [
			"sun_small_cloud"
		],
		o: 7
	},
	male_fairy: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DA-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9DA-1F3FB-200D-2642",
				image: "1f9da-1f3fb-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 3,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9DA-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9DA-1F3FC-200D-2642",
				image: "1f9da-1f3fc-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 4,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9DA-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9DA-1F3FD-200D-2642",
				image: "1f9da-1f3fd-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 5,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9DA-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9DA-1F3FE-200D-2642",
				image: "1f9da-1f3fe-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 6,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9DA-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9DA-1F3FF-200D-2642",
				image: "1f9da-1f3ff-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 7,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Male Fairy",
		b: "1F9DA-200D-2642-FE0F",
		c: "1F9DA-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			45,
			2
		],
		o: 10
	},
	barely_sunny: {
		a: "Barely Sunny",
		b: "1F325-FE0F",
		c: "1F325",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			6,
			27
		],
		n: [
			"sun_behind_cloud"
		],
		o: 7
	},
	white_medium_square: {
		a: "White Medium Square",
		b: "25FB-FE0F",
		c: "25FB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"stone",
			"icon"
		],
		k: [
			47,
			12
		],
		o: 3
	},
	"flag-pe": {
		a: "Peru Flag",
		b: "1F1F5-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			2
		]
	},
	vampire: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DB-1F3FB",
				non_qualified: null,
				image: "1f9db-1f3fb.png",
				sheet_x: 45,
				sheet_y: 27,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoleted_by: "1F9DB-1F3FB-200D-2640-FE0F"
			},
			"1F3FC": {
				unified: "1F9DB-1F3FC",
				non_qualified: null,
				image: "1f9db-1f3fc.png",
				sheet_x: 45,
				sheet_y: 28,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoleted_by: "1F9DB-1F3FC-200D-2640-FE0F"
			},
			"1F3FD": {
				unified: "1F9DB-1F3FD",
				non_qualified: null,
				image: "1f9db-1f3fd.png",
				sheet_x: 45,
				sheet_y: 29,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoleted_by: "1F9DB-1F3FD-200D-2640-FE0F"
			},
			"1F3FE": {
				unified: "1F9DB-1F3FE",
				non_qualified: null,
				image: "1f9db-1f3fe.png",
				sheet_x: 45,
				sheet_y: 30,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoleted_by: "1F9DB-1F3FE-200D-2640-FE0F"
			},
			"1F3FF": {
				unified: "1F9DB-1F3FF",
				non_qualified: null,
				image: "1f9db-1f3ff.png",
				sheet_x: 45,
				sheet_y: 31,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoleted_by: "1F9DB-1F3FF-200D-2640-FE0F"
			}
		},
		obsoleted_by: "1F9DB-200D-2640-FE0F",
		a: "Vampire",
		b: "1F9DB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			45,
			26
		],
		o: 10
	},
	female_vampire: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DB-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9DB-1F3FB-200D-2640",
				image: "1f9db-1f3fb-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 15,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DB-1F3FB"
			},
			"1F3FC": {
				unified: "1F9DB-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9DB-1F3FC-200D-2640",
				image: "1f9db-1f3fc-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 16,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DB-1F3FC"
			},
			"1F3FD": {
				unified: "1F9DB-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9DB-1F3FD-200D-2640",
				image: "1f9db-1f3fd-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 17,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DB-1F3FD"
			},
			"1F3FE": {
				unified: "1F9DB-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9DB-1F3FE-200D-2640",
				image: "1f9db-1f3fe-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 18,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DB-1F3FE"
			},
			"1F3FF": {
				unified: "1F9DB-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9DB-1F3FF-200D-2640",
				image: "1f9db-1f3ff-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 19,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DB-1F3FF"
			}
		},
		obsoletes: "1F9DB",
		a: "Female Vampire",
		b: "1F9DB-200D-2640-FE0F",
		c: "1F9DB-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			45,
			14
		],
		o: 10
	},
	partly_sunny_rain: {
		a: "Partly Sunny Rain",
		b: "1F326-FE0F",
		c: "1F326",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			6,
			28
		],
		n: [
			"sun_behind_rain_cloud"
		],
		o: 7
	},
	"flag-pf": {
		a: "French Polynesia Flag",
		b: "1F1F5-1F1EB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			3
		]
	},
	black_medium_square: {
		a: "Black Medium Square",
		b: "25FC-FE0F",
		c: "25FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"button",
			"icon"
		],
		k: [
			47,
			13
		],
		o: 3
	},
	white_medium_small_square: {
		a: "White Medium Small Square",
		b: "25FD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"stone",
			"icon",
			"button"
		],
		k: [
			47,
			14
		],
		o: 3
	},
	rain_cloud: {
		a: "Rain Cloud",
		b: "1F327-FE0F",
		c: "1F327",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			6,
			29
		],
		o: 7
	},
	"flag-pg": {
		a: "Papua New Guinea Flag",
		b: "1F1F5-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			4
		]
	},
	male_vampire: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DB-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9DB-1F3FB-200D-2642",
				image: "1f9db-1f3fb-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 21,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9DB-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9DB-1F3FC-200D-2642",
				image: "1f9db-1f3fc-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 22,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9DB-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9DB-1F3FD-200D-2642",
				image: "1f9db-1f3fd-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 23,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9DB-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9DB-1F3FE-200D-2642",
				image: "1f9db-1f3fe-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 24,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9DB-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9DB-1F3FF-200D-2642",
				image: "1f9db-1f3ff-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 25,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Male Vampire",
		b: "1F9DB-200D-2642-FE0F",
		c: "1F9DB-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			45,
			20
		],
		o: 10
	},
	"flag-ph": {
		a: "Philippines Flag",
		b: "1F1F5-1F1ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			5
		]
	},
	merperson: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DC-1F3FB",
				non_qualified: null,
				image: "1f9dc-1f3fb.png",
				sheet_x: 45,
				sheet_y: 45,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9DC-1F3FB-200D-2642-FE0F"
			},
			"1F3FC": {
				unified: "1F9DC-1F3FC",
				non_qualified: null,
				image: "1f9dc-1f3fc.png",
				sheet_x: 45,
				sheet_y: 46,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9DC-1F3FC-200D-2642-FE0F"
			},
			"1F3FD": {
				unified: "1F9DC-1F3FD",
				non_qualified: null,
				image: "1f9dc-1f3fd.png",
				sheet_x: 45,
				sheet_y: 47,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9DC-1F3FD-200D-2642-FE0F"
			},
			"1F3FE": {
				unified: "1F9DC-1F3FE",
				non_qualified: null,
				image: "1f9dc-1f3fe.png",
				sheet_x: 45,
				sheet_y: 48,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9DC-1F3FE-200D-2642-FE0F"
			},
			"1F3FF": {
				unified: "1F9DC-1F3FF",
				non_qualified: null,
				image: "1f9dc-1f3ff.png",
				sheet_x: 45,
				sheet_y: 49,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9DC-1F3FF-200D-2642-FE0F"
			}
		},
		obsoleted_by: "1F9DC-200D-2642-FE0F",
		a: "Merperson",
		b: "1F9DC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			45,
			44
		],
		o: 10
	},
	black_medium_small_square: {
		a: "Black Medium Small Square",
		b: "25FE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"icon",
			"shape",
			"button"
		],
		k: [
			47,
			15
		],
		o: 3
	},
	snow_cloud: {
		a: "Snow Cloud",
		b: "1F328-FE0F",
		c: "1F328",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			6,
			30
		],
		o: 7
	},
	lightning: {
		a: "Lightning",
		b: "1F329-FE0F",
		c: "1F329",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			6,
			31
		],
		n: [
			"lightning_cloud"
		],
		o: 7
	},
	black_large_square: {
		a: "Black Large Square",
		b: "2B1B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"icon",
			"button"
		],
		k: [
			50,
			20
		],
		o: 5
	},
	mermaid: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DC-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9DC-1F3FB-200D-2640",
				image: "1f9dc-1f3fb-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 33,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9DC-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9DC-1F3FC-200D-2640",
				image: "1f9dc-1f3fc-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 34,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9DC-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9DC-1F3FD-200D-2640",
				image: "1f9dc-1f3fd-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 35,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9DC-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9DC-1F3FE-200D-2640",
				image: "1f9dc-1f3fe-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 36,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9DC-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9DC-1F3FF-200D-2640",
				image: "1f9dc-1f3ff-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 37,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Mermaid",
		b: "1F9DC-200D-2640-FE0F",
		c: "1F9DC-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			45,
			32
		],
		o: 10
	},
	"flag-pk": {
		a: "Pakistan Flag",
		b: "1F1F5-1F1F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			6
		]
	},
	merman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DC-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9DC-1F3FB-200D-2642",
				image: "1f9dc-1f3fb-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 39,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DC-1F3FB"
			},
			"1F3FC": {
				unified: "1F9DC-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9DC-1F3FC-200D-2642",
				image: "1f9dc-1f3fc-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 40,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DC-1F3FC"
			},
			"1F3FD": {
				unified: "1F9DC-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9DC-1F3FD-200D-2642",
				image: "1f9dc-1f3fd-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 41,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DC-1F3FD"
			},
			"1F3FE": {
				unified: "1F9DC-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9DC-1F3FE-200D-2642",
				image: "1f9dc-1f3fe-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 42,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DC-1F3FE"
			},
			"1F3FF": {
				unified: "1F9DC-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9DC-1F3FF-200D-2642",
				image: "1f9dc-1f3ff-200d-2642-fe0f.png",
				sheet_x: 45,
				sheet_y: 43,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DC-1F3FF"
			}
		},
		obsoletes: "1F9DC",
		a: "Merman",
		b: "1F9DC-200D-2642-FE0F",
		c: "1F9DC-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			45,
			38
		],
		o: 10
	},
	white_large_square: {
		a: "White Large Square",
		b: "2B1C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"icon",
			"stone",
			"button"
		],
		k: [
			50,
			21
		],
		o: 5
	},
	tornado: {
		a: "Tornado",
		b: "1F32A-FE0F",
		c: "1F32A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"weather",
			"cyclone",
			"twister"
		],
		k: [
			6,
			32
		],
		n: [
			"tornado_cloud"
		],
		o: 7
	},
	"flag-pl": {
		a: "Poland Flag",
		b: "1F1F5-1F1F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			7
		]
	},
	elf: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DD-1F3FB",
				non_qualified: null,
				image: "1f9dd-1f3fb.png",
				sheet_x: 46,
				sheet_y: 11,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9DD-1F3FB-200D-2642-FE0F"
			},
			"1F3FC": {
				unified: "1F9DD-1F3FC",
				non_qualified: null,
				image: "1f9dd-1f3fc.png",
				sheet_x: 46,
				sheet_y: 12,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9DD-1F3FC-200D-2642-FE0F"
			},
			"1F3FD": {
				unified: "1F9DD-1F3FD",
				non_qualified: null,
				image: "1f9dd-1f3fd.png",
				sheet_x: 46,
				sheet_y: 13,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9DD-1F3FD-200D-2642-FE0F"
			},
			"1F3FE": {
				unified: "1F9DD-1F3FE",
				non_qualified: null,
				image: "1f9dd-1f3fe.png",
				sheet_x: 46,
				sheet_y: 14,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9DD-1F3FE-200D-2642-FE0F"
			},
			"1F3FF": {
				unified: "1F9DD-1F3FF",
				non_qualified: null,
				image: "1f9dd-1f3ff.png",
				sheet_x: 46,
				sheet_y: 15,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9DD-1F3FF-200D-2642-FE0F"
			}
		},
		obsoleted_by: "1F9DD-200D-2642-FE0F",
		a: "Elf",
		b: "1F9DD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			10
		],
		o: 10
	},
	fog: {
		a: "Fog",
		b: "1F32B-FE0F",
		c: "1F32B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"weather"
		],
		k: [
			6,
			33
		],
		o: 7
	},
	large_orange_diamond: {
		a: "Large Orange Diamond",
		b: "1F536",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"jewel",
			"gem"
		],
		k: [
			28,
			4
		]
	},
	"flag-pm": {
		a: "St. Pierre & Miquelon Flag",
		b: "1F1F5-1F1F2",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			8
		]
	},
	"flag-pn": {
		a: "Pitcairn Islands Flag",
		b: "1F1F5-1F1F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			9
		]
	},
	wind_blowing_face: {
		a: "Wind Blowing Face",
		b: "1F32C-FE0F",
		c: "1F32C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			6,
			34
		],
		o: 7
	},
	female_elf: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DD-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9DD-1F3FB-200D-2640",
				image: "1f9dd-1f3fb-200d-2640-fe0f.png",
				sheet_x: 45,
				sheet_y: 51,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9DD-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9DD-1F3FC-200D-2640",
				image: "1f9dd-1f3fc-200d-2640-fe0f.png",
				sheet_x: 46,
				sheet_y: 0,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9DD-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9DD-1F3FD-200D-2640",
				image: "1f9dd-1f3fd-200d-2640-fe0f.png",
				sheet_x: 46,
				sheet_y: 1,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9DD-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9DD-1F3FE-200D-2640",
				image: "1f9dd-1f3fe-200d-2640-fe0f.png",
				sheet_x: 46,
				sheet_y: 2,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9DD-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9DD-1F3FF-200D-2640",
				image: "1f9dd-1f3ff-200d-2640-fe0f.png",
				sheet_x: 46,
				sheet_y: 3,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Female Elf",
		b: "1F9DD-200D-2640-FE0F",
		c: "1F9DD-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			45,
			50
		],
		o: 10
	},
	large_blue_diamond: {
		a: "Large Blue Diamond",
		b: "1F537",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"jewel",
			"gem"
		],
		k: [
			28,
			5
		]
	},
	male_elf: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9DD-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9DD-1F3FB-200D-2642",
				image: "1f9dd-1f3fb-200d-2642-fe0f.png",
				sheet_x: 46,
				sheet_y: 5,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DD-1F3FB"
			},
			"1F3FC": {
				unified: "1F9DD-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9DD-1F3FC-200D-2642",
				image: "1f9dd-1f3fc-200d-2642-fe0f.png",
				sheet_x: 46,
				sheet_y: 6,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DD-1F3FC"
			},
			"1F3FD": {
				unified: "1F9DD-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9DD-1F3FD-200D-2642",
				image: "1f9dd-1f3fd-200d-2642-fe0f.png",
				sheet_x: 46,
				sheet_y: 7,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DD-1F3FD"
			},
			"1F3FE": {
				unified: "1F9DD-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9DD-1F3FE-200D-2642",
				image: "1f9dd-1f3fe-200d-2642-fe0f.png",
				sheet_x: 46,
				sheet_y: 8,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DD-1F3FE"
			},
			"1F3FF": {
				unified: "1F9DD-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9DD-1F3FF-200D-2642",
				image: "1f9dd-1f3ff-200d-2642-fe0f.png",
				sheet_x: 46,
				sheet_y: 9,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9DD-1F3FF"
			}
		},
		obsoletes: "1F9DD",
		a: "Male Elf",
		b: "1F9DD-200D-2642-FE0F",
		c: "1F9DD-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			4
		],
		o: 10
	},
	small_orange_diamond: {
		a: "Small Orange Diamond",
		b: "1F538",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"jewel",
			"gem"
		],
		k: [
			28,
			6
		]
	},
	"flag-pr": {
		a: "Puerto Rico Flag",
		b: "1F1F5-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			10
		]
	},
	cyclone: {
		a: "Cyclone",
		b: "1F300",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"weather",
			"swirl",
			"blue",
			"cloud",
			"vortex",
			"spiral",
			"whirlpool",
			"spin",
			"tornado",
			"hurricane",
			"typhoon"
		],
		k: [
			5,
			44
		]
	},
	rainbow: {
		a: "Rainbow",
		b: "1F308",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"nature",
			"happy",
			"unicorn_face",
			"photo",
			"sky",
			"spring"
		],
		k: [
			6,
			0
		]
	},
	small_blue_diamond: {
		a: "Small Blue Diamond",
		b: "1F539",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"jewel",
			"gem"
		],
		k: [
			28,
			7
		]
	},
	genie: {
		obsoleted_by: "1F9DE-200D-2642-FE0F",
		a: "Genie",
		b: "1F9DE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			18
		],
		o: 10
	},
	"flag-ps": {
		a: "Palestinian Territories Flag",
		b: "1F1F5-1F1F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			11
		]
	},
	small_red_triangle: {
		a: "Up-Pointing Red Triangle",
		b: "1F53A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"direction",
			"up",
			"top"
		],
		k: [
			28,
			8
		]
	},
	closed_umbrella: {
		a: "Closed Umbrella",
		b: "1F302",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"weather",
			"rain",
			"drizzle"
		],
		k: [
			5,
			46
		]
	},
	female_genie: {
		a: "Female Genie",
		b: "1F9DE-200D-2640-FE0F",
		c: "1F9DE-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			16
		],
		o: 10
	},
	"flag-pt": {
		a: "Portugal Flag",
		b: "1F1F5-1F1F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			12
		]
	},
	"flag-pw": {
		a: "Palau Flag",
		b: "1F1F5-1F1FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			13
		]
	},
	small_red_triangle_down: {
		a: "Down-Pointing Red Triangle",
		b: "1F53B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"direction",
			"bottom"
		],
		k: [
			28,
			9
		]
	},
	umbrella: {
		a: "Umbrella",
		b: "2602-FE0F",
		c: "2602",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"rainy",
			"weather",
			"spring"
		],
		k: [
			47,
			18
		],
		o: 1
	},
	male_genie: {
		obsoletes: "1F9DE",
		a: "Male Genie",
		b: "1F9DE-200D-2642-FE0F",
		c: "1F9DE-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			17
		],
		o: 10
	},
	zombie: {
		obsoleted_by: "1F9DF-200D-2642-FE0F",
		a: "Zombie",
		b: "1F9DF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			21
		],
		o: 10
	},
	"flag-py": {
		a: "Paraguay Flag",
		b: "1F1F5-1F1FE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			14
		]
	},
	diamond_shape_with_a_dot_inside: {
		a: "Diamond Shape with a Dot Inside",
		b: "1F4A0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"jewel",
			"blue",
			"gem",
			"crystal",
			"fancy"
		],
		k: [
			25,
			6
		]
	},
	umbrella_with_rain_drops: {
		a: "Umbrella with Rain Drops",
		b: "2614",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			47,
			23
		],
		o: 4
	},
	radio_button: {
		a: "Radio Button",
		b: "1F518",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"input",
			"old",
			"music",
			"circle"
		],
		k: [
			27,
			26
		]
	},
	female_zombie: {
		a: "Female Zombie",
		b: "1F9DF-200D-2640-FE0F",
		c: "1F9DF-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			19
		],
		o: 10
	},
	"flag-qa": {
		a: "Qatar Flag",
		b: "1F1F6-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			15
		]
	},
	umbrella_on_ground: {
		a: "Umbrella on Ground",
		b: "26F1-FE0F",
		c: "26F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			48,
			39
		],
		o: 5
	},
	black_square_button: {
		a: "Black Square Button",
		b: "1F532",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"input",
			"frame"
		],
		k: [
			28,
			0
		]
	},
	zap: {
		a: "High Voltage Sign",
		b: "26A1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"thunder",
			"weather",
			"lightning bolt",
			"fast"
		],
		k: [
			48,
			21
		],
		o: 4
	},
	male_zombie: {
		obsoletes: "1F9DF",
		a: "Male Zombie",
		b: "1F9DF-200D-2642-FE0F",
		c: "1F9DF-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			20
		],
		o: 10
	},
	"flag-re": {
		a: "Réunion Flag",
		b: "1F1F7-1F1EA",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			16
		]
	},
	"flag-ro": {
		a: "Romania Flag",
		b: "1F1F7-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			17
		]
	},
	snowflake: {
		a: "Snowflake",
		b: "2744-FE0F",
		c: "2744",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"winter",
			"season",
			"cold",
			"weather",
			"christmas",
			"xmas"
		],
		k: [
			49,
			51
		],
		o: 1
	},
	white_square_button: {
		a: "White Square Button",
		b: "1F533",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"input"
		],
		k: [
			28,
			1
		]
	},
	person_frowning: {
		skin_variations: {
			"1F3FB": {
				unified: "1F64D-1F3FB",
				non_qualified: null,
				image: "1f64d-1f3fb.png",
				sheet_x: 33,
				sheet_y: 31,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F64D-1F3FC",
				non_qualified: null,
				image: "1f64d-1f3fc.png",
				sheet_x: 33,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F64D-1F3FD",
				non_qualified: null,
				image: "1f64d-1f3fd.png",
				sheet_x: 33,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F64D-1F3FE",
				non_qualified: null,
				image: "1f64d-1f3fe.png",
				sheet_x: 33,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F64D-1F3FF",
				non_qualified: null,
				image: "1f64d-1f3ff.png",
				sheet_x: 33,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F64D-200D-2640-FE0F",
		a: "Person Frowning",
		b: "1F64D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			33,
			30
		]
	},
	"flag-rs": {
		a: "Serbia Flag",
		b: "1F1F7-1F1F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			18
		]
	},
	"man-frowning": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64D-1F3FB-200D-2642-FE0F",
				non_qualified: "1F64D-1F3FB-200D-2642",
				image: "1f64d-1f3fb-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F64D-1F3FC-200D-2642-FE0F",
				non_qualified: "1F64D-1F3FC-200D-2642",
				image: "1f64d-1f3fc-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F64D-1F3FD-200D-2642-FE0F",
				non_qualified: "1F64D-1F3FD-200D-2642",
				image: "1f64d-1f3fd-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F64D-1F3FE-200D-2642-FE0F",
				non_qualified: "1F64D-1F3FE-200D-2642",
				image: "1f64d-1f3fe-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F64D-1F3FF-200D-2642-FE0F",
				non_qualified: "1F64D-1F3FF-200D-2642",
				image: "1f64d-1f3ff-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Frowning",
		b: "1F64D-200D-2642-FE0F",
		c: "1F64D-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			33,
			24
		]
	},
	white_circle: {
		a: "Medium White Circle",
		b: "26AA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"round"
		],
		k: [
			48,
			22
		],
		o: 4
	},
	snowman: {
		a: "Snowman",
		b: "2603-FE0F",
		c: "2603",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"winter",
			"season",
			"cold",
			"weather",
			"christmas",
			"xmas",
			"frozen",
			"without_snow"
		],
		k: [
			47,
			19
		],
		o: 1
	},
	snowman_without_snow: {
		a: "Snowman Without Snow",
		b: "26C4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			48,
			28
		],
		o: 5
	},
	ru: {
		a: "Russia Flag",
		b: "1F1F7-1F1FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"russian",
			"federation",
			"flag",
			"nation",
			"country",
			"banner"
		],
		k: [
			4,
			19
		],
		n: [
			"flag-ru"
		]
	},
	black_circle: {
		a: "Medium Black Circle",
		b: "26AB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"button",
			"round"
		],
		k: [
			48,
			23
		],
		o: 4
	},
	"woman-frowning": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64D-1F3FB-200D-2640-FE0F",
				non_qualified: "1F64D-1F3FB-200D-2640",
				image: "1f64d-1f3fb-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F64D-1F3FC-200D-2640-FE0F",
				non_qualified: "1F64D-1F3FC-200D-2640",
				image: "1f64d-1f3fc-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F64D-1F3FD-200D-2640-FE0F",
				non_qualified: "1F64D-1F3FD-200D-2640",
				image: "1f64d-1f3fd-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F64D-1F3FE-200D-2640-FE0F",
				non_qualified: "1F64D-1F3FE-200D-2640",
				image: "1f64d-1f3fe-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F64D-1F3FF-200D-2640-FE0F",
				non_qualified: "1F64D-1F3FF-200D-2640",
				image: "1f64d-1f3ff-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F64D",
		a: "Woman Frowning",
		b: "1F64D-200D-2640-FE0F",
		c: "1F64D-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			33,
			18
		]
	},
	"flag-rw": {
		a: "Rwanda Flag",
		b: "1F1F7-1F1FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			20
		]
	},
	comet: {
		a: "Comet",
		b: "2604-FE0F",
		c: "2604",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"space"
		],
		k: [
			47,
			20
		],
		o: 1
	},
	person_with_pouting_face: {
		skin_variations: {
			"1F3FB": {
				unified: "1F64E-1F3FB",
				non_qualified: null,
				image: "1f64e-1f3fb.png",
				sheet_x: 33,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F64E-1F3FC",
				non_qualified: null,
				image: "1f64e-1f3fc.png",
				sheet_x: 33,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F64E-1F3FD",
				non_qualified: null,
				image: "1f64e-1f3fd.png",
				sheet_x: 33,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F64E-1F3FE",
				non_qualified: null,
				image: "1f64e-1f3fe.png",
				sheet_x: 34,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F64E-1F3FF",
				non_qualified: null,
				image: "1f64e-1f3ff.png",
				sheet_x: 34,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F64E-200D-2640-FE0F",
		a: "Person with Pouting Face",
		b: "1F64E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			33,
			48
		]
	},
	red_circle: {
		a: "Large Red Circle",
		b: "1F534",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"error",
			"danger"
		],
		k: [
			28,
			2
		]
	},
	large_blue_circle: {
		a: "Large Blue Circle",
		b: "1F535",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shape",
			"icon",
			"button"
		],
		k: [
			28,
			3
		]
	},
	"man-pouting": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64E-1F3FB-200D-2642-FE0F",
				non_qualified: "1F64E-1F3FB-200D-2642",
				image: "1f64e-1f3fb-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 43,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F64E-1F3FC-200D-2642-FE0F",
				non_qualified: "1F64E-1F3FC-200D-2642",
				image: "1f64e-1f3fc-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F64E-1F3FD-200D-2642-FE0F",
				non_qualified: "1F64E-1F3FD-200D-2642",
				image: "1f64e-1f3fd-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F64E-1F3FE-200D-2642-FE0F",
				non_qualified: "1F64E-1F3FE-200D-2642",
				image: "1f64e-1f3fe-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F64E-1F3FF-200D-2642-FE0F",
				non_qualified: "1F64E-1F3FF-200D-2642",
				image: "1f64e-1f3ff-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Pouting",
		b: "1F64E-200D-2642-FE0F",
		c: "1F64E-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			33,
			42
		]
	},
	"flag-sa": {
		a: "Saudi Arabia Flag",
		b: "1F1F8-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			21
		]
	},
	fire: {
		a: "Fire",
		b: "1F525",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"hot",
			"cook",
			"flame"
		],
		k: [
			27,
			39
		]
	},
	"woman-pouting": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64E-1F3FB-200D-2640-FE0F",
				non_qualified: "1F64E-1F3FB-200D-2640",
				image: "1f64e-1f3fb-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F64E-1F3FC-200D-2640-FE0F",
				non_qualified: "1F64E-1F3FC-200D-2640",
				image: "1f64e-1f3fc-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F64E-1F3FD-200D-2640-FE0F",
				non_qualified: "1F64E-1F3FD-200D-2640",
				image: "1f64e-1f3fd-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F64E-1F3FE-200D-2640-FE0F",
				non_qualified: "1F64E-1F3FE-200D-2640",
				image: "1f64e-1f3fe-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F64E-1F3FF-200D-2640-FE0F",
				non_qualified: "1F64E-1F3FF-200D-2640",
				image: "1f64e-1f3ff-200d-2640-fe0f.png",
				sheet_x: 33,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F64E",
		a: "Woman Pouting",
		b: "1F64E-200D-2640-FE0F",
		c: "1F64E-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			33,
			36
		]
	},
	"flag-sb": {
		a: "Solomon Islands Flag",
		b: "1F1F8-1F1E7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			22
		]
	},
	droplet: {
		a: "Droplet",
		b: "1F4A7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"water",
			"drip",
			"faucet",
			"spring"
		],
		k: [
			25,
			13
		]
	},
	no_good: {
		skin_variations: {
			"1F3FB": {
				unified: "1F645-1F3FB",
				non_qualified: null,
				image: "1f645-1f3fb.png",
				sheet_x: 32,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F645-1F3FC",
				non_qualified: null,
				image: "1f645-1f3fc.png",
				sheet_x: 32,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F645-1F3FD",
				non_qualified: null,
				image: "1f645-1f3fd.png",
				sheet_x: 32,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F645-1F3FE",
				non_qualified: null,
				image: "1f645-1f3fe.png",
				sheet_x: 32,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F645-1F3FF",
				non_qualified: null,
				image: "1f645-1f3ff.png",
				sheet_x: 32,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F645-200D-2640-FE0F",
		a: "Face with No Good Gesture",
		b: "1F645",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			32,
			1
		]
	},
	"flag-sc": {
		a: "Seychelles Flag",
		b: "1F1F8-1F1E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			23
		]
	},
	ocean: {
		a: "Water Wave",
		b: "1F30A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sea",
			"water",
			"wave",
			"nature",
			"tsunami",
			"disaster"
		],
		k: [
			6,
			2
		]
	},
	"man-gesturing-no": {
		skin_variations: {
			"1F3FB": {
				unified: "1F645-1F3FB-200D-2642-FE0F",
				non_qualified: "1F645-1F3FB-200D-2642",
				image: "1f645-1f3fb-200d-2642-fe0f.png",
				sheet_x: 31,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F645-1F3FC-200D-2642-FE0F",
				non_qualified: "1F645-1F3FC-200D-2642",
				image: "1f645-1f3fc-200d-2642-fe0f.png",
				sheet_x: 31,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F645-1F3FD-200D-2642-FE0F",
				non_qualified: "1F645-1F3FD-200D-2642",
				image: "1f645-1f3fd-200d-2642-fe0f.png",
				sheet_x: 31,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F645-1F3FE-200D-2642-FE0F",
				non_qualified: "1F645-1F3FE-200D-2642",
				image: "1f645-1f3fe-200d-2642-fe0f.png",
				sheet_x: 31,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F645-1F3FF-200D-2642-FE0F",
				non_qualified: "1F645-1F3FF-200D-2642",
				image: "1f645-1f3ff-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Gesturing No",
		b: "1F645-200D-2642-FE0F",
		c: "1F645-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			31,
			47
		]
	},
	"flag-sd": {
		a: "Sudan Flag",
		b: "1F1F8-1F1E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			24
		]
	},
	"woman-gesturing-no": {
		skin_variations: {
			"1F3FB": {
				unified: "1F645-1F3FB-200D-2640-FE0F",
				non_qualified: "1F645-1F3FB-200D-2640",
				image: "1f645-1f3fb-200d-2640-fe0f.png",
				sheet_x: 31,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F645-1F3FC-200D-2640-FE0F",
				non_qualified: "1F645-1F3FC-200D-2640",
				image: "1f645-1f3fc-200d-2640-fe0f.png",
				sheet_x: 31,
				sheet_y: 43,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F645-1F3FD-200D-2640-FE0F",
				non_qualified: "1F645-1F3FD-200D-2640",
				image: "1f645-1f3fd-200d-2640-fe0f.png",
				sheet_x: 31,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F645-1F3FE-200D-2640-FE0F",
				non_qualified: "1F645-1F3FE-200D-2640",
				image: "1f645-1f3fe-200d-2640-fe0f.png",
				sheet_x: 31,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F645-1F3FF-200D-2640-FE0F",
				non_qualified: "1F645-1F3FF-200D-2640",
				image: "1f645-1f3ff-200d-2640-fe0f.png",
				sheet_x: 31,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F645",
		a: "Woman Gesturing No",
		b: "1F645-200D-2640-FE0F",
		c: "1F645-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			31,
			41
		]
	},
	"flag-se": {
		a: "Sweden Flag",
		b: "1F1F8-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			25
		]
	},
	"flag-sg": {
		a: "Singapore Flag",
		b: "1F1F8-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			26
		]
	},
	ok_woman: {
		skin_variations: {
			"1F3FB": {
				unified: "1F646-1F3FB",
				non_qualified: null,
				image: "1f646-1f3fb.png",
				sheet_x: 32,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F646-1F3FC",
				non_qualified: null,
				image: "1f646-1f3fc.png",
				sheet_x: 32,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F646-1F3FD",
				non_qualified: null,
				image: "1f646-1f3fd.png",
				sheet_x: 32,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F646-1F3FE",
				non_qualified: null,
				image: "1f646-1f3fe.png",
				sheet_x: 32,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F646-1F3FF",
				non_qualified: null,
				image: "1f646-1f3ff.png",
				sheet_x: 32,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F646-200D-2640-FE0F",
		a: "Face with Ok Gesture",
		b: "1F646",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		j: [
			"women",
			"girl",
			"female",
			"pink",
			"human",
			"woman"
		],
		k: [
			32,
			19
		]
	},
	"flag-sh": {
		a: "St. Helena Flag",
		b: "1F1F8-1F1ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			27
		]
	},
	"man-gesturing-ok": {
		skin_variations: {
			"1F3FB": {
				unified: "1F646-1F3FB-200D-2642-FE0F",
				non_qualified: "1F646-1F3FB-200D-2642",
				image: "1f646-1f3fb-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F646-1F3FC-200D-2642-FE0F",
				non_qualified: "1F646-1F3FC-200D-2642",
				image: "1f646-1f3fc-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F646-1F3FD-200D-2642-FE0F",
				non_qualified: "1F646-1F3FD-200D-2642",
				image: "1f646-1f3fd-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F646-1F3FE-200D-2642-FE0F",
				non_qualified: "1F646-1F3FE-200D-2642",
				image: "1f646-1f3fe-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F646-1F3FF-200D-2642-FE0F",
				non_qualified: "1F646-1F3FF-200D-2642",
				image: "1f646-1f3ff-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Gesturing Ok",
		b: "1F646-200D-2642-FE0F",
		c: "1F646-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			32,
			13
		]
	},
	"flag-si": {
		a: "Slovenia Flag",
		b: "1F1F8-1F1EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			28
		]
	},
	"woman-gesturing-ok": {
		skin_variations: {
			"1F3FB": {
				unified: "1F646-1F3FB-200D-2640-FE0F",
				non_qualified: "1F646-1F3FB-200D-2640",
				image: "1f646-1f3fb-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F646-1F3FC-200D-2640-FE0F",
				non_qualified: "1F646-1F3FC-200D-2640",
				image: "1f646-1f3fc-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F646-1F3FD-200D-2640-FE0F",
				non_qualified: "1F646-1F3FD-200D-2640",
				image: "1f646-1f3fd-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F646-1F3FE-200D-2640-FE0F",
				non_qualified: "1F646-1F3FE-200D-2640",
				image: "1f646-1f3fe-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F646-1F3FF-200D-2640-FE0F",
				non_qualified: "1F646-1F3FF-200D-2640",
				image: "1f646-1f3ff-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F646",
		a: "Woman Gesturing Ok",
		b: "1F646-200D-2640-FE0F",
		c: "1F646-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			32,
			7
		]
	},
	information_desk_person: {
		skin_variations: {
			"1F3FB": {
				unified: "1F481-1F3FB",
				non_qualified: null,
				image: "1f481-1f3fb.png",
				sheet_x: 23,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F481-1F3FC",
				non_qualified: null,
				image: "1f481-1f3fc.png",
				sheet_x: 23,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F481-1F3FD",
				non_qualified: null,
				image: "1f481-1f3fd.png",
				sheet_x: 23,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F481-1F3FE",
				non_qualified: null,
				image: "1f481-1f3fe.png",
				sheet_x: 23,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F481-1F3FF",
				non_qualified: null,
				image: "1f481-1f3ff.png",
				sheet_x: 23,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F481-200D-2640-FE0F",
		a: "Information Desk Person",
		b: "1F481",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			23,
			13
		]
	},
	"flag-sj": {
		a: "Svalbard & Jan Mayen Flag",
		b: "1F1F8-1F1EF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			29
		]
	},
	"man-tipping-hand": {
		skin_variations: {
			"1F3FB": {
				unified: "1F481-1F3FB-200D-2642-FE0F",
				non_qualified: "1F481-1F3FB-200D-2642",
				image: "1f481-1f3fb-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F481-1F3FC-200D-2642-FE0F",
				non_qualified: "1F481-1F3FC-200D-2642",
				image: "1f481-1f3fc-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F481-1F3FD-200D-2642-FE0F",
				non_qualified: "1F481-1F3FD-200D-2642",
				image: "1f481-1f3fd-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F481-1F3FE-200D-2642-FE0F",
				non_qualified: "1F481-1F3FE-200D-2642",
				image: "1f481-1f3fe-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F481-1F3FF-200D-2642-FE0F",
				non_qualified: "1F481-1F3FF-200D-2642",
				image: "1f481-1f3ff-200d-2642-fe0f.png",
				sheet_x: 23,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Tipping Hand",
		b: "1F481-200D-2642-FE0F",
		c: "1F481-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			23,
			7
		]
	},
	"flag-sk": {
		a: "Slovakia Flag",
		b: "1F1F8-1F1F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			30
		]
	},
	"flag-sl": {
		a: "Sierra Leone Flag",
		b: "1F1F8-1F1F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			31
		]
	},
	"woman-tipping-hand": {
		skin_variations: {
			"1F3FB": {
				unified: "1F481-1F3FB-200D-2640-FE0F",
				non_qualified: "1F481-1F3FB-200D-2640",
				image: "1f481-1f3fb-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F481-1F3FC-200D-2640-FE0F",
				non_qualified: "1F481-1F3FC-200D-2640",
				image: "1f481-1f3fc-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F481-1F3FD-200D-2640-FE0F",
				non_qualified: "1F481-1F3FD-200D-2640",
				image: "1f481-1f3fd-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F481-1F3FE-200D-2640-FE0F",
				non_qualified: "1F481-1F3FE-200D-2640",
				image: "1f481-1f3fe-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F481-1F3FF-200D-2640-FE0F",
				non_qualified: "1F481-1F3FF-200D-2640",
				image: "1f481-1f3ff-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F481",
		a: "Woman Tipping Hand",
		b: "1F481-200D-2640-FE0F",
		c: "1F481-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			23,
			1
		]
	},
	"flag-sm": {
		a: "San Marino Flag",
		b: "1F1F8-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			32
		]
	},
	raising_hand: {
		skin_variations: {
			"1F3FB": {
				unified: "1F64B-1F3FB",
				non_qualified: null,
				image: "1f64b-1f3fb.png",
				sheet_x: 33,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F64B-1F3FC",
				non_qualified: null,
				image: "1f64b-1f3fc.png",
				sheet_x: 33,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F64B-1F3FD",
				non_qualified: null,
				image: "1f64b-1f3fd.png",
				sheet_x: 33,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F64B-1F3FE",
				non_qualified: null,
				image: "1f64b-1f3fe.png",
				sheet_x: 33,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F64B-1F3FF",
				non_qualified: null,
				image: "1f64b-1f3ff.png",
				sheet_x: 33,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F64B-200D-2640-FE0F",
		a: "Happy Person Raising One Hand",
		b: "1F64B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			33,
			6
		]
	},
	"flag-sn": {
		a: "Senegal Flag",
		b: "1F1F8-1F1F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			33
		]
	},
	"man-raising-hand": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64B-1F3FB-200D-2642-FE0F",
				non_qualified: "1F64B-1F3FB-200D-2642",
				image: "1f64b-1f3fb-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F64B-1F3FC-200D-2642-FE0F",
				non_qualified: "1F64B-1F3FC-200D-2642",
				image: "1f64b-1f3fc-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F64B-1F3FD-200D-2642-FE0F",
				non_qualified: "1F64B-1F3FD-200D-2642",
				image: "1f64b-1f3fd-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F64B-1F3FE-200D-2642-FE0F",
				non_qualified: "1F64B-1F3FE-200D-2642",
				image: "1f64b-1f3fe-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F64B-1F3FF-200D-2642-FE0F",
				non_qualified: "1F64B-1F3FF-200D-2642",
				image: "1f64b-1f3ff-200d-2642-fe0f.png",
				sheet_x: 33,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Raising Hand",
		b: "1F64B-200D-2642-FE0F",
		c: "1F64B-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			33,
			0
		]
	},
	"flag-so": {
		a: "Somalia Flag",
		b: "1F1F8-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			34
		]
	},
	"woman-raising-hand": {
		skin_variations: {
			"1F3FB": {
				unified: "1F64B-1F3FB-200D-2640-FE0F",
				non_qualified: "1F64B-1F3FB-200D-2640",
				image: "1f64b-1f3fb-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F64B-1F3FC-200D-2640-FE0F",
				non_qualified: "1F64B-1F3FC-200D-2640",
				image: "1f64b-1f3fc-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F64B-1F3FD-200D-2640-FE0F",
				non_qualified: "1F64B-1F3FD-200D-2640",
				image: "1f64b-1f3fd-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F64B-1F3FE-200D-2640-FE0F",
				non_qualified: "1F64B-1F3FE-200D-2640",
				image: "1f64b-1f3fe-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F64B-1F3FF-200D-2640-FE0F",
				non_qualified: "1F64B-1F3FF-200D-2640",
				image: "1f64b-1f3ff-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F64B",
		a: "Woman Raising Hand",
		b: "1F64B-200D-2640-FE0F",
		c: "1F64B-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			32,
			46
		]
	},
	"flag-sr": {
		a: "Suriname Flag",
		b: "1F1F8-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			35
		]
	},
	bow: {
		skin_variations: {
			"1F3FB": {
				unified: "1F647-1F3FB",
				non_qualified: null,
				image: "1f647-1f3fb.png",
				sheet_x: 32,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F647-1F3FC",
				non_qualified: null,
				image: "1f647-1f3fc.png",
				sheet_x: 32,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F647-1F3FD",
				non_qualified: null,
				image: "1f647-1f3fd.png",
				sheet_x: 32,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F647-1F3FE",
				non_qualified: null,
				image: "1f647-1f3fe.png",
				sheet_x: 32,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F647-1F3FF",
				non_qualified: null,
				image: "1f647-1f3ff.png",
				sheet_x: 32,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F647-200D-2642-FE0F",
		a: "Person Bowing Deeply",
		b: "1F647",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			32,
			37
		]
	},
	"man-bowing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F647-1F3FB-200D-2642-FE0F",
				non_qualified: "1F647-1F3FB-200D-2642",
				image: "1f647-1f3fb-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F647-1F3FC-200D-2642-FE0F",
				non_qualified: "1F647-1F3FC-200D-2642",
				image: "1f647-1f3fc-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F647-1F3FD-200D-2642-FE0F",
				non_qualified: "1F647-1F3FD-200D-2642",
				image: "1f647-1f3fd-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F647-1F3FE-200D-2642-FE0F",
				non_qualified: "1F647-1F3FE-200D-2642",
				image: "1f647-1f3fe-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F647-1F3FF-200D-2642-FE0F",
				non_qualified: "1F647-1F3FF-200D-2642",
				image: "1f647-1f3ff-200d-2642-fe0f.png",
				sheet_x: 32,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F647",
		a: "Man Bowing",
		b: "1F647-200D-2642-FE0F",
		c: "1F647-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			32,
			31
		]
	},
	"flag-ss": {
		a: "South Sudan Flag",
		b: "1F1F8-1F1F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			36
		]
	},
	"woman-bowing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F647-1F3FB-200D-2640-FE0F",
				non_qualified: "1F647-1F3FB-200D-2640",
				image: "1f647-1f3fb-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F647-1F3FC-200D-2640-FE0F",
				non_qualified: "1F647-1F3FC-200D-2640",
				image: "1f647-1f3fc-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F647-1F3FD-200D-2640-FE0F",
				non_qualified: "1F647-1F3FD-200D-2640",
				image: "1f647-1f3fd-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F647-1F3FE-200D-2640-FE0F",
				non_qualified: "1F647-1F3FE-200D-2640",
				image: "1f647-1f3fe-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F647-1F3FF-200D-2640-FE0F",
				non_qualified: "1F647-1F3FF-200D-2640",
				image: "1f647-1f3ff-200d-2640-fe0f.png",
				sheet_x: 32,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Bowing",
		b: "1F647-200D-2640-FE0F",
		c: "1F647-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			32,
			25
		]
	},
	"flag-st": {
		a: "São Tomé & Príncipe Flag",
		b: "1F1F8-1F1F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			37
		]
	},
	face_palm: {
		skin_variations: {
			"1F3FB": {
				unified: "1F926-1F3FB",
				non_qualified: null,
				image: "1f926-1f3fb.png",
				sheet_x: 38,
				sheet_y: 42,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F926-1F3FC",
				non_qualified: null,
				image: "1f926-1f3fc.png",
				sheet_x: 38,
				sheet_y: 43,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F926-1F3FD",
				non_qualified: null,
				image: "1f926-1f3fd.png",
				sheet_x: 38,
				sheet_y: 44,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F926-1F3FE",
				non_qualified: null,
				image: "1f926-1f3fe.png",
				sheet_x: 38,
				sheet_y: 45,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F926-1F3FF",
				non_qualified: null,
				image: "1f926-1f3ff.png",
				sheet_x: 38,
				sheet_y: 46,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Face Palm",
		b: "1F926",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			38,
			41
		],
		o: 9
	},
	"flag-sv": {
		a: "El Salvador Flag",
		b: "1F1F8-1F1FB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			38
		]
	},
	"man-facepalming": {
		skin_variations: {
			"1F3FB": {
				unified: "1F926-1F3FB-200D-2642-FE0F",
				non_qualified: "1F926-1F3FB-200D-2642",
				image: "1f926-1f3fb-200d-2642-fe0f.png",
				sheet_x: 38,
				sheet_y: 36,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F926-1F3FC-200D-2642-FE0F",
				non_qualified: "1F926-1F3FC-200D-2642",
				image: "1f926-1f3fc-200d-2642-fe0f.png",
				sheet_x: 38,
				sheet_y: 37,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F926-1F3FD-200D-2642-FE0F",
				non_qualified: "1F926-1F3FD-200D-2642",
				image: "1f926-1f3fd-200d-2642-fe0f.png",
				sheet_x: 38,
				sheet_y: 38,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F926-1F3FE-200D-2642-FE0F",
				non_qualified: "1F926-1F3FE-200D-2642",
				image: "1f926-1f3fe-200d-2642-fe0f.png",
				sheet_x: 38,
				sheet_y: 39,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F926-1F3FF-200D-2642-FE0F",
				non_qualified: "1F926-1F3FF-200D-2642",
				image: "1f926-1f3ff-200d-2642-fe0f.png",
				sheet_x: 38,
				sheet_y: 40,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Facepalming",
		b: "1F926-200D-2642-FE0F",
		c: "1F926-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			38,
			35
		],
		o: 9
	},
	"flag-sx": {
		a: "Sint Maarten Flag",
		b: "1F1F8-1F1FD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			39
		]
	},
	"flag-sy": {
		a: "Syria Flag",
		b: "1F1F8-1F1FE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			40
		]
	},
	"woman-facepalming": {
		skin_variations: {
			"1F3FB": {
				unified: "1F926-1F3FB-200D-2640-FE0F",
				non_qualified: "1F926-1F3FB-200D-2640",
				image: "1f926-1f3fb-200d-2640-fe0f.png",
				sheet_x: 38,
				sheet_y: 30,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F926-1F3FC-200D-2640-FE0F",
				non_qualified: "1F926-1F3FC-200D-2640",
				image: "1f926-1f3fc-200d-2640-fe0f.png",
				sheet_x: 38,
				sheet_y: 31,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F926-1F3FD-200D-2640-FE0F",
				non_qualified: "1F926-1F3FD-200D-2640",
				image: "1f926-1f3fd-200d-2640-fe0f.png",
				sheet_x: 38,
				sheet_y: 32,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F926-1F3FE-200D-2640-FE0F",
				non_qualified: "1F926-1F3FE-200D-2640",
				image: "1f926-1f3fe-200d-2640-fe0f.png",
				sheet_x: 38,
				sheet_y: 33,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F926-1F3FF-200D-2640-FE0F",
				non_qualified: "1F926-1F3FF-200D-2640",
				image: "1f926-1f3ff-200d-2640-fe0f.png",
				sheet_x: 38,
				sheet_y: 34,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Facepalming",
		b: "1F926-200D-2640-FE0F",
		c: "1F926-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			38,
			29
		],
		o: 9
	},
	shrug: {
		skin_variations: {
			"1F3FB": {
				unified: "1F937-1F3FB",
				non_qualified: null,
				image: "1f937-1f3fb.png",
				sheet_x: 40,
				sheet_y: 7,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F937-1F3FC",
				non_qualified: null,
				image: "1f937-1f3fc.png",
				sheet_x: 40,
				sheet_y: 8,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F937-1F3FD",
				non_qualified: null,
				image: "1f937-1f3fd.png",
				sheet_x: 40,
				sheet_y: 9,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F937-1F3FE",
				non_qualified: null,
				image: "1f937-1f3fe.png",
				sheet_x: 40,
				sheet_y: 10,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F937-1F3FF",
				non_qualified: null,
				image: "1f937-1f3ff.png",
				sheet_x: 40,
				sheet_y: 11,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Shrug",
		b: "1F937",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			40,
			6
		],
		o: 9
	},
	"flag-sz": {
		a: "Swaziland Flag",
		b: "1F1F8-1F1FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			41
		]
	},
	"flag-ta": {
		a: "Tristan Da Cunha Flag",
		b: "1F1F9-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			42
		]
	},
	"man-shrugging": {
		skin_variations: {
			"1F3FB": {
				unified: "1F937-1F3FB-200D-2642-FE0F",
				non_qualified: "1F937-1F3FB-200D-2642",
				image: "1f937-1f3fb-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 1,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F937-1F3FC-200D-2642-FE0F",
				non_qualified: "1F937-1F3FC-200D-2642",
				image: "1f937-1f3fc-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 2,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F937-1F3FD-200D-2642-FE0F",
				non_qualified: "1F937-1F3FD-200D-2642",
				image: "1f937-1f3fd-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 3,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F937-1F3FE-200D-2642-FE0F",
				non_qualified: "1F937-1F3FE-200D-2642",
				image: "1f937-1f3fe-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 4,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F937-1F3FF-200D-2642-FE0F",
				non_qualified: "1F937-1F3FF-200D-2642",
				image: "1f937-1f3ff-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 5,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Shrugging",
		b: "1F937-200D-2642-FE0F",
		c: "1F937-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			40,
			0
		],
		o: 9
	},
	"woman-shrugging": {
		skin_variations: {
			"1F3FB": {
				unified: "1F937-1F3FB-200D-2640-FE0F",
				non_qualified: "1F937-1F3FB-200D-2640",
				image: "1f937-1f3fb-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 47,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F937-1F3FC-200D-2640-FE0F",
				non_qualified: "1F937-1F3FC-200D-2640",
				image: "1f937-1f3fc-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 48,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F937-1F3FD-200D-2640-FE0F",
				non_qualified: "1F937-1F3FD-200D-2640",
				image: "1f937-1f3fd-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 49,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F937-1F3FE-200D-2640-FE0F",
				non_qualified: "1F937-1F3FE-200D-2640",
				image: "1f937-1f3fe-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 50,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F937-1F3FF-200D-2640-FE0F",
				non_qualified: "1F937-1F3FF-200D-2640",
				image: "1f937-1f3ff-200d-2640-fe0f.png",
				sheet_x: 39,
				sheet_y: 51,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Shrugging",
		b: "1F937-200D-2640-FE0F",
		c: "1F937-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			39,
			46
		],
		o: 9
	},
	"flag-tc": {
		a: "Turks & Caicos Islands Flag",
		b: "1F1F9-1F1E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			43
		]
	},
	massage: {
		skin_variations: {
			"1F3FB": {
				unified: "1F486-1F3FB",
				non_qualified: null,
				image: "1f486-1f3fb.png",
				sheet_x: 24,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F486-1F3FC",
				non_qualified: null,
				image: "1f486-1f3fc.png",
				sheet_x: 24,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F486-1F3FD",
				non_qualified: null,
				image: "1f486-1f3fd.png",
				sheet_x: 24,
				sheet_y: 13,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F486-1F3FE",
				non_qualified: null,
				image: "1f486-1f3fe.png",
				sheet_x: 24,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F486-1F3FF",
				non_qualified: null,
				image: "1f486-1f3ff.png",
				sheet_x: 24,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F486-200D-2640-FE0F",
		a: "Face Massage",
		b: "1F486",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			24,
			10
		]
	},
	"flag-td": {
		a: "Chad Flag",
		b: "1F1F9-1F1E9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			44
		]
	},
	"man-getting-massage": {
		skin_variations: {
			"1F3FB": {
				unified: "1F486-1F3FB-200D-2642-FE0F",
				non_qualified: "1F486-1F3FB-200D-2642",
				image: "1f486-1f3fb-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F486-1F3FC-200D-2642-FE0F",
				non_qualified: "1F486-1F3FC-200D-2642",
				image: "1f486-1f3fc-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F486-1F3FD-200D-2642-FE0F",
				non_qualified: "1F486-1F3FD-200D-2642",
				image: "1f486-1f3fd-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F486-1F3FE-200D-2642-FE0F",
				non_qualified: "1F486-1F3FE-200D-2642",
				image: "1f486-1f3fe-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F486-1F3FF-200D-2642-FE0F",
				non_qualified: "1F486-1F3FF-200D-2642",
				image: "1f486-1f3ff-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Getting Massage",
		b: "1F486-200D-2642-FE0F",
		c: "1F486-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			24,
			4
		]
	},
	"flag-tf": {
		a: "French Southern Territories Flag",
		b: "1F1F9-1F1EB",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			45
		]
	},
	"woman-getting-massage": {
		skin_variations: {
			"1F3FB": {
				unified: "1F486-1F3FB-200D-2640-FE0F",
				non_qualified: "1F486-1F3FB-200D-2640",
				image: "1f486-1f3fb-200d-2640-fe0f.png",
				sheet_x: 23,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F486-1F3FC-200D-2640-FE0F",
				non_qualified: "1F486-1F3FC-200D-2640",
				image: "1f486-1f3fc-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F486-1F3FD-200D-2640-FE0F",
				non_qualified: "1F486-1F3FD-200D-2640",
				image: "1f486-1f3fd-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F486-1F3FE-200D-2640-FE0F",
				non_qualified: "1F486-1F3FE-200D-2640",
				image: "1f486-1f3fe-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F486-1F3FF-200D-2640-FE0F",
				non_qualified: "1F486-1F3FF-200D-2640",
				image: "1f486-1f3ff-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F486",
		a: "Woman Getting Massage",
		b: "1F486-200D-2640-FE0F",
		c: "1F486-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			23,
			50
		]
	},
	"flag-tg": {
		a: "Togo Flag",
		b: "1F1F9-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			46
		]
	},
	haircut: {
		skin_variations: {
			"1F3FB": {
				unified: "1F487-1F3FB",
				non_qualified: null,
				image: "1f487-1f3fb.png",
				sheet_x: 24,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F487-1F3FC",
				non_qualified: null,
				image: "1f487-1f3fc.png",
				sheet_x: 24,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F487-1F3FD",
				non_qualified: null,
				image: "1f487-1f3fd.png",
				sheet_x: 24,
				sheet_y: 31,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F487-1F3FE",
				non_qualified: null,
				image: "1f487-1f3fe.png",
				sheet_x: 24,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F487-1F3FF",
				non_qualified: null,
				image: "1f487-1f3ff.png",
				sheet_x: 24,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F487-200D-2640-FE0F",
		a: "Haircut",
		b: "1F487",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			24,
			28
		]
	},
	"flag-th": {
		a: "Thailand Flag",
		b: "1F1F9-1F1ED",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			47
		]
	},
	"man-getting-haircut": {
		skin_variations: {
			"1F3FB": {
				unified: "1F487-1F3FB-200D-2642-FE0F",
				non_qualified: "1F487-1F3FB-200D-2642",
				image: "1f487-1f3fb-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F487-1F3FC-200D-2642-FE0F",
				non_qualified: "1F487-1F3FC-200D-2642",
				image: "1f487-1f3fc-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F487-1F3FD-200D-2642-FE0F",
				non_qualified: "1F487-1F3FD-200D-2642",
				image: "1f487-1f3fd-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F487-1F3FE-200D-2642-FE0F",
				non_qualified: "1F487-1F3FE-200D-2642",
				image: "1f487-1f3fe-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F487-1F3FF-200D-2642-FE0F",
				non_qualified: "1F487-1F3FF-200D-2642",
				image: "1f487-1f3ff-200d-2642-fe0f.png",
				sheet_x: 24,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Getting Haircut",
		b: "1F487-200D-2642-FE0F",
		c: "1F487-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			24,
			22
		]
	},
	"flag-tj": {
		a: "Tajikistan Flag",
		b: "1F1F9-1F1EF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			48
		]
	},
	"flag-tk": {
		a: "Tokelau Flag",
		b: "1F1F9-1F1F0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			49
		]
	},
	"woman-getting-haircut": {
		skin_variations: {
			"1F3FB": {
				unified: "1F487-1F3FB-200D-2640-FE0F",
				non_qualified: "1F487-1F3FB-200D-2640",
				image: "1f487-1f3fb-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F487-1F3FC-200D-2640-FE0F",
				non_qualified: "1F487-1F3FC-200D-2640",
				image: "1f487-1f3fc-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F487-1F3FD-200D-2640-FE0F",
				non_qualified: "1F487-1F3FD-200D-2640",
				image: "1f487-1f3fd-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F487-1F3FE-200D-2640-FE0F",
				non_qualified: "1F487-1F3FE-200D-2640",
				image: "1f487-1f3fe-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F487-1F3FF-200D-2640-FE0F",
				non_qualified: "1F487-1F3FF-200D-2640",
				image: "1f487-1f3ff-200d-2640-fe0f.png",
				sheet_x: 24,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F487",
		a: "Woman Getting Haircut",
		b: "1F487-200D-2640-FE0F",
		c: "1F487-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			24,
			16
		]
	},
	walking: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B6-1F3FB",
				non_qualified: null,
				image: "1f6b6-1f3fb.png",
				sheet_x: 36,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F6B6-1F3FC",
				non_qualified: null,
				image: "1f6b6-1f3fc.png",
				sheet_x: 36,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F6B6-1F3FD",
				non_qualified: null,
				image: "1f6b6-1f3fd.png",
				sheet_x: 36,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F6B6-1F3FE",
				non_qualified: null,
				image: "1f6b6-1f3fe.png",
				sheet_x: 36,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F6B6-1F3FF",
				non_qualified: null,
				image: "1f6b6-1f3ff.png",
				sheet_x: 36,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F6B6-200D-2642-FE0F",
		a: "Pedestrian",
		b: "1F6B6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			36,
			21
		]
	},
	"flag-tl": {
		a: "Timor-Leste Flag",
		b: "1F1F9-1F1F1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			50
		]
	},
	"man-walking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B6-1F3FB-200D-2642-FE0F",
				non_qualified: "1F6B6-1F3FB-200D-2642",
				image: "1f6b6-1f3fb-200d-2642-fe0f.png",
				sheet_x: 36,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F6B6-1F3FC-200D-2642-FE0F",
				non_qualified: "1F6B6-1F3FC-200D-2642",
				image: "1f6b6-1f3fc-200d-2642-fe0f.png",
				sheet_x: 36,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F6B6-1F3FD-200D-2642-FE0F",
				non_qualified: "1F6B6-1F3FD-200D-2642",
				image: "1f6b6-1f3fd-200d-2642-fe0f.png",
				sheet_x: 36,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F6B6-1F3FE-200D-2642-FE0F",
				non_qualified: "1F6B6-1F3FE-200D-2642",
				image: "1f6b6-1f3fe-200d-2642-fe0f.png",
				sheet_x: 36,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F6B6-1F3FF-200D-2642-FE0F",
				non_qualified: "1F6B6-1F3FF-200D-2642",
				image: "1f6b6-1f3ff-200d-2642-fe0f.png",
				sheet_x: 36,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F6B6",
		a: "Man Walking",
		b: "1F6B6-200D-2642-FE0F",
		c: "1F6B6-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			36,
			15
		]
	},
	"flag-tm": {
		a: "Turkmenistan Flag",
		b: "1F1F9-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			4,
			51
		]
	},
	"woman-walking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B6-1F3FB-200D-2640-FE0F",
				non_qualified: "1F6B6-1F3FB-200D-2640",
				image: "1f6b6-1f3fb-200d-2640-fe0f.png",
				sheet_x: 36,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F6B6-1F3FC-200D-2640-FE0F",
				non_qualified: "1F6B6-1F3FC-200D-2640",
				image: "1f6b6-1f3fc-200d-2640-fe0f.png",
				sheet_x: 36,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F6B6-1F3FD-200D-2640-FE0F",
				non_qualified: "1F6B6-1F3FD-200D-2640",
				image: "1f6b6-1f3fd-200d-2640-fe0f.png",
				sheet_x: 36,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F6B6-1F3FE-200D-2640-FE0F",
				non_qualified: "1F6B6-1F3FE-200D-2640",
				image: "1f6b6-1f3fe-200d-2640-fe0f.png",
				sheet_x: 36,
				sheet_y: 13,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F6B6-1F3FF-200D-2640-FE0F",
				non_qualified: "1F6B6-1F3FF-200D-2640",
				image: "1f6b6-1f3ff-200d-2640-fe0f.png",
				sheet_x: 36,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Walking",
		b: "1F6B6-200D-2640-FE0F",
		c: "1F6B6-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			36,
			9
		]
	},
	"flag-tn": {
		a: "Tunisia Flag",
		b: "1F1F9-1F1F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			0
		]
	},
	runner: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C3-1F3FB",
				non_qualified: null,
				image: "1f3c3-1f3fb.png",
				sheet_x: 9,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F3C3-1F3FC",
				non_qualified: null,
				image: "1f3c3-1f3fc.png",
				sheet_x: 9,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F3C3-1F3FD",
				non_qualified: null,
				image: "1f3c3-1f3fd.png",
				sheet_x: 9,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F3C3-1F3FE",
				non_qualified: null,
				image: "1f3c3-1f3fe.png",
				sheet_x: 9,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F3C3-1F3FF",
				non_qualified: null,
				image: "1f3c3-1f3ff.png",
				sheet_x: 9,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F3C3-200D-2642-FE0F",
		a: "Runner",
		b: "1F3C3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			9,
			46
		],
		n: [
			"running"
		]
	},
	"flag-to": {
		a: "Tonga Flag",
		b: "1F1F9-1F1F4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			1
		]
	},
	"man-running": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C3-1F3FB-200D-2642-FE0F",
				non_qualified: "1F3C3-1F3FB-200D-2642",
				image: "1f3c3-1f3fb-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3C3-1F3FC-200D-2642-FE0F",
				non_qualified: "1F3C3-1F3FC-200D-2642",
				image: "1f3c3-1f3fc-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3C3-1F3FD-200D-2642-FE0F",
				non_qualified: "1F3C3-1F3FD-200D-2642",
				image: "1f3c3-1f3fd-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 43,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3C3-1F3FE-200D-2642-FE0F",
				non_qualified: "1F3C3-1F3FE-200D-2642",
				image: "1f3c3-1f3fe-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3C3-1F3FF-200D-2642-FE0F",
				non_qualified: "1F3C3-1F3FF-200D-2642",
				image: "1f3c3-1f3ff-200d-2642-fe0f.png",
				sheet_x: 9,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F3C3",
		a: "Man Running",
		b: "1F3C3-200D-2642-FE0F",
		c: "1F3C3-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			9,
			40
		]
	},
	"flag-tr": {
		a: "Turkey Flag",
		b: "1F1F9-1F1F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			2
		]
	},
	"flag-tt": {
		a: "Trinidad & Tobago Flag",
		b: "1F1F9-1F1F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			3
		]
	},
	"woman-running": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C3-1F3FB-200D-2640-FE0F",
				non_qualified: "1F3C3-1F3FB-200D-2640",
				image: "1f3c3-1f3fb-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3C3-1F3FC-200D-2640-FE0F",
				non_qualified: "1F3C3-1F3FC-200D-2640",
				image: "1f3c3-1f3fc-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3C3-1F3FD-200D-2640-FE0F",
				non_qualified: "1F3C3-1F3FD-200D-2640",
				image: "1f3c3-1f3fd-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3C3-1F3FE-200D-2640-FE0F",
				non_qualified: "1F3C3-1F3FE-200D-2640",
				image: "1f3c3-1f3fe-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3C3-1F3FF-200D-2640-FE0F",
				non_qualified: "1F3C3-1F3FF-200D-2640",
				image: "1f3c3-1f3ff-200d-2640-fe0f.png",
				sheet_x: 9,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Running",
		b: "1F3C3-200D-2640-FE0F",
		c: "1F3C3-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			9,
			34
		]
	},
	"flag-tv": {
		a: "Tuvalu Flag",
		b: "1F1F9-1F1FB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			4
		]
	},
	dancer: {
		skin_variations: {
			"1F3FB": {
				unified: "1F483-1F3FB",
				non_qualified: null,
				image: "1f483-1f3fb.png",
				sheet_x: 23,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F483-1F3FC",
				non_qualified: null,
				image: "1f483-1f3fc.png",
				sheet_x: 23,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F483-1F3FD",
				non_qualified: null,
				image: "1f483-1f3fd.png",
				sheet_x: 23,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F483-1F3FE",
				non_qualified: null,
				image: "1f483-1f3fe.png",
				sheet_x: 23,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F483-1F3FF",
				non_qualified: null,
				image: "1f483-1f3ff.png",
				sheet_x: 23,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Dancer",
		b: "1F483",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"female",
			"girl",
			"woman",
			"fun"
		],
		k: [
			23,
			37
		]
	},
	"flag-tw": {
		a: "Taiwan Flag",
		b: "1F1F9-1F1FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			5
		]
	},
	man_dancing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F57A-1F3FB",
				non_qualified: null,
				image: "1f57a-1f3fb.png",
				sheet_x: 29,
				sheet_y: 22,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F57A-1F3FC",
				non_qualified: null,
				image: "1f57a-1f3fc.png",
				sheet_x: 29,
				sheet_y: 23,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F57A-1F3FD",
				non_qualified: null,
				image: "1f57a-1f3fd.png",
				sheet_x: 29,
				sheet_y: 24,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F57A-1F3FE",
				non_qualified: null,
				image: "1f57a-1f3fe.png",
				sheet_x: 29,
				sheet_y: 25,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F57A-1F3FF",
				non_qualified: null,
				image: "1f57a-1f3ff.png",
				sheet_x: 29,
				sheet_y: 26,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Man Dancing",
		b: "1F57A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"male",
			"boy",
			"fun",
			"dancer"
		],
		k: [
			29,
			21
		],
		o: 9
	},
	dancers: {
		obsoleted_by: "1F46F-200D-2640-FE0F",
		a: "Woman with Bunny Ears",
		b: "1F46F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			21,
			1
		]
	},
	"flag-tz": {
		a: "Tanzania Flag",
		b: "1F1F9-1F1FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			6
		]
	},
	"flag-ua": {
		a: "Ukraine Flag",
		b: "1F1FA-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			7
		]
	},
	"man-with-bunny-ears-partying": {
		a: "Man with Bunny Ears Partying",
		b: "1F46F-200D-2642-FE0F",
		c: "1F46F-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			21,
			0
		]
	},
	"woman-with-bunny-ears-partying": {
		obsoletes: "1F46F",
		a: "Woman with Bunny Ears Partying",
		b: "1F46F-200D-2640-FE0F",
		c: "1F46F-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			20,
			51
		]
	},
	"flag-ug": {
		a: "Uganda Flag",
		b: "1F1FA-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			8
		]
	},
	"flag-um": {
		a: "U.s. Outlying Islands Flag",
		b: "1F1FA-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			9
		]
	},
	person_in_steamy_room: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D6-1F3FB",
				non_qualified: null,
				image: "1f9d6-1f3fb.png",
				sheet_x: 43,
				sheet_y: 41,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D6-1F3FB-200D-2642-FE0F"
			},
			"1F3FC": {
				unified: "1F9D6-1F3FC",
				non_qualified: null,
				image: "1f9d6-1f3fc.png",
				sheet_x: 43,
				sheet_y: 42,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D6-1F3FC-200D-2642-FE0F"
			},
			"1F3FD": {
				unified: "1F9D6-1F3FD",
				non_qualified: null,
				image: "1f9d6-1f3fd.png",
				sheet_x: 43,
				sheet_y: 43,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D6-1F3FD-200D-2642-FE0F"
			},
			"1F3FE": {
				unified: "1F9D6-1F3FE",
				non_qualified: null,
				image: "1f9d6-1f3fe.png",
				sheet_x: 43,
				sheet_y: 44,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D6-1F3FE-200D-2642-FE0F"
			},
			"1F3FF": {
				unified: "1F9D6-1F3FF",
				non_qualified: null,
				image: "1f9d6-1f3ff.png",
				sheet_x: 43,
				sheet_y: 45,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D6-1F3FF-200D-2642-FE0F"
			}
		},
		obsoleted_by: "1F9D6-200D-2642-FE0F",
		a: "Person in Steamy Room",
		b: "1F9D6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			43,
			40
		],
		o: 10
	},
	woman_in_steamy_room: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D6-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9D6-1F3FB-200D-2640",
				image: "1f9d6-1f3fb-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 29,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9D6-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9D6-1F3FC-200D-2640",
				image: "1f9d6-1f3fc-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 30,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9D6-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9D6-1F3FD-200D-2640",
				image: "1f9d6-1f3fd-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 31,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9D6-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9D6-1F3FE-200D-2640",
				image: "1f9d6-1f3fe-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 32,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9D6-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9D6-1F3FF-200D-2640",
				image: "1f9d6-1f3ff-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 33,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman in Steamy Room",
		b: "1F9D6-200D-2640-FE0F",
		c: "1F9D6-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			43,
			28
		],
		o: 10
	},
	"flag-un": {
		a: "United Nations Flag",
		b: "1F1FA-1F1F3",
		d: false,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			5,
			10
		]
	},
	us: {
		a: "United States Flag",
		b: "1F1FA-1F1F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"united",
			"states",
			"america",
			"flag",
			"nation",
			"country",
			"banner"
		],
		k: [
			5,
			11
		],
		n: [
			"flag-us"
		]
	},
	man_in_steamy_room: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D6-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9D6-1F3FB-200D-2642",
				image: "1f9d6-1f3fb-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 35,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D6-1F3FB"
			},
			"1F3FC": {
				unified: "1F9D6-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9D6-1F3FC-200D-2642",
				image: "1f9d6-1f3fc-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 36,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D6-1F3FC"
			},
			"1F3FD": {
				unified: "1F9D6-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9D6-1F3FD-200D-2642",
				image: "1f9d6-1f3fd-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 37,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D6-1F3FD"
			},
			"1F3FE": {
				unified: "1F9D6-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9D6-1F3FE-200D-2642",
				image: "1f9d6-1f3fe-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 38,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D6-1F3FE"
			},
			"1F3FF": {
				unified: "1F9D6-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9D6-1F3FF-200D-2642",
				image: "1f9d6-1f3ff-200d-2642-fe0f.png",
				sheet_x: 43,
				sheet_y: 39,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D6-1F3FF"
			}
		},
		obsoletes: "1F9D6",
		a: "Man in Steamy Room",
		b: "1F9D6-200D-2642-FE0F",
		c: "1F9D6-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			43,
			34
		],
		o: 10
	},
	person_climbing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D7-1F3FB",
				non_qualified: null,
				image: "1f9d7-1f3fb.png",
				sheet_x: 44,
				sheet_y: 7,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D7-1F3FB-200D-2640-FE0F"
			},
			"1F3FC": {
				unified: "1F9D7-1F3FC",
				non_qualified: null,
				image: "1f9d7-1f3fc.png",
				sheet_x: 44,
				sheet_y: 8,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D7-1F3FC-200D-2640-FE0F"
			},
			"1F3FD": {
				unified: "1F9D7-1F3FD",
				non_qualified: null,
				image: "1f9d7-1f3fd.png",
				sheet_x: 44,
				sheet_y: 9,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D7-1F3FD-200D-2640-FE0F"
			},
			"1F3FE": {
				unified: "1F9D7-1F3FE",
				non_qualified: null,
				image: "1f9d7-1f3fe.png",
				sheet_x: 44,
				sheet_y: 10,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D7-1F3FE-200D-2640-FE0F"
			},
			"1F3FF": {
				unified: "1F9D7-1F3FF",
				non_qualified: null,
				image: "1f9d7-1f3ff.png",
				sheet_x: 44,
				sheet_y: 11,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D7-1F3FF-200D-2640-FE0F"
			}
		},
		obsoleted_by: "1F9D7-200D-2640-FE0F",
		a: "Person Climbing",
		b: "1F9D7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			44,
			6
		],
		o: 10
	},
	"flag-uy": {
		a: "Uruguay Flag",
		b: "1F1FA-1F1FE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			12
		]
	},
	woman_climbing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D7-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9D7-1F3FB-200D-2640",
				image: "1f9d7-1f3fb-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 47,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D7-1F3FB"
			},
			"1F3FC": {
				unified: "1F9D7-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9D7-1F3FC-200D-2640",
				image: "1f9d7-1f3fc-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 48,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D7-1F3FC"
			},
			"1F3FD": {
				unified: "1F9D7-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9D7-1F3FD-200D-2640",
				image: "1f9d7-1f3fd-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 49,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D7-1F3FD"
			},
			"1F3FE": {
				unified: "1F9D7-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9D7-1F3FE-200D-2640",
				image: "1f9d7-1f3fe-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 50,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D7-1F3FE"
			},
			"1F3FF": {
				unified: "1F9D7-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9D7-1F3FF-200D-2640",
				image: "1f9d7-1f3ff-200d-2640-fe0f.png",
				sheet_x: 43,
				sheet_y: 51,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D7-1F3FF"
			}
		},
		obsoletes: "1F9D7",
		a: "Woman Climbing",
		b: "1F9D7-200D-2640-FE0F",
		c: "1F9D7-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			43,
			46
		],
		o: 10
	},
	"flag-uz": {
		a: "Uzbekistan Flag",
		b: "1F1FA-1F1FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			13
		]
	},
	man_climbing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D7-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9D7-1F3FB-200D-2642",
				image: "1f9d7-1f3fb-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 1,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9D7-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9D7-1F3FC-200D-2642",
				image: "1f9d7-1f3fc-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 2,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9D7-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9D7-1F3FD-200D-2642",
				image: "1f9d7-1f3fd-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 3,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9D7-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9D7-1F3FE-200D-2642",
				image: "1f9d7-1f3fe-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 4,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9D7-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9D7-1F3FF-200D-2642",
				image: "1f9d7-1f3ff-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 5,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Climbing",
		b: "1F9D7-200D-2642-FE0F",
		c: "1F9D7-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			44,
			0
		],
		o: 10
	},
	"flag-va": {
		a: "Vatican City Flag",
		b: "1F1FB-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			14
		]
	},
	person_in_lotus_position: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D8-1F3FB",
				non_qualified: null,
				image: "1f9d8-1f3fb.png",
				sheet_x: 44,
				sheet_y: 25,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D8-1F3FB-200D-2640-FE0F"
			},
			"1F3FC": {
				unified: "1F9D8-1F3FC",
				non_qualified: null,
				image: "1f9d8-1f3fc.png",
				sheet_x: 44,
				sheet_y: 26,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D8-1F3FC-200D-2640-FE0F"
			},
			"1F3FD": {
				unified: "1F9D8-1F3FD",
				non_qualified: null,
				image: "1f9d8-1f3fd.png",
				sheet_x: 44,
				sheet_y: 27,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D8-1F3FD-200D-2640-FE0F"
			},
			"1F3FE": {
				unified: "1F9D8-1F3FE",
				non_qualified: null,
				image: "1f9d8-1f3fe.png",
				sheet_x: 44,
				sheet_y: 28,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D8-1F3FE-200D-2640-FE0F"
			},
			"1F3FF": {
				unified: "1F9D8-1F3FF",
				non_qualified: null,
				image: "1f9d8-1f3ff.png",
				sheet_x: 44,
				sheet_y: 29,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false,
				obsoleted_by: "1F9D8-1F3FF-200D-2640-FE0F"
			}
		},
		obsoleted_by: "1F9D8-200D-2640-FE0F",
		a: "Person in Lotus Position",
		b: "1F9D8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			44,
			24
		],
		o: 10
	},
	"flag-vc": {
		a: "St. Vincent & Grenadines Flag",
		b: "1F1FB-1F1E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			15
		]
	},
	"flag-ve": {
		a: "Venezuela Flag",
		b: "1F1FB-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			16
		]
	},
	woman_in_lotus_position: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D8-1F3FB-200D-2640-FE0F",
				non_qualified: "1F9D8-1F3FB-200D-2640",
				image: "1f9d8-1f3fb-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 13,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D8-1F3FB"
			},
			"1F3FC": {
				unified: "1F9D8-1F3FC-200D-2640-FE0F",
				non_qualified: "1F9D8-1F3FC-200D-2640",
				image: "1f9d8-1f3fc-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 14,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D8-1F3FC"
			},
			"1F3FD": {
				unified: "1F9D8-1F3FD-200D-2640-FE0F",
				non_qualified: "1F9D8-1F3FD-200D-2640",
				image: "1f9d8-1f3fd-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 15,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D8-1F3FD"
			},
			"1F3FE": {
				unified: "1F9D8-1F3FE-200D-2640-FE0F",
				non_qualified: "1F9D8-1F3FE-200D-2640",
				image: "1f9d8-1f3fe-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 16,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D8-1F3FE"
			},
			"1F3FF": {
				unified: "1F9D8-1F3FF-200D-2640-FE0F",
				non_qualified: "1F9D8-1F3FF-200D-2640",
				image: "1f9d8-1f3ff-200d-2640-fe0f.png",
				sheet_x: 44,
				sheet_y: 17,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false,
				obsoletes: "1F9D8-1F3FF"
			}
		},
		obsoletes: "1F9D8",
		a: "Woman in Lotus Position",
		b: "1F9D8-200D-2640-FE0F",
		c: "1F9D8-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			44,
			12
		],
		o: 10
	},
	man_in_lotus_position: {
		skin_variations: {
			"1F3FB": {
				unified: "1F9D8-1F3FB-200D-2642-FE0F",
				non_qualified: "1F9D8-1F3FB-200D-2642",
				image: "1f9d8-1f3fb-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 19,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F9D8-1F3FC-200D-2642-FE0F",
				non_qualified: "1F9D8-1F3FC-200D-2642",
				image: "1f9d8-1f3fc-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 20,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F9D8-1F3FD-200D-2642-FE0F",
				non_qualified: "1F9D8-1F3FD-200D-2642",
				image: "1f9d8-1f3fd-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 21,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F9D8-1F3FE-200D-2642-FE0F",
				non_qualified: "1F9D8-1F3FE-200D-2642",
				image: "1f9d8-1f3fe-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 22,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F9D8-1F3FF-200D-2642-FE0F",
				non_qualified: "1F9D8-1F3FF-200D-2642",
				image: "1f9d8-1f3ff-200d-2642-fe0f.png",
				sheet_x: 44,
				sheet_y: 23,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man in Lotus Position",
		b: "1F9D8-200D-2642-FE0F",
		c: "1F9D8-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			44,
			18
		],
		o: 10
	},
	"flag-vg": {
		a: "British Virgin Islands Flag",
		b: "1F1FB-1F1EC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			17
		]
	},
	"flag-vi": {
		a: "U.s. Virgin Islands Flag",
		b: "1F1FB-1F1EE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			18
		]
	},
	bath: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6C0-1F3FB",
				non_qualified: null,
				image: "1f6c0-1f3fb.png",
				sheet_x: 36,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F6C0-1F3FC",
				non_qualified: null,
				image: "1f6c0-1f3fc.png",
				sheet_x: 36,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F6C0-1F3FD",
				non_qualified: null,
				image: "1f6c0-1f3fd.png",
				sheet_x: 36,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F6C0-1F3FE",
				non_qualified: null,
				image: "1f6c0-1f3fe.png",
				sheet_x: 36,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F6C0-1F3FF",
				non_qualified: null,
				image: "1f6c0-1f3ff.png",
				sheet_x: 36,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Bath",
		b: "1F6C0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"clean",
			"shower",
			"bathroom"
		],
		k: [
			36,
			36
		]
	},
	sleeping_accommodation: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6CC-1F3FB",
				non_qualified: null,
				image: "1f6cc-1f3fb.png",
				sheet_x: 36,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F6CC-1F3FC",
				non_qualified: null,
				image: "1f6cc-1f3fc.png",
				sheet_x: 36,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F6CC-1F3FD",
				non_qualified: null,
				image: "1f6cc-1f3fd.png",
				sheet_x: 36,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F6CC-1F3FE",
				non_qualified: null,
				image: "1f6cc-1f3fe.png",
				sheet_x: 37,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F6CC-1F3FF",
				non_qualified: null,
				image: "1f6cc-1f3ff.png",
				sheet_x: 37,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Sleeping Accommodation",
		b: "1F6CC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			36,
			48
		],
		o: 7
	},
	"flag-vn": {
		a: "Vietnam Flag",
		b: "1F1FB-1F1F3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			19
		]
	},
	man_in_business_suit_levitating: {
		skin_variations: {
			"1F3FB": {
				unified: "1F574-1F3FB",
				non_qualified: null,
				image: "1f574-1f3fb.png",
				sheet_x: 28,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F574-1F3FC",
				non_qualified: null,
				image: "1f574-1f3fc.png",
				sheet_x: 28,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F574-1F3FD",
				non_qualified: null,
				image: "1f574-1f3fd.png",
				sheet_x: 28,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F574-1F3FE",
				non_qualified: null,
				image: "1f574-1f3fe.png",
				sheet_x: 28,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F574-1F3FF",
				non_qualified: null,
				image: "1f574-1f3ff.png",
				sheet_x: 28,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Man in Business Suit Levitating",
		b: "1F574-FE0F",
		c: "1F574",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			28,
			45
		],
		o: 7
	},
	"flag-vu": {
		a: "Vanuatu Flag",
		b: "1F1FB-1F1FA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			20
		]
	},
	"flag-wf": {
		a: "Wallis & Futuna Flag",
		b: "1F1FC-1F1EB",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			21
		]
	},
	speaking_head_in_silhouette: {
		a: "Speaking Head in Silhouette",
		b: "1F5E3-FE0F",
		c: "1F5E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			30,
			14
		],
		o: 7
	},
	bust_in_silhouette: {
		a: "Bust in Silhouette",
		b: "1F464",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"user",
			"person",
			"human"
		],
		k: [
			15,
			40
		]
	},
	"flag-ws": {
		a: "Samoa Flag",
		b: "1F1FC-1F1F8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			22
		]
	},
	busts_in_silhouette: {
		a: "Busts in Silhouette",
		b: "1F465",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"user",
			"person",
			"human",
			"group",
			"team"
		],
		k: [
			15,
			41
		]
	},
	"flag-xk": {
		a: "Kosovo Flag",
		b: "1F1FD-1F1F0",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			23
		]
	},
	fencer: {
		a: "Fencer",
		b: "1F93A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			40,
			48
		],
		o: 9
	},
	"flag-ye": {
		a: "Yemen Flag",
		b: "1F1FE-1F1EA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			24
		]
	},
	"flag-yt": {
		a: "Mayotte Flag",
		b: "1F1FE-1F1F9",
		d: true,
		e: false,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			25
		]
	},
	horse_racing: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C7-1F3FB",
				non_qualified: null,
				image: "1f3c7-1f3fb.png",
				sheet_x: 10,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F3C7-1F3FC",
				non_qualified: null,
				image: "1f3c7-1f3fc.png",
				sheet_x: 10,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F3C7-1F3FD",
				non_qualified: null,
				image: "1f3c7-1f3fd.png",
				sheet_x: 10,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F3C7-1F3FE",
				non_qualified: null,
				image: "1f3c7-1f3fe.png",
				sheet_x: 10,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F3C7-1F3FF",
				non_qualified: null,
				image: "1f3c7-1f3ff.png",
				sheet_x: 10,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Horse Racing",
		b: "1F3C7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"animal",
			"betting",
			"competition",
			"gambling",
			"luck"
		],
		k: [
			10,
			20
		]
	},
	"flag-za": {
		a: "South Africa Flag",
		b: "1F1FF-1F1E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			26
		]
	},
	skier: {
		a: "Skier",
		b: "26F7-FE0F",
		c: "26F7",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sports",
			"winter",
			"snow"
		],
		k: [
			48,
			44
		],
		o: 5
	},
	"flag-zm": {
		a: "Zambia Flag",
		b: "1F1FF-1F1F2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			27
		]
	},
	snowboarder: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C2-1F3FB",
				non_qualified: null,
				image: "1f3c2-1f3fb.png",
				sheet_x: 9,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F3C2-1F3FC",
				non_qualified: null,
				image: "1f3c2-1f3fc.png",
				sheet_x: 9,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F3C2-1F3FD",
				non_qualified: null,
				image: "1f3c2-1f3fd.png",
				sheet_x: 9,
				sheet_y: 31,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F3C2-1F3FE",
				non_qualified: null,
				image: "1f3c2-1f3fe.png",
				sheet_x: 9,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F3C2-1F3FF",
				non_qualified: null,
				image: "1f3c2-1f3ff.png",
				sheet_x: 9,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Snowboarder",
		b: "1F3C2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sports",
			"winter"
		],
		k: [
			9,
			28
		]
	},
	golfer: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CC-1F3FB",
				non_qualified: null,
				image: "1f3cc-1f3fb.png",
				sheet_x: 11,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3CC-1F3FC",
				non_qualified: null,
				image: "1f3cc-1f3fc.png",
				sheet_x: 11,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3CC-1F3FD",
				non_qualified: null,
				image: "1f3cc-1f3fd.png",
				sheet_x: 11,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3CC-1F3FE",
				non_qualified: null,
				image: "1f3cc-1f3fe.png",
				sheet_x: 11,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3CC-1F3FF",
				non_qualified: null,
				image: "1f3cc-1f3ff.png",
				sheet_x: 11,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoleted_by: "1F3CC-FE0F-200D-2642-FE0F",
		a: "Golfer",
		b: "1F3CC-FE0F",
		c: "1F3CC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			11,
			24
		],
		o: 7
	},
	"flag-zw": {
		a: "Zimbabwe Flag",
		b: "1F1FF-1F1FC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			5,
			28
		]
	},
	"man-golfing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CC-1F3FB-200D-2642-FE0F",
				non_qualified: "1F3CC-1F3FB-200D-2642",
				image: "1f3cc-1f3fb-200d-2642-fe0f.png",
				sheet_x: 11,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3CC-1F3FC-200D-2642-FE0F",
				non_qualified: "1F3CC-1F3FC-200D-2642",
				image: "1f3cc-1f3fc-200d-2642-fe0f.png",
				sheet_x: 11,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3CC-1F3FD-200D-2642-FE0F",
				non_qualified: "1F3CC-1F3FD-200D-2642",
				image: "1f3cc-1f3fd-200d-2642-fe0f.png",
				sheet_x: 11,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3CC-1F3FE-200D-2642-FE0F",
				non_qualified: "1F3CC-1F3FE-200D-2642",
				image: "1f3cc-1f3fe-200d-2642-fe0f.png",
				sheet_x: 11,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3CC-1F3FF-200D-2642-FE0F",
				non_qualified: "1F3CC-1F3FF-200D-2642",
				image: "1f3cc-1f3ff-200d-2642-fe0f.png",
				sheet_x: 11,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F3CC-FE0F",
		a: "Man Golfing",
		b: "1F3CC-FE0F-200D-2642-FE0F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			11,
			18
		],
		o: 7
	},
	"flag-england": {
		a: "England Flag",
		b: "1F3F4-E0067-E0062-E0065-E006E-E0067-E007F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			12,
			16
		],
		o: 7
	},
	"woman-golfing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CC-1F3FB-200D-2640-FE0F",
				non_qualified: "1F3CC-1F3FB-200D-2640",
				image: "1f3cc-1f3fb-200d-2640-fe0f.png",
				sheet_x: 11,
				sheet_y: 13,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3CC-1F3FC-200D-2640-FE0F",
				non_qualified: "1F3CC-1F3FC-200D-2640",
				image: "1f3cc-1f3fc-200d-2640-fe0f.png",
				sheet_x: 11,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3CC-1F3FD-200D-2640-FE0F",
				non_qualified: "1F3CC-1F3FD-200D-2640",
				image: "1f3cc-1f3fd-200d-2640-fe0f.png",
				sheet_x: 11,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3CC-1F3FE-200D-2640-FE0F",
				non_qualified: "1F3CC-1F3FE-200D-2640",
				image: "1f3cc-1f3fe-200d-2640-fe0f.png",
				sheet_x: 11,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3CC-1F3FF-200D-2640-FE0F",
				non_qualified: "1F3CC-1F3FF-200D-2640",
				image: "1f3cc-1f3ff-200d-2640-fe0f.png",
				sheet_x: 11,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Golfing",
		b: "1F3CC-FE0F-200D-2640-FE0F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			11,
			12
		],
		o: 7
	},
	"flag-scotland": {
		a: "Scotland Flag",
		b: "1F3F4-E0067-E0062-E0073-E0063-E0074-E007F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			12,
			17
		],
		o: 7
	},
	"flag-wales": {
		a: "Wales Flag",
		b: "1F3F4-E0067-E0062-E0077-E006C-E0073-E007F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			12,
			18
		],
		o: 7
	},
	surfer: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C4-1F3FB",
				non_qualified: null,
				image: "1f3c4-1f3fb.png",
				sheet_x: 10,
				sheet_y: 13,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F3C4-1F3FC",
				non_qualified: null,
				image: "1f3c4-1f3fc.png",
				sheet_x: 10,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F3C4-1F3FD",
				non_qualified: null,
				image: "1f3c4-1f3fd.png",
				sheet_x: 10,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F3C4-1F3FE",
				non_qualified: null,
				image: "1f3c4-1f3fe.png",
				sheet_x: 10,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F3C4-1F3FF",
				non_qualified: null,
				image: "1f3c4-1f3ff.png",
				sheet_x: 10,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F3C4-200D-2642-FE0F",
		a: "Surfer",
		b: "1F3C4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			10,
			12
		]
	},
	"man-surfing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C4-1F3FB-200D-2642-FE0F",
				non_qualified: "1F3C4-1F3FB-200D-2642",
				image: "1f3c4-1f3fb-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3C4-1F3FC-200D-2642-FE0F",
				non_qualified: "1F3C4-1F3FC-200D-2642",
				image: "1f3c4-1f3fc-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3C4-1F3FD-200D-2642-FE0F",
				non_qualified: "1F3C4-1F3FD-200D-2642",
				image: "1f3c4-1f3fd-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3C4-1F3FE-200D-2642-FE0F",
				non_qualified: "1F3C4-1F3FE-200D-2642",
				image: "1f3c4-1f3fe-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3C4-1F3FF-200D-2642-FE0F",
				non_qualified: "1F3C4-1F3FF-200D-2642",
				image: "1f3c4-1f3ff-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F3C4",
		a: "Man Surfing",
		b: "1F3C4-200D-2642-FE0F",
		c: "1F3C4-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			10,
			6
		]
	},
	"woman-surfing": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3C4-1F3FB-200D-2640-FE0F",
				non_qualified: "1F3C4-1F3FB-200D-2640",
				image: "1f3c4-1f3fb-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3C4-1F3FC-200D-2640-FE0F",
				non_qualified: "1F3C4-1F3FC-200D-2640",
				image: "1f3c4-1f3fc-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3C4-1F3FD-200D-2640-FE0F",
				non_qualified: "1F3C4-1F3FD-200D-2640",
				image: "1f3c4-1f3fd-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3C4-1F3FE-200D-2640-FE0F",
				non_qualified: "1F3C4-1F3FE-200D-2640",
				image: "1f3c4-1f3fe-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3C4-1F3FF-200D-2640-FE0F",
				non_qualified: "1F3C4-1F3FF-200D-2640",
				image: "1f3c4-1f3ff-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Surfing",
		b: "1F3C4-200D-2640-FE0F",
		c: "1F3C4-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			10,
			0
		]
	},
	rowboat: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6A3-1F3FB",
				non_qualified: null,
				image: "1f6a3-1f3fb.png",
				sheet_x: 35,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F6A3-1F3FC",
				non_qualified: null,
				image: "1f6a3-1f3fc.png",
				sheet_x: 35,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F6A3-1F3FD",
				non_qualified: null,
				image: "1f6a3-1f3fd.png",
				sheet_x: 35,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F6A3-1F3FE",
				non_qualified: null,
				image: "1f6a3-1f3fe.png",
				sheet_x: 35,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F6A3-1F3FF",
				non_qualified: null,
				image: "1f6a3-1f3ff.png",
				sheet_x: 35,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoleted_by: "1F6A3-200D-2642-FE0F",
		a: "Rowboat",
		b: "1F6A3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			35,
			3
		]
	},
	"man-rowing-boat": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6A3-1F3FB-200D-2642-FE0F",
				non_qualified: "1F6A3-1F3FB-200D-2642",
				image: "1f6a3-1f3fb-200d-2642-fe0f.png",
				sheet_x: 34,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F6A3-1F3FC-200D-2642-FE0F",
				non_qualified: "1F6A3-1F3FC-200D-2642",
				image: "1f6a3-1f3fc-200d-2642-fe0f.png",
				sheet_x: 34,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F6A3-1F3FD-200D-2642-FE0F",
				non_qualified: "1F6A3-1F3FD-200D-2642",
				image: "1f6a3-1f3fd-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F6A3-1F3FE-200D-2642-FE0F",
				non_qualified: "1F6A3-1F3FE-200D-2642",
				image: "1f6a3-1f3fe-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F6A3-1F3FF-200D-2642-FE0F",
				non_qualified: "1F6A3-1F3FF-200D-2642",
				image: "1f6a3-1f3ff-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F6A3",
		a: "Man Rowing Boat",
		b: "1F6A3-200D-2642-FE0F",
		c: "1F6A3-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			34,
			49
		]
	},
	"woman-rowing-boat": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6A3-1F3FB-200D-2640-FE0F",
				non_qualified: "1F6A3-1F3FB-200D-2640",
				image: "1f6a3-1f3fb-200d-2640-fe0f.png",
				sheet_x: 34,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F6A3-1F3FC-200D-2640-FE0F",
				non_qualified: "1F6A3-1F3FC-200D-2640",
				image: "1f6a3-1f3fc-200d-2640-fe0f.png",
				sheet_x: 34,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F6A3-1F3FD-200D-2640-FE0F",
				non_qualified: "1F6A3-1F3FD-200D-2640",
				image: "1f6a3-1f3fd-200d-2640-fe0f.png",
				sheet_x: 34,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F6A3-1F3FE-200D-2640-FE0F",
				non_qualified: "1F6A3-1F3FE-200D-2640",
				image: "1f6a3-1f3fe-200d-2640-fe0f.png",
				sheet_x: 34,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F6A3-1F3FF-200D-2640-FE0F",
				non_qualified: "1F6A3-1F3FF-200D-2640",
				image: "1f6a3-1f3ff-200d-2640-fe0f.png",
				sheet_x: 34,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Rowing Boat",
		b: "1F6A3-200D-2640-FE0F",
		c: "1F6A3-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			34,
			43
		]
	},
	swimmer: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CA-1F3FB",
				non_qualified: null,
				image: "1f3ca-1f3fb.png",
				sheet_x: 10,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F3CA-1F3FC",
				non_qualified: null,
				image: "1f3ca-1f3fc.png",
				sheet_x: 10,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F3CA-1F3FD",
				non_qualified: null,
				image: "1f3ca-1f3fd.png",
				sheet_x: 10,
				sheet_y: 43,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F3CA-1F3FE",
				non_qualified: null,
				image: "1f3ca-1f3fe.png",
				sheet_x: 10,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F3CA-1F3FF",
				non_qualified: null,
				image: "1f3ca-1f3ff.png",
				sheet_x: 10,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F3CA-200D-2642-FE0F",
		a: "Swimmer",
		b: "1F3CA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			10,
			40
		]
	},
	"man-swimming": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CA-1F3FB-200D-2642-FE0F",
				non_qualified: "1F3CA-1F3FB-200D-2642",
				image: "1f3ca-1f3fb-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3CA-1F3FC-200D-2642-FE0F",
				non_qualified: "1F3CA-1F3FC-200D-2642",
				image: "1f3ca-1f3fc-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3CA-1F3FD-200D-2642-FE0F",
				non_qualified: "1F3CA-1F3FD-200D-2642",
				image: "1f3ca-1f3fd-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3CA-1F3FE-200D-2642-FE0F",
				non_qualified: "1F3CA-1F3FE-200D-2642",
				image: "1f3ca-1f3fe-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3CA-1F3FF-200D-2642-FE0F",
				non_qualified: "1F3CA-1F3FF-200D-2642",
				image: "1f3ca-1f3ff-200d-2642-fe0f.png",
				sheet_x: 10,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F3CA",
		a: "Man Swimming",
		b: "1F3CA-200D-2642-FE0F",
		c: "1F3CA-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			10,
			34
		]
	},
	"woman-swimming": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CA-1F3FB-200D-2640-FE0F",
				non_qualified: "1F3CA-1F3FB-200D-2640",
				image: "1f3ca-1f3fb-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3CA-1F3FC-200D-2640-FE0F",
				non_qualified: "1F3CA-1F3FC-200D-2640",
				image: "1f3ca-1f3fc-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3CA-1F3FD-200D-2640-FE0F",
				non_qualified: "1F3CA-1F3FD-200D-2640",
				image: "1f3ca-1f3fd-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 31,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3CA-1F3FE-200D-2640-FE0F",
				non_qualified: "1F3CA-1F3FE-200D-2640",
				image: "1f3ca-1f3fe-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3CA-1F3FF-200D-2640-FE0F",
				non_qualified: "1F3CA-1F3FF-200D-2640",
				image: "1f3ca-1f3ff-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Swimming",
		b: "1F3CA-200D-2640-FE0F",
		c: "1F3CA-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			10,
			28
		]
	},
	person_with_ball: {
		skin_variations: {
			"1F3FB": {
				unified: "26F9-1F3FB",
				non_qualified: null,
				image: "26f9-1f3fb.png",
				sheet_x: 49,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "26F9-1F3FC",
				non_qualified: null,
				image: "26f9-1f3fc.png",
				sheet_x: 49,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "26F9-1F3FD",
				non_qualified: null,
				image: "26f9-1f3fd.png",
				sheet_x: 49,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "26F9-1F3FE",
				non_qualified: null,
				image: "26f9-1f3fe.png",
				sheet_x: 49,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "26F9-1F3FF",
				non_qualified: null,
				image: "26f9-1f3ff.png",
				sheet_x: 49,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoleted_by: "26F9-FE0F-200D-2642-FE0F",
		a: "Person with Ball",
		b: "26F9-FE0F",
		c: "26F9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			49,
			6
		],
		o: 5
	},
	"man-bouncing-ball": {
		skin_variations: {
			"1F3FB": {
				unified: "26F9-1F3FB-200D-2642-FE0F",
				non_qualified: "26F9-1F3FB-200D-2642",
				image: "26f9-1f3fb-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "26F9-1F3FC-200D-2642-FE0F",
				non_qualified: "26F9-1F3FC-200D-2642",
				image: "26f9-1f3fc-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "26F9-1F3FD-200D-2642-FE0F",
				non_qualified: "26F9-1F3FD-200D-2642",
				image: "26f9-1f3fd-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "26F9-1F3FE-200D-2642-FE0F",
				non_qualified: "26F9-1F3FE-200D-2642",
				image: "26f9-1f3fe-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "26F9-1F3FF-200D-2642-FE0F",
				non_qualified: "26F9-1F3FF-200D-2642",
				image: "26f9-1f3ff-200d-2642-fe0f.png",
				sheet_x: 49,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "26F9-FE0F",
		a: "Man Bouncing Ball",
		b: "26F9-FE0F-200D-2642-FE0F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			49,
			0
		],
		o: 5
	},
	"woman-bouncing-ball": {
		skin_variations: {
			"1F3FB": {
				unified: "26F9-1F3FB-200D-2640-FE0F",
				non_qualified: "26F9-1F3FB-200D-2640",
				image: "26f9-1f3fb-200d-2640-fe0f.png",
				sheet_x: 48,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "26F9-1F3FC-200D-2640-FE0F",
				non_qualified: "26F9-1F3FC-200D-2640",
				image: "26f9-1f3fc-200d-2640-fe0f.png",
				sheet_x: 48,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "26F9-1F3FD-200D-2640-FE0F",
				non_qualified: "26F9-1F3FD-200D-2640",
				image: "26f9-1f3fd-200d-2640-fe0f.png",
				sheet_x: 48,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "26F9-1F3FE-200D-2640-FE0F",
				non_qualified: "26F9-1F3FE-200D-2640",
				image: "26f9-1f3fe-200d-2640-fe0f.png",
				sheet_x: 48,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "26F9-1F3FF-200D-2640-FE0F",
				non_qualified: "26F9-1F3FF-200D-2640",
				image: "26f9-1f3ff-200d-2640-fe0f.png",
				sheet_x: 48,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Bouncing Ball",
		b: "26F9-FE0F-200D-2640-FE0F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			48,
			46
		],
		o: 5
	},
	weight_lifter: {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CB-1F3FB",
				non_qualified: null,
				image: "1f3cb-1f3fb.png",
				sheet_x: 11,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3CB-1F3FC",
				non_qualified: null,
				image: "1f3cb-1f3fc.png",
				sheet_x: 11,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3CB-1F3FD",
				non_qualified: null,
				image: "1f3cb-1f3fd.png",
				sheet_x: 11,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3CB-1F3FE",
				non_qualified: null,
				image: "1f3cb-1f3fe.png",
				sheet_x: 11,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3CB-1F3FF",
				non_qualified: null,
				image: "1f3cb-1f3ff.png",
				sheet_x: 11,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoleted_by: "1F3CB-FE0F-200D-2642-FE0F",
		a: "Weight Lifter",
		b: "1F3CB-FE0F",
		c: "1F3CB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			11,
			6
		],
		o: 7
	},
	"man-lifting-weights": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CB-1F3FB-200D-2642-FE0F",
				non_qualified: "1F3CB-1F3FB-200D-2642",
				image: "1f3cb-1f3fb-200d-2642-fe0f.png",
				sheet_x: 11,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3CB-1F3FC-200D-2642-FE0F",
				non_qualified: "1F3CB-1F3FC-200D-2642",
				image: "1f3cb-1f3fc-200d-2642-fe0f.png",
				sheet_x: 11,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3CB-1F3FD-200D-2642-FE0F",
				non_qualified: "1F3CB-1F3FD-200D-2642",
				image: "1f3cb-1f3fd-200d-2642-fe0f.png",
				sheet_x: 11,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3CB-1F3FE-200D-2642-FE0F",
				non_qualified: "1F3CB-1F3FE-200D-2642",
				image: "1f3cb-1f3fe-200d-2642-fe0f.png",
				sheet_x: 11,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3CB-1F3FF-200D-2642-FE0F",
				non_qualified: "1F3CB-1F3FF-200D-2642",
				image: "1f3cb-1f3ff-200d-2642-fe0f.png",
				sheet_x: 11,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F3CB-FE0F",
		a: "Man Lifting Weights",
		b: "1F3CB-FE0F-200D-2642-FE0F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			11,
			0
		],
		o: 7
	},
	"woman-lifting-weights": {
		skin_variations: {
			"1F3FB": {
				unified: "1F3CB-1F3FB-200D-2640-FE0F",
				non_qualified: "1F3CB-1F3FB-200D-2640",
				image: "1f3cb-1f3fb-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F3CB-1F3FC-200D-2640-FE0F",
				non_qualified: "1F3CB-1F3FC-200D-2640",
				image: "1f3cb-1f3fc-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F3CB-1F3FD-200D-2640-FE0F",
				non_qualified: "1F3CB-1F3FD-200D-2640",
				image: "1f3cb-1f3fd-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F3CB-1F3FE-200D-2640-FE0F",
				non_qualified: "1F3CB-1F3FE-200D-2640",
				image: "1f3cb-1f3fe-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F3CB-1F3FF-200D-2640-FE0F",
				non_qualified: "1F3CB-1F3FF-200D-2640",
				image: "1f3cb-1f3ff-200d-2640-fe0f.png",
				sheet_x: 10,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Lifting Weights",
		b: "1F3CB-FE0F-200D-2640-FE0F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			10,
			46
		],
		o: 7
	},
	bicyclist: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B4-1F3FB",
				non_qualified: null,
				image: "1f6b4-1f3fb.png",
				sheet_x: 35,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F6B4-1F3FC",
				non_qualified: null,
				image: "1f6b4-1f3fc.png",
				sheet_x: 35,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F6B4-1F3FD",
				non_qualified: null,
				image: "1f6b4-1f3fd.png",
				sheet_x: 35,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F6B4-1F3FE",
				non_qualified: null,
				image: "1f6b4-1f3fe.png",
				sheet_x: 35,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F6B4-1F3FF",
				non_qualified: null,
				image: "1f6b4-1f3ff.png",
				sheet_x: 35,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F6B4-200D-2642-FE0F",
		a: "Bicyclist",
		b: "1F6B4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			35,
			37
		]
	},
	"man-biking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B4-1F3FB-200D-2642-FE0F",
				non_qualified: "1F6B4-1F3FB-200D-2642",
				image: "1f6b4-1f3fb-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F6B4-1F3FC-200D-2642-FE0F",
				non_qualified: "1F6B4-1F3FC-200D-2642",
				image: "1f6b4-1f3fc-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F6B4-1F3FD-200D-2642-FE0F",
				non_qualified: "1F6B4-1F3FD-200D-2642",
				image: "1f6b4-1f3fd-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F6B4-1F3FE-200D-2642-FE0F",
				non_qualified: "1F6B4-1F3FE-200D-2642",
				image: "1f6b4-1f3fe-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F6B4-1F3FF-200D-2642-FE0F",
				non_qualified: "1F6B4-1F3FF-200D-2642",
				image: "1f6b4-1f3ff-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F6B4",
		a: "Man Biking",
		b: "1F6B4-200D-2642-FE0F",
		c: "1F6B4-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			35,
			31
		]
	},
	"woman-biking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B4-1F3FB-200D-2640-FE0F",
				non_qualified: "1F6B4-1F3FB-200D-2640",
				image: "1f6b4-1f3fb-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F6B4-1F3FC-200D-2640-FE0F",
				non_qualified: "1F6B4-1F3FC-200D-2640",
				image: "1f6b4-1f3fc-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F6B4-1F3FD-200D-2640-FE0F",
				non_qualified: "1F6B4-1F3FD-200D-2640",
				image: "1f6b4-1f3fd-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F6B4-1F3FE-200D-2640-FE0F",
				non_qualified: "1F6B4-1F3FE-200D-2640",
				image: "1f6b4-1f3fe-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F6B4-1F3FF-200D-2640-FE0F",
				non_qualified: "1F6B4-1F3FF-200D-2640",
				image: "1f6b4-1f3ff-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Biking",
		b: "1F6B4-200D-2640-FE0F",
		c: "1F6B4-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			35,
			25
		]
	},
	mountain_bicyclist: {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B5-1F3FB",
				non_qualified: null,
				image: "1f6b5-1f3fb.png",
				sheet_x: 36,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F6B5-1F3FC",
				non_qualified: null,
				image: "1f6b5-1f3fc.png",
				sheet_x: 36,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F6B5-1F3FD",
				non_qualified: null,
				image: "1f6b5-1f3fd.png",
				sheet_x: 36,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F6B5-1F3FE",
				non_qualified: null,
				image: "1f6b5-1f3fe.png",
				sheet_x: 36,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F6B5-1F3FF",
				non_qualified: null,
				image: "1f6b5-1f3ff.png",
				sheet_x: 36,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: true
			}
		},
		obsoleted_by: "1F6B5-200D-2642-FE0F",
		a: "Mountain Bicyclist",
		b: "1F6B5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			36,
			3
		]
	},
	"man-mountain-biking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B5-1F3FB-200D-2642-FE0F",
				non_qualified: "1F6B5-1F3FB-200D-2642",
				image: "1f6b5-1f3fb-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F6B5-1F3FC-200D-2642-FE0F",
				non_qualified: "1F6B5-1F3FC-200D-2642",
				image: "1f6b5-1f3fc-200d-2642-fe0f.png",
				sheet_x: 35,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F6B5-1F3FD-200D-2642-FE0F",
				non_qualified: "1F6B5-1F3FD-200D-2642",
				image: "1f6b5-1f3fd-200d-2642-fe0f.png",
				sheet_x: 36,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F6B5-1F3FE-200D-2642-FE0F",
				non_qualified: "1F6B5-1F3FE-200D-2642",
				image: "1f6b5-1f3fe-200d-2642-fe0f.png",
				sheet_x: 36,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F6B5-1F3FF-200D-2642-FE0F",
				non_qualified: "1F6B5-1F3FF-200D-2642",
				image: "1f6b5-1f3ff-200d-2642-fe0f.png",
				sheet_x: 36,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		obsoletes: "1F6B5",
		a: "Man Mountain Biking",
		b: "1F6B5-200D-2642-FE0F",
		c: "1F6B5-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			35,
			49
		]
	},
	"woman-mountain-biking": {
		skin_variations: {
			"1F3FB": {
				unified: "1F6B5-1F3FB-200D-2640-FE0F",
				non_qualified: "1F6B5-1F3FB-200D-2640",
				image: "1f6b5-1f3fb-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F6B5-1F3FC-200D-2640-FE0F",
				non_qualified: "1F6B5-1F3FC-200D-2640",
				image: "1f6b5-1f3fc-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F6B5-1F3FD-200D-2640-FE0F",
				non_qualified: "1F6B5-1F3FD-200D-2640",
				image: "1f6b5-1f3fd-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F6B5-1F3FE-200D-2640-FE0F",
				non_qualified: "1F6B5-1F3FE-200D-2640",
				image: "1f6b5-1f3fe-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F6B5-1F3FF-200D-2640-FE0F",
				non_qualified: "1F6B5-1F3FF-200D-2640",
				image: "1f6b5-1f3ff-200d-2640-fe0f.png",
				sheet_x: 35,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Mountain Biking",
		b: "1F6B5-200D-2640-FE0F",
		c: "1F6B5-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			35,
			43
		]
	},
	racing_car: {
		a: "Racing Car",
		b: "1F3CE-FE0F",
		c: "1F3CE",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"sports",
			"race",
			"fast",
			"formula",
			"f1"
		],
		k: [
			11,
			31
		],
		o: 7
	},
	racing_motorcycle: {
		a: "Racing Motorcycle",
		b: "1F3CD-FE0F",
		c: "1F3CD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			11,
			30
		],
		o: 7
	},
	person_doing_cartwheel: {
		skin_variations: {
			"1F3FB": {
				unified: "1F938-1F3FB",
				non_qualified: null,
				image: "1f938-1f3fb.png",
				sheet_x: 40,
				sheet_y: 25,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F938-1F3FC",
				non_qualified: null,
				image: "1f938-1f3fc.png",
				sheet_x: 40,
				sheet_y: 26,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F938-1F3FD",
				non_qualified: null,
				image: "1f938-1f3fd.png",
				sheet_x: 40,
				sheet_y: 27,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F938-1F3FE",
				non_qualified: null,
				image: "1f938-1f3fe.png",
				sheet_x: 40,
				sheet_y: 28,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F938-1F3FF",
				non_qualified: null,
				image: "1f938-1f3ff.png",
				sheet_x: 40,
				sheet_y: 29,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Person Doing Cartwheel",
		b: "1F938",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			40,
			24
		],
		o: 9
	},
	"man-cartwheeling": {
		skin_variations: {
			"1F3FB": {
				unified: "1F938-1F3FB-200D-2642-FE0F",
				non_qualified: "1F938-1F3FB-200D-2642",
				image: "1f938-1f3fb-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 19,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F938-1F3FC-200D-2642-FE0F",
				non_qualified: "1F938-1F3FC-200D-2642",
				image: "1f938-1f3fc-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 20,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F938-1F3FD-200D-2642-FE0F",
				non_qualified: "1F938-1F3FD-200D-2642",
				image: "1f938-1f3fd-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 21,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F938-1F3FE-200D-2642-FE0F",
				non_qualified: "1F938-1F3FE-200D-2642",
				image: "1f938-1f3fe-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 22,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F938-1F3FF-200D-2642-FE0F",
				non_qualified: "1F938-1F3FF-200D-2642",
				image: "1f938-1f3ff-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 23,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Cartwheeling",
		b: "1F938-200D-2642-FE0F",
		c: "1F938-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			40,
			18
		],
		o: 9
	},
	"woman-cartwheeling": {
		skin_variations: {
			"1F3FB": {
				unified: "1F938-1F3FB-200D-2640-FE0F",
				non_qualified: "1F938-1F3FB-200D-2640",
				image: "1f938-1f3fb-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 13,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F938-1F3FC-200D-2640-FE0F",
				non_qualified: "1F938-1F3FC-200D-2640",
				image: "1f938-1f3fc-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 14,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F938-1F3FD-200D-2640-FE0F",
				non_qualified: "1F938-1F3FD-200D-2640",
				image: "1f938-1f3fd-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 15,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F938-1F3FE-200D-2640-FE0F",
				non_qualified: "1F938-1F3FE-200D-2640",
				image: "1f938-1f3fe-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 16,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F938-1F3FF-200D-2640-FE0F",
				non_qualified: "1F938-1F3FF-200D-2640",
				image: "1f938-1f3ff-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 17,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Cartwheeling",
		b: "1F938-200D-2640-FE0F",
		c: "1F938-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			40,
			12
		],
		o: 9
	},
	wrestlers: {
		a: "Wrestlers",
		b: "1F93C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			40,
			51
		],
		o: 9
	},
	"man-wrestling": {
		a: "Man Wrestling",
		b: "1F93C-200D-2642-FE0F",
		c: "1F93C-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			40,
			50
		],
		o: 9
	},
	"woman-wrestling": {
		a: "Woman Wrestling",
		b: "1F93C-200D-2640-FE0F",
		c: "1F93C-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			40,
			49
		],
		o: 9
	},
	water_polo: {
		skin_variations: {
			"1F3FB": {
				unified: "1F93D-1F3FB",
				non_qualified: null,
				image: "1f93d-1f3fb.png",
				sheet_x: 41,
				sheet_y: 13,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F93D-1F3FC",
				non_qualified: null,
				image: "1f93d-1f3fc.png",
				sheet_x: 41,
				sheet_y: 14,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F93D-1F3FD",
				non_qualified: null,
				image: "1f93d-1f3fd.png",
				sheet_x: 41,
				sheet_y: 15,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F93D-1F3FE",
				non_qualified: null,
				image: "1f93d-1f3fe.png",
				sheet_x: 41,
				sheet_y: 16,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F93D-1F3FF",
				non_qualified: null,
				image: "1f93d-1f3ff.png",
				sheet_x: 41,
				sheet_y: 17,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Water Polo",
		b: "1F93D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			41,
			12
		],
		o: 9
	},
	"man-playing-water-polo": {
		skin_variations: {
			"1F3FB": {
				unified: "1F93D-1F3FB-200D-2642-FE0F",
				non_qualified: "1F93D-1F3FB-200D-2642",
				image: "1f93d-1f3fb-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 7,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F93D-1F3FC-200D-2642-FE0F",
				non_qualified: "1F93D-1F3FC-200D-2642",
				image: "1f93d-1f3fc-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 8,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F93D-1F3FD-200D-2642-FE0F",
				non_qualified: "1F93D-1F3FD-200D-2642",
				image: "1f93d-1f3fd-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 9,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F93D-1F3FE-200D-2642-FE0F",
				non_qualified: "1F93D-1F3FE-200D-2642",
				image: "1f93d-1f3fe-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 10,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F93D-1F3FF-200D-2642-FE0F",
				non_qualified: "1F93D-1F3FF-200D-2642",
				image: "1f93d-1f3ff-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 11,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Playing Water Polo",
		b: "1F93D-200D-2642-FE0F",
		c: "1F93D-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			41,
			6
		],
		o: 9
	},
	"woman-playing-water-polo": {
		skin_variations: {
			"1F3FB": {
				unified: "1F93D-1F3FB-200D-2640-FE0F",
				non_qualified: "1F93D-1F3FB-200D-2640",
				image: "1f93d-1f3fb-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 1,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F93D-1F3FC-200D-2640-FE0F",
				non_qualified: "1F93D-1F3FC-200D-2640",
				image: "1f93d-1f3fc-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 2,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F93D-1F3FD-200D-2640-FE0F",
				non_qualified: "1F93D-1F3FD-200D-2640",
				image: "1f93d-1f3fd-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 3,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F93D-1F3FE-200D-2640-FE0F",
				non_qualified: "1F93D-1F3FE-200D-2640",
				image: "1f93d-1f3fe-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 4,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F93D-1F3FF-200D-2640-FE0F",
				non_qualified: "1F93D-1F3FF-200D-2640",
				image: "1f93d-1f3ff-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 5,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Playing Water Polo",
		b: "1F93D-200D-2640-FE0F",
		c: "1F93D-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			41,
			0
		],
		o: 9
	},
	handball: {
		skin_variations: {
			"1F3FB": {
				unified: "1F93E-1F3FB",
				non_qualified: null,
				image: "1f93e-1f3fb.png",
				sheet_x: 41,
				sheet_y: 31,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F93E-1F3FC",
				non_qualified: null,
				image: "1f93e-1f3fc.png",
				sheet_x: 41,
				sheet_y: 32,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F93E-1F3FD",
				non_qualified: null,
				image: "1f93e-1f3fd.png",
				sheet_x: 41,
				sheet_y: 33,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F93E-1F3FE",
				non_qualified: null,
				image: "1f93e-1f3fe.png",
				sheet_x: 41,
				sheet_y: 34,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F93E-1F3FF",
				non_qualified: null,
				image: "1f93e-1f3ff.png",
				sheet_x: 41,
				sheet_y: 35,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Handball",
		b: "1F93E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			41,
			30
		],
		o: 9
	},
	"man-playing-handball": {
		skin_variations: {
			"1F3FB": {
				unified: "1F93E-1F3FB-200D-2642-FE0F",
				non_qualified: "1F93E-1F3FB-200D-2642",
				image: "1f93e-1f3fb-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 25,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F93E-1F3FC-200D-2642-FE0F",
				non_qualified: "1F93E-1F3FC-200D-2642",
				image: "1f93e-1f3fc-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 26,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F93E-1F3FD-200D-2642-FE0F",
				non_qualified: "1F93E-1F3FD-200D-2642",
				image: "1f93e-1f3fd-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 27,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F93E-1F3FE-200D-2642-FE0F",
				non_qualified: "1F93E-1F3FE-200D-2642",
				image: "1f93e-1f3fe-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 28,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F93E-1F3FF-200D-2642-FE0F",
				non_qualified: "1F93E-1F3FF-200D-2642",
				image: "1f93e-1f3ff-200d-2642-fe0f.png",
				sheet_x: 41,
				sheet_y: 29,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Playing Handball",
		b: "1F93E-200D-2642-FE0F",
		c: "1F93E-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			41,
			24
		],
		o: 9
	},
	"woman-playing-handball": {
		skin_variations: {
			"1F3FB": {
				unified: "1F93E-1F3FB-200D-2640-FE0F",
				non_qualified: "1F93E-1F3FB-200D-2640",
				image: "1f93e-1f3fb-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 19,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F93E-1F3FC-200D-2640-FE0F",
				non_qualified: "1F93E-1F3FC-200D-2640",
				image: "1f93e-1f3fc-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 20,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F93E-1F3FD-200D-2640-FE0F",
				non_qualified: "1F93E-1F3FD-200D-2640",
				image: "1f93e-1f3fd-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 21,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F93E-1F3FE-200D-2640-FE0F",
				non_qualified: "1F93E-1F3FE-200D-2640",
				image: "1f93e-1f3fe-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 22,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F93E-1F3FF-200D-2640-FE0F",
				non_qualified: "1F93E-1F3FF-200D-2640",
				image: "1f93e-1f3ff-200d-2640-fe0f.png",
				sheet_x: 41,
				sheet_y: 23,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Playing Handball",
		b: "1F93E-200D-2640-FE0F",
		c: "1F93E-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			41,
			18
		],
		o: 9
	},
	juggling: {
		skin_variations: {
			"1F3FB": {
				unified: "1F939-1F3FB",
				non_qualified: null,
				image: "1f939-1f3fb.png",
				sheet_x: 40,
				sheet_y: 43,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F939-1F3FC",
				non_qualified: null,
				image: "1f939-1f3fc.png",
				sheet_x: 40,
				sheet_y: 44,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F939-1F3FD",
				non_qualified: null,
				image: "1f939-1f3fd.png",
				sheet_x: 40,
				sheet_y: 45,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F939-1F3FE",
				non_qualified: null,
				image: "1f939-1f3fe.png",
				sheet_x: 40,
				sheet_y: 46,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F939-1F3FF",
				non_qualified: null,
				image: "1f939-1f3ff.png",
				sheet_x: 40,
				sheet_y: 47,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Juggling",
		b: "1F939",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			40,
			42
		],
		o: 9
	},
	"man-juggling": {
		skin_variations: {
			"1F3FB": {
				unified: "1F939-1F3FB-200D-2642-FE0F",
				non_qualified: "1F939-1F3FB-200D-2642",
				image: "1f939-1f3fb-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 37,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F939-1F3FC-200D-2642-FE0F",
				non_qualified: "1F939-1F3FC-200D-2642",
				image: "1f939-1f3fc-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 38,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F939-1F3FD-200D-2642-FE0F",
				non_qualified: "1F939-1F3FD-200D-2642",
				image: "1f939-1f3fd-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 39,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F939-1F3FE-200D-2642-FE0F",
				non_qualified: "1F939-1F3FE-200D-2642",
				image: "1f939-1f3fe-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 40,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F939-1F3FF-200D-2642-FE0F",
				non_qualified: "1F939-1F3FF-200D-2642",
				image: "1f939-1f3ff-200d-2642-fe0f.png",
				sheet_x: 40,
				sheet_y: 41,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Man Juggling",
		b: "1F939-200D-2642-FE0F",
		c: "1F939-200D-2642",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			40,
			36
		],
		o: 9
	},
	"woman-juggling": {
		skin_variations: {
			"1F3FB": {
				unified: "1F939-1F3FB-200D-2640-FE0F",
				non_qualified: "1F939-1F3FB-200D-2640",
				image: "1f939-1f3fb-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 31,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F939-1F3FC-200D-2640-FE0F",
				non_qualified: "1F939-1F3FC-200D-2640",
				image: "1f939-1f3fc-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 32,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F939-1F3FD-200D-2640-FE0F",
				non_qualified: "1F939-1F3FD-200D-2640",
				image: "1f939-1f3fd-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 33,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F939-1F3FE-200D-2640-FE0F",
				non_qualified: "1F939-1F3FE-200D-2640",
				image: "1f939-1f3fe-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 34,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F939-1F3FF-200D-2640-FE0F",
				non_qualified: "1F939-1F3FF-200D-2640",
				image: "1f939-1f3ff-200d-2640-fe0f.png",
				sheet_x: 40,
				sheet_y: 35,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: false,
				has_img_messenger: false
			}
		},
		a: "Woman Juggling",
		b: "1F939-200D-2640-FE0F",
		c: "1F939-200D-2640",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: false,
		k: [
			40,
			30
		],
		o: 9
	},
	couple: {
		a: "Man and Woman Holding Hands",
		b: "1F46B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"pair",
			"people",
			"human",
			"love",
			"date",
			"dating",
			"like",
			"affection",
			"valentines",
			"marriage"
		],
		k: [
			20,
			30
		],
		n: [
			"man_and_woman_holding_hands"
		]
	},
	two_men_holding_hands: {
		a: "Two Men Holding Hands",
		b: "1F46C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"pair",
			"couple",
			"love",
			"like",
			"bromance",
			"friendship",
			"people",
			"human"
		],
		k: [
			20,
			31
		]
	},
	two_women_holding_hands: {
		a: "Two Women Holding Hands",
		b: "1F46D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"pair",
			"friendship",
			"couple",
			"love",
			"like",
			"female",
			"people",
			"human"
		],
		k: [
			20,
			32
		]
	},
	couplekiss: {
		obsoleted_by: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
		a: "Kiss",
		b: "1F48F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			24,
			41
		]
	},
	"woman-kiss-man": {
		obsoletes: "1F48F",
		a: "Woman Kiss Man",
		b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",
		c: "1F469-200D-2764-200D-1F48B-200D-1F468",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			20,
			21
		]
	},
	"man-kiss-man": {
		a: "Man Kiss Man",
		b: "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468",
		c: "1F468-200D-2764-200D-1F48B-200D-1F468",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			18,
			10
		]
	},
	"woman-kiss-woman": {
		a: "Woman Kiss Woman",
		b: "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469",
		c: "1F469-200D-2764-200D-1F48B-200D-1F469",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			20,
			22
		]
	},
	couple_with_heart: {
		obsoleted_by: "1F469-200D-2764-FE0F-200D-1F468",
		a: "Couple with Heart",
		b: "1F491",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			24,
			43
		]
	},
	"woman-heart-man": {
		obsoletes: "1F491",
		a: "Woman Heart Man",
		b: "1F469-200D-2764-FE0F-200D-1F468",
		c: "1F469-200D-2764-200D-1F468",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			20,
			19
		]
	},
	"man-heart-man": {
		a: "Man Heart Man",
		b: "1F468-200D-2764-FE0F-200D-1F468",
		c: "1F468-200D-2764-200D-1F468",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			18,
			9
		]
	},
	"woman-heart-woman": {
		a: "Woman Heart Woman",
		b: "1F469-200D-2764-FE0F-200D-1F469",
		c: "1F469-200D-2764-200D-1F469",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			20,
			20
		]
	},
	family: {
		obsoleted_by: "1F468-200D-1F469-200D-1F466",
		a: "Family",
		b: "1F46A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: false,
		i: true,
		k: [
			20,
			29
		],
		n: [
			"man-woman-boy"
		]
	},
	"man-woman-boy": {
		obsoletes: "1F46A",
		a: "Man Woman Boy",
		b: "1F468-200D-1F469-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			17,
			2
		],
		n: [
			"family"
		]
	},
	"man-woman-girl": {
		a: "Man Woman Girl",
		b: "1F468-200D-1F469-200D-1F467",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			17,
			4
		]
	},
	"man-woman-girl-boy": {
		a: "Man Woman Girl Boy",
		b: "1F468-200D-1F469-200D-1F467-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			17,
			5
		]
	},
	"man-woman-boy-boy": {
		a: "Man Woman Boy Boy",
		b: "1F468-200D-1F469-200D-1F466-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			17,
			3
		]
	},
	"man-woman-girl-girl": {
		a: "Man Woman Girl Girl",
		b: "1F468-200D-1F469-200D-1F467-200D-1F467",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			17,
			6
		]
	},
	"man-man-boy": {
		a: "Man Man Boy",
		b: "1F468-200D-1F468-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			16,
			49
		]
	},
	"man-man-girl": {
		a: "Man Man Girl",
		b: "1F468-200D-1F468-200D-1F467",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			16,
			51
		]
	},
	"man-man-girl-boy": {
		a: "Man Man Girl Boy",
		b: "1F468-200D-1F468-200D-1F467-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			17,
			0
		]
	},
	"man-man-boy-boy": {
		a: "Man Man Boy Boy",
		b: "1F468-200D-1F468-200D-1F466-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			16,
			50
		]
	},
	"man-man-girl-girl": {
		a: "Man Man Girl Girl",
		b: "1F468-200D-1F468-200D-1F467-200D-1F467",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			17,
			1
		]
	},
	"woman-woman-boy": {
		a: "Woman Woman Boy",
		b: "1F469-200D-1F469-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			19,
			12
		]
	},
	"woman-woman-girl": {
		a: "Woman Woman Girl",
		b: "1F469-200D-1F469-200D-1F467",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			19,
			14
		]
	},
	"woman-woman-girl-boy": {
		a: "Woman Woman Girl Boy",
		b: "1F469-200D-1F469-200D-1F467-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			19,
			15
		]
	},
	"woman-woman-boy-boy": {
		a: "Woman Woman Boy Boy",
		b: "1F469-200D-1F469-200D-1F466-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			19,
			13
		]
	},
	"woman-woman-girl-girl": {
		a: "Woman Woman Girl Girl",
		b: "1F469-200D-1F469-200D-1F467-200D-1F467",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			19,
			16
		]
	},
	"man-boy": {
		a: "Man Boy",
		b: "1F468-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			45
		]
	},
	"man-boy-boy": {
		a: "Man Boy Boy",
		b: "1F468-200D-1F466-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			44
		]
	},
	"man-girl": {
		a: "Man Girl",
		b: "1F468-200D-1F467",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			48
		]
	},
	"man-girl-boy": {
		a: "Man Girl Boy",
		b: "1F468-200D-1F467-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			46
		]
	},
	"man-girl-girl": {
		a: "Man Girl Girl",
		b: "1F468-200D-1F467-200D-1F467",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			16,
			47
		]
	},
	"woman-boy": {
		a: "Woman Boy",
		b: "1F469-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			8
		]
	},
	"woman-boy-boy": {
		a: "Woman Boy Boy",
		b: "1F469-200D-1F466-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			7
		]
	},
	"woman-girl": {
		a: "Woman Girl",
		b: "1F469-200D-1F467",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			11
		]
	},
	"woman-girl-boy": {
		a: "Woman Girl Boy",
		b: "1F469-200D-1F467-200D-1F466",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			9
		]
	},
	"woman-girl-girl": {
		a: "Woman Girl Girl",
		b: "1F469-200D-1F467-200D-1F467",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			19,
			10
		]
	},
	selfie: {
		skin_variations: {
			"1F3FB": {
				unified: "1F933-1F3FB",
				non_qualified: null,
				image: "1f933-1f3fb.png",
				sheet_x: 39,
				sheet_y: 23,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F933-1F3FC",
				non_qualified: null,
				image: "1f933-1f3fc.png",
				sheet_x: 39,
				sheet_y: 24,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F933-1F3FD",
				non_qualified: null,
				image: "1f933-1f3fd.png",
				sheet_x: 39,
				sheet_y: 25,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F933-1F3FE",
				non_qualified: null,
				image: "1f933-1f3fe.png",
				sheet_x: 39,
				sheet_y: 26,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F933-1F3FF",
				non_qualified: null,
				image: "1f933-1f3ff.png",
				sheet_x: 39,
				sheet_y: 27,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Selfie",
		b: "1F933",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"camera",
			"phone"
		],
		k: [
			39,
			22
		],
		o: 9
	},
	muscle: {
		skin_variations: {
			"1F3FB": {
				unified: "1F4AA-1F3FB",
				non_qualified: null,
				image: "1f4aa-1f3fb.png",
				sheet_x: 25,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F4AA-1F3FC",
				non_qualified: null,
				image: "1f4aa-1f3fc.png",
				sheet_x: 25,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F4AA-1F3FD",
				non_qualified: null,
				image: "1f4aa-1f3fd.png",
				sheet_x: 25,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F4AA-1F3FE",
				non_qualified: null,
				image: "1f4aa-1f3fe.png",
				sheet_x: 25,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F4AA-1F3FF",
				non_qualified: null,
				image: "1f4aa-1f3ff.png",
				sheet_x: 25,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Flexed Biceps",
		b: "1F4AA",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"arm",
			"flex",
			"hand",
			"summer",
			"strong",
			"biceps"
		],
		k: [
			25,
			16
		]
	},
	point_left: {
		skin_variations: {
			"1F3FB": {
				unified: "1F448-1F3FB",
				non_qualified: null,
				image: "1f448-1f3fb.png",
				sheet_x: 14,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F448-1F3FC",
				non_qualified: null,
				image: "1f448-1f3fc.png",
				sheet_x: 14,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F448-1F3FD",
				non_qualified: null,
				image: "1f448-1f3fd.png",
				sheet_x: 14,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F448-1F3FE",
				non_qualified: null,
				image: "1f448-1f3fe.png",
				sheet_x: 14,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F448-1F3FF",
				non_qualified: null,
				image: "1f448-1f3ff.png",
				sheet_x: 14,
				sheet_y: 24,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "White Left Pointing Backhand Index",
		b: "1F448",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"direction",
			"fingers",
			"hand",
			"left"
		],
		k: [
			14,
			19
		]
	},
	point_right: {
		skin_variations: {
			"1F3FB": {
				unified: "1F449-1F3FB",
				non_qualified: null,
				image: "1f449-1f3fb.png",
				sheet_x: 14,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F449-1F3FC",
				non_qualified: null,
				image: "1f449-1f3fc.png",
				sheet_x: 14,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F449-1F3FD",
				non_qualified: null,
				image: "1f449-1f3fd.png",
				sheet_x: 14,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F449-1F3FE",
				non_qualified: null,
				image: "1f449-1f3fe.png",
				sheet_x: 14,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F449-1F3FF",
				non_qualified: null,
				image: "1f449-1f3ff.png",
				sheet_x: 14,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "White Right Pointing Backhand Index",
		b: "1F449",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fingers",
			"hand",
			"direction",
			"right"
		],
		k: [
			14,
			25
		]
	},
	point_up: {
		skin_variations: {
			"1F3FB": {
				unified: "261D-1F3FB",
				non_qualified: null,
				image: "261d-1f3fb.png",
				sheet_x: 47,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "261D-1F3FC",
				non_qualified: null,
				image: "261d-1f3fc.png",
				sheet_x: 47,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "261D-1F3FD",
				non_qualified: null,
				image: "261d-1f3fd.png",
				sheet_x: 47,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "261D-1F3FE",
				non_qualified: null,
				image: "261d-1f3fe.png",
				sheet_x: 47,
				sheet_y: 30,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "261D-1F3FF",
				non_qualified: null,
				image: "261d-1f3ff.png",
				sheet_x: 47,
				sheet_y: 31,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "White Up Pointing Index",
		b: "261D-FE0F",
		c: "261D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"hand",
			"fingers",
			"direction",
			"up"
		],
		k: [
			47,
			26
		],
		o: 1
	},
	point_up_2: {
		skin_variations: {
			"1F3FB": {
				unified: "1F446-1F3FB",
				non_qualified: null,
				image: "1f446-1f3fb.png",
				sheet_x: 14,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F446-1F3FC",
				non_qualified: null,
				image: "1f446-1f3fc.png",
				sheet_x: 14,
				sheet_y: 9,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F446-1F3FD",
				non_qualified: null,
				image: "1f446-1f3fd.png",
				sheet_x: 14,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F446-1F3FE",
				non_qualified: null,
				image: "1f446-1f3fe.png",
				sheet_x: 14,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F446-1F3FF",
				non_qualified: null,
				image: "1f446-1f3ff.png",
				sheet_x: 14,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "White Up Pointing Backhand Index",
		b: "1F446",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fingers",
			"hand",
			"direction",
			"up"
		],
		k: [
			14,
			7
		]
	},
	middle_finger: {
		skin_variations: {
			"1F3FB": {
				unified: "1F595-1F3FB",
				non_qualified: null,
				image: "1f595-1f3fb.png",
				sheet_x: 29,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F595-1F3FC",
				non_qualified: null,
				image: "1f595-1f3fc.png",
				sheet_x: 29,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F595-1F3FD",
				non_qualified: null,
				image: "1f595-1f3fd.png",
				sheet_x: 29,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F595-1F3FE",
				non_qualified: null,
				image: "1f595-1f3fe.png",
				sheet_x: 29,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F595-1F3FF",
				non_qualified: null,
				image: "1f595-1f3ff.png",
				sheet_x: 29,
				sheet_y: 43,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Reversed Hand with Middle Finger Extended",
		b: "1F595",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			29,
			38
		],
		n: [
			"reversed_hand_with_middle_finger_extended"
		],
		o: 7
	},
	point_down: {
		skin_variations: {
			"1F3FB": {
				unified: "1F447-1F3FB",
				non_qualified: null,
				image: "1f447-1f3fb.png",
				sheet_x: 14,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F447-1F3FC",
				non_qualified: null,
				image: "1f447-1f3fc.png",
				sheet_x: 14,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F447-1F3FD",
				non_qualified: null,
				image: "1f447-1f3fd.png",
				sheet_x: 14,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F447-1F3FE",
				non_qualified: null,
				image: "1f447-1f3fe.png",
				sheet_x: 14,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F447-1F3FF",
				non_qualified: null,
				image: "1f447-1f3ff.png",
				sheet_x: 14,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "White Down Pointing Backhand Index",
		b: "1F447",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fingers",
			"hand",
			"direction",
			"down"
		],
		k: [
			14,
			13
		]
	},
	v: {
		skin_variations: {
			"1F3FB": {
				unified: "270C-1F3FB",
				non_qualified: null,
				image: "270c-1f3fb.png",
				sheet_x: 49,
				sheet_y: 31,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "270C-1F3FC",
				non_qualified: null,
				image: "270c-1f3fc.png",
				sheet_x: 49,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "270C-1F3FD",
				non_qualified: null,
				image: "270c-1f3fd.png",
				sheet_x: 49,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "270C-1F3FE",
				non_qualified: null,
				image: "270c-1f3fe.png",
				sheet_x: 49,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "270C-1F3FF",
				non_qualified: null,
				image: "270c-1f3ff.png",
				sheet_x: 49,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Victory Hand",
		b: "270C-FE0F",
		c: "270C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fingers",
			"ohyeah",
			"hand",
			"peace",
			"victory",
			"two"
		],
		k: [
			49,
			30
		],
		o: 1
	},
	crossed_fingers: {
		skin_variations: {
			"1F3FB": {
				unified: "1F91E-1F3FB",
				non_qualified: null,
				image: "1f91e-1f3fb.png",
				sheet_x: 38,
				sheet_y: 12,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F91E-1F3FC",
				non_qualified: null,
				image: "1f91e-1f3fc.png",
				sheet_x: 38,
				sheet_y: 13,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F91E-1F3FD",
				non_qualified: null,
				image: "1f91e-1f3fd.png",
				sheet_x: 38,
				sheet_y: 14,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F91E-1F3FE",
				non_qualified: null,
				image: "1f91e-1f3fe.png",
				sheet_x: 38,
				sheet_y: 15,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F91E-1F3FF",
				non_qualified: null,
				image: "1f91e-1f3ff.png",
				sheet_x: 38,
				sheet_y: 16,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Hand with Index and Middle Fingers Crossed",
		b: "1F91E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"good",
			"lucky"
		],
		k: [
			38,
			11
		],
		n: [
			"hand_with_index_and_middle_fingers_crossed"
		],
		o: 9
	},
	"spock-hand": {
		skin_variations: {
			"1F3FB": {
				unified: "1F596-1F3FB",
				non_qualified: null,
				image: "1f596-1f3fb.png",
				sheet_x: 29,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F596-1F3FC",
				non_qualified: null,
				image: "1f596-1f3fc.png",
				sheet_x: 29,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F596-1F3FD",
				non_qualified: null,
				image: "1f596-1f3fd.png",
				sheet_x: 29,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F596-1F3FE",
				non_qualified: null,
				image: "1f596-1f3fe.png",
				sheet_x: 29,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F596-1F3FF",
				non_qualified: null,
				image: "1f596-1f3ff.png",
				sheet_x: 29,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Raised Hand with Part Between Middle and Ring Fingers",
		b: "1F596",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			29,
			44
		],
		o: 7
	},
	the_horns: {
		skin_variations: {
			"1F3FB": {
				unified: "1F918-1F3FB",
				non_qualified: null,
				image: "1f918-1f3fb.png",
				sheet_x: 37,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F918-1F3FC",
				non_qualified: null,
				image: "1f918-1f3fc.png",
				sheet_x: 37,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F918-1F3FD",
				non_qualified: null,
				image: "1f918-1f3fd.png",
				sheet_x: 37,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F918-1F3FE",
				non_qualified: null,
				image: "1f918-1f3fe.png",
				sheet_x: 37,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F918-1F3FF",
				non_qualified: null,
				image: "1f918-1f3ff.png",
				sheet_x: 37,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Sign of the Horns",
		b: "1F918",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			32
		],
		n: [
			"sign_of_the_horns"
		],
		o: 8
	},
	call_me_hand: {
		skin_variations: {
			"1F3FB": {
				unified: "1F919-1F3FB",
				non_qualified: null,
				image: "1f919-1f3fb.png",
				sheet_x: 37,
				sheet_y: 39,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F919-1F3FC",
				non_qualified: null,
				image: "1f919-1f3fc.png",
				sheet_x: 37,
				sheet_y: 40,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F919-1F3FD",
				non_qualified: null,
				image: "1f919-1f3fd.png",
				sheet_x: 37,
				sheet_y: 41,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F919-1F3FE",
				non_qualified: null,
				image: "1f919-1f3fe.png",
				sheet_x: 37,
				sheet_y: 42,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F919-1F3FF",
				non_qualified: null,
				image: "1f919-1f3ff.png",
				sheet_x: 37,
				sheet_y: 43,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Call Me Hand",
		b: "1F919",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"hands",
			"gesture"
		],
		k: [
			37,
			38
		],
		o: 9
	},
	raised_hand_with_fingers_splayed: {
		skin_variations: {
			"1F3FB": {
				unified: "1F590-1F3FB",
				non_qualified: null,
				image: "1f590-1f3fb.png",
				sheet_x: 29,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F590-1F3FC",
				non_qualified: null,
				image: "1f590-1f3fc.png",
				sheet_x: 29,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F590-1F3FD",
				non_qualified: null,
				image: "1f590-1f3fd.png",
				sheet_x: 29,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F590-1F3FE",
				non_qualified: null,
				image: "1f590-1f3fe.png",
				sheet_x: 29,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F590-1F3FF",
				non_qualified: null,
				image: "1f590-1f3ff.png",
				sheet_x: 29,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Raised Hand with Fingers Splayed",
		b: "1F590-FE0F",
		c: "1F590",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"hand",
			"fingers",
			"palm"
		],
		k: [
			29,
			32
		],
		o: 7
	},
	hand: {
		skin_variations: {
			"1F3FB": {
				unified: "270B-1F3FB",
				non_qualified: null,
				image: "270b-1f3fb.png",
				sheet_x: 49,
				sheet_y: 25,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "270B-1F3FC",
				non_qualified: null,
				image: "270b-1f3fc.png",
				sheet_x: 49,
				sheet_y: 26,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "270B-1F3FD",
				non_qualified: null,
				image: "270b-1f3fd.png",
				sheet_x: 49,
				sheet_y: 27,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "270B-1F3FE",
				non_qualified: null,
				image: "270b-1f3fe.png",
				sheet_x: 49,
				sheet_y: 28,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "270B-1F3FF",
				non_qualified: null,
				image: "270b-1f3ff.png",
				sheet_x: 49,
				sheet_y: 29,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Raised Hand",
		b: "270B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			49,
			24
		],
		n: [
			"raised_hand"
		]
	},
	ok_hand: {
		skin_variations: {
			"1F3FB": {
				unified: "1F44C-1F3FB",
				non_qualified: null,
				image: "1f44c-1f3fb.png",
				sheet_x: 14,
				sheet_y: 44,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F44C-1F3FC",
				non_qualified: null,
				image: "1f44c-1f3fc.png",
				sheet_x: 14,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F44C-1F3FD",
				non_qualified: null,
				image: "1f44c-1f3fd.png",
				sheet_x: 14,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F44C-1F3FE",
				non_qualified: null,
				image: "1f44c-1f3fe.png",
				sheet_x: 14,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F44C-1F3FF",
				non_qualified: null,
				image: "1f44c-1f3ff.png",
				sheet_x: 14,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Ok Hand Sign",
		b: "1F44C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fingers",
			"limbs",
			"perfect",
			"ok",
			"okay"
		],
		k: [
			14,
			43
		]
	},
	"+1": {
		skin_variations: {
			"1F3FB": {
				unified: "1F44D-1F3FB",
				non_qualified: null,
				image: "1f44d-1f3fb.png",
				sheet_x: 14,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F44D-1F3FC",
				non_qualified: null,
				image: "1f44d-1f3fc.png",
				sheet_x: 14,
				sheet_y: 51,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F44D-1F3FD",
				non_qualified: null,
				image: "1f44d-1f3fd.png",
				sheet_x: 15,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F44D-1F3FE",
				non_qualified: null,
				image: "1f44d-1f3fe.png",
				sheet_x: 15,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F44D-1F3FF",
				non_qualified: null,
				image: "1f44d-1f3ff.png",
				sheet_x: 15,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Thumbs Up Sign",
		b: "1F44D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"thumbsup",
			"yes",
			"awesome",
			"good",
			"agree",
			"accept",
			"cool",
			"hand",
			"like"
		],
		k: [
			14,
			49
		],
		n: [
			"thumbsup"
		]
	},
	"-1": {
		skin_variations: {
			"1F3FB": {
				unified: "1F44E-1F3FB",
				non_qualified: null,
				image: "1f44e-1f3fb.png",
				sheet_x: 15,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F44E-1F3FC",
				non_qualified: null,
				image: "1f44e-1f3fc.png",
				sheet_x: 15,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F44E-1F3FD",
				non_qualified: null,
				image: "1f44e-1f3fd.png",
				sheet_x: 15,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F44E-1F3FE",
				non_qualified: null,
				image: "1f44e-1f3fe.png",
				sheet_x: 15,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F44E-1F3FF",
				non_qualified: null,
				image: "1f44e-1f3ff.png",
				sheet_x: 15,
				sheet_y: 8,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Thumbs Down Sign",
		b: "1F44E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"thumbsdown",
			"no",
			"dislike",
			"hand"
		],
		k: [
			15,
			3
		],
		n: [
			"thumbsdown"
		]
	},
	fist: {
		skin_variations: {
			"1F3FB": {
				unified: "270A-1F3FB",
				non_qualified: null,
				image: "270a-1f3fb.png",
				sheet_x: 49,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "270A-1F3FC",
				non_qualified: null,
				image: "270a-1f3fc.png",
				sheet_x: 49,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "270A-1F3FD",
				non_qualified: null,
				image: "270a-1f3fd.png",
				sheet_x: 49,
				sheet_y: 21,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "270A-1F3FE",
				non_qualified: null,
				image: "270a-1f3fe.png",
				sheet_x: 49,
				sheet_y: 22,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "270A-1F3FF",
				non_qualified: null,
				image: "270a-1f3ff.png",
				sheet_x: 49,
				sheet_y: 23,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Raised Fist",
		b: "270A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fingers",
			"hand",
			"grasp"
		],
		k: [
			49,
			18
		]
	},
	facepunch: {
		skin_variations: {
			"1F3FB": {
				unified: "1F44A-1F3FB",
				non_qualified: null,
				image: "1f44a-1f3fb.png",
				sheet_x: 14,
				sheet_y: 32,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F44A-1F3FC",
				non_qualified: null,
				image: "1f44a-1f3fc.png",
				sheet_x: 14,
				sheet_y: 33,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F44A-1F3FD",
				non_qualified: null,
				image: "1f44a-1f3fd.png",
				sheet_x: 14,
				sheet_y: 34,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F44A-1F3FE",
				non_qualified: null,
				image: "1f44a-1f3fe.png",
				sheet_x: 14,
				sheet_y: 35,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F44A-1F3FF",
				non_qualified: null,
				image: "1f44a-1f3ff.png",
				sheet_x: 14,
				sheet_y: 36,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Fisted Hand Sign",
		b: "1F44A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"angry",
			"violence",
			"fist",
			"hit",
			"attack",
			"hand"
		],
		k: [
			14,
			31
		],
		n: [
			"punch"
		]
	},
	"left-facing_fist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F91B-1F3FB",
				non_qualified: null,
				image: "1f91b-1f3fb.png",
				sheet_x: 37,
				sheet_y: 51,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F91B-1F3FC",
				non_qualified: null,
				image: "1f91b-1f3fc.png",
				sheet_x: 38,
				sheet_y: 0,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F91B-1F3FD",
				non_qualified: null,
				image: "1f91b-1f3fd.png",
				sheet_x: 38,
				sheet_y: 1,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F91B-1F3FE",
				non_qualified: null,
				image: "1f91b-1f3fe.png",
				sheet_x: 38,
				sheet_y: 2,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F91B-1F3FF",
				non_qualified: null,
				image: "1f91b-1f3ff.png",
				sheet_x: 38,
				sheet_y: 3,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Left-Facing Fist",
		b: "1F91B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			50
		],
		o: 9
	},
	"right-facing_fist": {
		skin_variations: {
			"1F3FB": {
				unified: "1F91C-1F3FB",
				non_qualified: null,
				image: "1f91c-1f3fb.png",
				sheet_x: 38,
				sheet_y: 5,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F91C-1F3FC",
				non_qualified: null,
				image: "1f91c-1f3fc.png",
				sheet_x: 38,
				sheet_y: 6,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F91C-1F3FD",
				non_qualified: null,
				image: "1f91c-1f3fd.png",
				sheet_x: 38,
				sheet_y: 7,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F91C-1F3FE",
				non_qualified: null,
				image: "1f91c-1f3fe.png",
				sheet_x: 38,
				sheet_y: 8,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F91C-1F3FF",
				non_qualified: null,
				image: "1f91c-1f3ff.png",
				sheet_x: 38,
				sheet_y: 9,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Right-Facing Fist",
		b: "1F91C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			38,
			4
		],
		o: 9
	},
	raised_back_of_hand: {
		skin_variations: {
			"1F3FB": {
				unified: "1F91A-1F3FB",
				non_qualified: null,
				image: "1f91a-1f3fb.png",
				sheet_x: 37,
				sheet_y: 45,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F91A-1F3FC",
				non_qualified: null,
				image: "1f91a-1f3fc.png",
				sheet_x: 37,
				sheet_y: 46,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F91A-1F3FD",
				non_qualified: null,
				image: "1f91a-1f3fd.png",
				sheet_x: 37,
				sheet_y: 47,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F91A-1F3FE",
				non_qualified: null,
				image: "1f91a-1f3fe.png",
				sheet_x: 37,
				sheet_y: 48,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F91A-1F3FF",
				non_qualified: null,
				image: "1f91a-1f3ff.png",
				sheet_x: 37,
				sheet_y: 49,
				added_in: "9.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Raised Back of Hand",
		b: "1F91A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"fingers",
			"raised",
			"backhand"
		],
		k: [
			37,
			44
		],
		o: 9
	},
	wave: {
		skin_variations: {
			"1F3FB": {
				unified: "1F44B-1F3FB",
				non_qualified: null,
				image: "1f44b-1f3fb.png",
				sheet_x: 14,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F44B-1F3FC",
				non_qualified: null,
				image: "1f44b-1f3fc.png",
				sheet_x: 14,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F44B-1F3FD",
				non_qualified: null,
				image: "1f44b-1f3fd.png",
				sheet_x: 14,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F44B-1F3FE",
				non_qualified: null,
				image: "1f44b-1f3fe.png",
				sheet_x: 14,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F44B-1F3FF",
				non_qualified: null,
				image: "1f44b-1f3ff.png",
				sheet_x: 14,
				sheet_y: 42,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Waving Hand Sign",
		b: "1F44B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"hands",
			"gesture",
			"goodbye",
			"solong",
			"farewell",
			"hello",
			"hi",
			"palm"
		],
		k: [
			14,
			37
		]
	},
	i_love_you_hand_sign: {
		skin_variations: {
			"1F3FB": {
				unified: "1F91F-1F3FB",
				non_qualified: null,
				image: "1f91f-1f3fb.png",
				sheet_x: 38,
				sheet_y: 18,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F91F-1F3FC",
				non_qualified: null,
				image: "1f91f-1f3fc.png",
				sheet_x: 38,
				sheet_y: 19,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F91F-1F3FD",
				non_qualified: null,
				image: "1f91f-1f3fd.png",
				sheet_x: 38,
				sheet_y: 20,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F91F-1F3FE",
				non_qualified: null,
				image: "1f91f-1f3fe.png",
				sheet_x: 38,
				sheet_y: 21,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F91F-1F3FF",
				non_qualified: null,
				image: "1f91f-1f3ff.png",
				sheet_x: 38,
				sheet_y: 22,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "I Love You Hand Sign",
		b: "1F91F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			38,
			17
		],
		o: 10
	},
	writing_hand: {
		skin_variations: {
			"1F3FB": {
				unified: "270D-1F3FB",
				non_qualified: null,
				image: "270d-1f3fb.png",
				sheet_x: 49,
				sheet_y: 37,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "270D-1F3FC",
				non_qualified: null,
				image: "270d-1f3fc.png",
				sheet_x: 49,
				sheet_y: 38,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "270D-1F3FD",
				non_qualified: null,
				image: "270d-1f3fd.png",
				sheet_x: 49,
				sheet_y: 39,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "270D-1F3FE",
				non_qualified: null,
				image: "270d-1f3fe.png",
				sheet_x: 49,
				sheet_y: 40,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "270D-1F3FF",
				non_qualified: null,
				image: "270d-1f3ff.png",
				sheet_x: 49,
				sheet_y: 41,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Writing Hand",
		b: "270D-FE0F",
		c: "270D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"lower_left_ballpoint_pen",
			"stationery",
			"write",
			"compose"
		],
		k: [
			49,
			36
		],
		o: 1
	},
	clap: {
		skin_variations: {
			"1F3FB": {
				unified: "1F44F-1F3FB",
				non_qualified: null,
				image: "1f44f-1f3fb.png",
				sheet_x: 15,
				sheet_y: 10,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F44F-1F3FC",
				non_qualified: null,
				image: "1f44f-1f3fc.png",
				sheet_x: 15,
				sheet_y: 11,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F44F-1F3FD",
				non_qualified: null,
				image: "1f44f-1f3fd.png",
				sheet_x: 15,
				sheet_y: 12,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F44F-1F3FE",
				non_qualified: null,
				image: "1f44f-1f3fe.png",
				sheet_x: 15,
				sheet_y: 13,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F44F-1F3FF",
				non_qualified: null,
				image: "1f44f-1f3ff.png",
				sheet_x: 15,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Clapping Hands Sign",
		b: "1F44F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"hands",
			"praise",
			"applause",
			"congrats",
			"yay"
		],
		k: [
			15,
			9
		]
	},
	open_hands: {
		skin_variations: {
			"1F3FB": {
				unified: "1F450-1F3FB",
				non_qualified: null,
				image: "1f450-1f3fb.png",
				sheet_x: 15,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F450-1F3FC",
				non_qualified: null,
				image: "1f450-1f3fc.png",
				sheet_x: 15,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F450-1F3FD",
				non_qualified: null,
				image: "1f450-1f3fd.png",
				sheet_x: 15,
				sheet_y: 18,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F450-1F3FE",
				non_qualified: null,
				image: "1f450-1f3fe.png",
				sheet_x: 15,
				sheet_y: 19,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F450-1F3FF",
				non_qualified: null,
				image: "1f450-1f3ff.png",
				sheet_x: 15,
				sheet_y: 20,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Open Hands Sign",
		b: "1F450",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fingers",
			"butterfly",
			"hands",
			"open"
		],
		k: [
			15,
			15
		]
	},
	raised_hands: {
		skin_variations: {
			"1F3FB": {
				unified: "1F64C-1F3FB",
				non_qualified: null,
				image: "1f64c-1f3fb.png",
				sheet_x: 33,
				sheet_y: 13,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F64C-1F3FC",
				non_qualified: null,
				image: "1f64c-1f3fc.png",
				sheet_x: 33,
				sheet_y: 14,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F64C-1F3FD",
				non_qualified: null,
				image: "1f64c-1f3fd.png",
				sheet_x: 33,
				sheet_y: 15,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F64C-1F3FE",
				non_qualified: null,
				image: "1f64c-1f3fe.png",
				sheet_x: 33,
				sheet_y: 16,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F64C-1F3FF",
				non_qualified: null,
				image: "1f64c-1f3ff.png",
				sheet_x: 33,
				sheet_y: 17,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Person Raising Both Hands in Celebration",
		b: "1F64C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"gesture",
			"hooray",
			"yea",
			"celebration",
			"hands"
		],
		k: [
			33,
			12
		]
	},
	palms_up_together: {
		skin_variations: {
			"1F3FB": {
				unified: "1F932-1F3FB",
				non_qualified: null,
				image: "1f932-1f3fb.png",
				sheet_x: 39,
				sheet_y: 17,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FC": {
				unified: "1F932-1F3FC",
				non_qualified: null,
				image: "1f932-1f3fc.png",
				sheet_x: 39,
				sheet_y: 18,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FD": {
				unified: "1F932-1F3FD",
				non_qualified: null,
				image: "1f932-1f3fd.png",
				sheet_x: 39,
				sheet_y: 19,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FE": {
				unified: "1F932-1F3FE",
				non_qualified: null,
				image: "1f932-1f3fe.png",
				sheet_x: 39,
				sheet_y: 20,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			},
			"1F3FF": {
				unified: "1F932-1F3FF",
				non_qualified: null,
				image: "1f932-1f3ff.png",
				sheet_x: 39,
				sheet_y: 21,
				added_in: "10.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: false
			}
		},
		a: "Palms Up Together",
		b: "1F932",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			39,
			16
		],
		o: 10
	},
	pray: {
		skin_variations: {
			"1F3FB": {
				unified: "1F64F-1F3FB",
				non_qualified: null,
				image: "1f64f-1f3fb.png",
				sheet_x: 34,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F64F-1F3FC",
				non_qualified: null,
				image: "1f64f-1f3fc.png",
				sheet_x: 34,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F64F-1F3FD",
				non_qualified: null,
				image: "1f64f-1f3fd.png",
				sheet_x: 34,
				sheet_y: 5,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F64F-1F3FE",
				non_qualified: null,
				image: "1f64f-1f3fe.png",
				sheet_x: 34,
				sheet_y: 6,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F64F-1F3FF",
				non_qualified: null,
				image: "1f64f-1f3ff.png",
				sheet_x: 34,
				sheet_y: 7,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Person with Folded Hands",
		b: "1F64F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"please",
			"hope",
			"wish",
			"namaste",
			"highfive"
		],
		k: [
			34,
			2
		]
	},
	handshake: {
		a: "Handshake",
		b: "1F91D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"agreement",
			"shake"
		],
		k: [
			38,
			10
		],
		o: 9
	},
	nail_care: {
		skin_variations: {
			"1F3FB": {
				unified: "1F485-1F3FB",
				non_qualified: null,
				image: "1f485-1f3fb.png",
				sheet_x: 23,
				sheet_y: 45,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F485-1F3FC",
				non_qualified: null,
				image: "1f485-1f3fc.png",
				sheet_x: 23,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F485-1F3FD",
				non_qualified: null,
				image: "1f485-1f3fd.png",
				sheet_x: 23,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F485-1F3FE",
				non_qualified: null,
				image: "1f485-1f3fe.png",
				sheet_x: 23,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F485-1F3FF",
				non_qualified: null,
				image: "1f485-1f3ff.png",
				sheet_x: 23,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Nail Polish",
		b: "1F485",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"beauty",
			"manicure",
			"finger",
			"fashion",
			"nail"
		],
		k: [
			23,
			44
		]
	},
	ear: {
		skin_variations: {
			"1F3FB": {
				unified: "1F442-1F3FB",
				non_qualified: null,
				image: "1f442-1f3fb.png",
				sheet_x: 13,
				sheet_y: 46,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F442-1F3FC",
				non_qualified: null,
				image: "1f442-1f3fc.png",
				sheet_x: 13,
				sheet_y: 47,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F442-1F3FD",
				non_qualified: null,
				image: "1f442-1f3fd.png",
				sheet_x: 13,
				sheet_y: 48,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F442-1F3FE",
				non_qualified: null,
				image: "1f442-1f3fe.png",
				sheet_x: 13,
				sheet_y: 49,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F442-1F3FF",
				non_qualified: null,
				image: "1f442-1f3ff.png",
				sheet_x: 13,
				sheet_y: 50,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Ear",
		b: "1F442",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"hear",
			"sound",
			"listen"
		],
		k: [
			13,
			45
		]
	},
	nose: {
		skin_variations: {
			"1F3FB": {
				unified: "1F443-1F3FB",
				non_qualified: null,
				image: "1f443-1f3fb.png",
				sheet_x: 14,
				sheet_y: 0,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FC": {
				unified: "1F443-1F3FC",
				non_qualified: null,
				image: "1f443-1f3fc.png",
				sheet_x: 14,
				sheet_y: 1,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FD": {
				unified: "1F443-1F3FD",
				non_qualified: null,
				image: "1f443-1f3fd.png",
				sheet_x: 14,
				sheet_y: 2,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FE": {
				unified: "1F443-1F3FE",
				non_qualified: null,
				image: "1f443-1f3fe.png",
				sheet_x: 14,
				sheet_y: 3,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			},
			"1F3FF": {
				unified: "1F443-1F3FF",
				non_qualified: null,
				image: "1f443-1f3ff.png",
				sheet_x: 14,
				sheet_y: 4,
				added_in: "8.0",
				has_img_apple: true,
				has_img_google: true,
				has_img_twitter: true,
				has_img_emojione: true,
				has_img_facebook: true,
				has_img_messenger: true
			}
		},
		a: "Nose",
		b: "1F443",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"smell",
			"sniff"
		],
		k: [
			13,
			51
		]
	},
	footprints: {
		a: "Footprints",
		b: "1F463",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"feet",
			"tracking",
			"walking",
			"beach"
		],
		k: [
			15,
			39
		]
	},
	eyes: {
		a: "Eyes",
		b: "1F440",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"look",
			"watch",
			"stalk",
			"peek",
			"see"
		],
		k: [
			13,
			42
		]
	},
	eye: {
		a: "Eye",
		b: "1F441-FE0F",
		c: "1F441",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face",
			"look",
			"see",
			"watch",
			"stare"
		],
		k: [
			13,
			44
		],
		o: 7
	},
	"eye-in-speech-bubble": {
		a: "Eye in Speech Bubble",
		b: "1F441-FE0F-200D-1F5E8-FE0F",
		d: true,
		e: true,
		f: false,
		g: true,
		h: false,
		i: false,
		k: [
			13,
			43
		],
		o: 7
	},
	brain: {
		a: "Brain",
		b: "1F9E0",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			22
		],
		o: 10
	},
	tongue: {
		a: "Tongue",
		b: "1F445",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"mouth",
			"playful"
		],
		k: [
			14,
			6
		]
	},
	lips: {
		a: "Mouth",
		b: "1F444",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"mouth",
			"kiss"
		],
		k: [
			14,
			5
		]
	},
	kiss: {
		a: "Kiss Mark",
		b: "1F48B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"face",
			"lips",
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			24,
			37
		]
	},
	cupid: {
		a: "Heart with Arrow",
		b: "1F498",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"heart",
			"affection",
			"valentines"
		],
		k: [
			24,
			50
		]
	},
	heart: {
		a: "Heavy Black Heart",
		b: "2764-FE0F",
		c: "2764",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"valentines"
		],
		k: [
			50,
			8
		],
		l: [
			"<3"
		],
		m: "<3",
		o: 1
	},
	heartbeat: {
		a: "Beating Heart",
		b: "1F493",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines",
			"pink",
			"heart"
		],
		k: [
			24,
			45
		]
	},
	broken_heart: {
		a: "Broken Heart",
		b: "1F494",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sad",
			"sorry",
			"break",
			"heart",
			"heartbreak"
		],
		k: [
			24,
			46
		],
		l: [
			"</3"
		],
		m: "</3"
	},
	two_hearts: {
		a: "Two Hearts",
		b: "1F495",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines",
			"heart"
		],
		k: [
			24,
			47
		]
	},
	sparkling_heart: {
		a: "Sparkling Heart",
		b: "1F496",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			24,
			48
		]
	},
	heartpulse: {
		a: "Growing Heart",
		b: "1F497",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"like",
			"love",
			"affection",
			"valentines",
			"pink"
		],
		k: [
			24,
			49
		]
	},
	blue_heart: {
		a: "Blue Heart",
		b: "1F499",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			24,
			51
		],
		m: "<3"
	},
	green_heart: {
		a: "Green Heart",
		b: "1F49A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			25,
			0
		],
		m: "<3"
	},
	yellow_heart: {
		a: "Yellow Heart",
		b: "1F49B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			25,
			1
		],
		m: "<3"
	},
	orange_heart: {
		a: "Orange Heart",
		b: "1F9E1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			23
		],
		o: 10
	},
	purple_heart: {
		a: "Purple Heart",
		b: "1F49C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			25,
			2
		],
		m: "<3"
	},
	black_heart: {
		a: "Black Heart",
		b: "1F5A4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"evil"
		],
		k: [
			29,
			50
		],
		o: 9
	},
	gift_heart: {
		a: "Heart with Ribbon",
		b: "1F49D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"valentines"
		],
		k: [
			25,
			3
		]
	},
	revolving_hearts: {
		a: "Revolving Hearts",
		b: "1F49E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		k: [
			25,
			4
		]
	},
	heart_decoration: {
		a: "Heart Decoration",
		b: "1F49F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"purple-square",
			"love",
			"like"
		],
		k: [
			25,
			5
		]
	},
	heavy_heart_exclamation_mark_ornament: {
		a: "Heavy Heart Exclamation Mark Ornament",
		b: "2763-FE0F",
		c: "2763",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			50,
			7
		],
		o: 1
	},
	love_letter: {
		a: "Love Letter",
		b: "1F48C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"email",
			"like",
			"affection",
			"envelope",
			"valentines"
		],
		k: [
			24,
			38
		]
	},
	zzz: {
		a: "Sleeping Symbol",
		b: "1F4A4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"sleepy",
			"tired",
			"dream"
		],
		k: [
			25,
			10
		]
	},
	anger: {
		a: "Anger Symbol",
		b: "1F4A2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"angry",
			"mad"
		],
		k: [
			25,
			8
		]
	},
	bomb: {
		a: "Bomb",
		b: "1F4A3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"boom",
			"explode",
			"explosion",
			"terrorism"
		],
		k: [
			25,
			9
		]
	},
	boom: {
		a: "Collision Symbol",
		b: "1F4A5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"bomb",
			"explode",
			"explosion",
			"collision",
			"blown"
		],
		k: [
			25,
			11
		],
		n: [
			"collision"
		]
	},
	sweat_drops: {
		a: "Splashing Sweat Symbol",
		b: "1F4A6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"water",
			"drip",
			"oops"
		],
		k: [
			25,
			12
		]
	},
	dash: {
		a: "Dash Symbol",
		b: "1F4A8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"wind",
			"air",
			"fast",
			"shoo",
			"fart",
			"smoke",
			"puff"
		],
		k: [
			25,
			14
		]
	},
	dizzy: {
		a: "Dizzy Symbol",
		b: "1F4AB",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"star",
			"sparkle",
			"shoot",
			"magic"
		],
		k: [
			25,
			22
		]
	},
	speech_balloon: {
		a: "Speech Balloon",
		b: "1F4AC",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"bubble",
			"words",
			"message",
			"talk",
			"chatting"
		],
		k: [
			25,
			23
		]
	},
	left_speech_bubble: {
		a: "Left Speech Bubble",
		b: "1F5E8-FE0F",
		c: "1F5E8",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"words",
			"message",
			"talk",
			"chatting"
		],
		k: [
			30,
			15
		],
		o: 7
	},
	right_anger_bubble: {
		a: "Right Anger Bubble",
		b: "1F5EF-FE0F",
		c: "1F5EF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"caption",
			"speech",
			"thinking",
			"mad"
		],
		k: [
			30,
			16
		],
		o: 7
	},
	thought_balloon: {
		a: "Thought Balloon",
		b: "1F4AD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"bubble",
			"cloud",
			"speech",
			"thinking",
			"dream"
		],
		k: [
			25,
			24
		]
	},
	hole: {
		a: "Hole",
		b: "1F573-FE0F",
		c: "1F573",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"embarrassing"
		],
		k: [
			28,
			44
		],
		o: 7
	},
	eyeglasses: {
		a: "Eyeglasses",
		b: "1F453",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fashion",
			"accessories",
			"eyesight",
			"nerdy",
			"dork",
			"geek"
		],
		k: [
			15,
			23
		]
	},
	dark_sunglasses: {
		a: "Dark Sunglasses",
		b: "1F576-FE0F",
		c: "1F576",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"face",
			"cool",
			"accessories"
		],
		k: [
			29,
			17
		],
		o: 7
	},
	necktie: {
		a: "Necktie",
		b: "1F454",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shirt",
			"suitup",
			"formal",
			"fashion",
			"cloth",
			"business"
		],
		k: [
			15,
			24
		]
	},
	shirt: {
		a: "T-Shirt",
		b: "1F455",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		k: [
			15,
			25
		],
		n: [
			"tshirt"
		]
	},
	jeans: {
		a: "Jeans",
		b: "1F456",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fashion",
			"shopping"
		],
		k: [
			15,
			26
		]
	},
	scarf: {
		a: "Scarf",
		b: "1F9E3",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			25
		],
		o: 10
	},
	gloves: {
		a: "Gloves",
		b: "1F9E4",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			26
		],
		o: 10
	},
	coat: {
		a: "Coat",
		b: "1F9E5",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			27
		],
		o: 10
	},
	socks: {
		a: "Socks",
		b: "1F9E6",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			28
		],
		o: 10
	},
	dress: {
		a: "Dress",
		b: "1F457",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"clothes",
			"fashion",
			"shopping"
		],
		k: [
			15,
			27
		]
	},
	kimono: {
		a: "Kimono",
		b: "1F458",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"dress",
			"fashion",
			"women",
			"female",
			"japanese"
		],
		k: [
			15,
			28
		]
	},
	bikini: {
		a: "Bikini",
		b: "1F459",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"swimming",
			"female",
			"woman",
			"girl",
			"fashion",
			"beach",
			"summer"
		],
		k: [
			15,
			29
		]
	},
	womans_clothes: {
		a: "Womans Clothes",
		b: "1F45A",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fashion",
			"shopping_bags",
			"female"
		],
		k: [
			15,
			30
		]
	},
	purse: {
		a: "Purse",
		b: "1F45B",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fashion",
			"accessories",
			"money",
			"sales",
			"shopping"
		],
		k: [
			15,
			31
		]
	},
	handbag: {
		a: "Handbag",
		b: "1F45C",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fashion",
			"accessory",
			"accessories",
			"shopping"
		],
		k: [
			15,
			32
		]
	},
	pouch: {
		a: "Pouch",
		b: "1F45D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"bag",
			"accessories",
			"shopping"
		],
		k: [
			15,
			33
		]
	},
	shopping_bags: {
		a: "Shopping Bags",
		b: "1F6CD-FE0F",
		c: "1F6CD",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			37,
			2
		],
		o: 7
	},
	school_satchel: {
		a: "School Satchel",
		b: "1F392",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"student",
			"education",
			"bag",
			"backpack"
		],
		k: [
			8,
			37
		]
	},
	mans_shoe: {
		a: "Mans Shoe",
		b: "1F45E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fashion",
			"male"
		],
		k: [
			15,
			34
		],
		n: [
			"shoe"
		]
	},
	athletic_shoe: {
		a: "Athletic Shoe",
		b: "1F45F",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shoes",
			"sports",
			"sneakers"
		],
		k: [
			15,
			35
		]
	},
	high_heel: {
		a: "High-Heeled Shoe",
		b: "1F460",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fashion",
			"shoes",
			"female",
			"pumps",
			"stiletto"
		],
		k: [
			15,
			36
		]
	},
	sandal: {
		a: "Womans Sandal",
		b: "1F461",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shoes",
			"fashion",
			"flip flops"
		],
		k: [
			15,
			37
		]
	},
	boot: {
		a: "Womans Boots",
		b: "1F462",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"shoes",
			"fashion"
		],
		k: [
			15,
			38
		]
	},
	crown: {
		a: "Crown",
		b: "1F451",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"king",
			"kod",
			"leader",
			"royalty",
			"lord"
		],
		k: [
			15,
			21
		]
	},
	womans_hat: {
		a: "Womans Hat",
		b: "1F452",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"fashion",
			"accessories",
			"female",
			"lady",
			"spring"
		],
		k: [
			15,
			22
		]
	},
	tophat: {
		a: "Top Hat",
		b: "1F3A9",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"magic",
			"gentleman",
			"classy",
			"circus"
		],
		k: [
			9,
			3
		]
	},
	mortar_board: {
		a: "Graduation Cap",
		b: "1F393",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"school",
			"college",
			"degree",
			"university",
			"graduation",
			"cap",
			"hat",
			"legal",
			"learn",
			"education"
		],
		k: [
			8,
			38
		]
	},
	billed_cap: {
		a: "Billed Cap",
		b: "1F9E2",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			46,
			24
		],
		o: 10
	},
	helmet_with_white_cross: {
		a: "Helmet with White Cross",
		b: "26D1-FE0F",
		c: "26D1",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		k: [
			48,
			33
		],
		o: 5
	},
	prayer_beads: {
		a: "Prayer Beads",
		b: "1F4FF",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: false,
		j: [
			"dhikr",
			"religious"
		],
		k: [
			27,
			1
		],
		o: 8
	},
	lipstick: {
		a: "Lipstick",
		b: "1F484",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"female",
			"girl",
			"fashion",
			"woman"
		],
		k: [
			23,
			43
		]
	},
	ring: {
		a: "Ring",
		b: "1F48D",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"wedding",
			"propose",
			"marriage",
			"valentines",
			"diamond",
			"fashion",
			"jewelry",
			"gem",
			"engagement"
		],
		k: [
			24,
			39
		]
	},
	gem: {
		a: "Gem Stone",
		b: "1F48E",
		d: true,
		e: true,
		f: true,
		g: true,
		h: true,
		i: true,
		j: [
			"blue",
			"ruby",
			"diamond",
			"jewelry"
		],
		k: [
			24,
			40
		]
	}
};
var aliases = {
	satisfied: "laughing",
	grinning_face_with_star_eyes: "star-struck",
	face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
	telephone: "phone",
	cooking: "fried_egg",
	paw_prints: "feet",
	"flag-cn": "cn",
	lantern: "izakaya_lantern",
	shocked_face_with_exploding_head: "exploding_head",
	open_book: "book",
	"flag-de": "de",
	grinning_face_with_one_large_and_one_small_eye: "zany_face",
	serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
	flipper: "dolphin",
	face_with_open_mouth_vomiting: "face_vomiting",
	"flag-es": "es",
	face_with_finger_covering_closed_lips: "shushing_face",
	smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
	"flag-fr": "fr",
	honeybee: "bee",
	red_car: "car",
	envelope: "email",
	uk: "gb",
	"flag-gb": "gb",
	poop: "hankey",
	shit: "hankey",
	staff_of_aesculapius: "medical_symbol",
	knife: "hocho",
	sailboat: "boat",
	pencil: "memo",
	"flag-it": "it",
	"flag-jp": "jp",
	heavy_exclamation_mark: "exclamation",
	"flag-kr": "kr",
	waxing_gibbous_moon: "moon",
	mother_christmas: "mrs_claus",
	sun_small_cloud: "mostly_sunny",
	sun_behind_cloud: "barely_sunny",
	sun_behind_rain_cloud: "partly_sunny_rain",
	lightning_cloud: "lightning",
	tornado_cloud: "tornado",
	"flag-ru": "ru",
	running: "runner",
	"flag-us": "us",
	man_and_woman_holding_hands: "couple",
	"man-woman-boy": "family",
	family: "man-woman-boy",
	reversed_hand_with_middle_finger_extended: "middle_finger",
	hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
	sign_of_the_horns: "the_horns",
	raised_hand: "hand",
	thumbsup: "+1",
	thumbsdown: "-1",
	punch: "facepunch",
	collision: "boom",
	tshirt: "shirt",
	shoe: "mans_shoe"
};
var data = {
	compressed: compressed,
	categories: categories,
	emojis: emojis,
	aliases: aliases
};

function _classCallCheck$3 (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

var _Object = Object;

var _createClass$3 = (function createClass() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      _Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var $JSON = _core.JSON || (_core.JSON = { stringify: JSON.stringify });
var stringify = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

var stringify$1 = createCommonjsModule(function (module) {
module.exports = { "default": stringify, __esModule: true };
});

var _JSON$stringify = unwrapExports(stringify$1);

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
var hasOwnProperty = Object.prototype.hasOwnProperty,
    hasDontEnumBug = !{ toString: null }.propertyIsEnumerable('toString'),
    dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'],
    dontEnumsLength = dontEnums.length;

function _Object$keys (obj) {
  if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
    throw new TypeError('Object.keys called on non-object');
  }

  var result = [],
      prop,
      i;

  for (prop in obj) {
    if (hasOwnProperty.call(obj, prop)) {
      result.push(prop);
    }
  }

  if (hasDontEnumBug) {
    for (i = 0; i < dontEnumsLength; i++) {
      if (hasOwnProperty.call(obj, dontEnums[i])) {
        result.push(dontEnums[i]);
      }
    }
  }
  return result;
}

var mapping = {
  name: 'a',
  unified: 'b',
  non_qualified: 'c',
  has_img_apple: 'd',
  has_img_google: 'e',
  has_img_twitter: 'f',
  has_img_emojione: 'g',
  has_img_facebook: 'h',
  has_img_messenger: 'i',
  keywords: 'j',
  sheet: 'k',
  emoticons: 'l',
  text: 'm',
  short_names: 'n',
  added_in: 'o'
};

var buildSearch = function buildSearch(emoji) {
  var search = [];

  var addToSearch = function addToSearch(strings, split) {
    if (!strings) {
      return;
    }
(Array.isArray(strings) ? strings : [strings]).forEach(function (string) {
(split ? string.split(/[-|_|\s]+/) : [string]).forEach(function (s) {
        s = s.toLowerCase();

        if (search.indexOf(s) == -1) {
          search.push(s);
        }
      });
    });
  };

  addToSearch(emoji.short_names, true);
  addToSearch(emoji.name, true);
  addToSearch(emoji.keywords, false);
  addToSearch(emoji.emoticons, false);

  return search.join(',');
};

var uncompress = function uncompress(data) {
  data.compressed = false;

  for (var id in data.emojis) {
    var emoji = data.emojis[id];

    for (var key in mapping) {
      emoji[key] = emoji[mapping[key]];
      delete emoji[mapping[key]];
    }

    if (!emoji.short_names) emoji.short_names = [];
    emoji.short_names.unshift(id);

    emoji.sheet_x = emoji.sheet[0];
    emoji.sheet_y = emoji.sheet[1];
    delete emoji.sheet;

    if (!emoji.text) emoji.text = '';

    if (!emoji.added_in) emoji.added_in = 6;
    emoji.added_in = emoji.added_in.toFixed(1);

    emoji.search = buildSearch(emoji);
  }
};

var _String = String;

var stringFromCodePoint = _String.fromCodePoint || function stringFromCodePoint() {
  var MAX_SIZE = 0x4000;
  var codeUnits = [];
  var highSurrogate;
  var lowSurrogate;
  var index = -1;
  var length = arguments.length;
  if (!length) {
    return '';
  }
  var result = '';
  while (++index < length) {
    var codePoint = Number(arguments[index]);
    if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
    codePoint < 0 || // not a valid Unicode code point
    codePoint > 0x10ffff || // not a valid Unicode code point
    Math.floor(codePoint) != codePoint // not an integer
    ) {
        throw RangeError('Invalid code point: ' + codePoint);
      }
    if (codePoint <= 0xffff) {
      // BMP code point
      codeUnits.push(codePoint);
    } else {
      // Astral code point; split in surrogate halves
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      codePoint -= 0x10000;
      highSurrogate = (codePoint >> 10) + 0xd800;
      lowSurrogate = codePoint % 0x400 + 0xdc00;
      codeUnits.push(highSurrogate, lowSurrogate);
    }
    if (index + 1 === length || codeUnits.length > MAX_SIZE) {
      result += String.fromCharCode.apply(null, codeUnits);
      codeUnits.length = 0;
    }
  }
  return result;
};

var COLONS_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
var SKINS = ['1F3FA', '1F3FB', '1F3FC', '1F3FD', '1F3FE', '1F3FF'];

function unifiedToNative(unified) {
  var unicodes = unified.split('-'),
      codePoints = unicodes.map(function (u) {
    return '0x' + u;
  });

  return stringFromCodePoint.apply(null, codePoints);
}

function sanitize(emoji) {
  var name = emoji.name;
  var short_names = emoji.short_names;
  var skin_tone = emoji.skin_tone;
  var skin_variations = emoji.skin_variations;
  var emoticons = emoji.emoticons;
  var unified = emoji.unified;
  var custom = emoji.custom;
  var customCategory = emoji.customCategory;
  var imageUrl = emoji.imageUrl;
  var id = emoji.id || short_names[0];
  var colons = ':' + id + ':';

  if (custom) {
    return {
      id: id,
      name: name,
      short_names: short_names,
      colons: colons,
      emoticons: emoticons,
      custom: custom,
      customCategory: customCategory,
      imageUrl: imageUrl
    };
  }

  if (skin_tone) {
    colons += ':skin-tone-' + skin_tone + ':';
  }

  return {
    id: id,
    name: name,
    short_names: short_names,
    colons: colons,
    emoticons: emoticons,
    unified: unified.toLowerCase(),
    skin: skin_tone || (skin_variations ? 1 : null),
    native: unifiedToNative(unified)
  };
}

function getSanitizedData() {
  return sanitize(getData.apply(undefined, arguments));
}

function getData(emoji, skin, set, data) {
  var emojiData = {};

  if (typeof emoji == 'string') {
    var matches = emoji.match(COLONS_REGEX);

    if (matches) {
      emoji = matches[1];

      if (matches[2]) {
        skin = parseInt(matches[2], 10);
      }
    }

    if (data.aliases.hasOwnProperty(emoji)) {
      emoji = data.aliases[emoji];
    }

    if (data.emojis.hasOwnProperty(emoji)) {
      emojiData = data.emojis[emoji];
    } else {
      return null;
    }
  } else if (emoji.id) {
    if (data.aliases.hasOwnProperty(emoji.id)) {
      emoji.id = data.aliases[emoji.id];
    }

    if (data.emojis.hasOwnProperty(emoji.id)) {
      emojiData = data.emojis[emoji.id];
      skin || (skin = emoji.skin);
    }
  }

  if (!_Object$keys(emojiData).length) {
    emojiData = emoji;
    emojiData.custom = true;

    if (!emojiData.search) {
      emojiData.search = buildSearch(emoji);
    }
  }

  emojiData.emoticons || (emojiData.emoticons = []);
  emojiData.variations || (emojiData.variations = []);

  if (emojiData.skin_variations && skin > 1) {
    emojiData = JSON.parse(_JSON$stringify(emojiData));

    var skinKey = SKINS[skin - 1],
        variationData = emojiData.skin_variations[skinKey];

    if (!variationData.variations && emojiData.variations) {
      delete emojiData.variations;
    }

    if (set && (variationData['has_img_' + set] == undefined || variationData['has_img_' + set]) || !set) {
      emojiData.skin_tone = skin;

      for (var k in variationData) {
        var v = variationData[k];
        emojiData[k] = v;
      }
    }
  }

  if (emojiData.variations && emojiData.variations.length) {
    emojiData = JSON.parse(_JSON$stringify(emojiData));
    emojiData.unified = emojiData.variations.shift();
  }

  return emojiData;
}

function uniq(arr) {
  return arr.reduce(function (acc, item) {
    if (acc.indexOf(item) === -1) {
      acc.push(item);
    }
    return acc;
  }, []);
}

function intersect(a, b) {
  var uniqA = uniq(a);
  var uniqB = uniq(b);

  return uniqA.filter(function (item) {
    return uniqB.indexOf(item) >= 0;
  });
}

function deepMerge(a, b) {
  var o = {};

  for (var key in a) {
    var originalValue = a[key],
        value = originalValue;

    if (b.hasOwnProperty(key)) {
      value = b[key];
    }

    if (typeof value === 'object') {
      value = deepMerge(originalValue, value);
    }

    o[key] = value;
  }

  return o;
}

// https://github.com/sonicdoe/measure-scrollbar
function measureScrollbar() {
  if (typeof document == 'undefined') return 0;
  var div = document.createElement('div');

  div.style.width = '100px';
  div.style.height = '100px';
  div.style.overflow = 'scroll';
  div.style.position = 'absolute';
  div.style.top = '-9999px';

  document.body.appendChild(div);
  var scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);

  return scrollbarWidth;
}

// Use requestIdleCallback() if available, else fall back to setTimeout().
// Throttle so as not to run too frequently.
function throttleIdleTask(func) {
  var doIdleTask = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  var running = false;

  return function throttled() {
    if (running) {
      return;
    }
    running = true;
    doIdleTask(function () {
      running = false;
      func();
    });
  };
}

var NAMESPACE = 'emoji-mart';

var isLocalStorageSupported = typeof window !== 'undefined' && 'localStorage' in window;

var getter = void 0;
var setter = void 0;

function setHandlers(handlers) {
  handlers || (handlers = {});

  getter = handlers.getter;
  setter = handlers.setter;
}

function setNamespace(namespace) {
  NAMESPACE = namespace;
}

function update(state) {
  for (var key in state) {
    var value = state[key];
    set(key, value);
  }
}

function set(key, value) {
  if (setter) {
    setter(key, value);
  } else {
    if (!isLocalStorageSupported) return;
    try {
      window.localStorage[NAMESPACE + '.' + key] = _JSON$stringify(value);
    } catch (e) {}
  }
}

function get(key) {
  if (getter) {
    return getter(key);
  } else {
    if (!isLocalStorageSupported) return;
    try {
      var value = window.localStorage[NAMESPACE + '.' + key];

      if (value) {
        return JSON.parse(value);
      }
    } catch (e) {
      return;
    }
  }
}

var store = { update: update, set: set, get: get, setNamespace: setNamespace, setHandlers: setHandlers };

var NimbleEmojiIndex = function () {
  function NimbleEmojiIndex(data, set) {
    _classCallCheck$3(this, NimbleEmojiIndex);

    if (data.compressed) {
      uncompress(data);
    }

    this.data = data || {};
    this.set = set || null;
    this.originalPool = {};
    this.index = {};
    this.emojis = {};
    this.emoticons = {};
    this.customEmojisList = [];

    this.buildIndex();
  }

  _createClass$3(NimbleEmojiIndex, [{
    key: 'buildIndex',
    value: function buildIndex() {
      var _this = this;

      var _loop = function _loop(emoji) {
        var emojiData = _this.data.emojis[emoji];
        var short_names = emojiData.short_names;
        var emoticons = emojiData.emoticons;
        var skin_variations = emojiData.skin_variations;
        var id = short_names[0];

        if (emoticons) {
          emoticons.forEach(function (emoticon) {
            if (_this.emoticons[emoticon]) {
              return;
            }

            _this.emoticons[emoticon] = id;
          });
        }

        // If skin variations include them
        if (skin_variations) {
          _this.emojis[id] = {};
          for (var skinTone = 1; skinTone <= 6; skinTone++) {
            _this.emojis[id][skinTone] = getSanitizedData({ id: id, skin: skinTone }, skinTone, _this.set, _this.data);
          }
        } else {
          _this.emojis[id] = getSanitizedData(id, null, _this.set, _this.data);
        }

        _this.originalPool[id] = emojiData;
      };

      for (var emoji in this.data.emojis) {
        _loop(emoji);
      }
    }
  }, {
    key: 'clearCustomEmojis',
    value: function clearCustomEmojis(pool) {
      var _this2 = this;

      this.customEmojisList.forEach(function (emoji) {
        var emojiId = emoji.id || emoji.short_names[0];

        delete pool[emojiId];
        delete _this2.emojis[emojiId];
      });
    }
  }, {
    key: 'addCustomToPool',
    value: function addCustomToPool(custom, pool) {
      var _this3 = this;

      if (this.customEmojisList.length) this.clearCustomEmojis(pool);

      custom.forEach(function (emoji) {
        var emojiId = emoji.id || emoji.short_names[0];

        if (emojiId && !pool[emojiId]) {
          pool[emojiId] = getData(emoji, null, null, _this3.data);
          _this3.emojis[emojiId] = getSanitizedData(emoji, null, null, _this3.data);
        }
      });

      this.customEmojisList = custom;
      this.index = {};
    }
  }, {
    key: 'search',
    value: function search(value) {
      var _this4 = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var emojisToShowFilter = _ref.emojisToShowFilter;
      var maxResults = _ref.maxResults;
      var include = _ref.include;
      var exclude = _ref.exclude;
      var _ref$custom = _ref.custom;
      var custom = _ref$custom === undefined ? [] : _ref$custom;

      if (this.customEmojisList != custom) this.addCustomToPool(custom, this.originalPool);

      var skinTone = store.get('skin') || 1;

      maxResults || (maxResults = 75);
      include || (include = []);
      exclude || (exclude = []);

      var results = null,
          pool = this.originalPool;

      if (value.length) {
        if (value == '-' || value == '-1') {
          return [this.emojis['-1'][skinTone]];
        }

        var values = value.toLowerCase().split(/[\s|,|\-|_]+/),
            allResults = [];

        if (values.length > 2) {
          values = [values[0], values[1]];
        }

        if (include.length || exclude.length) {
          pool = {};

          this.data.categories.forEach(function (category) {
            var isIncluded = include && include.length ? include.indexOf(category.id) > -1 : true;
            var isExcluded = exclude && exclude.length ? exclude.indexOf(category.id) > -1 : false;
            if (!isIncluded || isExcluded) {
              return;
            }

            category.emojis.forEach(function (emojiId) {
              return pool[emojiId] = _this4.data.emojis[emojiId];
            });
          });

          if (custom.length) {
            var customIsIncluded = include && include.length ? include.indexOf('custom') > -1 : true;
            var customIsExcluded = exclude && exclude.length ? exclude.indexOf('custom') > -1 : false;
            if (customIsIncluded && !customIsExcluded) {
              this.addCustomToPool(custom, pool);
            }
          }
        }

        allResults = values.map(function (value) {
          var aPool = pool,
              aIndex = _this4.index,
              length = 0;

          for (var charIndex = 0; charIndex < value.length; charIndex++) {
            var char = value[charIndex];
            length++;

            aIndex[char] || (aIndex[char] = {});
            aIndex = aIndex[char];

            if (!aIndex.results) {
              (function () {
                var scores = {};

                aIndex.results = [];
                aIndex.pool = {};

                for (var _id in aPool) {
                  var emoji = aPool[_id];
                  var search = emoji.search;
                  var sub = value.substr(0, length);
                  var subIndex = search.indexOf(sub);

                  if (subIndex != -1) {
                    var score = subIndex + 1;
                    if (sub == _id) score = 0;

                    if (_this4.emojis[_id] && _this4.emojis[_id][skinTone]) {
                      aIndex.results.push(_this4.emojis[_id][skinTone]);
                    } else {
                      aIndex.results.push(_this4.emojis[_id]);
                    }
                    aIndex.pool[_id] = emoji;

                    scores[_id] = score;
                  }
                }

                aIndex.results.sort(function (a, b) {
                  var aScore = scores[a.id],
                      bScore = scores[b.id];

                  if (aScore == bScore) {
                    return a.id.localeCompare(b.id);
                  } else {
                    return aScore - bScore;
                  }
                });
              })();
            }

            aPool = aIndex.pool;
          }

          return aIndex.results;
        }).filter(function (a) {
          return a;
        });

        if (allResults.length > 1) {
          results = intersect.apply(null, allResults);
        } else if (allResults.length) {
          results = allResults[0];
        } else {
          results = [];
        }
      }

      if (results) {
        if (emojisToShowFilter) {
          results = results.filter(function (result) {
            return emojisToShowFilter(pool[result.id]);
          });
        }

        if (results && results.length > maxResults) {
          results = results.slice(0, maxResults);
        }
      }

      return results;
    }
  }]);

  return NimbleEmojiIndex;
}();

var emojiIndex = new NimbleEmojiIndex(data);

var DEFAULTS = ['+1', 'grinning', 'kissing_heart', 'heart_eyes', 'laughing', 'stuck_out_tongue_winking_eye', 'sweat_smile', 'joy', 'scream', 'disappointed', 'unamused', 'weary', 'sob', 'sunglasses', 'heart', 'poop'];

var frequently = void 0,
    initialized = void 0;
var defaults = {};

function init() {
  initialized = true;
  frequently = store.get('frequently');
}

function add(emoji) {
  if (!initialized) init();
  var id = emoji.id;


  frequently || (frequently = defaults);
  frequently[id] || (frequently[id] = 0);
  frequently[id] += 1;

  store.set('last', id);
  store.set('frequently', frequently);
}

function get$1(perLine) {
  if (!initialized) init();
  if (!frequently) {
    defaults = {};

    var result = [];

    for (var i = 0; i < perLine; i++) {
      defaults[DEFAULTS[i]] = perLine - i;
      result.push(DEFAULTS[i]);
    }

    return result;
  }

  var quantity = perLine * 4;
  var frequentlyKeys = [];

  for (var key in frequently) {
    if (frequently.hasOwnProperty(key)) {
      frequentlyKeys.push(key);
    }
  }

  var sorted = frequentlyKeys.sort(function (a, b) {
    return frequently[a] - frequently[b];
  }).reverse();
  var sliced = sorted.slice(0, quantity);

  var last = store.get('last');

  if (last && sliced.indexOf(last) == -1) {
    sliced.pop();
    sliced.push(last);
  }

  return sliced;
}

var frequently$1 = { add: add, get: get$1 };

var _Object$1 = Object;

var _extends$2 = _Object$1.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _Object$2 = Object;

var _Object$getPrototypeOf = _Object$2.getPrototypeOf || function (O) {
  O = Object(O);

  if (typeof O.constructor === 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }

  return O instanceof Object ? Object.prototype : null;
};

function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
}

var _Object$3 = Object;

function inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  }

  subClass.prototype = _Object$3.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) {
    _Object$3.setPrototypeOf ? _Object$3.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
}

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty$1 = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty$1.call(it, key);
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx(out, _global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode:  'pure' ,
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var f$1 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$1
};

var isEnum = _objectPie.f;
var _objectToArray = function (isEntries) {
  return function (it) {
    var O = _toIobject(it);
    var keys = _objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!_descriptors || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

// https://github.com/tc39/proposal-object-values-entries

var $values = _objectToArray(false);

_export(_export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

var values = _core.Object.values;

var values$1 = createCommonjsModule(function (module) {
module.exports = { "default": values, __esModule: true };
});

var _Object$values = unwrapExports(values$1);

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _redefine = _hide;

var _iterators = {};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$2 = _global.document;
var _html = document$2 && document$2.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS$1 = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS$1: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if (( FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS$1),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

// call something on iterator step with safe closing on error

var _iterCall = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$1 = _wks('iterator');
var ArrayProto = Array.prototype;

var _isArrayIter = function (it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR$1] === it);
};

var _createProperty = function (object, index, value) {
  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
  else object[index] = value;
};

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$1 = _wks('toStringTag');
// ES3 wrong here
var ARG = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var ITERATOR$2 = _wks('iterator');

var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$2]
    || it['@@iterator']
    || _iterators[_classof(it)];
};

var ITERATOR$3 = _wks('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR$3]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

var _iterDetect = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$3]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$3] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

_export(_export.S + _export.F * !_iterDetect(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = _toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = core_getIteratorMethod(O);
    var length, result, step, iterator;
    if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = _toLength(O.length);
      for (result = new C(length); length > index; index++) {
        _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

var from_1 = _core.Array.from;

var from_1$1 = createCommonjsModule(function (module) {
module.exports = { "default": from_1, __esModule: true };
});

unwrapExports(from_1$1);

var toConsumableArray = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _from2 = _interopRequireDefault(from_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
});

var _toConsumableArray$1 = unwrapExports(toConsumableArray);

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

var isWindowAvailable = typeof window !== 'undefined';

isWindowAvailable && function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];

  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback, element) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = window.setTimeout(function () {
      callback(currTime + timeToCall);
    }, timeToCall);

    lastTime = currTime + timeToCall;
    return id;
  };

  if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
    clearTimeout(id);
  };
}();

var categories$1 = {
  activity: function activity() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      },
      React.createElement("path", { d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113" })
    );
  },

  custom: function custom() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      },
      React.createElement(
        "g",
        { transform: "translate(2.000000, 1.000000)" },
        React.createElement("rect", { id: "Rectangle", x: "8", y: "0", width: "3", height: "21", rx: "1.5" }),
        React.createElement("rect", {
          id: "Rectangle",
          transform: "translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) ",
          x: "8.343",
          y: "0.049",
          width: "3",
          height: "21",
          rx: "1.5"
        }),
        React.createElement("rect", {
          id: "Rectangle",
          transform: "translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) ",
          x: "8.343",
          y: "0.049",
          width: "3",
          height: "21",
          rx: "1.5"
        })
      )
    );
  },

  flags: function flags() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      },
      React.createElement("path", { d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z" })
    );
  },

  foods: function foods() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      },
      React.createElement("path", { d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9" })
    );
  },

  nature: function nature() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      },
      React.createElement("path", { d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8" }),
      React.createElement("path", { d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235" })
    );
  },

  objects: function objects() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      },
      React.createElement("path", { d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z" }),
      React.createElement("path", { d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789" })
    );
  },

  people: function people() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      },
      React.createElement("path", { d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10" }),
      React.createElement("path", { d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0" })
    );
  },

  places: function places() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      },
      React.createElement("path", { d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5" }),
      React.createElement("path", { d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z" })
    );
  },

  recent: function recent() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      },
      React.createElement("path", { d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z" }),
      React.createElement("path", { d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10" })
    );
  },

  symbols: function symbols() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      },
      React.createElement("path", { d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76" })
    );
  }
};

var search = {
  search: function search() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "13",
        viewBox: "0 0 20 20",
        opacity: "0.5"
      },
      React.createElement("path", { d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z" })
    );
  },

  delete: function _delete() {
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "13",
        viewBox: "0 0 20 20",
        opacity: "0.5"
      },
      React.createElement("path", { d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z" })
    );
  }
};

var icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  categories: categories$1,
  search: search
});

var EmojiPropTypes = {
  data: PropTypes.object.isRequired,
  onOver: PropTypes.func,
  onLeave: PropTypes.func,
  onClick: PropTypes.func,
  fallback: PropTypes.func,
  backgroundImageFn: PropTypes.func,
  native: PropTypes.bool,
  forceSize: PropTypes.bool,
  tooltip: PropTypes.bool,
  skin: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  sheetSize: PropTypes.oneOf([16, 20, 32, 64]),
  sheetColumns: PropTypes.number,
  sheetRows: PropTypes.number,
  set: PropTypes.oneOf(['apple', 'google', 'twitter', 'emojione', 'messenger', 'facebook']),
  size: PropTypes.number.isRequired,
  emoji: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};

var PickerPropTypes = {
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  onSkinChange: PropTypes.func,
  perLine: PropTypes.number,
  emojiSize: PropTypes.number,
  i18n: PropTypes.object,
  style: PropTypes.object,
  title: PropTypes.string,
  emoji: PropTypes.string,
  color: PropTypes.string,
  set: EmojiPropTypes.set,
  skin: EmojiPropTypes.skin,
  native: PropTypes.bool,
  backgroundImageFn: EmojiPropTypes.backgroundImageFn,
  sheetSize: EmojiPropTypes.sheetSize,
  emojisToShowFilter: PropTypes.func,
  showPreview: PropTypes.bool,
  showSkinTones: PropTypes.bool,
  emojiTooltip: EmojiPropTypes.tooltip,
  include: PropTypes.arrayOf(PropTypes.string),
  exclude: PropTypes.arrayOf(PropTypes.string),
  recent: PropTypes.arrayOf(PropTypes.string),
  autoFocus: PropTypes.bool,
  custom: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    short_names: PropTypes.arrayOf(PropTypes.string).isRequired,
    emoticons: PropTypes.arrayOf(PropTypes.string),
    keywords: PropTypes.arrayOf(PropTypes.string),
    imageUrl: PropTypes.string,
    spriteUrl: PropTypes.string,
    sheet_x: PropTypes.number,
    sheet_y: PropTypes.number,
    size: PropTypes.number,
    sheetColumns: PropTypes.number,
    sheetRows: PropTypes.number
  })),
  skinEmoji: PropTypes.string,
  notFound: PropTypes.func,
  notFoundEmoji: PropTypes.string,
  icons: PropTypes.object
};

var Anchors = function (_React$PureComponent) {
  inherits(Anchors, _React$PureComponent);

  function Anchors(props) {
    _classCallCheck$3(this, Anchors);

    var _this = possibleConstructorReturn(this, (Anchors.__proto__ || _Object$getPrototypeOf(Anchors)).call(this, props));

    var defaultCategory = props.categories.filter(function (category) {
      return category.first;
    })[0];

    _this.state = {
      selected: defaultCategory.name
    };

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass$3(Anchors, [{
    key: 'handleClick',
    value: function handleClick(e) {
      var index = e.currentTarget.getAttribute('data-index');
      var _props = this.props;
      var categories = _props.categories;
      var onAnchorClick = _props.onAnchorClick;


      onAnchorClick(categories[index], index);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props;
      var categories = _props2.categories;
      var color = _props2.color;
      var i18n = _props2.i18n;
      var icons = _props2.icons;
      var selected = this.state.selected;


      return React.createElement(
        'nav',
        { className: 'emoji-mart-anchors', 'aria-label': i18n.categorieslabel },
        categories.map(function (category, i) {
          var id = category.id;
          var name = category.name;
          var anchor = category.anchor;
          var isSelected = name == selected;

          if (anchor === false) {
            return null;
          }

          var iconId = id.startsWith('custom-') ? 'custom' : id;

          return React.createElement(
            'button',
            {
              key: id,
              'aria-label': i18n.categories[id],
              title: i18n.categories[id],
              'data-index': i,
              type: 'button',
              onClick: _this2.handleClick,
              className: 'emoji-mart-anchor ' + (isSelected ? 'emoji-mart-anchor-selected' : ''),
              style: { color: isSelected ? color : null }
            },
            React.createElement(
              'div',
              { className: 'emoji-mart-anchor-icon' },
              icons.categories[iconId]()
            ),
            React.createElement('span', {
              className: 'emoji-mart-anchor-bar',
              style: { backgroundColor: color }
            })
          );
        })
      );
    }
  }]);

  return Anchors;
}(React.PureComponent);


Anchors.propTypes /* remove-proptypes */ = {
  categories: PropTypes.array,
  onAnchorClick: PropTypes.func,
  icons: PropTypes.object
};

Anchors.defaultProps = {
  categories: [],
  onAnchorClick: function onAnchorClick() {},
  icons: {}
};

var EmojiDefaultProps = {
  skin: 1,
  set: 'apple',
  sheetSize: 64,
  sheetColumns: 52,
  sheetRows: 52,
  native: false,
  forceSize: false,
  tooltip: false,
  backgroundImageFn: function backgroundImageFn(set, sheetSize) {
    return 'https://unpkg.com/emoji-datasource-' + set + '@' + '4.0.4' + '/img/' + set + '/sheets-256/' + sheetSize + '.png';
  }
};

var PickerDefaultProps = {
  onClick: function onClick() {},
  onSelect: function onSelect() {},
  onSkinChange: function onSkinChange() {},
  emojiSize: 24,
  perLine: 9,
  i18n: {},
  style: {},
  title: 'Emoji Mart™',
  emoji: 'department_store',
  color: '#ae65c5',
  set: EmojiDefaultProps.set,
  skin: null,
  defaultSkin: EmojiDefaultProps.skin,
  native: EmojiDefaultProps.native,
  sheetSize: EmojiDefaultProps.sheetSize,
  backgroundImageFn: EmojiDefaultProps.backgroundImageFn,
  emojisToShowFilter: null,
  showPreview: true,
  showSkinTones: true,
  darkMode: !!(typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches),
  emojiTooltip: EmojiDefaultProps.tooltip,
  autoFocus: false,
  custom: [],
  skinEmoji: '',
  notFound: function notFound() {},
  notFoundEmoji: 'sleuth_or_spy',
  icons: {}
};

var _getData = function _getData(props) {
  var emoji = props.emoji;
  var skin = props.skin;
  var set = props.set;
  var data = props.data;

  return getData(emoji, skin, set, data);
};

var _getPosition = function _getPosition(props) {
  var _getData2 = _getData(props);

  var sheet_x = _getData2.sheet_x;
  var sheet_y = _getData2.sheet_y;
  var multiplyX = 100 / (props.sheetColumns - 1);
  var multiplyY = 100 / (props.sheetRows - 1);

  return multiplyX * sheet_x + '% ' + multiplyY * sheet_y + '%';
};

var _getSanitizedData = function _getSanitizedData(props) {
  var emoji = props.emoji;
  var skin = props.skin;
  var set = props.set;
  var data = props.data;

  return getSanitizedData(emoji, skin, set, data);
};

var _handleClick = function _handleClick(e, props) {
  if (!props.onClick) {
    return;
  }
  var onClick = props.onClick;
  var emoji = _getSanitizedData(props);

  onClick(emoji, e);
};

var _handleOver = function _handleOver(e, props) {
  if (!props.onOver) {
    return;
  }
  var onOver = props.onOver;
  var emoji = _getSanitizedData(props);

  onOver(emoji, e);
};

var _handleLeave = function _handleLeave(e, props) {
  if (!props.onLeave) {
    return;
  }
  var onLeave = props.onLeave;
  var emoji = _getSanitizedData(props);

  onLeave(emoji, e);
};

var _isNumeric = function _isNumeric(value) {
  return !isNaN(value - parseFloat(value));
};

var _convertStyleToCSS = function _convertStyleToCSS(style) {
  var div = document.createElement('div');

  for (var key in style) {
    var value = style[key];

    if (_isNumeric(value)) {
      value += 'px';
    }

    div.style[key] = value;
  }

  return div.getAttribute('style');
};

var NimbleEmoji = function NimbleEmoji(props) {
  if (props.data.compressed) {
    uncompress(props.data);
  }

  for (var k in NimbleEmoji.defaultProps) {
    if (props[k] == undefined && NimbleEmoji.defaultProps[k] != undefined) {
      props[k] = NimbleEmoji.defaultProps[k];
    }
  }

  var data = _getData(props);
  if (!data) {
    if (props.fallback) {
      return props.fallback(null, props);
    } else {
      return null;
    }
  }

  var unified = data.unified;
  var custom = data.custom;
  var short_names = data.short_names;
  var imageUrl = data.imageUrl;
  var style = {};
  var children = props.children;
  var className = 'emoji-mart-emoji';
  var nativeEmoji = unified && unifiedToNative(unified);
  // combine the emoji itself and all shortcodes into an accessible label
  var label = [nativeEmoji].concat(short_names).filter(Boolean).join(', ');
  var title = null;

  if (!unified && !custom) {
    if (props.fallback) {
      return props.fallback(data, props);
    } else {
      return null;
    }
  }

  if (props.tooltip) {
    title = short_names[0];
  }

  if (props.native && unified) {
    className += ' emoji-mart-emoji-native';
    style = { fontSize: props.size };
    children = nativeEmoji;

    if (props.forceSize) {
      style.display = 'inline-block';
      style.width = props.size;
      style.height = props.size;
      style.wordBreak = 'keep-all';
    }
  } else if (custom) {
    className += ' emoji-mart-emoji-custom';
    style = {
      width: props.size,
      height: props.size,
      display: 'inline-block'
    };
    if (data.spriteUrl) {
      style = _extends$2({}, style, {
        backgroundImage: 'url(' + data.spriteUrl + ')',
        backgroundSize: 100 * props.sheetColumns + '% ' + 100 * props.sheetRows + '%',
        backgroundPosition: _getPosition(props)
      });
    } else {
      style = _extends$2({}, style, {
        backgroundImage: 'url(' + imageUrl + ')',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      });
    }
  } else {
    var setHasEmoji = data['has_img_' + props.set] == undefined || data['has_img_' + props.set];

    if (!setHasEmoji) {
      if (props.fallback) {
        return props.fallback(data, props);
      } else {
        return null;
      }
    } else {
      style = {
        width: props.size,
        height: props.size,
        display: 'inline-block',
        backgroundImage: 'url(' + props.backgroundImageFn(props.set, props.sheetSize) + ')',
        backgroundSize: 100 * props.sheetColumns + '% ' + 100 * props.sheetRows + '%',
        backgroundPosition: _getPosition(props)
      };
    }
  }

  var Tag = {
    name: 'span',
    props: {}
  };

  if (props.onClick) {
    Tag.name = 'button';
    Tag.props = {
      type: 'button'
    };
  }

  if (props.html) {
    style = _convertStyleToCSS(style);
    return '<' + Tag.name + ' style=\'' + style + '\' aria-label=\'' + label + '\' ' + (title ? 'title=\'' + title + '\'' : '') + ' class=\'' + className + '\'>' + (children || '') + '</' + Tag.name + '>';
  } else {
    return React.createElement(
      Tag.name,
      _extends$2({
        onClick: function onClick(e) {
          return _handleClick(e, props);
        },
        onMouseEnter: function onMouseEnter(e) {
          return _handleOver(e, props);
        },
        onMouseLeave: function onMouseLeave(e) {
          return _handleLeave(e, props);
        },
        'aria-label': label,
        title: title,
        className: className
      }, Tag.props),
      React.createElement(
        'span',
        { style: style },
        children
      )
    );
  }
};

NimbleEmoji.propTypes /* remove-proptypes */ = _extends$2({}, EmojiPropTypes, {
  data: PropTypes.object.isRequired
});
NimbleEmoji.defaultProps = EmojiDefaultProps;

var NotFound = function (_React$PureComponent) {
  inherits(NotFound, _React$PureComponent);

  function NotFound() {
    _classCallCheck$3(this, NotFound);

    return possibleConstructorReturn(this, (NotFound.__proto__ || _Object$getPrototypeOf(NotFound)).apply(this, arguments));
  }

  _createClass$3(NotFound, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var data = _props.data;
      var emojiProps = _props.emojiProps;
      var i18n = _props.i18n;
      var notFound = _props.notFound;
      var notFoundEmoji = _props.notFoundEmoji;


      var component = notFound && notFound() || React.createElement(
        'div',
        { className: 'emoji-mart-no-results' },
        NimbleEmoji(_extends$2({
          data: data
        }, emojiProps, {
          size: 38,
          emoji: notFoundEmoji,
          onOver: null,
          onLeave: null,
          onClick: null
        })),
        React.createElement(
          'div',
          { className: 'emoji-mart-no-results-label' },
          i18n.notfound
        )
      );

      return component;
    }
  }]);

  return NotFound;
}(React.PureComponent);


NotFound.propTypes /* remove-proptypes */ = {
  notFound: PropTypes.func.isRequired,
  emojiProps: PropTypes.object.isRequired
};

var Category = function (_React$Component) {
  inherits(Category, _React$Component);

  function Category(props) {
    _classCallCheck$3(this, Category);

    var _this = possibleConstructorReturn(this, (Category.__proto__ || _Object$getPrototypeOf(Category)).call(this, props));

    _this.data = props.data;
    _this.setContainerRef = _this.setContainerRef.bind(_this);
    _this.setLabelRef = _this.setLabelRef.bind(_this);
    return _this;
  }

  _createClass$3(Category, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.margin = 0;
      this.minMargin = 0;

      this.memoizeSize();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _props = this.props;
      var name = _props.name;
      var perLine = _props.perLine;
      var native = _props.native;
      var hasStickyPosition = _props.hasStickyPosition;
      var emojis = _props.emojis;
      var emojiProps = _props.emojiProps;
      var skin = emojiProps.skin;
      var size = emojiProps.size;
      var set = emojiProps.set;
      var nextPerLine = nextProps.perLine;
      var nextNative = nextProps.native;
      var nextHasStickyPosition = nextProps.hasStickyPosition;
      var nextEmojis = nextProps.emojis;
      var nextEmojiProps = nextProps.emojiProps;
      var nextSkin = nextEmojiProps.skin;
      var nextSize = nextEmojiProps.size;
      var nextSet = nextEmojiProps.set;
      var shouldUpdate = false;

      if (name == 'Recent' && perLine != nextPerLine) {
        shouldUpdate = true;
      }

      if (name == 'Search') {
        shouldUpdate = !(emojis == nextEmojis);
      }

      if (skin != nextSkin || size != nextSize || native != nextNative || set != nextSet || hasStickyPosition != nextHasStickyPosition) {
        shouldUpdate = true;
      }

      return shouldUpdate;
    }
  }, {
    key: 'memoizeSize',
    value: function memoizeSize() {
      if (!this.container) {
        // probably this is a test environment, e.g. jest
        this.top = 0;
        this.maxMargin = 0;
        return;
      }
      var parent = this.container.parentElement;

      var _container$getBoundin = this.container.getBoundingClientRect();

      var top = _container$getBoundin.top;
      var height = _container$getBoundin.height;

      var _parent$getBoundingCl = parent.getBoundingClientRect();

      var parentTop = _parent$getBoundingCl.top;

      var _label$getBoundingCli = this.label.getBoundingClientRect();

      var labelHeight = _label$getBoundingCli.height;


      this.top = top - parentTop + parent.scrollTop;

      if (height == 0) {
        this.maxMargin = 0;
      } else {
        this.maxMargin = height - labelHeight;
      }
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(scrollTop) {
      var margin = scrollTop - this.top;
      margin = margin < this.minMargin ? this.minMargin : margin;
      margin = margin > this.maxMargin ? this.maxMargin : margin;

      if (margin == this.margin) return;

      if (!this.props.hasStickyPosition) {
        this.label.style.top = margin + 'px';
      }

      this.margin = margin;
      return true;
    }
  }, {
    key: 'getEmojis',
    value: function getEmojis() {
      var _this2 = this;

      var _props2 = this.props;
      var name = _props2.name;
      var emojis = _props2.emojis;
      var recent = _props2.recent;
      var perLine = _props2.perLine;


      if (name == 'Recent') {
        var custom = this.props.custom;

        var frequentlyUsed = recent || frequently$1.get(perLine);

        if (frequentlyUsed.length) {
          emojis = frequentlyUsed.map(function (id) {
            var emoji = custom.filter(function (e) {
              return e.id === id;
            })[0];
            if (emoji) {
              return emoji;
            }

            return id;
          }).filter(function (id) {
            return !!getData(id, null, null, _this2.data);
          });
        }

        if (emojis.length === 0 && frequentlyUsed.length > 0) {
          return null;
        }
      }

      if (emojis) {
        emojis = emojis.slice(0);
      }

      return emojis;
    }
  }, {
    key: 'updateDisplay',
    value: function updateDisplay(display) {
      var emojis = this.getEmojis();

      if (!emojis || !this.container) {
        return;
      }

      this.container.style.display = display;
    }
  }, {
    key: 'setContainerRef',
    value: function setContainerRef(c) {
      this.container = c;
    }
  }, {
    key: 'setLabelRef',
    value: function setLabelRef(c) {
      this.label = c;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props;
      var id = _props3.id;
      var name = _props3.name;
      var hasStickyPosition = _props3.hasStickyPosition;
      var emojiProps = _props3.emojiProps;
      var i18n = _props3.i18n;
      var notFound = _props3.notFound;
      var notFoundEmoji = _props3.notFoundEmoji;
      var emojis = this.getEmojis();
      var labelStyles = {};
      var labelSpanStyles = {};
      var containerStyles = {};

      if (!emojis) {
        containerStyles = {
          display: 'none'
        };
      }

      if (!hasStickyPosition) {
        labelStyles = {
          height: 28
        };

        labelSpanStyles = {
          position: 'absolute'
        };
      }

      var label = i18n.categories[id] || name;

      return React.createElement(
        'section',
        {
          ref: this.setContainerRef,
          className: 'emoji-mart-category',
          'aria-label': label,
          style: containerStyles
        },
        React.createElement(
          'div',
          {
            style: labelStyles,
            'data-name': name,
            className: 'emoji-mart-category-label'
          },
          React.createElement(
            'span',
            {
              style: labelSpanStyles,
              ref: this.setLabelRef,
              'aria-hidden': true /* already labeled by the section aria-label */
            },
            label
          )
        ),
        React.createElement(
          'ul',
          { className: 'emoji-mart-category-list' },
          emojis && emojis.map(function (emoji) {
            return React.createElement(
              'li',
              {
                key: emoji.short_names && emoji.short_names.join('_') || emoji
              },
              NimbleEmoji(_extends$2({ emoji: emoji, data: _this3.data }, emojiProps))
            );
          })
        ),
        emojis && !emojis.length && React.createElement(NotFound, {
          i18n: i18n,
          notFound: notFound,
          notFoundEmoji: notFoundEmoji,
          data: this.data,
          emojiProps: emojiProps
        })
      );
    }
  }]);

  return Category;
}(React.Component);


Category.propTypes /* remove-proptypes */ = {
  emojis: PropTypes.array,
  hasStickyPosition: PropTypes.bool,
  name: PropTypes.string.isRequired,
  native: PropTypes.bool.isRequired,
  perLine: PropTypes.number.isRequired,
  emojiProps: PropTypes.object.isRequired,
  recent: PropTypes.arrayOf(PropTypes.string),
  notFound: PropTypes.func,
  notFoundEmoji: PropTypes.string.isRequired
};

Category.defaultProps = {
  emojis: [],
  hasStickyPosition: true
};

var Skins = function (_React$PureComponent) {
  inherits(Skins, _React$PureComponent);

  function Skins(props) {
    _classCallCheck$3(this, Skins);

    var _this = possibleConstructorReturn(this, (Skins.__proto__ || _Object$getPrototypeOf(Skins)).call(this, props));

    _this.state = {
      opened: false
    };
    return _this;
  }

  _createClass$3(Skins, [{
    key: 'handleClick',
    value: function handleClick(e) {
      var skin = parseInt(e.currentTarget.getAttribute('data-skin'));
      var onChange = this.props.onChange;


      if (!this.state.opened) {
        this.setState({ opened: true });
      } else {
        this.setState({ opened: false });
        if (skin != this.props.skin) {
          onChange(skin);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Skins;
}(React.PureComponent);


Skins.propTypes /* remove-proptypes */ = {
  onChange: PropTypes.func,
  skin: PropTypes.number.isRequired
};

Skins.defaultProps = {
  onChange: function onChange() {}
};

var SkinsEmoji = function (_Skins) {
  inherits(SkinsEmoji, _Skins);

  function SkinsEmoji(props) {
    _classCallCheck$3(this, SkinsEmoji);

    var _this = possibleConstructorReturn(this, (SkinsEmoji.__proto__ || _Object$getPrototypeOf(SkinsEmoji)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass$3(SkinsEmoji, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var skin = _props.skin;
      var emojiProps = _props.emojiProps;
      var data = _props.data;
      var skinEmoji = _props.skinEmoji;
      var i18n = _props.i18n;
      var opened = this.state.opened;

      var skinToneNodes = [];

      for (var skinTone = 1; skinTone <= 6; skinTone++) {
        var selected = skinTone === skin;
        skinToneNodes.push(React.createElement(
          'span',
          {
            key: 'skin-tone-' + skinTone,
            className: 'emoji-mart-skin-swatch custom' + (selected ? ' selected' : '')
          },
          React.createElement(
            'span',
            {
              onClick: this.handleClick,
              'data-skin': skinTone,
              className: 'emoji-mart-skin-tone-' + skinTone
            },
            NimbleEmoji({
              emoji: skinEmoji,
              data: data,
              skin: skinTone,
              backgroundImageFn: emojiProps.backgroundImageFn,
              native: emojiProps.native,
              set: emojiProps.set,
              sheetSize: emojiProps.sheetSize,
              size: 23
            })
          )
        ));
      }

      return React.createElement(
        'div',
        {
          className: 'emoji-mart-skin-swatches custom' + (opened ? ' opened' : '')
        },
        React.createElement(
          'div',
          { className: 'emoji-mart-skin-text' + (opened ? ' opened' : '') },
          i18n.skintext
        ),
        skinToneNodes
      );
    }
  }]);

  return SkinsEmoji;
}(Skins);


SkinsEmoji.propTypes /* remove-proptypes */ = {
  onChange: PropTypes.func,
  skin: PropTypes.number.isRequired,
  emojiProps: PropTypes.object.isRequired,
  skinTone: PropTypes.number,
  skinEmoji: PropTypes.string.isRequired,
  i18n: PropTypes.object
};

SkinsEmoji.defaultProps = {
  onChange: function onChange() {},
  skinTone: null
};

var SkinsDot = function (_Skins) {
  inherits(SkinsDot, _Skins);

  function SkinsDot(props) {
    _classCallCheck$3(this, SkinsDot);

    var _this = possibleConstructorReturn(this, (SkinsDot.__proto__ || _Object$getPrototypeOf(SkinsDot)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  _createClass$3(SkinsDot, [{
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      // if either enter or space is pressed, then execute
      if (event.keyCode === 13 || event.keyCode === 32) {
        this.handleClick(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var skin = _props.skin;
      var i18n = _props.i18n;
      var opened = this.state.opened;

      var skinToneNodes = [];

      for (var skinTone = 1; skinTone <= 6; skinTone++) {
        var selected = skinTone === skin;
        var visible = opened || selected;
        skinToneNodes.push(React.createElement(
          'span',
          _extends$2({
            key: 'skin-tone-' + skinTone,
            className: 'emoji-mart-skin-swatch' + (selected ? ' selected' : ''),
            'aria-label': i18n.skintones[skinTone],
            'aria-hidden': !visible
          }, opened ? { role: 'menuitem' } : {}),
          React.createElement('span', _extends$2({
            onClick: this.handleClick,
            onKeyDown: this.handleKeyDown,
            role: 'button'
          }, selected ? {
            'aria-haspopup': true,
            'aria-expanded': !!opened
          } : {}, opened ? { 'aria-pressed': !!selected } : {}, {
            tabIndex: visible ? '0' : '',
            'aria-label': i18n.skintones[skinTone],
            title: i18n.skintones[skinTone],
            'data-skin': skinTone,
            className: 'emoji-mart-skin emoji-mart-skin-tone-' + skinTone
          }))
        ));
      }

      return React.createElement(
        'section',
        {
          className: 'emoji-mart-skin-swatches' + (opened ? ' opened' : ''),
          'aria-label': i18n.skintext
        },
        React.createElement(
          'div',
          opened ? { role: 'menubar' } : {},
          skinToneNodes
        )
      );
    }
  }]);

  return SkinsDot;
}(Skins);


SkinsDot.propTypes /* remove-proptypes */ = {
  onChange: PropTypes.func,
  skin: PropTypes.number.isRequired,
  i18n: PropTypes.object
};

SkinsDot.defaultProps = {
  onChange: function onChange() {}
};

var Preview = function (_React$PureComponent) {
  inherits(Preview, _React$PureComponent);

  function Preview(props) {
    _classCallCheck$3(this, Preview);

    var _this = possibleConstructorReturn(this, (Preview.__proto__ || _Object$getPrototypeOf(Preview)).call(this, props));

    _this.data = props.data;
    _this.state = { emoji: null };
    return _this;
  }

  _createClass$3(Preview, [{
    key: 'render',
    value: function render() {
      var emoji = this.state.emoji;
      var _props = this.props;
      var emojiProps = _props.emojiProps;
      var skinsProps = _props.skinsProps;
      var showSkinTones = _props.showSkinTones;
      var title = _props.title;
      var idleEmoji = _props.emoji;
      var i18n = _props.i18n;
      var showPreview = _props.showPreview;


      if (emoji && showPreview) {
        var emojiData = getData(emoji, null, null, this.data);
        var _emojiData$emoticons = emojiData.emoticons;
        var emoticons = _emojiData$emoticons === undefined ? [] : _emojiData$emoticons;
        var knownEmoticons = [];
        var listedEmoticons = [];

        emoticons.forEach(function (emoticon) {
          if (knownEmoticons.indexOf(emoticon.toLowerCase()) >= 0) {
            return;
          }

          knownEmoticons.push(emoticon.toLowerCase());
          listedEmoticons.push(emoticon);
        });

        return React.createElement(
          'div',
          { className: 'emoji-mart-preview' },
          React.createElement(
            'div',
            { className: 'emoji-mart-preview-emoji', 'aria-hidden': 'true' },
            NimbleEmoji(_extends$2({
              key: emoji.id,
              emoji: emoji,
              data: this.data
            }, emojiProps))
          ),
          React.createElement(
            'div',
            { className: 'emoji-mart-preview-data', 'aria-hidden': 'true' },
            React.createElement(
              'div',
              { className: 'emoji-mart-preview-name' },
              emoji.name
            ),
            React.createElement(
              'div',
              { className: 'emoji-mart-preview-shortnames' },
              emojiData.short_names.map(function (short_name) {
                return React.createElement(
                  'span',
                  { key: short_name, className: 'emoji-mart-preview-shortname' },
                  ':',
                  short_name,
                  ':'
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'emoji-mart-preview-emoticons' },
              listedEmoticons.map(function (emoticon) {
                return React.createElement(
                  'span',
                  { key: emoticon, className: 'emoji-mart-preview-emoticon' },
                  emoticon
                );
              })
            )
          )
        );
      } else {
        return React.createElement(
          'div',
          { className: 'emoji-mart-preview' },
          React.createElement(
            'div',
            { className: 'emoji-mart-preview-emoji', 'aria-hidden': 'true' },
            idleEmoji && idleEmoji.length && NimbleEmoji(_extends$2({ emoji: idleEmoji, data: this.data }, emojiProps))
          ),
          React.createElement(
            'div',
            { className: 'emoji-mart-preview-data', 'aria-hidden': 'true' },
            React.createElement(
              'span',
              { className: 'emoji-mart-title-label' },
              title
            )
          ),
          showSkinTones && React.createElement(
            'div',
            {
              className: 'emoji-mart-preview-skins' + (skinsProps.skinEmoji ? ' custom' : '')
            },
            skinsProps.skinEmoji ? React.createElement(SkinsEmoji, {
              skin: skinsProps.skin,
              emojiProps: emojiProps,
              data: this.data,
              skinEmoji: skinsProps.skinEmoji,
              i18n: i18n,
              onChange: skinsProps.onChange
            }) : React.createElement(SkinsDot, {
              skin: skinsProps.skin,
              i18n: i18n,
              onChange: skinsProps.onChange
            })
          )
        );
      }
    }
  }]);

  return Preview;
}(React.PureComponent);


Preview.propTypes /* remove-proptypes */ = {
  showSkinTones: PropTypes.bool,
  title: PropTypes.string.isRequired,
  emoji: PropTypes.string.isRequired,
  emojiProps: PropTypes.object.isRequired,
  skinsProps: PropTypes.object.isRequired
};

Preview.defaultProps = {
  showSkinTones: true,
  onChange: function onChange() {}
};

var id$1 = 0;

var Search = function (_React$PureComponent) {
  inherits(Search, _React$PureComponent);

  function Search(props) {
    _classCallCheck$3(this, Search);

    var _this = possibleConstructorReturn(this, (Search.__proto__ || _Object$getPrototypeOf(Search)).call(this, props));

    _this.state = {
      icon: search.search,
      isSearching: false,
      id: ++id$1
    };

    _this.data = props.data;
    _this.emojiIndex = new NimbleEmojiIndex(_this.data);
    _this.setRef = _this.setRef.bind(_this);
    _this.clear = _this.clear.bind(_this);
    _this.handleKeyUp = _this.handleKeyUp.bind(_this);

    // throttle keyboard input so that typing isn't delayed
    _this.handleChange = throttleIdleTask(_this.handleChange.bind(_this));
    return _this;
  }

  _createClass$3(Search, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // in some cases (e.g. preact) the input may already be pre-populated
      // this.input is undefined in Jest tests
      if (this.input && this.input.value) {
        this.search(this.input.value);
      }
    }
  }, {
    key: 'search',
    value: function search$1(value) {
      if (value == '') this.setState({
        icon: search.search,
        isSearching: false
      });else this.setState({
        icon: search.delete,
        isSearching: true
      });

      this.props.onSearch(this.emojiIndex.search(value, {
        emojisToShowFilter: this.props.emojisToShowFilter,
        maxResults: this.props.maxResults,
        include: this.props.include,
        exclude: this.props.exclude,
        custom: this.props.custom
      }));
    }
  }, {
    key: 'clear',
    value: function clear() {
      if (this.input.value == '') return;
      this.input.value = '';
      this.input.focus();
      this.search('');
    }
  }, {
    key: 'handleChange',
    value: function handleChange() {
      this.search(this.input.value);
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (e.keyCode === 13) {
        this.clear();
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(c) {
      this.input = c;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var i18n = _props.i18n;
      var autoFocus = _props.autoFocus;
      var _state = this.state;
      var icon = _state.icon;
      var isSearching = _state.isSearching;
      var id = _state.id;

      var inputId = 'emoji-mart-search-' + id;

      return React.createElement(
        'section',
        { className: 'emoji-mart-search', 'aria-label': i18n.search },
        React.createElement('input', {
          id: inputId,
          ref: this.setRef,
          type: 'search',
          onChange: this.handleChange,
          placeholder: i18n.search,
          autoFocus: autoFocus
        }),
        React.createElement(
          'label',
          { className: 'emoji-mart-sr-only', htmlFor: inputId },
          i18n.search
        ),
        React.createElement(
          'button',
          {
            className: 'emoji-mart-search-icon',
            onClick: this.clear,
            onKeyUp: this.handleKeyUp,
            'aria-label': i18n.clear,
            disabled: !isSearching
          },
          icon()
        )
      );
    }
  }]);

  return Search;
}(React.PureComponent);


Search.propTypes /* remove-proptypes */ = {
  onSearch: PropTypes.func,
  maxResults: PropTypes.number,
  emojisToShowFilter: PropTypes.func,
  autoFocus: PropTypes.bool
};

Search.defaultProps = {
  onSearch: function onSearch() {},
  maxResults: 75,
  emojisToShowFilter: null,
  autoFocus: false
};

var I18N = {
  search: 'Search',
  clear: 'Clear', // Accessible label on "clear" button
  notfound: 'No Emoji Found',
  skintext: 'Choose your default skin tone',
  categories: {
    search: 'Search Results',
    recent: 'Frequently Used',
    people: 'Smileys & People',
    nature: 'Animals & Nature',
    foods: 'Food & Drink',
    activity: 'Activity',
    places: 'Travel & Places',
    objects: 'Objects',
    symbols: 'Symbols',
    flags: 'Flags',
    custom: 'Custom'
  },
  categorieslabel: 'Emoji categories', // Accessible title for the list of categories
  skintones: {
    1: 'Default Skin Tone',
    2: 'Light Skin Tone',
    3: 'Medium-Light Skin Tone',
    4: 'Medium Skin Tone',
    5: 'Medium-Dark Skin Tone',
    6: 'Dark Skin Tone'
  }
};

var NimblePicker = function (_React$PureComponent) {
  inherits(NimblePicker, _React$PureComponent);

  function NimblePicker(props) {
    _classCallCheck$3(this, NimblePicker);

    var _this = possibleConstructorReturn(this, (NimblePicker.__proto__ || _Object$getPrototypeOf(NimblePicker)).call(this, props));

    _this.CUSTOM = [];

    _this.RECENT_CATEGORY = { id: 'recent', name: 'Recent', emojis: null };
    _this.SEARCH_CATEGORY = {
      id: 'search',
      name: 'Search',
      emojis: null,
      anchor: false
    };

    if (props.data.compressed) {
      uncompress(props.data);
    }

    _this.data = props.data;
    _this.i18n = deepMerge(I18N, props.i18n);
    _this.icons = deepMerge(icons, props.icons);
    _this.state = {
      skin: props.skin || store.get('skin') || props.defaultSkin,
      firstRender: true
    };

    _this.categories = [];
    var allCategories = [].concat(_this.data.categories);

    if (props.custom.length > 0) {
      var customCategories = {};
      var customCategoriesCreated = 0;

      props.custom.forEach(function (emoji) {
        if (!customCategories[emoji.customCategory]) {
          customCategories[emoji.customCategory] = {
            id: emoji.customCategory ? 'custom-' + emoji.customCategory : 'custom',
            name: emoji.customCategory || 'Custom',
            emojis: [],
            anchor: customCategoriesCreated === 0
          };

          customCategoriesCreated++;
        }

        var category = customCategories[emoji.customCategory];

        var customEmoji = _extends$2({}, emoji, {
          // `<Category />` expects emoji to have an `id`.
          id: emoji.short_names[0],
          custom: true
        });

        category.emojis.push(customEmoji);
        _this.CUSTOM.push(customEmoji);
      });

      allCategories.push.apply(allCategories, _toConsumableArray$1(_Object$values(customCategories)));
    }

    _this.hideRecent = true;

    if (props.include != undefined) {
      allCategories.sort(function (a, b) {
        if (props.include.indexOf(a.id) > props.include.indexOf(b.id)) {
          return 1;
        }

        return -1;
      });
    }

    for (var categoryIndex = 0; categoryIndex < allCategories.length; categoryIndex++) {
      var category = allCategories[categoryIndex];
      var isIncluded = props.include && props.include.length ? props.include.indexOf(category.id) > -1 : true;
      var isExcluded = props.exclude && props.exclude.length ? props.exclude.indexOf(category.id) > -1 : false;
      if (!isIncluded || isExcluded) {
        continue;
      }

      if (props.emojisToShowFilter) {
        var newEmojis = [];

        var emojis = category.emojis;

        for (var emojiIndex = 0; emojiIndex < emojis.length; emojiIndex++) {
          var emoji = emojis[emojiIndex];
          if (props.emojisToShowFilter(_this.data.emojis[emoji] || emoji)) {
            newEmojis.push(emoji);
          }
        }

        if (newEmojis.length) {
          var newCategory = {
            emojis: newEmojis,
            name: category.name,
            id: category.id
          };

          _this.categories.push(newCategory);
        }
      } else {
        _this.categories.push(category);
      }
    }

    var includeRecent = props.include && props.include.length ? props.include.indexOf(_this.RECENT_CATEGORY.id) > -1 : true;
    var excludeRecent = props.exclude && props.exclude.length ? props.exclude.indexOf(_this.RECENT_CATEGORY.id) > -1 : false;
    if (includeRecent && !excludeRecent) {
      _this.hideRecent = false;
      _this.categories.unshift(_this.RECENT_CATEGORY);
    }

    if (_this.categories[0]) {
      _this.categories[0].first = true;
    }

    _this.categories.unshift(_this.SEARCH_CATEGORY);

    _this.setAnchorsRef = _this.setAnchorsRef.bind(_this);
    _this.handleAnchorClick = _this.handleAnchorClick.bind(_this);
    _this.setSearchRef = _this.setSearchRef.bind(_this);
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.setScrollRef = _this.setScrollRef.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.handleScrollPaint = _this.handleScrollPaint.bind(_this);
    _this.handleEmojiOver = _this.handleEmojiOver.bind(_this);
    _this.handleEmojiLeave = _this.handleEmojiLeave.bind(_this);
    _this.handleEmojiClick = _this.handleEmojiClick.bind(_this);
    _this.handleEmojiSelect = _this.handleEmojiSelect.bind(_this);
    _this.setPreviewRef = _this.setPreviewRef.bind(_this);
    _this.handleSkinChange = _this.handleSkinChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  _createClass$3(NimblePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.state.firstRender) {
        this.testStickyPosition();
        this.firstRenderTimeout = setTimeout(function () {
          _this2.setState({ firstRender: false });
        }, 60);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateCategoriesSize();
      this.handleScroll();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.SEARCH_CATEGORY.emojis = null;

      clearTimeout(this.leaveTimeout);
      clearTimeout(this.firstRenderTimeout);
    }
  }, {
    key: 'testStickyPosition',
    value: function testStickyPosition() {
      var stickyTestElement = document.createElement('div');

      var prefixes = ['', '-webkit-', '-ms-', '-moz-', '-o-'];

      prefixes.forEach(function (prefix) {
        return stickyTestElement.style.position = prefix + 'sticky';
      });

      this.hasStickyPosition = !!stickyTestElement.style.position.length;
    }
  }, {
    key: 'handleEmojiOver',
    value: function handleEmojiOver(emoji) {
      var preview = this.preview;

      if (!preview) {
        return;
      }

      // Use Array.prototype.find() when it is more widely supported.
      var emojiData = this.CUSTOM.filter(function (customEmoji) {
        return customEmoji.id === emoji.id;
      })[0];
      for (var key in emojiData) {
        if (emojiData.hasOwnProperty(key)) {
          emoji[key] = emojiData[key];
        }
      }

      preview.setState({ emoji: emoji });
      clearTimeout(this.leaveTimeout);
    }
  }, {
    key: 'handleEmojiLeave',
    value: function handleEmojiLeave(emoji) {
      var preview = this.preview;

      if (!preview) {
        return;
      }

      this.leaveTimeout = setTimeout(function () {
        preview.setState({ emoji: null });
      }, 16);
    }
  }, {
    key: 'handleEmojiClick',
    value: function handleEmojiClick(emoji, e) {
      this.props.onClick(emoji, e);
      this.handleEmojiSelect(emoji);
    }
  }, {
    key: 'handleEmojiSelect',
    value: function handleEmojiSelect(emoji) {
      var _this3 = this;

      this.props.onSelect(emoji);
      if (!this.hideRecent && !this.props.recent) frequently$1.add(emoji);

      var component = this.categoryRefs['category-1'];
      if (component) {
        var maxMargin = component.maxMargin;
        component.forceUpdate();

        window.requestAnimationFrame(function () {
          if (!_this3.scroll) return;
          component.memoizeSize();
          if (maxMargin == component.maxMargin) return;

          _this3.updateCategoriesSize();
          _this3.handleScrollPaint();

          if (_this3.SEARCH_CATEGORY.emojis) {
            component.updateDisplay('none');
          }
        });
      }
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      if (!this.waitingForPaint) {
        this.waitingForPaint = true;
        window.requestAnimationFrame(this.handleScrollPaint);
      }
    }
  }, {
    key: 'handleScrollPaint',
    value: function handleScrollPaint() {
      this.waitingForPaint = false;

      if (!this.scroll) {
        return;
      }

      var activeCategory = null;

      if (this.SEARCH_CATEGORY.emojis) {
        activeCategory = this.SEARCH_CATEGORY;
      } else {
        var target = this.scroll,
            scrollTop = target.scrollTop,
            scrollingDown = scrollTop > (this.scrollTop || 0),
            minTop = 0;

        for (var i = 0, l = this.categories.length; i < l; i++) {
          var ii = scrollingDown ? this.categories.length - 1 - i : i,
              category = this.categories[ii],
              component = this.categoryRefs['category-' + ii];

          if (component) {
            var active = component.handleScroll(scrollTop);

            if (!minTop || component.top < minTop) {
              if (component.top > 0) {
                minTop = component.top;
              }
            }

            if (active && !activeCategory) {
              activeCategory = category;
            }
          }
        }

        if (scrollTop < minTop) {
          activeCategory = this.categories.filter(function (category) {
            return !(category.anchor === false);
          })[0];
        } else if (scrollTop + this.clientHeight >= this.scrollHeight) {
          activeCategory = this.categories[this.categories.length - 1];
        }
      }

      if (activeCategory) {
        var anchors = this.anchors;
        var _activeCategory = activeCategory;
        var categoryName = _activeCategory.name;


        if (anchors.state.selected != categoryName) {
          anchors.setState({ selected: categoryName });
        }
      }

      this.scrollTop = scrollTop;
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(emojis) {
      this.SEARCH_CATEGORY.emojis = emojis;

      for (var i = 0, l = this.categories.length; i < l; i++) {
        var component = this.categoryRefs['category-' + i];

        if (component && component.props.name != 'Search') {
          var display = emojis ? 'none' : 'inherit';
          component.updateDisplay(display);
        }
      }

      this.forceUpdate();
      if (this.scroll) {
        this.scroll.scrollTop = 0;
      }
      this.handleScroll();
    }
  }, {
    key: 'handleAnchorClick',
    value: function handleAnchorClick(category, i) {
      var component = this.categoryRefs['category-' + i];
      var scroll = this.scroll;
      var anchors = this.anchors;
      var scrollToComponent = null;

      scrollToComponent = function scrollToComponent() {
        if (component) {
          var top = component.top;


          if (category.first) {
            top = 0;
          } else {
            top += 1;
          }

          scroll.scrollTop = top;
        }
      };

      if (this.SEARCH_CATEGORY.emojis) {
        this.handleSearch(null);
        this.search.clear();

        window.requestAnimationFrame(scrollToComponent);
      } else {
        scrollToComponent();
      }
    }
  }, {
    key: 'handleSkinChange',
    value: function handleSkinChange(skin) {
      var newState = { skin: skin };
      var onSkinChange = this.props.onSkinChange;


      this.setState(newState);
      store.update(newState);

      onSkinChange(skin);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      var handled = false;

      switch (e.keyCode) {
        case 13:
          var emoji = void 0;

          if (this.SEARCH_CATEGORY.emojis && this.SEARCH_CATEGORY.emojis.length && (emoji = getSanitizedData(this.SEARCH_CATEGORY.emojis[0], this.state.skin, this.props.set, this.props.data))) {
            this.handleEmojiSelect(emoji);
            handled = true;
          }

          break;
      }

      if (handled) {
        e.preventDefault();
      }
    }
  }, {
    key: 'updateCategoriesSize',
    value: function updateCategoriesSize() {
      for (var i = 0, l = this.categories.length; i < l; i++) {
        var component = this.categoryRefs['category-' + i];
        if (component) component.memoizeSize();
      }

      if (this.scroll) {
        var target = this.scroll;
        this.scrollHeight = target.scrollHeight;
        this.clientHeight = target.clientHeight;
      }
    }
  }, {
    key: 'getCategories',
    value: function getCategories() {
      return this.state.firstRender ? this.categories.slice(0, 3) : this.categories;
    }
  }, {
    key: 'setAnchorsRef',
    value: function setAnchorsRef(c) {
      this.anchors = c;
    }
  }, {
    key: 'setSearchRef',
    value: function setSearchRef(c) {
      this.search = c;
    }
  }, {
    key: 'setPreviewRef',
    value: function setPreviewRef(c) {
      this.preview = c;
    }
  }, {
    key: 'setScrollRef',
    value: function setScrollRef(c) {
      this.scroll = c;
    }
  }, {
    key: 'setCategoryRef',
    value: function setCategoryRef(name, c) {
      if (!this.categoryRefs) {
        this.categoryRefs = {};
      }

      this.categoryRefs[name] = c;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props;
      var perLine = _props.perLine;
      var emojiSize = _props.emojiSize;
      var set = _props.set;
      var sheetSize = _props.sheetSize;
      var sheetColumns = _props.sheetColumns;
      var sheetRows = _props.sheetRows;
      var style = _props.style;
      var title = _props.title;
      var emoji = _props.emoji;
      var color = _props.color;
      var native = _props.native;
      var backgroundImageFn = _props.backgroundImageFn;
      var emojisToShowFilter = _props.emojisToShowFilter;
      var showPreview = _props.showPreview;
      var showSkinTones = _props.showSkinTones;
      var emojiTooltip = _props.emojiTooltip;
      var include = _props.include;
      var exclude = _props.exclude;
      var recent = _props.recent;
      var autoFocus = _props.autoFocus;
      var skinEmoji = _props.skinEmoji;
      var notFound = _props.notFound;
      var notFoundEmoji = _props.notFoundEmoji;
      var darkMode = _props.darkMode;
      var skin = this.state.skin;
      var width = perLine * (emojiSize + 12) + 12 + 2 + measureScrollbar();

      return React.createElement(
        'section',
        {
          style: _extends$2({ width: width }, style),
          className: 'emoji-mart ' + (darkMode ? 'emoji-mart-dark' : ''),
          'aria-label': title,
          onKeyDown: this.handleKeyDown
        },
        React.createElement(
          'div',
          { className: 'emoji-mart-bar' },
          React.createElement(Anchors, {
            ref: this.setAnchorsRef,
            data: this.data,
            i18n: this.i18n,
            color: color,
            categories: this.categories,
            onAnchorClick: this.handleAnchorClick,
            icons: this.icons
          })
        ),
        React.createElement(Search, {
          ref: this.setSearchRef,
          onSearch: this.handleSearch,
          data: this.data,
          i18n: this.i18n,
          emojisToShowFilter: emojisToShowFilter,
          include: include,
          exclude: exclude,
          custom: this.CUSTOM,
          autoFocus: autoFocus
        }),
        React.createElement(
          'div',
          {
            ref: this.setScrollRef,
            className: 'emoji-mart-scroll',
            onScroll: this.handleScroll
          },
          this.getCategories().map(function (category, i) {
            return React.createElement(Category, {
              ref: _this4.setCategoryRef.bind(_this4, 'category-' + i),
              key: category.name,
              id: category.id,
              name: category.name,
              emojis: category.emojis,
              perLine: perLine,
              native: native,
              hasStickyPosition: _this4.hasStickyPosition,
              data: _this4.data,
              i18n: _this4.i18n,
              recent: category.id == _this4.RECENT_CATEGORY.id ? recent : undefined,
              custom: category.id == _this4.RECENT_CATEGORY.id ? _this4.CUSTOM : undefined,
              emojiProps: {
                native: native,
                skin: skin,
                size: emojiSize,
                set: set,
                sheetSize: sheetSize,
                sheetColumns: sheetColumns,
                sheetRows: sheetRows,
                forceSize: native,
                tooltip: emojiTooltip,
                backgroundImageFn: backgroundImageFn,
                onOver: _this4.handleEmojiOver,
                onLeave: _this4.handleEmojiLeave,
                onClick: _this4.handleEmojiClick
              },
              notFound: notFound,
              notFoundEmoji: notFoundEmoji
            });
          })
        ),
        (showPreview || showSkinTones) && React.createElement(
          'div',
          { className: 'emoji-mart-bar' },
          React.createElement(Preview, {
            ref: this.setPreviewRef,
            data: this.data,
            title: title,
            emoji: emoji,
            showSkinTones: showSkinTones,
            showPreview: showPreview,
            emojiProps: {
              native: native,
              size: 38,
              skin: skin,
              set: set,
              sheetSize: sheetSize,
              sheetColumns: sheetColumns,
              sheetRows: sheetRows,
              backgroundImageFn: backgroundImageFn
            },
            skinsProps: {
              skin: skin,
              onChange: this.handleSkinChange,
              skinEmoji: skinEmoji
            },
            i18n: this.i18n
          })
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.skin) {
        return _extends$2({}, state, {
          skin: props.skin
        });
      } else if (props.defaultSkin && !store.get('skin')) {
        return _extends$2({}, state, {
          skin: props.defaultSkin
        });
      }
      return state;
    }
  }]);

  return NimblePicker;
}(React.PureComponent);


NimblePicker.propTypes /* remove-proptypes */ = _extends$2({}, PickerPropTypes, {
  data: PropTypes.object.isRequired
});
NimblePicker.defaultProps = _extends$2({}, PickerDefaultProps);

var Picker = function (_React$PureComponent) {
  inherits(Picker, _React$PureComponent);

  function Picker() {
    _classCallCheck$3(this, Picker);

    return possibleConstructorReturn(this, (Picker.__proto__ || _Object$getPrototypeOf(Picker)).apply(this, arguments));
  }

  _createClass$3(Picker, [{
    key: 'render',
    value: function render() {
      return React.createElement(NimblePicker, _extends$2({}, this.props, this.state));
    }
  }]);

  return Picker;
}(React.PureComponent);


Picker.propTypes /* remove-proptypes */ = PickerPropTypes;
Picker.defaultProps = _extends$2({}, PickerDefaultProps, { data: data });

var Emoji = function Emoji(props) {
  for (var k in Emoji.defaultProps) {
    if (props[k] == undefined && Emoji.defaultProps[k] != undefined) {
      props[k] = Emoji.defaultProps[k];
    }
  }

  return NimbleEmoji(_extends$2({}, props));
};

Emoji.propTypes /* remove-proptypes */ = EmojiPropTypes;
Emoji.defaultProps = _extends$2({}, EmojiDefaultProps, { data: data });

var css_248z$3 = ".EmojiPortal_emojiPickerWrapper__FII9h {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100%;\n  z-index: 1000000009;\n  overflow: hidden; }\n  .EmojiPortal_emojiPickerWrapper__FII9h * {\n    -webkit-font-smoothing: antialiased; }\n\n.EmojiPortal_emojiPickerOverlay__1dS9D {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #000;\n  opacity: 0;\n  transition: 0.2s linear; }\n  .EmojiPortal_emojiPickerOverlay__1dS9D.EmojiPortal_emojiPickerActive__33D82 {\n    opacity: 0.1 !important; }\n\n.EmojiPortal_emojiPicker__1E8Gw {\n  position: fixed;\n  transform: translate3d(calc(-100% + 12px), -8px, 0);\n  z-index: 1000000099;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  transition: 0.5s cubic-bezier(0.175, 0.5, 0.12, 1);\n  border-radius: 5px; }\n  .EmojiPortal_emojiPicker__1E8Gw.EmojiPortal_emojiPickerActive__33D82 {\n    opacity: 1;\n    transform: translate3d(calc(-100% - 4px), -8px, 0); }\n\n.emoji-mart,\n.emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15; }\n\n.emoji-mart {\n  font-family: -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  display: inline-block;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff; }\n\n.emoji-mart .emoji-mart-emoji {\n  background: #fff;\n  padding: 6px;\n  border: 0;\n  cursor: pointer;\n  border-image: none; }\n\n.emoji-mart-bar {\n  border: 0 solid #d9d9d9; }\n\n.emoji-mart-bar:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px; }\n\n.emoji-mart-bar:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border: none; }\n\n.emoji-mart-anchors {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0 6px;\n  color: #858585;\n  line-height: 0; }\n\n.emoji-mart-anchor {\n  position: relative;\n  display: block;\n  flex: 1 1 auto;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color 0.1s ease-out;\n  cursor: pointer;\n  border-image: none;\n  outline: none;\n  background: #fff;\n  border: 0; }\n\n.emoji-mart-anchor:hover,\n.emoji-mart-anchor-selected {\n  color: #464646; }\n\n.emoji-mart-anchor-selected .emoji-mart-anchor-bar {\n  bottom: 0; }\n\n.emoji-mart-anchor-bar {\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #464646; }\n\n.emoji-mart-anchors i {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px; }\n\n.emoji-mart-anchors svg {\n  fill: currentColor;\n  max-height: 18px; }\n\n.emoji-mart-scroll {\n  overflow-y: scroll;\n  height: 270px;\n  padding: 0 6px 6px 6px;\n  margin-top: 8px;\n  will-change: transform;\n  /* avoids \"repaints on scroll\" in mobile Chrome */ }\n\n.emoji-mart-search {\n  margin-top: 6px;\n  padding: 0 6px;\n  position: relative; }\n\n.emoji-mart-search input {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: 0.2em 0.6em;\n  border-radius: 25px;\n  border: 1px solid #d9d9d9;\n  outline: 0; }\n\n.emoji-mart-search label {\n  display: none; }\n\n.emoji-mart-search-icon {\n  right: 10px;\n  border: 0;\n  position: absolute;\n  top: 50%;\n  cursor: pointer;\n  transform: translateY(-50%); }\n\n.emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: pointer; }\n\n.emoji-mart-category .emoji-mart-emoji:hover:before {\n  z-index: 0;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%; }\n\n.emoji-mart-category-label {\n  z-index: 2;\n  position: relative;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0; }\n\n.emoji-mart-category-label span {\n  display: block;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.95);\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 14px; }\n\n.emoji-mart-emoji {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n  outline: none; }\n\n.emoji-mart-no-results {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585; }\n\n.emoji-mart-no-results .emoji-mart-category-label {\n  display: none; }\n\n.emoji-mart-no-results .emoji-mart-no-results-label {\n  margin-top: 0.2em; }\n\n.emoji-mart-no-results .emoji-mart-emoji:hover:before {\n  content: none; }\n\n.emoji-mart-preview {\n  position: relative;\n  height: 10px; }\n\n.emoji-mart-preview-emoji,\n.emoji-mart-preview-data,\n.emoji-mart-preview-skins {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%); }\n\n.emoji-mart-preview-emoji {\n  left: 12px; }\n\n.emoji-mart-preview-data {\n  left: 68px;\n  right: 12px;\n  word-break: break-all; }\n\n.emoji-mart-preview-skins {\n  right: 30px;\n  text-align: right; }\n\n.emoji-mart-preview-name {\n  font-size: 14px; }\n\n.emoji-mart-preview-shortname {\n  font-size: 12px;\n  color: #888; }\n\n.emoji-mart-preview-shortname + .emoji-mart-preview-shortname,\n.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,\n.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon {\n  margin-left: 0.5em; }\n\n.emoji-mart-preview-emoticon {\n  font-size: 11px;\n  color: #bbb; }\n\n.emoji-mart-title span {\n  display: inline-block;\n  vertical-align: middle; }\n\n.emoji-mart-title .emoji-mart-emoji {\n  padding: 0; }\n\n.emoji-mart-title-label {\n  color: #999a9c;\n  font-size: 26px;\n  font-weight: 400; }\n\n.emoji-mart-skin-swatches {\n  font-size: 0;\n  padding: 2px 0;\n  border-radius: 12px;\n  background-color: #fff; }\n\n.emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch {\n  width: 16px;\n  padding: 0 2px; }\n\n.emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch-selected:after {\n  opacity: 0.75; }\n\n.emoji-mart-skin-swatch {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: 0.125s;\n  transition-timing-function: ease-out; }\n\n.emoji-mart-skin-swatch:nth-child(1) {\n  transition-delay: 0s; }\n\n.emoji-mart-skin-swatch:nth-child(2) {\n  transition-delay: 0.03s; }\n\n.emoji-mart-skin-swatch:nth-child(3) {\n  transition-delay: 0.06s; }\n\n.emoji-mart-skin-swatch:nth-child(4) {\n  transition-delay: 0.09s; }\n\n.emoji-mart-skin-swatch:nth-child(5) {\n  transition-delay: 0.12s; }\n\n.emoji-mart-skin-swatch:nth-child(6) {\n  transition-delay: 0.15s; }\n\n.emoji-mart-skin-swatch-selected {\n  position: relative;\n  width: 16px;\n  padding: 0 2px; }\n\n.emoji-mart-skin-swatch-selected:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 4px;\n  height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease-out; }\n\n.emoji-mart-skin {\n  display: inline-block;\n  width: 100%;\n  padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%; }\n\n.emoji-mart-skin-tone-1 {\n  background-color: #ffc93a; }\n\n.emoji-mart-skin-tone-2 {\n  background-color: #fadcbc; }\n\n.emoji-mart-skin-tone-3 {\n  background-color: #e0bb95; }\n\n.emoji-mart-skin-tone-4 {\n  background-color: #bf8f68; }\n\n.emoji-mart-skin-tone-5 {\n  background-color: #9b643d; }\n\n.emoji-mart-skin-tone-6 {\n  background-color: #594539; }\n\n.emoji-mart-category-list {\n  display: flex;\n  list-style-type: none;\n  flex-wrap: wrap;\n  padding: 0 6px;\n  margin: 6px 0 18px; }\n  .emoji-mart-category-list > li {\n    margin: 2px 0; }\n";
var styles$3 = {"emojiPickerWrapper":"EmojiPortal_emojiPickerWrapper__FII9h","emojiPickerOverlay":"EmojiPortal_emojiPickerOverlay__1dS9D","emojiPickerActive":"EmojiPortal_emojiPickerActive__33D82","emojiPicker":"EmojiPortal_emojiPicker__1E8Gw"};
styleInject$1(css_248z$3);

var _dec, _class;
var EMOJI_BAR_HEIGHT = 420;
var EmojiPortal = (_dec = Activify(), _dec(_class = /*#__PURE__*/function (_React$Component) {
  function EmojiPortal() {
    var _this;
    _classCallCheck$4(this, EmojiPortal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EmojiPortal, [].concat(args));
    _defineProperty$1(_this, "_handleSelect", function (emoji) {
      _this.props.onSelect(emoji["native"]);
    });
    _defineProperty$1(_this, "_handleKeyUp", function (e) {
      if (e.keyCode === KEY_CODES.ESC) {
        _this.props.onOverlayClick();
      }
    });
    _defineProperty$1(_this, "_createEmojiContainer", function () {
      _this._el = document.getElementById("emoji-container");
      if (!_this._el) {
        _this._el = document.createElement("div");
        _this._el.setAttribute("id", "emoji-container");
        document.body.appendChild(_this._el);
      }
    });
    return _this;
  }
  _inherits$3(EmojiPortal, _React$Component);
  return _createClass$4(EmojiPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._createEmojiContainer();
      document.addEventListener("keyup", this._handleKeyUp);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keyup", this._handleKeyUp);
    }
  }, {
    key: "render",
    value: function render() {
      if (!document.getElementById("emoji-container")) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Portal$3, {
        node: document && document.getElementById("emoji-container")
      }, this.renderPortalContainer());
    }
  }, {
    key: "renderPortalContainer",
    value: function renderPortalContainer() {
      var activeClassName = this.props.active ? styles$3.emojiPickerActive : "";
      var top = this.props.attachToRect.top;
      if (top + EMOJI_BAR_HEIGHT > window.innerHeight) {
        top -= top + EMOJI_BAR_HEIGHT - window.innerHeight + 32;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: styles$3.emojiPickerWrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3.emojiPickerOverlay, " ").concat(activeClassName),
        onClick: this.props.onOverlayClick
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3.emojiPicker, " ").concat(activeClassName),
        style: {
          left: this.props.attachToRect.left,
          top: top
        }
      }, /*#__PURE__*/React.createElement(Picker, {
        onSelect: this._handleSelect,
        emoji: "",
        "native": true,
        showPreview: false,
        title: "",
        color: "#0E4498"
      })));
    }
  }]);
}(React.Component)) || _class);
EmojiPortal.propTypes = {
  onOverlayClick: PropTypes.func,
  active: PropTypes.bool,
  attachToRect: PropTypes.object,
  onSelect: PropTypes.func
};
EmojiPortal.defaultProps = {
  onOverlayClick: function onOverlayClick() {},
  active: false,
  onSelect: function onSelect() {}
};
EmojiPortal.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "renderPortalContainer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_handleSelect",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "emoji",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleKeyUp",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_createEmojiContainer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "EmojiPortal",
  "props": {
    "onOverlayClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onSelect": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "attachToRect": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

var EmojiPicker = function EmojiPicker() {
  return function (WrappedComponent) {
    return /*#__PURE__*/function (_React$Component) {
      function _class() {
        var _this;
        _classCallCheck$4(this, _class);
        _this = _callSuper(this, _class);
        _defineProperty$1(_this, "activateEmojiPicker", function (emojiIconRect, callback) {
          _this.setState({
            pickerActive: true,
            emojiIconRect: emojiIconRect
          });
          _this._callback = callback;
        });
        _defineProperty$1(_this, "deactivateEmojiPicker", function (e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          _this.setState({
            pickerActive: false
          });
        });
        _defineProperty$1(_this, "_renderEmojiPicker", function () {
          return /*#__PURE__*/React.createElement(EmojiPortal, {
            attachToRect: _this.state.emojiIconRect,
            active: _this.state.pickerActive,
            onClose: _this.deactivateEmojiPicker,
            onOverlayClick: _this.deactivateEmojiPicker,
            onSelect: function onSelect(emoji) {
              _this._callback(emoji);
              _this.deactivateEmojiPicker();
            }
          });
        });
        _this.state = {
          pickerActive: false,
          emojiIconRect: {}
        };
        return _this;
      }
      _inherits$3(_class, _React$Component);
      return _createClass$4(_class, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WrappedComponent, _extends$9({}, this.props, {
            activateEmojiPicker: this.activateEmojiPicker
          })), this._renderEmojiPicker());
        }
      }]);
    }(React.Component);
  };
};

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var EmojiIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$3({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#333",
  strokeLinejoin: "round",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: "9",
  cy: "8.791",
  fill: "#FFF",
  strokeLinecap: "square",
  rx: "9",
  ry: "8.791"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5.287",
  cy: "6.879",
  fill: "#FFF",
  strokeLinecap: "square",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12.488",
  cy: "6.879",
  fill: "#FFF",
  strokeLinecap: "square",
  r: "1"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M4.765 11.894S5.783 14.407 9 14.48a4.377 4.377 0 004.235-2.586"
}))));

var _dec$1, _class$1;
var EmojiTrigger = (_dec$1 = EmojiPicker(), _dec$1(_class$1 = /*#__PURE__*/function (_React$Component) {
  function EmojiTrigger() {
    var _this;
    _classCallCheck$4(this, EmojiTrigger);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EmojiTrigger, [].concat(args));
    _defineProperty$1(_this, "handleTrigger", function () {
      _this.props.activateEmojiPicker(_this._emojiIcon.getBoundingClientRect(), function (emoji) {
        _this.handleEmojiSelect(emoji);
      });
    });
    _defineProperty$1(_this, "handleEmojiSelect", function (emoji) {
      var _this$props = _this.props,
        elem = _this$props.elem,
        onSelect = _this$props.onSelect;
      var newElemObj = insertAtSelection({
        selectionStart: elem.current.selectionStart,
        selectionEnd: elem.current.selectionEnd,
        value: elem.current.value,
        insertString: emoji
      });
      sendGoogleAnalyticsEvents({
        eventCategory: GA.CATEGORIES.RICH_TEXT_EDITOR,
        eventAction: GA.ACTIONS.EMOJI,
        eventLabel: GA.LABEL.SELECT_EMOJI,
        eventValue: 0
      });
      onSelect(newElemObj);
    });
    return _this;
  }
  _inherits$3(EmojiTrigger, _React$Component);
  return _createClass$4(EmojiTrigger, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement(Icon, {
        innerRef: function innerRef(DOMElement) {
          _this2._emojiIcon = DOMElement;
        },
        onClick: this.handleTrigger,
        src: EmojiIcon,
        className: this.props.className
      });
    }
  }]);
}(React.Component)) || _class$1);
EmojiTrigger.propTypes = {
  className: PropTypes.string,
  elem: PropTypes.shape({
    current: PropTypes.shape({
      selectionStart: PropTypes.number,
      selectionEnd: PropTypes.number,
      value: PropTypes.string
    })
  }),
  onSelect: PropTypes.func,
  activateEmojiPicker: PropTypes.func
};
EmojiTrigger.defaultProps = {
  className: "",
  elem: {},
  onSelect: function onSelect() {},
  activateEmojiPicker: function activateEmojiPicker() {}
};
EmojiTrigger.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleTrigger",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleEmojiSelect",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "emoji",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "EmojiTrigger",
  "props": {
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "elem": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "shape",
            "value": {
              "selectionStart": {
                "name": "number",
                "required": false
              },
              "selectionEnd": {
                "name": "number",
                "required": false
              },
              "value": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "onSelect": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateEmojiPicker": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$4 = ".List_list__2pc5G {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  overflow-y: auto;\n  width: 100%;\n  box-sizing: border-box; }\n  .List_listItem__200FJ {\n    transition: background-color 300ms ease-in;\n    background-color: white;\n    position: relative;\n    display: flex;\n    align-items: flex-start;\n    cursor: pointer;\n    border-top: 1px solid #ddd;\n    padding: 10px 15px; }\n    .List_listItem__200FJ > .List_list__2pc5G {\n      margin-left: 15px; }\n    .List_listItemAction__3PaSK {\n      display: none;\n      margin-left: auto;\n      box-sizing: border-box; }\n  .List_listItem__200FJ:last-child {\n    border-bottom: 1px solid #ddd; }\n  .List_listItem__200FJ.List_active__1cSWd {\n    background-color: rgba(32, 156, 255, 0.1); }\n  .List_listItem__200FJ:not(.List_active__1cSWd):hover {\n    background-color: #eee; }\n  .List_listItem__200FJ:hover .List_listItemAction__3PaSK {\n    display: flex; }\n";
var styles$4 = {"list":"List_list__2pc5G","listItem":"List_listItem__200FJ","listItemAction":"List_listItemAction__3PaSK","active":"List_active__1cSWd"};
styleInject$1(css_248z$4);

var ListItemAction = function ListItemAction(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$4.listItemAction
  }, children);
};
var ListItemContent = function ListItemContent(_ref2) {
  var children = _ref2.children,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? "" : _ref2$className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$4.listItemContent, " ").concat(className)
  }, children);
};
var ListItem = /*#__PURE__*/function (_React$Component) {
  function ListItem() {
    _classCallCheck$4(this, ListItem);
    return _callSuper(this, ListItem, arguments);
  }
  _inherits$3(ListItem, _React$Component);
  return _createClass$4(ListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        onClick = _this$props.onClick,
        _this$props$className = _this$props.className,
        className = _this$props$className === void 0 ? "" : _this$props$className;
      return /*#__PURE__*/React.createElement("li", {
        className: "".concat(styles$4.listItem, " ").concat(className),
        onClick: onClick
      }, children);
    }
  }]);
}(React.Component);
_defineProperty$1(ListItem, "Action", ListItemAction);
_defineProperty$1(ListItem, "Content", ListItemContent);
var List = /*#__PURE__*/function (_React$Component2) {
  function List() {
    _classCallCheck$4(this, List);
    return _callSuper(this, List, arguments);
  }
  _inherits$3(List, _React$Component2);
  return _createClass$4(List, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("ul", {
        className: styles$4.list
      }, this.props.children);
    }
  }]);
}(React.Component);
_defineProperty$1(List, "Item", ListItem);
List.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "List"
};

var css_248z$5 = ".EntityPicker-v2_entityListHeader__1qbdg {\n  display: flex;\n  flex-direction: row; }\n  .EntityPicker-v2_entityListHeader__1qbdg .EntityPicker-v2_entityListTitle__36cJ3 {\n    text-align: center; }\n\n.EntityPicker-v2_entityListBody__VW9Up {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 61px); }\n  .EntityPicker-v2_entityListBody__VW9Up .EntityPicker-v2_searchWrapper__58ghs {\n    position: relative;\n    z-index: 1;\n    box-shadow: 0 2px 3px #ddd; }\n    .EntityPicker-v2_entityListBody__VW9Up .EntityPicker-v2_searchWrapper__58ghs .EntityPicker-v2_search__38COL {\n      margin: 10px 15px;\n      flex: 0; }\n  .EntityPicker-v2_entityListBody__VW9Up .EntityPicker-v2_subListItem__1-TB- {\n    padding-left: 20px; }\n  .EntityPicker-v2_entityListBody__VW9Up .EntityPicker-v2_description__2A8QS {\n    color: #aaaaaa; }\n  .EntityPicker-v2_entityListBody__VW9Up .EntityPicker-v2_title__3WyyC {\n    font-size: 14px; }\n  .EntityPicker-v2_entityListBody__VW9Up .EntityPicker-v2_title__3WyyC,\n  .EntityPicker-v2_entityListBody__VW9Up .EntityPicker-v2_description__2A8QS {\n    word-break: break-all; }\n";
var styles$5 = {"entityListHeader":"EntityPicker-v2_entityListHeader__1qbdg","entityListTitle":"EntityPicker-v2_entityListTitle__36cJ3","entityListBody":"EntityPicker-v2_entityListBody__VW9Up","searchWrapper":"EntityPicker-v2_searchWrapper__58ghs","search":"EntityPicker-v2_search__38COL","subListItem":"EntityPicker-v2_subListItem__1-TB-","description":"EntityPicker-v2_description__2A8QS","title":"EntityPicker-v2_title__3WyyC"};
styleInject$1(css_248z$5);

var STATIC_ENTITIES = [{
  format: "%full_name",
  description: "full name of user"
}, {
  format: "%name",
  description: "full name of user"
}, {
  format: "%email",
  description: "email of user"
}, {
  format: "%mobile_no",
  description: "mobile number of user"
}, {
  format: "%city",
  description: "city of user"
}, {
  format: "%date",
  description: "date in mmm dd format E.g. Mar 5"
}, {
  format: "%time",
  description: "time in hh:mm nn format E.g. 7:05 am"
}, {
  format: "%timeofday",
  // eslint-disable-next-line max-len
  description: "morning' when time is between 4 am to 12 pm, 'afternoon' when time is between 12 pm to 5 pm and evening for the 5 pm to 4 am"
}];
var EntityPicker = /*#__PURE__*/function (_React$Component) {
  function EntityPicker() {
    var _this;
    _classCallCheck$4(this, EntityPicker);
    _this = _callSuper(this, EntityPicker);
    _defineProperty$1(_this, "fetchEntities", function () {
      if (_this.state.fetched) return;
      var entitySearchURL = _this.props.entitySearchURL;
      var search = entitySearchURL.search,
        map = entitySearchURL.map;
      if (search && map) {
        var options = {
          method: "GET"
        };
        var allRequests = [fetch(search, options).then(function (response) {
          return response.json();
        }), fetch(map, options).then(function (response) {
          return response.json();
        })];
        Promise.all(allRequests).then(function (responseArr) {
          var customEntityList = responseArr[0].body;
          var entityFormat = responseArr[1].body;
          var entities = customEntityList.reduce(function (acc, item) {
            var newItem = {
              format: "%entitytag_".concat(item.name),
              description: item.description
            };
            if (entityFormat.hasOwnProperty(item.entity_type)) {
              newItem.formats = entityFormat[item.entity_type].map(function (formatItem) {
                return _objectSpread2$1(_objectSpread2$1({}, formatItem), {}, {
                  format: "".concat(newItem.format, "@").concat(formatItem.format)
                });
              });
            }
            acc = [].concat(_toConsumableArray$2(acc), [newItem]);
            return acc;
          }, []);
          if (entities.length) {
            _this.setState(function (state) {
              return {
                entities: [].concat(_toConsumableArray$2(state.entities), _toConsumableArray$2(entities)),
                fetched: true
              };
            });
          }
        });
      }
    });
    _defineProperty$1(_this, "closePicker", function () {
      return _this.setState({
        active: false
      });
    });
    _defineProperty$1(_this, "openPicker", function () {
      return _this.setState({
        active: true
      }, _this.fetchEntities);
    });
    _defineProperty$1(_this, "handleSearch", function (value) {
      return _this.setState({
        searchString: value.trim()
      });
    });
    _defineProperty$1(_this, "getFilteredEntities", function () {
      var _this$state = _this.state,
        searchString = _this$state.searchString,
        entities = _this$state.entities;
      if (!searchString) return entities;
      return entities.reduce(function (acc, entity) {
        if (entity.hasOwnProperty("formats")) {
          var searchedFormats = entity.formats.filter(function (formatItem) {
            return formatItem.format.includes(searchString);
          });
          if (searchedFormats.length) {
            acc = [].concat(_toConsumableArray$2(acc), [_objectSpread2$1(_objectSpread2$1({}, entity), {}, {
              formats: searchedFormats
            })]);
          }
        } else if (entity.format.includes(searchString)) {
          acc = [].concat(_toConsumableArray$2(acc), [entity]);
        }
        return acc;
      }, []);
    });
    _defineProperty$1(_this, "renderEntityDrawer", function () {
      var _this$state2 = _this.state,
        active = _this$state2.active,
        searchString = _this$state2.searchString;
      var entities = _this.getFilteredEntities();
      return /*#__PURE__*/React.createElement(Drawer, {
        zIndex: 10002,
        active: active,
        onClose: _this.closePicker,
        width: 400
      }, /*#__PURE__*/React.createElement(Drawer.Header, null, /*#__PURE__*/React.createElement(Button, {
        onClick: _this.closePicker,
        secondary: true
      }, "Cancel"), "\xA0\xA0 Pick Entity"), /*#__PURE__*/React.createElement("div", {
        className: styles$5.entityListBody
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$5.searchWrapper
      }, /*#__PURE__*/React.createElement(Search$1, {
        onType: _this.handleSearch,
        className: styles$5.search,
        searchTerm: searchString,
        placeholder: "Search entities"
      })), /*#__PURE__*/React.createElement(List, null, entities.map(function (entity, i) {
        if (entity.formats) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(List.Item, null, /*#__PURE__*/React.createElement(List.Item.Content, null, /*#__PURE__*/React.createElement(Label, null, entity.description), /*#__PURE__*/React.createElement("small", {
            className: styles$5.description
          }))), entity.formats.map(function (format, j) {
            return /*#__PURE__*/React.createElement(List.Item, {
              key: "".concat(format.format, "-").concat(j),
              onClick: function onClick(e) {
                return _this.handleItemClick(e, format);
              }
            }, /*#__PURE__*/React.createElement(List.Item.Content, null, /*#__PURE__*/React.createElement("div", {
              className: styles$5.subListItem
            }, /*#__PURE__*/React.createElement("div", {
              className: styles$5.title
            }, format.format), /*#__PURE__*/React.createElement("small", {
              className: styles$5.description
            }, format.description))));
          }));
        }
        return /*#__PURE__*/React.createElement(List.Item, {
          key: "".concat(entity.format, "-").concat(i),
          onClick: function onClick(e) {
            return _this.handleItemClick(e, entity);
          }
        }, /*#__PURE__*/React.createElement(List.Item.Content, null, /*#__PURE__*/React.createElement("div", {
          className: styles$5.title
        }, entity.format), /*#__PURE__*/React.createElement("small", {
          className: styles$5.description
        }, entity.description)));
      }))));
    });
    _defineProperty$1(_this, "handleSelect", function (entity) {
      var _this$props = _this.props,
        elem = _this$props.elem,
        onSelect = _this$props.onSelect;
      var newElemObj = insertAtSelection({
        selectionStart: elem.current.selectionStart,
        selectionEnd: elem.current.selectionEnd,
        value: elem.current.value,
        insertString: entity,
        suffix: " ",
        prefix: " "
      });
      sendGoogleAnalyticsEvents({
        eventCategory: GA.CATEGORIES.RICH_TEXT_EDITOR,
        eventAction: GA.ACTIONS.ENTITY,
        eventLabel: GA.LABEL.SELECT_ENTITY,
        eventValue: 0
      });
      onSelect(newElemObj);
      _this.closePicker();
    });
    _defineProperty$1(_this, "handleItemClick", function (e, item) {
      e.stopPropagation();
      _this.handleSelect(item.format);
    });
    _this.state = {
      active: false,
      fetched: false,
      entities: [].concat(STATIC_ENTITIES)
    };
    return _this;
  }
  _inherits$3(EntityPicker, _React$Component);
  return _createClass$4(EntityPicker, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.active !== nextState.active || this.state.entities !== nextState.entities || this.state.searchString !== nextState.searchString;
    }
  }, {
    key: "render",
    value: function render() {
      var entitySearchURL = this.props.entitySearchURL;
      if (!entitySearchURL) return null;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.openPicker,
        type: Button.TYPES.SECONDARY
      }, "Add Entity"), this.renderEntityDrawer());
    }
  }]);
}(React.Component);
EntityPicker.propTypes = {
  elem: PropTypes.node.isRequired,
  onSelect: PropTypes.func.isRequired,
  entitySearchURL: PropTypes.shape({
    search: PropTypes.string,
    map: PropTypes.string
  })
};
EntityPicker.defaultProps = {
  entitySearchURL: null
};
EntityPicker.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "fetchEntities",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "closePicker",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "openPicker",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleSearch",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getFilteredEntities",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "renderEntityDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleSelect",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "entity",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleItemClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }, {
      "name": "item",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "EntityPicker",
  "props": {
    "entitySearchURL": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "search": {
            "name": "string",
            "required": false
          },
          "map": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "elem": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "onSelect": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};

var css_248z$6 = ".InputHeader_entityPicker__1jFhi {\n  margin: 0; }\n  .InputHeader_entityPicker__1jFhi > div {\n    padding: 0 8px; }\n";
var styles$6 = {"entityPicker":"InputHeader_entityPicker__1jFhi"};
styleInject$1(css_248z$6);

/*
 * It's a generic wrapper to pass-on on select method to any picker
 * component that returns a value. This is used to modify HSL content
 */
var PickerWrapper = /*#__PURE__*/function (_Component) {
  function PickerWrapper() {
    var _this;
    _classCallCheck$4(this, PickerWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PickerWrapper, [].concat(args));
    _defineProperty$1(_this, "_handleSelect", function (data) {
      var _this$props = _this.props,
        element = _this$props.element,
        onSelect = _this$props.onSelect;
      var newElemObj = insertAtSelection({
        selectionStart: element.current.selectionStart,
        selectionEnd: element.current.selectionEnd,
        value: element.current.value,
        insertString: data,
        suffix: " ",
        prefix: " "
      });
      onSelect(newElemObj);
    });
    return _this;
  }
  _inherits$3(PickerWrapper, _Component);
  return _createClass$4(PickerWrapper, [{
    key: "render",
    value: function render() {
      var picker = this.props.picker;
      return /*#__PURE__*/React.cloneElement(picker, {
        onSelect: this._handleSelect
      });
    }
  }]);
}(Component);
PickerWrapper.propTypes = {
  picker: PropTypes.element.isRequired,
  onSelect: PropTypes.func.isRequired,
  element: PropTypes.shape({
    current: PropTypes.shape({
      selectionStart: PropTypes.number,
      selectionEnd: PropTypes.number,
      value: PropTypes.string
    })
  }).isRequired
};
PickerWrapper.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_handleSelect",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "data",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "PickerWrapper",
  "props": {
    "picker": {
      "type": {
        "name": "element"
      },
      "required": true,
      "description": ""
    },
    "onSelect": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "element": {
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "shape",
            "value": {
              "selectionStart": {
                "name": "number",
                "required": false
              },
              "selectionEnd": {
                "name": "number",
                "required": false
              },
              "value": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": true,
      "description": ""
    }
  }
};

var MIXPANEL_GLOBALCONSTANT_ADDITION = "CS_GlobalConstant_Addition";
function GlobalConstantsPicker(_ref) {
  var elem = _ref.elem,
    onSelect = _ref.onSelect,
    apiUrl = _ref.apiUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray$2(_useState, 2),
    isDrawerActive = _useState2[0],
    setIsDrawerActive = _useState2[1];
  var closeDrawer = function closeDrawer() {
    return setIsDrawerActive(false);
  };

  // When user selects a constant
  var handleSelect = function handleSelect(constantKey) {
    var _window$mixpanel;
    var newElemObj = insertAtSelection({
      selectionStart: elem.current.selectionStart,
      selectionEnd: elem.current.selectionEnd,
      value: elem.current.value,
      insertString: constantKey,
      suffix: " ",
      prefix: " ~"
    });
    onSelect(newElemObj);

    // Mixpanel Event
    var botData = JSON.parse(localStorage.getItem("ww_iva"));
    (_window$mixpanel = window.mixpanel) === null || _window$mixpanel === void 0 || _window$mixpanel.track(MIXPANEL_GLOBALCONSTANT_ADDITION, {
      "Bot Name": botData === null || botData === void 0 ? void 0 : botData.title,
      "Bot Account": botData === null || botData === void 0 ? void 0 : botData.client
    });
    closeDrawer();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    type: Button.TYPES.SECONDARY,
    onClick: function onClick() {
      return setIsDrawerActive(true);
    }
  }, "Add Bot Variable"), /*#__PURE__*/React.createElement(Drawer, {
    active: isDrawerActive,
    onClose: closeDrawer,
    zIndex: 10002,
    width: 400
  }, /*#__PURE__*/React.createElement(Drawer.Header, null, /*#__PURE__*/React.createElement(Icon, {
    src: "close",
    onClick: closeDrawer,
    style: {
      cursor: "pointer"
    }
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "h3.semi-bold",
    color: "black.haptik",
    style: {
      marginLeft: "16px"
    }
  }, "Select Bot Variables")), /*#__PURE__*/React.createElement(GlobalConstants, {
    apiUrl: apiUrl,
    onSelect: handleSelect,
    isSelectMode: true
  })));
}
GlobalConstantsPicker.propTypes = {
  /** Node Element to get the value of response */
  elem: PropTypes.node.isRequired,
  /** Handles Constant Select Event */
  onSelect: PropTypes.func.isRequired,
  /** API Endpoint for the Global Constants */
  apiUrl: PropTypes.string
};
GlobalConstantsPicker.defaultProps = {
  apiUrl: ""
};

var InputHeader = function InputHeader(_ref) {
  var entitySearchURL = _ref.entitySearchURL,
    element = _ref.element,
    onSelect = _ref.onSelect,
    jsonPickerButton = _ref.jsonPickerButton,
    globalConstantsURL = _ref.globalConstantsURL,
    displayGlobalConstantSelect = _ref.displayGlobalConstantSelect;
  return [/*#__PURE__*/React.createElement(BoldAction, {
    elem: element,
    onSelect: onSelect
  }), /*#__PURE__*/React.createElement(EmojiTrigger, {
    elem: element,
    onSelect: onSelect,
    className: styles$6.emojiIcon
  }),
  // component should not mount if no Url is provided
  entitySearchURL ? /*#__PURE__*/React.createElement(EntityPicker, {
    elem: element,
    onSelect: onSelect,
    entitySearchURL: entitySearchURL
  }) : false, displayGlobalConstantSelect ? /*#__PURE__*/React.createElement(GlobalConstantsPicker, {
    elem: element,
    onSelect: onSelect,
    apiUrl: globalConstantsURL
  }) : false, jsonPickerButton ? /*#__PURE__*/React.createElement(PickerWrapper, {
    picker: jsonPickerButton,
    element: element,
    onSelect: onSelect
  }) : false].filter(function (item) {
    return !!item;
  });
}; // to eliminate non-truthy element from array

var emojiRegex = function () {
	// https://mathiasbynens.be/notes/es-unicode-property-escapes#emoji
	return (/\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]\uFE0F|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F/g
	);
};

var emojiRegex$1 = emojiRegex();

function emojiStrip (string) {
  return string.replace(emojiRegex$1, '')
}

var emojiStrip_1 = emojiStrip;

var AudioFormats = {
  ogg_vorbis: "audio/ogg",
  mp3: "audio/mpeg",
  pcm: "audio/wave; codecs=1"
};
var cleanMessage = function cleanMessage(text) {
  var cleanText = "";
  if (text && text.indexOf("{chatform}") > -1) cleanText = "";else if (text && text.indexOf("{image}") > -1) cleanText = "";else cleanText = text;
  var emojiRegex = /([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g;
  var urlRegex = /(?:https?|ftp):\/\/[\n\S]+/g;
  cleanText = cleanText.replace(emojiRegex, "").replace(urlRegex, "").replace(/\*/g, "").replace(/-/g, "").replace(/⏱/g, "").replace(/&/g, "and");
  return emojiStrip_1(cleanText);
};
var getSupportedAudioFormats = function getSupportedAudioFormats() {
  var player = document.createElement("audio");
  return Object.keys(AudioFormats).filter(function (format) {
    var supported = player.canPlayType(AudioFormats[format]);
    return supported === "probably" || supported === "maybe";
  });
};
var generateURL = function generateURL(text) {
  var supportedFormats = getSupportedAudioFormats();
  var baseURL = ENDPOINTS.SYNTHESIS_ENDPOINT;
  var voiceType = "Raveena";
  var voiceParams = "&format=".concat(supportedFormats[0], "&type=").concat(voiceType);
  var audioURL = "".concat(baseURL, "?text=").concat(encodeURI(text)).concat(voiceParams);
  return audioURL;
};

var VoicePlayer = function VoicePlayer(_ref) {
  var text = _ref.text,
    onEnd = _ref.onEnd;
  if (!text) return null;
  var cleanedMessage = cleanMessage(text);
  var src = generateURL(cleanedMessage);
  return /*#__PURE__*/React.createElement("audio", {
    key: src,
    src: src,
    autoPlay: true,
    onEnded: onEnd
  }, /*#__PURE__*/React.createElement("track", {
    "default": true,
    kind: "captions",
    srcLang: "en"
  }), "Sorry, your browser does not support embedded audio.");
};
VoicePlayer.propTypes = {
  text: PropTypes.object,
  onEnd: PropTypes.object
};
VoicePlayer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VoicePlayer",
  "props": {
    "text": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "onEnd": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var speakerIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$4({
  width: "94",
  height: "68",
  viewBox: "0 0 94 68",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.008 6.785a3.322 3.322 0 00-3.328-.012L16.114 19.668H3.669A3.33 3.33 0 00.337 23v20a3.33 3.33 0 003.332 3.332h12.445L38.68 59.227a3.326 3.326 0 003.324-.008 3.338 3.338 0 001.664-2.886V9.669c0-1.188-.633-2.29-1.66-2.883v-.001z",
  id: "main"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.578 20.402a3.333 3.333 0 00-.512 4.688c3.45 4.285 3.45 11.534 0 15.82a3.333 3.333 0 002.602 5.421c.972 0 1.941-.425 2.601-1.242 5.45-6.781 5.45-17.398 0-24.18a3.35 3.35 0 00-4.691-.508v.001z",
  id: "wave1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.402 15.09c7.942 9.875 7.942 25.94 0 35.82a3.333 3.333 0 00.512 4.687 3.342 3.342 0 004.688-.508c9.792-12.18 9.792-32 0-44.18a3.344 3.344 0 00-4.688-.508 3.334 3.334 0 00-.512 4.688z",
  id: "wave2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.93 1.91a3.343 3.343 0 00-4.688-.508 3.333 3.333 0 00-.511 4.688c12.375 15.39 12.375 40.43 0 55.82a3.333 3.333 0 002.601 5.422c.973 0 1.942-.426 2.602-1.243 14.223-17.695 14.223-46.484-.004-64.18v.001z",
  id: "wave3"
})))));

var css_248z$7 = ".RichText_richText__1LZtu {\n  position: relative; }\n  .RichText_richTextWrapper__ZjT1N {\n    position: relative;\n    overflow: hidden; }\n  .RichText_richTextBorderBottom__1RQv2 {\n    border-radius: 8px 8px 0px 0px; }\n  .RichText_richText__1LZtu textarea,\n  .RichText_richText__1LZtu input {\n    margin-top: 44px; }\n  .RichText_richTextHeading__1Vt03 {\n    display: flex; }\n    .RichText_richTextHeading__1Vt03 p {\n      color: #666;\n      font-size: 12px;\n      font-weight: 600;\n      margin: 0 8px 0 2px; }\n  .RichText_richTextCounter__3nEDI {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 2px 4px 0;\n    font-size: 12px;\n    opacity: 0.5; }\n\n.RichText_headerItems__3mTmm {\n  position: absolute;\n  display: flex;\n  padding: 4px 10px;\n  top: 26px;\n  border-bottom: 1px solid #ddd;\n  left: 1px;\n  z-index: 999;\n  width: 100%;\n  align-items: center; }\n  .RichText_headerItems__3mTmm > * {\n    margin-right: 8px; }\n\n.RichText_speakerIcon__GX92- {\n  cursor: pointer;\n  color: #666;\n  width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  transition: 0.2s ease-out;\n  opacity: 0.6; }\n  .RichText_speakerIcon__GX92-:hover {\n    opacity: 1; }\n  .RichText_speakerIcon__GX92- #RichText_wave3__1abjl {\n    opacity: 0; }\n  .RichText_speakerIcon__GX92- svg path {\n    transition: 1s ease-out; }\n  .RichText_speakerIcon__GX92-.RichText_speaking__2uuRc {\n    opacity: 1; }\n    .RichText_speakerIcon__GX92-.RichText_speaking__2uuRc svg {\n      overflow: visible; }\n      .RichText_speakerIcon__GX92-.RichText_speaking__2uuRc svg path {\n        fill: #0a2f69; }\n    .RichText_speakerIcon__GX92-.RichText_speaking__2uuRc svg #wave1 {\n      animation: RichText_soundwave__2qyBW 1s ease-out infinite;\n      animation-delay: 0.2s; }\n    .RichText_speakerIcon__GX92-.RichText_speaking__2uuRc svg #wave2 {\n      animation: RichText_soundwave__2qyBW 1s ease-out infinite;\n      animation-delay: 0.4s; }\n    .RichText_speakerIcon__GX92-.RichText_speaking__2uuRc svg #wave3 {\n      animation: RichText_soundwave__2qyBW 1s ease-out infinite;\n      animation-delay: 0.6s; }\n";
var styles$7 = {"richText":"RichText_richText__1LZtu","richTextWrapper":"RichText_richTextWrapper__ZjT1N","richTextBorderBottom":"RichText_richTextBorderBottom__1RQv2","richTextHeading":"RichText_richTextHeading__1Vt03","richTextCounter":"RichText_richTextCounter__3nEDI","headerItems":"RichText_headerItems__3mTmm","speakerIcon":"RichText_speakerIcon__GX92-","wave3":"RichText_wave3__1abjl","speaking":"RichText_speaking__2uuRc","soundwave":"RichText_soundwave__2qyBW"};
styleInject$1(css_248z$7);

var RichText = /*#__PURE__*/function (_React$Component) {
  function RichText(props) {
    var _this;
    _classCallCheck$4(this, RichText);
    _this = _callSuper(this, RichText, [props]);
    _defineProperty$1(_this, "_renderHeader", function () {
      if (!_this.props.withHeader) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$7.headerItems
      }, InputHeader({
        entitySearchURL: _this.props.entitySearchURL,
        globalConstantsURL: _this.props.globalConstantsURL,
        displayGlobalConstantSelect: _this.props.displayGlobalConstantSelect,
        jsonPickerButton: _this.props.jsonPickerButton,
        element: _this.myRef,
        onSelect: _this._onSelect
      }));
    });
    _defineProperty$1(_this, "_renderAudio", function () {
      if (!_this.props.hasVoice) return null;
      var speakingClassName = _this.state.synthesisText ? styles$7.speaking : "";
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        src: speakerIcon,
        onClick: _this._toggleAudio,
        className: "".concat(styles$7.speakerIcon, " ").concat(speakingClassName)
      }), /*#__PURE__*/React.createElement(VoicePlayer, {
        text: _this.state.synthesisText,
        onEnd: _this._resetAudio
      }));
    });
    _defineProperty$1(_this, "_renderCounter", function () {
      var _this$props = _this.props,
        hasCounter = _this$props.hasCounter,
        value = _this$props.value,
        maxCharacters = _this$props.maxCharacters;
      if (!hasCounter) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$7.richTextCounter
      }, /*#__PURE__*/React.createElement("span", null, (value || "").length, "/", maxCharacters, " characters"));
    });
    _defineProperty$1(_this, "_onSelect", function (newElement) {
      _this.props.onChange(newElement.newValue);
    });
    _defineProperty$1(_this, "_toggleAudio", function () {
      _this.setState({
        synthesisText: _this.props.value
      });
    });
    _defineProperty$1(_this, "_resetAudio", function () {
      _this.setState({
        synthesisText: undefined
      });
    });
    _this.state = {
      synthesisText: null
    };
    _this.myRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits$3(RichText, _React$Component);
  return _createClass$4(RichText, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var headerClassName = this.props.withHeader ? "".concat(styles$7.richText, " ").concat(this.props.isRephraseEnabled ? styles$7.richTextBorderBottom : "") : "";
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$7.richTextWrapper, " input-margin")
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$7.richTextHeading
      }, /*#__PURE__*/React.createElement("p", null, this.props.label), this._renderAudio()), this._renderHeader(), /*#__PURE__*/React.createElement(Text$1, {
        innerRef: this.myRef,
        prefixClassName: headerClassName,
        value: this.props.value,
        onChange: function onChange(newValue) {
          return _this2.props.onChange(newValue);
        },
        onFocus: this.props.onFocus,
        placeholder: this.props.placeholder,
        multiline: this.props.multiline,
        autoFocus: this.props.autoFocus
      }), this.props.isRephraseEnabled && /*#__PURE__*/React.createElement(RephraseBotResponses, {
        baseUrl: this.props.baseUrl,
        botResponse: this.props.value,
        onChange: function onChange(newValue) {
          return _this2.props.onChange(newValue);
        }
      }), this._renderCounter());
    }
  }]);
}(React.Component);
RichText.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  entitySearchURL: PropTypes.shape({
    map: PropTypes.string,
    search: PropTypes.string
  }),
  jsonPickerButton: PropTypes.element,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  multiline: PropTypes.bool,
  autoFocus: PropTypes.bool,
  maxCharacters: PropTypes.number,
  hasVoice: PropTypes.bool,
  hasCounter: PropTypes.bool,
  withHeader: PropTypes.bool,
  isRephraseEnabled: PropTypes.bool,
  baseUrl: PropTypes.string
};
RichText.defaultProps = {
  placeholder: "",
  value: "",
  label: "",
  entitySearchURL: null,
  jsonPickerButton: null,
  onChange: function onChange() {},
  multiline: false,
  autoFocus: false,
  hasVoice: false,
  onFocus: function onFocus() {},
  withHeader: false,
  hasCounter: false,
  maxCharacters: 150,
  isRephraseEnabled: false,
  baseUrl: ""
};
RichText.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_renderHeader",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderAudio",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderCounter",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_onSelect",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "newElement",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_toggleAudio",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_resetAudio",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "RichText",
  "props": {
    "placeholder": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "entitySearchURL": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "map": {
            "name": "string",
            "required": false
          },
          "search": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "jsonPickerButton": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "element"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "multiline": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "autoFocus": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "hasVoice": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "withHeader": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "hasCounter": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "maxCharacters": {
      "defaultValue": {
        "value": "150",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "isRephraseEnabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "baseUrl": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var PlusIconV2 = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$5({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.9 4.5H8.1v3.6H4.5v1.8h3.6v3.6h1.8V9.9h3.6V8.1H9.9V4.5zM9 0C4.032 0 0 4.032 0 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zm0 16.2c-3.969 0-7.2-3.231-7.2-7.2 0-3.969 3.231-7.2 7.2-7.2 3.969 0 7.2 3.231 7.2 7.2 0 3.969-3.231 7.2-7.2 7.2z",
  fill: "#0067DD"
})));

var css_248z$8 = ".AddButton_addButton__12OJH {\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  color: #0e4498;\n  border-bottom: 1px solid #ddd;\n  cursor: pointer;\n  transition: 0.2s ease-out; }\n  .AddButton_addButton__12OJH:hover {\n    background-color: rgba(14, 68, 152, 0.05); }\n  .AddButton_addButton__12OJH > div {\n    margin-right: 8px; }\n  .AddButton_addButton__12OJH g,\n  .AddButton_addButton__12OJH circle {\n    stroke: #0e4498; }\n\n.AddButton_addButtonNested__2tT2X {\n  padding: 8px 0;\n  border-bottom: none;\n  margin-bottom: 8px; }\n  .AddButton_addButtonNested__2tT2X:hover {\n    background-color: transparent; }\n\n.AddButton_addButtonV2__2Ke4b {\n  border-bottom: 0; }\n";
var styles$8 = {"addButton":"AddButton_addButton__12OJH","addButtonNested":"AddButton_addButtonNested__2tT2X","addButtonV2":"AddButton_addButtonV2__2Ke4b"};
styleInject$1(css_248z$8);

var AddButton = function AddButton(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    nested = _ref.nested,
    isV2 = _ref.isV2;
  var nestedStyle = nested ? styles$8.addButtonNested : "";
  var v2Style = isV2 ? styles$8.addButtonV2 : "";
  return /*#__PURE__*/React.createElement("div", {
    className: [styles$8.addButton, nestedStyle, v2Style].join(" "),
    onClick: onClick
  }, isV2 ? /*#__PURE__*/React.createElement(Icon, {
    size: Icon.SIZES.SMALL,
    src: PlusIconV2
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: AddIcon
  }), children);
};
AddButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  nested: PropTypes.bool
};
AddButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AddButton",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "nested": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

function APIRequest(_x, _x2) {
  return _APIRequest.apply(this, arguments);
}
function _APIRequest() {
  _APIRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, method) {
    var data,
      request,
      response,
      contentType,
      json,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = _args.length > 2 && _args[2] !== undefined ? _args[2] : undefined;
          request = new Request(url, {
            method: method || "GET",
            headers: new Headers({
              "Content-Type": "application/json"
            }),
            credentials: "same-origin",
            mode: "cors",
            cache: "default",
            body: JSON.stringify(data)
          });
          _context.prev = 2;
          _context.next = 5;
          return fetch(request);
        case 5:
          response = _context.sent;
          contentType = response.headers.get("content-type");
          if (!(contentType && contentType.indexOf("application/json") !== -1)) {
            _context.next = 12;
            break;
          }
          _context.next = 10;
          return response.json();
        case 10:
          json = _context.sent;
          return _context.abrupt("return", Promise.resolve(json));
        case 12:
          throw new Error("API request failed!");
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 15]]);
  }));
  return _APIRequest.apply(this, arguments);
}
function upload(_x3, _x4, _x5, _x6, _x7) {
  return _upload.apply(this, arguments);
}
function _upload() {
  _upload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file, fileObject, onProgress, onComplete, onError) {
    var url, policy, fd, xhr;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = ENDPOINTS$1.BASE_URL + ENDPOINTS$1.POLICY_ENDPOINT;
          _context2.next = 3;
          return APIRequest(url, "POST", fileObject);
        case 3:
          policy = _context2.sent.body;
          fd = new FormData();
          xhr = new XMLHttpRequest();
          Object.keys(policy.fields).map(function (key) {
            fd.append(key, policy.fields[key]);
          });
          fd.append("file", file);

          // Ideally this content type should flow from backend just to avoid edge cases
          // setting a default Content-Type to skip the default(binary/octet-stream) by S3
          if (!fd.get("Content-Type")) {
            fd.set("Content-Type", fileObject.file_object && fileObject.file_object.type || "image/png");
          }
          xhr.upload.onprogress = function (e) {
            if (e.lengthComputable) {
              var percentComplete = (e.loaded / e.total * 100).toFixed(2);
              var percentCompleteToNumber = +percentComplete;
              onProgress(percentCompleteToNumber);
            }
          };
          xhr.onload = function () {
            // Always 204 No Content
            if (xhr.status === 204) {
              var _url = "".concat(policy.url).concat(policy.fields.key);
              var _fileObject$file_obje = fileObject.file_object,
                width = _fileObject$file_obje.width,
                height = _fileObject$file_obje.height;
              if (width && height) {
                _url += "?w=".concat(width, "&h=").concat(height);
              }
              var presignedUrl = policy.presigned_url;
              if (presignedUrl) {
                _url = policy.presigned_url;
              }
              var cdnUrl = _url.replace("haptikappimg.s3.amazonaws.com", "haptikappimg.haptikapi.com");
              onComplete(cdnUrl);
            }
            if (xhr.status === 403 || xhr.status === 400) {
              xhr.onerror();
            }
          };
          xhr.onerror = function (e) {
            if (onError) onError(e);
          };
          xhr.open("POST", policy.url);
          xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
          xhr.setRequestHeader("x-amz-acl", policy.fields && policy.fields.acl);
          xhr.send(fd);
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _upload.apply(this, arguments);
}

var uploadFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file, onProgress, onComplete, onError, businessId, source) {
    var img, extenstionRegex, extension, fileObject;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          img = new Image();
          extenstionRegex = /(?:\.([^.]+))?$/;
          extension = extenstionRegex.exec(file.name)[1] && extenstionRegex.exec(file.name)[1].toLowerCase();
          fileObject = {
            file_object: {
              type: file.type,
              size: file.size,
              extension: [extension, extension],
              source: source
            }
          };
          if (businessId) {
            fileObject.business_id = businessId;
          }
          if (IMAGE_EXTENSIONS.includes(extension)) {
            img.src = URL.createObjectURL(file);
            img.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    fileObject.file_object.width = img.width;
                    fileObject.file_object.height = img.height;
                    upload(file, fileObject, onProgress, onComplete, onError);
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
          } else {
            upload(file, fileObject, onProgress, onComplete, onError);
          }
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function uploadFile(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var FileIconv2 = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$6({
  width: "40",
  height: "34",
  viewBox: "0 0 40 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M39.355 6.538h-1.936V3.27a.658.658 0 00-.189-.462.64.64 0 00-.456-.192H13.947L12.836.361A.651.651 0 0012.258 0H3.226a.64.64 0 00-.456.192.658.658 0 00-.19.462v5.884H.646a.64.64 0 00-.456.192.658.658 0 00-.189.462v26.154c0 .174.068.34.189.463A.64.64 0 00.645 34h38.71a.641.641 0 00.456-.191.658.658 0 00.189-.463V7.192a.658.658 0 00-.189-.462.64.64 0 00-.456-.192zM3.87 1.308h7.989l1.111 2.254a.651.651 0 00.577.361H36.13v2.615H3.871v-5.23zM38.71 32.692H1.29V7.846h37.42v24.846z",
  fill: "#0067DD"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0067DD",
  fillOpacity: ".3",
  d: "M1.048 7.601H38.79v25.337H1.048z"
})));

function _extends$1$1() { _extends$1$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$1.apply(this, arguments); }
var ImageIconv2 = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1$1({
  width: "34",
  height: "34",
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M23.071 9.714a3.642 3.642 0 11-7.284 0 3.642 3.642 0 017.284 0zM34 3.643v26.714A3.643 3.643 0 0130.357 34H3.643A3.643 3.643 0 010 30.357V3.643A3.643 3.643 0 013.643 0h26.714A3.643 3.643 0 0134 3.643zm-2.429 0a1.214 1.214 0 00-1.214-1.214H3.643a1.214 1.214 0 00-1.214 1.214v20.145l8.852-8.864a1.214 1.214 0 011.724 0l6.424 6.435 3.995-4.007a1.216 1.216 0 011.724 0l6.423 6.436V3.643z",
  fill: "#6FB2FF"
})));

function _extends$2$1() { _extends$2$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$1.apply(this, arguments); }
var VideoIconv2 = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$2$1({
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M25.879 0H2.12C.951 0 0 .95 0 2.121V25.88C0 27.045.95 28 2.121 28H25.88c1.17 0 2.121-.954 2.121-2.121V2.12C28 .951 27.05 0 25.879 0zm-1.417 23.898H9.278a1.693 1.693 0 01-1.642 1.272c-.789 0-1.455-.539-1.641-1.272H3.538a.423.423 0 01-.424-.425c0-.233.19-.424.424-.424h2.457a1.698 1.698 0 011.641-1.273c.79 0 1.456.543 1.642 1.273h15.184c.233 0 .424.191.424.424 0 .238-.19.425-.424.425zm.428-4.243c0 .233-.19.424-.424.424H3.534a.425.425 0 01-.424-.424V3.36c0-.233.19-.424.424-.424h20.932c.233 0 .424.19.424.424v16.295z",
  fill: "#6FB2FF"
})));

var css_248z$9 = ".FilePlaceholder_filePlaceholder__19af0 {\n  display: flex;\n  align-items: center; }\n\n.FilePlaceholder_filePlaceholderIcon__gz4-d {\n  width: 48px;\n  height: 48px;\n  border-radius: 24px;\n  margin-right: 24px; }\n\n.FilePlaceholder_filePlaceholderText__1d25L {\n  font-size: 14px; }\n  .FilePlaceholder_filePlaceholderText__1d25L > span {\n    display: block; }\n\n.FilePlaceholder_filePlaceholderTextTitle__10wpd {\n  margin-bottom: 8px;\n  font-weight: 600; }\n\n.FilePlaceholder_filePlaceholderTextSubtitle__3THM6 {\n  margin-bottom: 4px;\n  opacity: 0.5; }\n";
var styles$9 = {"filePlaceholder":"FilePlaceholder_filePlaceholder__19af0","filePlaceholderIcon":"FilePlaceholder_filePlaceholderIcon__gz4-d","filePlaceholderText":"FilePlaceholder_filePlaceholderText__1d25L","filePlaceholderTextTitle":"FilePlaceholder_filePlaceholderTextTitle__10wpd","filePlaceholderTextSubtitle":"FilePlaceholder_filePlaceholderTextSubtitle__3THM6"};
styleInject(css_248z$9);

var FilePlaceholder = function FilePlaceholder(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$9.filePlaceholder, " ").concat(props.prefixClassName, "-wrapper")
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "".concat(styles$9.filePlaceholderIcon, " ").concat(props.prefixClassName, "-icon"),
    src: props.customIcon || PlaceholderIcon$1
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$9.filePlaceholderText, " ").concat(props.prefixClassName, "-text-wrapper")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$9.filePlaceholderTextTitle, " ").concat(props.prefixClassName, "-title")
  }, "Upload / Drag & Drop File"), /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$9.filePlaceholderTextSubtitle, " ").concat(props.prefixClassName, "-filesize")
  }, "Max File Size: ".concat(props.maxFileSize, "MB")), /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$9.filePlaceholderTextSubtitle, " ").concat(props.prefixClassName, "-format")
  }, "Supported Formats: ".concat(props.type))));
};
FilePlaceholder.propTypes = {
  prefixClassName: PropTypes.string,
  maxFileSize: PropTypes.number,
  type: PropTypes.string,
  customIcon: PropTypes.string
};
FilePlaceholder.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FilePlaceholder",
  "props": {
    "prefixClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "maxFileSize": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "customIcon": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$1$2 = ".ImagePlaceholder_imagePlaceholder__2sc7R {\n  display: flex;\n  align-items: center; }\n\n.ImagePlaceholder_imagePlaceholderIcon__1UUe5 {\n  width: 48px;\n  height: 48px;\n  border-radius: 24px;\n  margin-right: 24px; }\n\n.ImagePlaceholder_imagePlaceholderText__24R2L {\n  font-size: 14px; }\n  .ImagePlaceholder_imagePlaceholderText__24R2L > span {\n    display: block; }\n\n.ImagePlaceholder_imagePlaceholderTextTitle__1nHrc {\n  margin-bottom: 8px;\n  font-weight: 600; }\n\n.ImagePlaceholder_imagePlaceholderTextSubtitle__3jEUc {\n  margin-bottom: 4px;\n  opacity: 0.5; }\n";
var styles$1$2 = {"imagePlaceholder":"ImagePlaceholder_imagePlaceholder__2sc7R","imagePlaceholderIcon":"ImagePlaceholder_imagePlaceholderIcon__1UUe5","imagePlaceholderText":"ImagePlaceholder_imagePlaceholderText__24R2L","imagePlaceholderTextTitle":"ImagePlaceholder_imagePlaceholderTextTitle__1nHrc","imagePlaceholderTextSubtitle":"ImagePlaceholder_imagePlaceholderTextSubtitle__3jEUc"};
styleInject(css_248z$1$2);

// TODO to rename this component to a generic placeholder

var ImagePlaceholder = function ImagePlaceholder(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1$2.imagePlaceholder, " ").concat(props.prefixClassName, "-wrapper")
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "".concat(styles$1$2.imagePlaceholderIcon, " ").concat(props.prefixClassName, "-icon"),
    src: props.customIcon || PlaceholderIcon
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1$2.imagePlaceholderText, " ").concat(props.prefixClassName, "-text-wrapper")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$1$2.imagePlaceholderTextTitle, " ").concat(props.prefixClassName, "-title")
  }, "Upload / Drag & Drop ", props.title), /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$1$2.imagePlaceholderTextSubtitle, " ").concat(props.prefixClassName, "-image-dimensions")
  }, "Dimensions: ".concat(props.dimensions)), /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$1$2.imagePlaceholderTextSubtitle, " ").concat(props.prefixClassName, "-filesize")
  }, "Max File Size: ".concat(props.maxFileSize, "MB")), /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$1$2.imagePlaceholderTextSubtitle, " ").concat(props.prefixClassName, "-format")
  }, "Supported Formats: ".concat(props.type))));
};
ImagePlaceholder.propTypes = {
  prefixClassName: PropTypes.string,
  maxFileSize: PropTypes.number,
  type: PropTypes.string,
  dimensions: PropTypes.string,
  customIcon: PropTypes.string
};
ImagePlaceholder.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ImagePlaceholder",
  "props": {
    "prefixClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "maxFileSize": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "dimensions": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "customIcon": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$2$1 = ".ImageProgressBar_progressBar__1pgzi {\n  position: absolute;\n  width: 100%;\n  top: 100%;\n  left: 0;\n  height: 8px;\n  background-color: #000;\n  opacity: 0;\n  transition: 0.2s ease-out; }\n  .ImageProgressBar_progressBar__1pgzi.ImageProgressBar_active__2AYEM {\n    opacity: 1;\n    transform: translateY(-100%); }\n\n.ImageProgressBar_progressBarInner__3sAaz {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background-color: #124fa0;\n  transition: 0.1s ease-out; }\n";
var styles$2$1 = {"progressBar":"ImageProgressBar_progressBar__1pgzi","active":"ImageProgressBar_active__2AYEM","progressBarInner":"ImageProgressBar_progressBarInner__3sAaz"};
styleInject(css_248z$2$1);

var ImageProgressBar = function ImageProgressBar(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$2$1.progressBar, " ").concat(props.active ? styles$2$1.active : "", " ").concat(props.prefixClassName, "-wrapper")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$2$1.progressBarInner, " ").concat(props.prefixClassName, "-bar"),
    style: {
      width: "".concat(props.complete, "%")
    }
  }));
};
ImageProgressBar.propTypes = {
  complete: PropTypes.number,
  active: PropTypes.bool,
  prefixClassName: PropTypes.string
};
ImageProgressBar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ImageProgressBar",
  "props": {
    "complete": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$3$1 = ".File_files__1JQtB {\n  position: relative;\n  margin-bottom: 24px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #fff;\n  padding: 8px;\n  max-width: 100%;\n  overflow: auto; }\n\n.File_filesList__3HdWc {\n  display: flex;\n  align-items: stretch; }\n\n.File_addNewFile__1SdjH {\n  position: relative;\n  width: 213.33333px;\n  min-width: 213.33333px;\n  margin-right: 16px;\n  border-radius: 8px;\n  overflow: hidden;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #ddd;\n  cursor: pointer;\n  transition: 0.2s ease-out;\n  transform: translateY(10px);\n  animation: File_slide-up__1Y2ik 0.5s ease-out;\n  animation-fill-mode: both;\n  opacity: 0; }\n  .File_addNewFile__1SdjH:hover {\n    background-color: #ecf1f7; }\n\n.File_addNewFileIcon__2JZiX {\n  margin-bottom: 8px;\n  width: 32px;\n  height: 32px; }\n  .File_addNewFileIcon__2JZiX svg g {\n    stroke: #124fa0; }\n  .File_addNewFileIcon__2JZiX svg path {\n    fill: #124fa0; }\n\n.File_addNewFileText__3Wg6l {\n  text-align: center;\n  color: #124fa0; }\n\n.File_imageInputWrapper__g57LY {\n  position: relative;\n  width: 213.33333px;\n  height: 120px;\n  margin-right: 16px;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: #000;\n  border: 1px solid #fff;\n  transition: 0.2s ease-out;\n  overflow: hidden;\n  transform: translateY(10px);\n  animation: File_slide-up__1Y2ik 0.5s ease-out;\n  animation-fill-mode: both;\n  opacity: 0; }\n\n.File_fileInput__uQNlb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer; }\n\n.File_imageInputPreviewWrapper__3nrD2 {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  border-radius: 4px; }\n\n.File_imageInputPreview__8RvRC {\n  position: absolute;\n  top: -8px;\n  left: -8px;\n  width: calc(100% + 16px);\n  height: calc(100% + 16px);\n  filter: blur(0px);\n  object-fit: contain;\n  transition: 0.2s ease-out; }\n  .File_imageInputPreview__8RvRC.File_isUploading__UMYqr {\n    filter: blur(8px); }\n\n.File_loader__6FNV_ {\n  position: absolute;\n  top: 50% !important;\n  left: 50% !important;\n  transform: translate(-50%, -50%) !important;\n  margin-top: 0;\n  opacity: 0;\n  transition: 0.2s ease-out; }\n  .File_loader__6FNV_.File_isUploading__UMYqr {\n    opacity: 1; }\n\n.File_imageInputPreviewDelete__3mnjC {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  cursor: pointer;\n  transition: 0.1s ease-out;\n  font-size: 14px; }\n  .File_imageInputPreviewDelete__3mnjC:hover {\n    opacity: 1; }\n    .File_imageInputPreviewDelete__3mnjC:hover > div {\n      transform: translateY(0); }\n  .File_imageInputPreviewDelete__3mnjC:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #000;\n    opacity: 0.6; }\n  .File_imageInputPreviewDelete__3mnjC .File_imageInputPreviewDeleteIcon__gxCId {\n    position: relative;\n    z-index: 2;\n    width: 40px;\n    height: 40px;\n    padding: 8px;\n    background-color: #fff;\n    border-radius: 100px;\n    transform: translateY(5px);\n    transition: 0.2s ease-out; }\n\n.File_customKeyImage__3SYaX {\n  width: 100%;\n  min-height: 150px;\n  height: 100%;\n  background-color: #eee;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column; }\n  .File_customKeyImage__3SYaX > div {\n    padding-bottom: 8px; }\n\n.File_onUploadPreviewWrapper__1Ejr6 {\n  display: flex;\n  align-items: center;\n  margin-right: 16px; }\n  .File_onUploadPreviewWrapper__1Ejr6 .File_filePreview__1A76G {\n    width: 100%; }\n\n.File_filePreviewWrapper__19Tns,\n.File_onUploadPreviewWrapper__1Ejr6 {\n  position: relative;\n  width: 100%;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 8px;\n  overflow: hidden; }\n  .File_filePreviewWrapper__19Tns .File_filePreview__1A76G,\n  .File_onUploadPreviewWrapper__1Ejr6 .File_filePreview__1A76G {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    transition: 0.2s ease-out; }\n    .File_filePreviewWrapper__19Tns .File_filePreview__1A76G .File_onUploadFileName__5S-A-,\n    .File_onUploadPreviewWrapper__1Ejr6 .File_filePreview__1A76G .File_onUploadFileName__5S-A- {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n    .File_filePreviewWrapper__19Tns .File_filePreview__1A76G.File_onUploadDeleteWrapper__HeIHd,\n    .File_onUploadPreviewWrapper__1Ejr6 .File_filePreview__1A76G.File_onUploadDeleteWrapper__HeIHd {\n      width: auto;\n      padding-left: 10px; }\n    .File_filePreviewWrapper__19Tns .File_filePreviewTitle__22cp2,\n    .File_onUploadPreviewWrapper__1Ejr6 .File_filePreviewTitle__22cp2 {\n      font-size: 18px;\n      font-weight: 600;\n      transition: 0.2s ease-out;\n      color: #333; }\n    .File_filePreviewWrapper__19Tns .File_filePreview__1A76G.File_isUploading__UMYqr,\n    .File_onUploadPreviewWrapper__1Ejr6 .File_filePreview__1A76G.File_isUploading__UMYqr {\n      padding-bottom: 5px; }\n      .File_filePreviewWrapper__19Tns .File_filePreview__1A76G.File_isUploading__UMYqr .File_filePreviewTitle__22cp2,\n      .File_onUploadPreviewWrapper__1Ejr6 .File_filePreview__1A76G.File_isUploading__UMYqr .File_filePreviewTitle__22cp2 {\n        padding-left: 28px; }\n  .File_filePreviewWrapper__19Tns .File_loader__6FNV_,\n  .File_onUploadPreviewWrapper__1Ejr6 .File_loader__6FNV_ {\n    left: 0;\n    right: auto;\n    transform: scale3d(0.6, 0.6, 1);\n    margin: 2px; }\n\n@keyframes File_slide-up__1Y2ik {\n  0% {\n    opacity: 0;\n    transform: translateY(10px); }\n  100% {\n    opacity: 1;\n    transform: translateY(0px); } }\n";
var styles$3$1 = {"files":"File_files__1JQtB","filesList":"File_filesList__3HdWc","addNewFile":"File_addNewFile__1SdjH","slide-up":"File_slide-up__1Y2ik","addNewFileIcon":"File_addNewFileIcon__2JZiX","addNewFileText":"File_addNewFileText__3Wg6l","imageInputWrapper":"File_imageInputWrapper__g57LY","fileInput":"File_fileInput__uQNlb","imageInputPreviewWrapper":"File_imageInputPreviewWrapper__3nrD2","imageInputPreview":"File_imageInputPreview__8RvRC","isUploading":"File_isUploading__UMYqr","loader":"File_loader__6FNV_","imageInputPreviewDelete":"File_imageInputPreviewDelete__3mnjC","imageInputPreviewDeleteIcon":"File_imageInputPreviewDeleteIcon__gxCId","customKeyImage":"File_customKeyImage__3SYaX","onUploadPreviewWrapper":"File_onUploadPreviewWrapper__1Ejr6","filePreview":"File_filePreview__1A76G","filePreviewWrapper":"File_filePreviewWrapper__19Tns","onUploadFileName":"File_onUploadFileName__5S-A-","onUploadDeleteWrapper":"File_onUploadDeleteWrapper__HeIHd","filePreviewTitle":"File_filePreviewTitle__22cp2"};
styleInject(css_248z$3$1);

var FileV2InputWrapperStyle = function FileV2InputWrapperStyle(props) {
  return {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '24px 6px',
    textAlign: 'center',
    backgroundColor: '#CFE5FF1A',
    border: "".concat(props.theme.borderWidths.xs, "px dashed ").concat(props.theme.colors.blue.haptik),
    borderRadius: props.theme.radii.lg
  };
};
var FileV2InputWrapper = styled("div")(FileV2InputWrapperStyle);
var IconWrapperStyle = function IconWrapperStyle(props) {
  return {
    marginBottom: props.theme.space.sm
  };
};
var IconWrapper = styled("div")(IconWrapperStyle);
var HiddenFileInputStyle = function HiddenFileInputStyle() {
  return {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    opacity: '0',
    cursor: 'pointer'
  };
};
var HiddenFileInput = styled("input")(HiddenFileInputStyle);
var UploadInfoWrapperStyle = function UploadInfoWrapperStyle(props) {
  return {
    position: 'relative',
    width: '75%',
    alignSelf: 'flex-start',
    paddingLeft: props.theme.space.md * 2
  };
};
var UploadInfoWrapper = styled("div")(UploadInfoWrapperStyle);
var ProgressBarWrapperStyle = function ProgressBarWrapperStyle(props) {
  return {
    position: 'relative',
    width: '100%',
    height: '5px',
    backgroundColor: '#CFE5FF',
    borderRadius: '10px',
    overflow: 'hidden',
    marginTop: props.theme.space.sm
  };
};
var ProgressBarWrapper = styled("div")(ProgressBarWrapperStyle);
var ProgressBarStyle = function ProgressBarStyle(props) {
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '5px',
    backgroundColor: props.theme.colors.blue.haptik,
    borderRadius: '10px'
  };
};
var ProgressBar = styled("div")(ProgressBarStyle);
var CancelIconStyle = function CancelIconStyle() {
  return {
    position: 'absolute',
    bottom: '-3px',
    right: '-30px'
  };
};
var CancelIcon = styled(Icon)(CancelIconStyle);

var _dec$2, _class$2;
var FILE_ACCEPT_TYPES =
// eslint-disable-next-line max-len
"image/png, image/jpeg, application/pdf, application/ vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, text/csv, application/vnd.ms-excel, image/gif";
var IMAGE_ACCEPT_TYPES = "image/png, image/jpeg, image/gif";
var VIDEO_ACCEPT_TYPES = "video/mp4, video/quicktime";
var AUDIO_ACCEPT_TYPES = "audio/mpeg, audio/ogg";
var InputTypes = {
  FILE: "file",
  IMAGE: "image",
  VIDEO: "video",
  AUDIO: "audio"
};
var getFileUploadSize = function getFileUploadSize(type) {
  var VIDEO = InputTypes.VIDEO,
    AUDIO = InputTypes.AUDIO;
  switch (type) {
    case VIDEO:
      return 15;
    case AUDIO:
      return 1;
    default:
      return 5;
  }
};
var File = (_dec$2 = ToastMessage(), _dec$2(_class$2 = /*#__PURE__*/function (_React$Component) {
  _inherits$4(File, _React$Component);
  var _super = _createSuper(File);
  function File() {
    var _this;
    _classCallCheck$5(this, File);
    _this = _super.call(this);
    _defineProperty$2(_assertThisInitialized$1(_this), "_newUploadItem", {
      isUploading: true,
      uploadedPercent: 25,
      previewURL: undefined
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_renderPlaceholder", function () {
      var _this$props = _this.props,
        type = _this$props.type,
        prefixClassName = _this$props.prefixClassName,
        customIcon = _this$props.customIcon,
        dimensions = _this$props.dimensions;
      var checkAudioAcceptType = type === InputTypes.AUDIO ? AUDIO_ACCEPT_TYPES : IMAGE_ACCEPT_TYPES;
      var acceptType = type === InputTypes.VIDEO ? VIDEO_ACCEPT_TYPES : checkAudioAcceptType;
      if (type === InputTypes.FILE) {
        return /*#__PURE__*/React.createElement(FilePlaceholder, {
          prefixClassName: "".concat(prefixClassName, "-placeholder"),
          maxFileSize: _this.state.fileUploadSize,
          type: FILE_ACCEPT_TYPES,
          customIcon: customIcon
        });
      }
      return /*#__PURE__*/React.createElement(ImagePlaceholder, {
        prefixClassName: "".concat(prefixClassName, "-placeholder"),
        maxFileSize: _this.state.fileUploadSize,
        type: acceptType,
        dimensions: dimensions,
        customIcon: customIcon,
        title: type
      });
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_renderFiles", function (uploads) {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3$1.filesList, " ").concat(_this.props.prefixClassName, "-wrapper")
      }, uploads.map(_this._renderPreview), _this.props.multiple ? _this._renderAddMoreButton() : null);
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_renderAddMoreButton", function (type) {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3$1.addNewFile, " ").concat(_this.props.prefixClassName, "-addmore-wrapper")
      }, /*#__PURE__*/React.createElement(Icon, {
        src: PlusIcon,
        className: "".concat(styles$3$1.addNewFileIcon, " ").concat(_this.props.prefixClassName, "-addmore-icon")
      }), /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles$3$1.addNewFileText, " ").concat(_this.props.prefixClassName, "-addmore-text")
      }, "Add more images"), _this._renderInput(type));
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_renderInput", function () {
      var type = _this.props.type;
      var acceptType = "";
      if (type === InputTypes.FILE) {
        acceptType = FILE_ACCEPT_TYPES;
      } else if (type === InputTypes.VIDEO) {
        acceptType = VIDEO_ACCEPT_TYPES;
      } else if (type === InputTypes.AUDIO) {
        acceptType = AUDIO_ACCEPT_TYPES;
      } else {
        acceptType = IMAGE_ACCEPT_TYPES;
      }
      return /*#__PURE__*/React.createElement("input", {
        className: "".concat(styles$3$1.fileInput, " ").concat(_this.props.prefixClassName, "-input"),
        onChange: _this._handleFile,
        type: InputTypes.FILE,
        accept: acceptType,
        multiple: _this.props.multiple
      });
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_renderPreview", function (upload, i) {
      if (_this.props.onUpload) return _this._renderOnUploadPreview(i);
      if (upload.fileType === InputTypes.FILE) return _this._renderFilePreview(upload, i);
      return _this._renderImagePreview(upload, i);
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_renderImagePreview", function (upload, i) {
      var isUploading = upload.isUploading,
        uploadedPercent = upload.uploadedPercent,
        previewURL = upload.previewURL,
        value = upload.value;
      var imageRatio = _this.props.ratio || 1.77;
      var width = _this.props.baseWidth || 290;
      var minWidth = width;
      var height = width / imageRatio;
      var URL = value || previewURL;
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "".concat(styles$3$1.imageInputWrapper, " ").concat(_this.props.prefixClassName, "-image-wrapper"),
        style: {
          width: width,
          height: height,
          minWidth: minWidth
        }
      }, _this._renderImage(URL, isUploading, i), _this._renderLoader(isUploading), /*#__PURE__*/React.createElement(ImageProgressBar, {
        prefixClassName: "".concat(_this.props.prefixClassName, "-progressbar"),
        complete: uploadedPercent,
        active: isUploading,
        maxFileSize: _this.state.fileUploadSize
      }));
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_renderFilePreview", function (upload, i) {
      var isUploading = upload.isUploading,
        uploadedPercent = upload.uploadedPercent,
        previewURL = upload.previewURL,
        value = upload.value;
      var URL = value || previewURL;
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "".concat(styles$3$1.filePreviewWrapper, " ").concat(_this.props.prefixClassName, "-file-wrapper")
      }, _this._renderFile(URL, value, isUploading, i), _this._renderLoader(isUploading), /*#__PURE__*/React.createElement(ImageProgressBar, {
        prefixClassName: "".concat(_this.props.prefixClassName, "-progressbar"),
        complete: uploadedPercent,
        active: isUploading,
        maxFileSize: _this.state.fileUploadSize
      }));
    });
    /**
     * Renders the preview of the file which has been selected via onUpload prop
     * @param {Number} index index of the file selected
     * */
    _defineProperty$2(_assertThisInitialized$1(_this), "_renderOnUploadPreview", function (index) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "".concat(styles$3$1.onUploadPreviewWrapper, " ").concat(_this.props.prefixClassName, "-on-upload-wrapper")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3$1.filePreview, " ").concat(_this.props.prefixClassName, "-on-upload-preview")
      }, /*#__PURE__*/React.createElement("span", {
        className: styles$3$1.onUploadFileName
      }, _this.state.filenames[index] || "Attachment"), /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return _this._deleteFile(index);
        },
        className: "".concat(styles$3$1.filePreview, " ").concat(styles$3$1.onUploadDeleteWrapper, " \n          ").concat(_this.props.prefixClassName, "-on-upload-preview-delete-wrapper")
      }, /*#__PURE__*/React.createElement(Icon, {
        src: TrashIcon,
        className: "".concat(styles$3$1.filePreviewDeleteIcon, " \n            ").concat(_this.props.prefixClassName, "-on-upload-preview-delete-icon")
      }))));
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_renderImage", function (previewURL, isUploading, index) {
      var type = _this.props.type;
      var isUploadingClassName = isUploading ? styles$3$1.isUploading : "";
      if (!isValidURL$1(previewURL)) {
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(styles$3$1.customKeyImage, " ").concat(_this.props.prefixClassName, "-image-preview")
        }, /*#__PURE__*/React.createElement(Icon, {
          className: "".concat(styles$3$1.carouselImagePlaceholderIcon, " ").concat(_this.props.prefixClassName, "-image-preview-icon"),
          src: PlaceholderIcon
        }), previewURL);
      }
      var classNames = {
        main: cc([styles$3$1.imageInputPreview, isUploadingClassName])
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3$1.imageInputPreviewWrapper, " ").concat(_this.props.prefixClassName, "-image-preview")
      }, type === "video" ?
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/media-has-caption
      React.createElement("video", {
        className: "".concat(classNames.main, " ").concat(_this.props.prefixClassName, "-image-preview-image"),
        controls: true
      }, /*#__PURE__*/React.createElement("source", {
        src: previewURL,
        type: "video/mp4"
      })) : /*#__PURE__*/React.createElement("img", {
        src: previewURL,
        className: "".concat(classNames.main, " ").concat(_this.props.prefixClassName, "-image-preview-image")
      }), /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return _this._deleteFile(index);
        },
        className: "".concat(styles$3$1.imageInputPreviewDelete, " ").concat(_this.props.prefixClassName, "-image-preview-delete")
      }, /*#__PURE__*/React.createElement(Icon, {
        src: TrashIcon,
        className: "".concat(styles$3$1.imageInputPreviewDeleteIcon, " ").concat(_this.props.prefixClassName, "-image-preview-delete-icon")
      })));
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_renderFile", function (previewURL, value, isUploading, index) {
      var isUploadingClassName = isUploading ? styles$3$1.isUploading : "";
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3$1.filePreview, " ").concat(isUploadingClassName, " ").concat(_this.props.prefixClassName, "-file-preview")
      }, /*#__PURE__*/React.createElement("a", {
        href: value,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "".concat(styles$3$1.filePreviewTitle, " ").concat(_this.props.prefixClassName, "-file-preview-title")
      }, _this.state.filenames[index] || "Attachment"), /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return _this._deleteFile(index);
        },
        className: "".concat(styles$3$1.filePreview, " ").concat(_this.props.prefixClassName, "-file-preview-delete-wrapper")
      }, /*#__PURE__*/React.createElement(Icon, {
        src: TrashIcon,
        className: "".concat(styles$3$1.filePreviewDeleteIcon, " ").concat(_this.props.prefixClassName, "-file-preview-delete-icon")
      })));
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_renderLoader", function (isUploading) {
      var isUploadingClassName = isUploading ? styles$3$1.isUploading : "";
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$3$1.loader, " ").concat(isUploadingClassName, " ").concat(_this.props.prefixClassName, "-loader")
      }, /*#__PURE__*/React.createElement(Loader, null));
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_transform", function (values) {
      return values.map(function (value) {
        var extenstionRegex = /(?:\.([^.]+))?$/;
        var fileExtension = extenstionRegex.exec(value.split("?")[0])[1];
        var isImage = IMAGE_EXTENSIONS.includes(fileExtension);
        var isVideo = VIDEO_EXTENSIONS$1.includes(fileExtension);
        var isAudio = AUDIO_EXTENSIONS.includes(fileExtension);
        return {
          isUploading: false,
          uploadedPercent: 0,
          fileType: _this.getFileType(isImage, isVideo, isAudio),
          previewURL: value,
          value: value
        };
      });
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_deleteFile", function (index) {
      var value = "";
      var onUpload = _this.props.onUpload;
      if (onUpload) {
        _this.setState(function (prevState) {
          var uploads = prevState.uploads.filter(function (_, i) {
            return i !== index;
          });
          var filenames = prevState.filenames.filter(function (_, i) {
            return i !== index;
          });
          return {
            uploads: uploads,
            filenames: filenames
          };
        });
      } else if (_this.props.multiple) {
        value = _this.props.value.filter(function (_, i) {
          return i !== index;
        });
      }
      _this.props.onChange(value);
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_handleFile", function (e) {
      var _this$props2 = _this.props,
        onUpload = _this$props2.onUpload,
        source = _this$props2.source;
      var selectedFiles = e.target.files;
      // Only upload valid files
      var files = _this._getValidFiles(selectedFiles);
      var filenames = [];
      var uploads = _toConsumableArray$3(files).map(function (file, i) {
        if (onUpload) {
          onUpload(file, i, files.length);
        } else {
          _this._uploadFile(file, i, files.length, source);
        }
        filenames[i] = file.name;
        var extenstionRegex = /(?:\.([^.]+))?$/;
        var fileExtension = extenstionRegex.exec(file.name)[1];
        var isImage = IMAGE_EXTENSIONS.includes(fileExtension);
        var isVideo = VIDEO_EXTENSIONS$1.includes(fileExtension);
        var isAudio = AUDIO_EXTENSIONS.includes(fileExtension);
        return _objectSpread2(_objectSpread2({}, _this._newUploadItem), {}, {
          previewURL: URL.createObjectURL(file),
          fileType: _this.getFileType(isImage, isVideo, isAudio)
        });
      });
      _this.setState({
        uploads: uploads,
        filenames: filenames
      });
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_uploadFile", function (file, index, numFiles, source) {
      uploadFile(file, function (uploadedPercent) {
        return _this._onUploadProgress(uploadedPercent, index);
      }, function (fileURL) {
        return _this._onUploadComplete(fileURL, index, numFiles);
      }, function () {}, _this.props.businessId, source);
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_onUploadProgress", function (uploadedPercent, index) {
      _this.setState(function (prevState) {
        var uploads = prevState.uploads;
        uploads[index].uploadedPercent = uploadedPercent;
        return {
          uploads: uploads
        };
      });
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_onUploadComplete", function (fileURL, index, numFiles) {
      var value = _this.props.value || [];
      var uploadsCompleted;
      var uploads;
      _this.setState(function (prevState) {
        uploadsCompleted = prevState.uploadsCompleted + 1;
        uploads = prevState.uploads;
        uploads[index].isUploading = false;
        uploads[index].uploadedPercent = 0;
        uploads[index].value = fileURL;
        return {
          uploads: uploads,
          uploadsCompleted: uploadsCompleted
        };
      }, function () {
        if (_this.props.onChange && uploadsCompleted >= numFiles) {
          if (_this.props.multiple) {
            _this.props.onChange(value.concat(uploads.map(function (upload) {
              return upload.value;
            })));
          } else {
            _this.props.onChange(uploads[0].value);
          }
          setTimeout(function () {
            return _this.setState({
              uploads: [],
              uploadsCompleted: 0
            });
          }, 0);
        }
      });
    });
    _defineProperty$2(_assertThisInitialized$1(_this), "_getValidFiles", function (files) {
      // Validate the file and add them to the below arrays accordingly
      var validFiles = [];
      var errorMessages = [];
      var _this$props3 = _this.props,
        type = _this$props3.type,
        customValidate = _this$props3.customValidate;
      // Accepts the file extenstions and the selected file's type to validate
      var fileValidation = function fileValidation(allowedFileTypes, file, fileType) {
        var errorMsg = files.length > 1 ? "Some of the files selected are invalid." : "Invalid File selected.";
        if (customValidate) {
          if (!customValidate(allowedFileTypes, file, fileType)) {
            errorMessages.push(errorMsg);
          }
        } else if (!allowedFileTypes.includes(fileType)) {
          errorMessages.push("".concat(errorMsg, " Supported formats: ").concat(allowedFileTypes));
        }
        if (file.size > 1024 * 1024 * _this.state.fileUploadSize) {
          errorMessages.push("File: ".concat(file.name, " must be less than ").concat(_this.state.fileUploadSize, "MB"));
        }
        if (errorMessages.length === 0) {
          validFiles.push(file);
        }
      };
      _toConsumableArray$3(files).map(function (file) {
        // Image Extension Check
        if (type === InputTypes.IMAGE) {
          var allowedImageTypes = IMAGE_ACCEPT_TYPES.split(", ");
          fileValidation(allowedImageTypes, file, file.type);
        }

        // File Extenstions Check
        else if (type === InputTypes.FILE) {
          var allowedFileTypes = FILE_ACCEPT_TYPES.split(", ");
          fileValidation(allowedFileTypes, file, file.type);
        } else if (type === InputTypes.VIDEO) {
          var _allowedFileTypes = VIDEO_ACCEPT_TYPES.split(", ");
          fileValidation(_allowedFileTypes, file, file.type);
        } else if (type === InputTypes.AUDIO) {
          var _allowedFileTypes2 = AUDIO_ACCEPT_TYPES.split(", ");
          fileValidation(_allowedFileTypes2, file, file.type);
        }

        // Custom Extenstions Check
        else {
          // Removed all the dots from the extensions to match the types with filetypes
          var allowedTypes = type.replace(/\./g, "").split(", ");
          var formattedFileType = file.type.split("/");
          var fileType = formattedFileType[formattedFileType.length - 1];
          fileValidation(allowedTypes, file, fileType);
        }
      });
      if (errorMessages.length > 0) {
        _this.props.onError();
        // Show the toast message
        _this.props.activateToastMessage({
          title: errorMessages.join("\n"),
          type: "NEGATIVE"
        });
      }
      return validFiles;
    });
    _this.state = {
      uploads: [],
      filenames: [],
      uploadsCompleted: 0
    };
    return _this;
  }
  _createClass$5(File, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        value = _this$props4.value,
        multiple = _this$props4.multiple,
        className = _this$props4.className,
        prefixClassName = _this$props4.prefixClassName,
        type = _this$props4.type;
      this.state.fileUploadSize = getFileUploadSize(type);
      var values = [];
      if (value) {
        values = multiple ? this._transform(value) : this._transform([value]);
      }
      var uploads = values.concat(this.state.uploads);
      if (this.props.children) return this.props.children(uploads, this._renderInput);
      if (this.props.themed) {
        var acceptType = "";
        if (type === InputTypes.FILE) {
          acceptType = FILE_ACCEPT_TYPES;
        } else if (type === InputTypes.VIDEO) {
          acceptType = VIDEO_ACCEPT_TYPES;
        } else if (type === InputTypes.AUDIO) {
          acceptType = AUDIO_ACCEPT_TYPES;
        } else {
          acceptType = IMAGE_ACCEPT_TYPES;
        }
        return /*#__PURE__*/React.createElement(FileV2InputWrapper, {
          "data-testid": "file",
          className: "".concat(className, " ").concat(prefixClassName)
        }, /*#__PURE__*/React.createElement(HiddenFileInput, {
          className: "".concat(prefixClassName, "-input"),
          onChange: this._handleFile,
          type: InputTypes.FILE,
          accept: acceptType,
          multiple: this.props.multiple
        }), /*#__PURE__*/React.createElement(IconWrapper, null, type === "document" && /*#__PURE__*/React.createElement(FileIconv2, null), type === InputTypes.IMAGE && /*#__PURE__*/React.createElement(ImageIconv2, null), type === InputTypes.VIDEO && /*#__PURE__*/React.createElement(VideoIconv2, null)), uploads && uploads.length ? /*#__PURE__*/React.createElement(React.Fragment, null, uploads.map(function (upload, i) {
          return /*#__PURE__*/React.createElement(UploadInfoWrapper, {
            key: i
          }, /*#__PURE__*/React.createElement(Box, {
            backgroundColor: "transparent",
            justifyContent: "space-between",
            padding: "zero"
          }, /*#__PURE__*/React.createElement(Text, {
            variant: "body.md",
            color: "black.haptik"
          }, _this2.state.filenames[i].substring(0, 24)), /*#__PURE__*/React.createElement(Text, {
            variant: "body.md",
            color: "black.haptik"
          }, upload.uploadedPercent, "%")), /*#__PURE__*/React.createElement(ProgressBarWrapper, null, /*#__PURE__*/React.createElement(ProgressBar, {
            style: {
              width: "".concat(upload.uploadedPercent, "%")
            }
          })), /*#__PURE__*/React.createElement(CancelIcon, {
            onClick: function onClick() {
              return _this2._deleteFile(i);
            },
            size: Icon.SIZES.MEDIUM,
            src: "closeV2",
            tooltip: "Cancel Upload"
          }));
        })) : /*#__PURE__*/React.createElement(Box, {
          backgroundColor: "transparent",
          flexDirection: "column"
        }, /*#__PURE__*/React.createElement(Text, {
          variant: "body.md",
          color: "blue.haptik",
          className: "mt-1"
        }, "Click here to upload your ", this.props.type), /*#__PURE__*/React.createElement(Text, {
          variant: "body.sm",
          color: "grey.deep",
          className: "mt-1"
        }, "Maximum ", this.props.type, " size ", this.state.fileUploadSize, " MB")));
      }
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "file",
        className: "".concat(styles$3$1.files, " ").concat(className, " ").concat(prefixClassName)
      }, uploads.length === 0 ? this._renderPlaceholder() : this._renderFiles(uploads), uploads.length === 0 ? this._renderInput() : null);
    }
  }, {
    key: "getFileType",
    value: function getFileType(isImage, isVideo, isAudio) {
      if (isImage) return InputTypes.IMAGE;
      if (isVideo) return InputTypes.VIDEO;
      if (isAudio) return InputTypes.AUDIO;
      return InputTypes.FILE;
    }
  }]);
  return File;
}(React.Component)) || _class$2);
File.propTypes = {
  /** Names of already choosen file/files, could be a string (if single file), could be an array(if multiple files) */
  value: PropTypes.oneOf([PropTypes.string, PropTypes.array]),
  /** on change function for input */
  onChange: PropTypes.func,
  /** Custom Icon for File upload */
  customIcon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** Provides a custom validate callback. Returns 'allowedFileTypes, file, fileType' in parameters
   * (Should always return 'true' or 'false' if validation passes/fails respectively)   */
  customValidate: PropTypes.func,
  /** Overrides default upload, a function can be passed to override. Returns 'file, index and numFiles' in
   * parameters. */
  onUpload: PropTypes.func,
  /** Boolean value to allow multiple files */
  multiple: PropTypes.bool,
  /** ratio of the preview image to be generated */
  ratio: PropTypes.string,
  /** Base width for the preview image */
  baseWidth: PropTypes.number,
  /** The classname to be appended to the outermost element */
  className: PropTypes.string,
  /** Prefix to be appended before classname to the outermost element and
   *  variation of prefix gets appended to child elements */
  prefixClassName: PropTypes.string,
  /** Type of file to accept (file or image) or you can pass your own custom formats as a string */
  type: PropTypes.string,
  /** Size of the file allowed in MBs */
  maxFileSize: PropTypes.number,
  /** Dimensions of the file to upload (Doesn't work with type 'file') */
  dimensions: PropTypes.string,
  /** When a custom ui is needed. This render func calls with uploads and the renderInput function */
  children: PropTypes.func,
  activateToastMessage: PropTypes.func,
  /** Gets called whenever file validation returns an error */
  onError: PropTypes.func,
  /** Flag to determine if file input is themed */
  themed: PropTypes.bool,
  /** Indicates from where the upload file action is called */
  source: PropTypes.number
};
File.defaultProps = {
  value: "",
  onChange: function onChange() {},
  customIcon: "",
  onUpload: null,
  customValidate: null,
  multiple: false,
  ratio: "",
  baseWidth: 290,
  className: "",
  prefixClassName: "",
  type: ".png, .jpeg",
  dimensions: "450px X 450px",
  maxFileSize: 5,
  onError: function onError() {},
  themed: false
};
File.classNames = {
  $prefix: "Outermost element",
  "$prefix-placeholder-wrapper": "Outermost element of placeholder",
  "$prefix-placeholder-icon": "Icon element of placeholder",
  "$prefix-placeholder-text-wrapper": "Wraps all the elements containing text inside placeholder",
  "$prefix-placeholder-title": "Title of placeholder",
  "$prefix-placeholder-filesize": "Filesize warning inside placeholder",
  "$prefix-placeholder-format": "Filesize warning inside placeholder",
  "$prefix-placeholder-image-dimensions": "Dimensions text inside placeholder",
  "$prefix-wrapper": "Wrapper of the files",
  "$prefix-file-wrapper": "Wrapper of individual file divs",
  "$prefix-file-preview": "Preview individual file wrapper",
  "$prefix-file-preview-title": "Title of the file in the preview",
  "$prefix-file-preview-delete-wrapper": "Delete icon wrapper over the preview",
  "$prefix-file-preview-delete-icon": "File delete icon",
  "$prefix-on-upload-wrapper": "Wrapper of individual file divs",
  "$prefix-on-upload-preview": "Preview individual custom file wrapper",
  "$prefix-on-upload-preview-delete-wrapper": "Delete icon wrapper over the preview",
  "$prefix-on-upload-preview-delete-icon": "File delete icon",
  "$prefix-loader": "Loader for the file component",
  "$prefix-progressbar-wrapper": "Wrapper for the progress bar",
  "$prefix-progressbar-bar": "Progress bar inside the wrapper",
  "$prefix-image-wrapper": "Wrapper of individual image divs",
  "$prefix-image-preview": "Wrapper of individual image divs",
  "$prefix-image-preview-icon": "Preview icon for image wrapper",
  "$prefix-image-preview-image": "Image inside wrapper",
  "$prefix-image-preview-delete": "Delete wrapper inside image preview",
  "$prefix-image-preview-delete-icon": "Delete icon inside a wrapper image preview",
  "$prefix-input": "Input field",
  "$prefix-addmore-wrapper": "Wrapper for add more button",
  "$prefix-addmore-icon": "Add more button icon",
  "$prefix-addmore-text": "Add more button text"
};
File.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_renderPlaceholder",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderFiles",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "uploads",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderAddMoreButton",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "type",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderInput",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderPreview",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "upload",
      "type": null
    }, {
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderImagePreview",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "upload",
      "type": null
    }, {
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderFilePreview",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "upload",
      "type": null
    }, {
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderOnUploadPreview",
    "docblock": "Renders the preview of the file which has been selected via onUpload prop\n@param {Number} index index of the file selected",
    "modifiers": [],
    "params": [{
      "name": "index",
      "description": "index of the file selected",
      "type": {
        "name": "Number"
      },
      "optional": false
    }],
    "returns": null,
    "description": "Renders the preview of the file which has been selected via onUpload prop"
  }, {
    "name": "_renderImage",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "previewURL",
      "type": null
    }, {
      "name": "isUploading",
      "type": null
    }, {
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderFile",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "previewURL",
      "type": null
    }, {
      "name": "value",
      "type": null
    }, {
      "name": "isUploading",
      "type": null
    }, {
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderLoader",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "isUploading",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getFileType",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "isImage",
      "type": null
    }, {
      "name": "isVideo",
      "type": null
    }, {
      "name": "isAudio",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_transform",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "values",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_deleteFile",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleFile",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_uploadFile",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "file",
      "type": null
    }, {
      "name": "index",
      "type": null
    }, {
      "name": "numFiles",
      "type": null
    }, {
      "name": "source",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onUploadProgress",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "uploadedPercent",
      "type": null
    }, {
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onUploadComplete",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "fileURL",
      "type": null
    }, {
      "name": "index",
      "type": null
    }, {
      "name": "numFiles",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getValidFiles",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "files",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "File",
  "props": {
    "value": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "PropTypes.string",
          "computed": true
        }, {
          "value": "PropTypes.array",
          "computed": true
        }]
      },
      "required": false,
      "description": "Names of already choosen file/files, could be a string (if single file), could be an array(if multiple files)"
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "on change function for input"
    },
    "customIcon": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "Custom Icon for File upload"
    },
    "onUpload": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Overrides default upload, a function can be passed to override. Returns 'file, index and numFiles' in\nparameters."
    },
    "customValidate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Provides a custom validate callback. Returns 'allowedFileTypes, file, fileType' in parameters\n(Should always return 'true' or 'false' if validation passes/fails respectively)"
    },
    "multiple": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Boolean value to allow multiple files"
    },
    "ratio": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "ratio of the preview image to be generated"
    },
    "baseWidth": {
      "defaultValue": {
        "value": "290",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Base width for the preview image"
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The classname to be appended to the outermost element"
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Prefix to be appended before classname to the outermost element and\n variation of prefix gets appended to child elements"
    },
    "type": {
      "defaultValue": {
        "value": "\".png, .jpeg\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Type of file to accept (file or image) or you can pass your own custom formats as a string"
    },
    "dimensions": {
      "defaultValue": {
        "value": "\"450px X 450px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Dimensions of the file to upload (Doesn't work with type 'file')"
    },
    "maxFileSize": {
      "defaultValue": {
        "value": "5",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Size of the file allowed in MBs"
    },
    "onError": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Gets called whenever file validation returns an error"
    },
    "themed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Flag to determine if file input is themed"
    },
    "children": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "When a custom ui is needed. This render func calls with uploads and the renderInput function"
    },
    "activateToastMessage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "source": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Indicates from where the upload file action is called"
    }
  }
};

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var TickIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$7({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/tick",
  stroke: "#81c781"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy-4",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-1-Copy-2",
  cx: "9",
  cy: "9",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Oval-1-Copy-3",
  d: "M13.287 5.942l-6.095 6.367L4.56 9.81"
}))))));

var css_248z$a = ".PreviewWithButton_carouselDetailPreviewImage__LIaEG {\n  width: 100%;\n  height: 80%;\n  border-radius: 8px;\n  background-color: #eee;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n  overflow: hidden; }\n\n.PreviewWithButton_carouselDetailPreviewThumb__cuo7z {\n  width: 100%;\n  height: auto;\n  margin: 0;\n  background-color: #ccc;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n  margin-bottom: 16px; }\n\n.PreviewWithButton_carouselDetailPreviewHeader__1szKr {\n  position: relative;\n  z-index: 2;\n  background-color: #fff;\n  color: #fff;\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #eee; }\n\n.PreviewWithButton_carouselDetailPreviewIcon__3JnaQ {\n  transform: rotate(90deg); }\n\n.PreviewWithButton_carouselDetailPreviewTitle__2gqQh {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 16px;\n  padding-bottom: 6px;\n  text-align: left; }\n\n.PreviewWithButton_carouselDetailPreviewDescription__2Az82 {\n  display: block;\n  font-size: 12px;\n  text-align: left;\n  padding: 6px 16px;\n  opacity: 0.7;\n  margin-bottom: 16px;\n  line-height: 1.4; }\n\n.PreviewWithButton_carouselDetailPreviewButton__3pYhx {\n  width: 100%; }\n\n.PreviewWithButton_carouselDetailPreviewInput__1c63v {\n  margin-top: auto;\n  margin-bottom: 0;\n  padding: 12px 16px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n  background-color: #0e4498;\n  color: #fff; }\n";
var styles$a = {"carouselDetailPreviewImage":"PreviewWithButton_carouselDetailPreviewImage__LIaEG","carouselDetailPreviewThumb":"PreviewWithButton_carouselDetailPreviewThumb__cuo7z","carouselDetailPreviewHeader":"PreviewWithButton_carouselDetailPreviewHeader__1szKr","carouselDetailPreviewIcon":"PreviewWithButton_carouselDetailPreviewIcon__3JnaQ","carouselDetailPreviewTitle":"PreviewWithButton_carouselDetailPreviewTitle__2gqQh","carouselDetailPreviewDescription":"PreviewWithButton_carouselDetailPreviewDescription__2Az82","carouselDetailPreviewButton":"PreviewWithButton_carouselDetailPreviewButton__3pYhx","carouselDetailPreviewInput":"PreviewWithButton_carouselDetailPreviewInput__1c63v"};
styleInject$1(css_248z$a);

var PreviewWithButton = function PreviewWithButton(_ref) {
  var title = _ref.title,
    description = _ref.description,
    buttonText = _ref.buttonText,
    _ref$images = _ref.images,
    images = _ref$images === void 0 ? [] : _ref$images;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$a.carouselDetailPreviewImage
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$a.carouselDetailPreviewHeader
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "angle-down",
    className: styles$a.carouselDetailPreviewIcon
  })), /*#__PURE__*/React.createElement("img", {
    src: images[0],
    className: styles$a.carouselDetailPreviewThumb
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$a.carouselDetailPreviewTitle
  }, title), /*#__PURE__*/React.createElement("span", {
    className: styles$a.carouselDetailPreviewDescription
  }, description), /*#__PURE__*/React.createElement("div", {
    className: styles$a.carouselDetailPreviewInput
  }, buttonText));
};
PreviewWithButton.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  images: PropTypes.array
};
PreviewWithButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PreviewWithButton",
  "props": {
    "images": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "buttonText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$b = ".PreviewWithText_carouselDetailPreviewImage__1zMtw {\n  width: 100%;\n  height: 80%;\n  border-radius: 8px;\n  background-color: #eee;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n  overflow: hidden; }\n\n.PreviewWithText_carouselDetailPreviewThumb__3Vl6x {\n  width: calc(100% - 32px);\n  height: auto;\n  margin: 0 16px;\n  background-color: #ccc;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n  margin-bottom: 16px; }\n\n.PreviewWithText_carouselDetailPreviewHeader__3cGgI {\n  background-color: #0e4498;\n  color: #fff;\n  padding: 8px;\n  text-align: left;\n  display: flex;\n  align-items: center; }\n\n.PreviewWithText_carouselDetailPreviewIcon__2N8mN {\n  transform: rotate(90deg);\n  margin-right: 8px; }\n  .PreviewWithText_carouselDetailPreviewIcon__2N8mN svg path:nth-child(2) {\n    stroke: #fff; }\n\n.PreviewWithText_carouselDetailPreviewTitle__2m3Sy {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 2px; }\n\n.PreviewWithText_carouselDetailPreviewSubtitle__165rP {\n  display: block;\n  font-size: 12px;\n  font-weight: 400; }\n\n.PreviewWithText_carouselDetailPreviewDescription__3wYx6 {\n  display: block;\n  font-size: 12px;\n  text-align: left;\n  padding: 6px 8px;\n  opacity: 0.7;\n  background-color: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n  margin-bottom: 16px; }\n\n.PreviewWithText_carouselDetailPreviewButton__1Yb3w {\n  width: 100%; }\n\n.PreviewWithText_carouselDetailPreviewInput__2Po8F {\n  margin-top: auto;\n  margin-bottom: 0;\n  padding: 12px 16px;\n  text-align: left;\n  font-size: 12px;\n  color: #999;\n  background-color: #fff; }\n";
var styles$b = {"carouselDetailPreviewImage":"PreviewWithText_carouselDetailPreviewImage__1zMtw","carouselDetailPreviewThumb":"PreviewWithText_carouselDetailPreviewThumb__3Vl6x","carouselDetailPreviewHeader":"PreviewWithText_carouselDetailPreviewHeader__3cGgI","carouselDetailPreviewIcon":"PreviewWithText_carouselDetailPreviewIcon__2N8mN","carouselDetailPreviewTitle":"PreviewWithText_carouselDetailPreviewTitle__2m3Sy","carouselDetailPreviewSubtitle":"PreviewWithText_carouselDetailPreviewSubtitle__165rP","carouselDetailPreviewDescription":"PreviewWithText_carouselDetailPreviewDescription__3wYx6","carouselDetailPreviewButton":"PreviewWithText_carouselDetailPreviewButton__1Yb3w","carouselDetailPreviewInput":"PreviewWithText_carouselDetailPreviewInput__2Po8F"};
styleInject$1(css_248z$b);

var PreviewWithText = function PreviewWithText(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    description = _ref.description,
    _ref$images = _ref.images,
    images = _ref$images === void 0 ? [] : _ref$images;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$b.carouselDetailPreviewImage
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$b.carouselDetailPreviewHeader
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "angle-down",
    className: styles$b.carouselDetailPreviewIcon
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$b.carouselDetailPreviewHeaderText
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$b.carouselDetailPreviewTitle
  }, title), /*#__PURE__*/React.createElement("span", {
    className: styles$b.carouselDetailPreviewSubtitle
  }, subtitle))), /*#__PURE__*/React.createElement("span", {
    className: styles$b.carouselDetailPreviewDescription
  }, description), /*#__PURE__*/React.createElement("img", {
    src: images[0],
    className: styles$b.carouselDetailPreviewThumb
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$b.carouselDetailPreviewInput
  }, "Type out your order"));
};
PreviewWithText.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  subtitle: PropTypes.string,
  images: PropTypes.array
};
PreviewWithText.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PreviewWithText",
  "props": {
    "images": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subtitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$c = ".CarouselDetail_carouselDetailModal__1YyLP-body {\n  width: 80vw; }\n\n.CarouselDetail_carouselDetailWrapper__SLK6R {\n  display: flex;\n  align-items: stretch; }\n\n.CarouselDetail_carouselDetailPreview__2WIVC {\n  padding: 16px 32px;\n  border-right: 1px solid #ddd;\n  flex: 1;\n  text-align: center;\n  box-sizing: border-box;\n  max-width: 300px; }\n  .CarouselDetail_carouselDetailPreviewText__F2_Ca {\n    display: block;\n    text-align: center;\n    margin-bottom: 24px; }\n  .CarouselDetail_carouselDetailPreviewImage__3LeP4 {\n    width: 100%;\n    height: 80%;\n    border-radius: 8px;\n    background-color: #eee; }\n\n.CarouselDetail_carouselDetailForm__3jWdE {\n  flex: 2.5;\n  padding: 16px;\n  overflow: hidden; }\n  .CarouselDetail_carouselDetailFormRow__2Wi6B {\n    display: flex;\n    align-items: center;\n    margin-bottom: 12px; }\n    .CarouselDetail_carouselDetailFormRow__2Wi6B > div:not(:last-child) {\n      margin-right: 12px; }\n\n.CarouselDetail_carouselDetailDesc__2mkGq {\n  margin-bottom: 12px; }\n";
var styles$c = {"carouselDetailModal":"CarouselDetail_carouselDetailModal__1YyLP","carouselDetailWrapper":"CarouselDetail_carouselDetailWrapper__SLK6R","carouselDetailPreview":"CarouselDetail_carouselDetailPreview__2WIVC","carouselDetailPreviewText":"CarouselDetail_carouselDetailPreviewText__F2_Ca","carouselDetailPreviewImage":"CarouselDetail_carouselDetailPreviewImage__3LeP4","carouselDetailForm":"CarouselDetail_carouselDetailForm__3jWdE","carouselDetailFormRow":"CarouselDetail_carouselDetailFormRow__2Wi6B","carouselDetailDesc":"CarouselDetail_carouselDetailDesc__2mkGq"};
styleInject$1(css_248z$c);

var CarouselDetail = /*#__PURE__*/function (_React$Component) {
  function CarouselDetail(props) {
    var _this;
    _classCallCheck$4(this, CarouselDetail);
    _this = _callSuper(this, CarouselDetail, [props]);
    _defineProperty$1(_this, "_renderPreview", function () {
      if (_this.props.withButton) {
        return /*#__PURE__*/React.createElement(PreviewWithButton, _this.state);
      }
      if (_this.props.withText) {
        return /*#__PURE__*/React.createElement(PreviewWithText, _this.state);
      }
      return null;
    });
    _this.state = {
      title: "",
      subtitle: "",
      description: "",
      images: [],
      buttonText: "",
      userMessage: "",
      gogoMessage: ""
    };
    if (props.value) {
      _this.state = props.value;
    }
    return _this;
  }
  _inherits$3(CarouselDetail, _React$Component);
  return _createClass$4(CarouselDetail, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;
      var updatedAlready = false;
      Object.keys(this.state).map(function (key) {
        if (typeof nextProps.value[key] === "string") {
          if (_this2.props.value[key] !== nextProps.value[key] && !updatedAlready) {
            _this2.setState(nextProps.value);
            updatedAlready = true;
          }
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        title = _this$state.title,
        subtitle = _this$state.subtitle,
        description = _this$state.description,
        buttonText = _this$state.buttonText,
        userMessage = _this$state.userMessage,
        gogoMessage = _this$state.gogoMessage;
      return /*#__PURE__*/React.createElement(Modal$1, {
        prefixClassName: styles$c.carouselDetailModal,
        onClose: this.props.onClose,
        active: this.props.active
      }, /*#__PURE__*/React.createElement(Modal$1.Header, {
        withSave: true,
        onClose: this.props.onClose,
        onSave: function onSave(e) {
          return _this3.props.onChange(_this3.state, e);
        }
      }, "Add Information for Carousel Detail View (With", " ", this.props.withText ? "Text" : "Button", ")"), /*#__PURE__*/React.createElement("div", {
        className: styles$c.carouselDetailWrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$c.carouselDetailPreview
      }, /*#__PURE__*/React.createElement("span", {
        className: styles$c.carouselDetailPreviewText
      }, "Preview"), this._renderPreview()), /*#__PURE__*/React.createElement("div", {
        className: styles$c.carouselDetailForm
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$c.carouselDetailFormRow
      }, /*#__PURE__*/React.createElement(Text$1, {
        labelClassName: styles$c.carouselDetailInputLabel,
        label: "Title",
        value: title,
        onChange: function onChange(title) {
          _this3.setState({
            title: title
          });
        }
      }), /*#__PURE__*/React.createElement(Text$1, {
        labelClassName: styles$c.carouselDetailInputLabel,
        label: "Subtitle",
        value: subtitle,
        onChange: function onChange(subtitle) {
          _this3.setState({
            subtitle: subtitle
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: styles$c.carouselDetailDesc
      }, /*#__PURE__*/React.createElement(Text$1, {
        label: "Description",
        multiline: true,
        value: description,
        onChange: function onChange(description) {
          _this3.setState({
            description: description
          });
        }
      })), /*#__PURE__*/React.createElement(File, {
        value: this.state.images,
        onChange: function onChange(images) {
          return _this3.setState({
            images: images
          });
        },
        multiple: true,
        baseWidth: 200,
        source: 0
      }), /*#__PURE__*/React.createElement("br", null), this.props.withButton ? /*#__PURE__*/React.createElement("div", {
        className: styles$c.carouselDetailFormRow
      }, /*#__PURE__*/React.createElement(Text$1, {
        labelClassName: styles$c.carouselDetailInputLabel,
        label: "Button Text",
        value: buttonText,
        onChange: function onChange(buttonText) {
          _this3.setState({
            buttonText: buttonText
          });
        }
      }), /*#__PURE__*/React.createElement(Text$1, {
        labelClassName: styles$c.carouselDetailInputLabel,
        label: "User Message",
        value: userMessage,
        onChange: function onChange(userMessage) {
          _this3.setState({
            userMessage: userMessage
          });
        }
      }), /*#__PURE__*/React.createElement(Text$1, {
        labelClassName: styles$c.carouselDetailInputLabel,
        label: "Payload Message",
        value: gogoMessage,
        onChange: function onChange(gogoMessage) {
          _this3.setState({
            gogoMessage: gogoMessage
          });
        }
      })) : null)));
    }
  }]);
}(React.Component);
CarouselDetail.propTypes = {
  active: PropTypes.bool,
  onClose: PropTypes.func,
  value: PropTypes.object,
  onChange: PropTypes.func,
  withButton: PropTypes.bool,
  withText: PropTypes.bool
};
CarouselDetail.defaultProps = {
  active: false,
  withButton: false,
  withText: false,
  value: null,
  onClose: function onClose() {},
  onChange: function onChange() {}
};
CarouselDetail.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_renderPreview",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "CarouselDetail",
  "props": {
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withButton": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withText": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "onClose": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$d = ".LocationDetail_modal__o-QtX {\n  width: 80vw; }\n  .LocationDetail_modal__o-QtX-body {\n    min-width: 60vw !important;\n    overflow: hidden; }\n\n.LocationDetail_wrapper__1tugp {\n  max-height: 70vh;\n  overflow-y: auto; }\n\n.LocationDetail_formRow__3w4LO {\n  display: flex;\n  align-items: center;\n  padding: 16px; }\n  .LocationDetail_formRowItem__w38bz {\n    display: flex;\n    align-items: center;\n    padding: 8px 0; }\n\n.LocationDetail_inputLabel__1Qtxg {\n  font-size: 13px; }\n\n.LocationDetail_inputMessage__DoEym {\n  padding-right: 6px; }\n\n.LocationDetail_gogoMessage__1a08m {\n  padding-left: 6px; }\n\n.LocationDetail_items__NluFa {\n  background-color: #fff;\n  overflow: hidden; }\n\n.LocationDetail_item__1dHTL {\n  padding: 16px 16px 8px;\n  border-bottom: 1px solid #ddd; }\n\n.LocationDetail_itemHeader__2GFxk {\n  font-size: 16px;\n  font-weight: 600;\n  padding-bottom: 8px;\n  display: flex;\n  justify-content: space-between; }\n";
var styles$d = {"modal":"LocationDetail_modal__o-QtX","wrapper":"LocationDetail_wrapper__1tugp","formRow":"LocationDetail_formRow__3w4LO","formRowItem":"LocationDetail_formRowItem__w38bz","inputLabel":"LocationDetail_inputLabel__1Qtxg","inputMessage":"LocationDetail_inputMessage__DoEym","gogoMessage":"LocationDetail_gogoMessage__1a08m","items":"LocationDetail_items__NluFa","item":"LocationDetail_item__1dHTL","itemHeader":"LocationDetail_itemHeader__2GFxk"};
styleInject$1(css_248z$d);

var LocationItem = function LocationItem(_ref) {
  var latKey = _ref.latKey,
    lngKey = _ref.lngKey,
    actionableText = _ref.actionableText,
    descriptionText = _ref.descriptionText,
    _onChange = _ref.onChange,
    index = _ref.index,
    onDelete = _ref.onDelete;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$d.item
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$d.itemHeader
  }, /*#__PURE__*/React.createElement("span", null, "Location ", index + 1), /*#__PURE__*/React.createElement(Icon, {
    onClick: onDelete,
    src: "trash"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$d.formRowItem
  }, /*#__PURE__*/React.createElement(Text$1, {
    className: styles$d.inputMessage,
    labelClassName: styles$d.inputLabel,
    label: "Actionable Text",
    withMargin: true,
    value: actionableText,
    onChange: function onChange(actionableText) {
      _onChange("actionableText", actionableText);
    }
  }), /*#__PURE__*/React.createElement(Text$1, {
    className: styles$d.gogoMessage,
    labelClassName: styles$d.inputLabel,
    label: "Description Text",
    value: descriptionText,
    onChange: function onChange(descriptionText) {
      _onChange("descriptionText", descriptionText);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$d.formRowItem
  }, /*#__PURE__*/React.createElement(Text$1, {
    className: styles$d.inputMessage,
    labelClassName: styles$d.inputLabel,
    label: "Latitude Key",
    withMargin: true,
    value: latKey,
    onChange: function onChange(latKey) {
      _onChange("latKey", latKey);
    }
  }), /*#__PURE__*/React.createElement(Text$1, {
    className: styles$d.gogoMessage,
    labelClassName: styles$d.inputLabel,
    label: "Longitude Key",
    value: lngKey,
    onChange: function onChange(lngKey) {
      _onChange("lngKey", lngKey);
    }
  })));
};
LocationItem.propTypes = {
  latKey: PropTypes.string,
  lngKey: PropTypes.string,
  actionableText: PropTypes.string,
  descriptionText: PropTypes.string,
  index: PropTypes.number,
  onChange: PropTypes.func,
  onDelete: PropTypes.func
};
LocationItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LocationItem",
  "props": {
    "latKey": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "lngKey": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "actionableText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "descriptionText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "index": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDelete": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var LocationDetail = /*#__PURE__*/function (_React$Component) {
  function LocationDetail(props) {
    var _this;
    _classCallCheck$4(this, LocationDetail);
    _this = _callSuper(this, LocationDetail, [props]);
    _defineProperty$1(_this, "_newLocation", {
      latKey: "",
      lngKey: "",
      descriptionText: "",
      actionableText: "",
      index: 0
    });
    _defineProperty$1(_this, "_handleChange", function (i, key, value) {
      _this.setState(function (state) {
        var locations = state.location || [];
        locations[i][key] = value;
        return {
          location: locations
        };
      });
    });
    _defineProperty$1(_this, "_handleDelete", function (i) {
      _this.setState(function (state) {
        var locations = state.location || [];
        locations.splice(i, 1);
        locations = locations.map(function (location, i) {
          location.index = i;
          return location;
        });
        return {
          location: locations
        };
      });
    });
    _defineProperty$1(_this, "_addLocation", function () {
      _this.setState(function (state) {
        var locations = state.location || [];
        var newLocation = _objectSpread2$1({}, _this._newLocation);
        newLocation.index = locations.length;
        return {
          location: locations.concat([newLocation])
        };
      }, function () {
        if (_this.locationItems.current) {
          _this.locationItems.current.scroll({
            top: _this.locationItems.current.scrollHeight,
            behavior: "smooth"
          });
        }
      });
    });
    _this.state = {
      message: "",
      gogoMessage: "",
      location: []
    };
    _this.locationItems = /*#__PURE__*/React.createRef();
    if (props.value) {
      _this.state = props.value;
    }
    return _this;
  }
  _inherits$3(LocationDetail, _React$Component);
  return _createClass$4(LocationDetail, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;
      var updatedAlready = false;
      Object.keys(this.state).map(function (key) {
        if (typeof nextProps.value[key] === "string") {
          if (_this2.props.value[key] !== nextProps.value[key] && !updatedAlready) {
            _this2.setState(nextProps.value);
            updatedAlready = true;
          }
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        message = _this$state.message,
        gogoMessage = _this$state.gogoMessage,
        _this$state$location = _this$state.location,
        location = _this$state$location === void 0 ? [] : _this$state$location;
      return /*#__PURE__*/React.createElement(Modal$1, {
        onClose: this.props.onClose,
        active: this.props.active,
        prefixClassName: styles$d.modal
      }, /*#__PURE__*/React.createElement(Modal$1.Header, {
        withSave: true,
        onClose: this.props.onClose,
        onSave: function onSave(e) {
          return _this3.props.onChange(_this3.state, e);
        }
      }, "Add Information for the Location Picker"), /*#__PURE__*/React.createElement("div", {
        className: styles$d.wrapper,
        ref: this.locationItems
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$d.form
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$d.formRow
      }, /*#__PURE__*/React.createElement(Text$1, {
        className: styles$d.inputMessage,
        labelClassName: styles$d.inputLabel,
        label: "Message",
        withMargin: true,
        value: message,
        onChange: function onChange(message) {
          _this3.setState({
            message: message
          });
        }
      }), /*#__PURE__*/React.createElement(Text$1, {
        className: styles$d.gogoMessage,
        labelClassName: styles$d.inputLabel,
        label: "Payload Message",
        value: gogoMessage,
        onChange: function onChange(gogoMessage) {
          _this3.setState({
            gogoMessage: gogoMessage
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: styles$d.items
      }, location.map(function (locationItem, i) {
        return /*#__PURE__*/React.createElement(LocationItem, _extends$9({
          key: i
        }, locationItem, {
          onDelete: function onDelete() {
            return _this3._handleDelete(i);
          },
          onChange: function onChange(key, value) {
            return _this3._handleChange(i, key, value);
          }
        }));
      }), /*#__PURE__*/React.createElement(AddButton, {
        onClick: this._addLocation
      }, " ", "Add location collector", " ")))));
    }
  }]);
}(React.Component);
LocationDetail.propTypes = {
  active: PropTypes.bool,
  onClose: PropTypes.func,
  value: PropTypes.object,
  onChange: PropTypes.func
};
LocationDetail.defaultProps = {
  onClose: function onClose() {}
};
LocationDetail.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_handleChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "key",
      "type": null
    }, {
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleDelete",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_addLocation",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "LocationDetail",
  "props": {
    "onClose": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$e = ".Popup_popup__eOhfN {\n  margin-right: 8px; }\n  .Popup_popupButton__3vueC {\n    width: 100%; }\n\n.Popup_popupIcon__Q8_io {\n  width: 20px;\n  height: 20px;\n  border-radius: 8px; }\n\n.Popup_popupIconTicked__kBj4x svg circle {\n  fill: #0e4498; }\n\n.Popup_popupIconTicked__kBj4x path,\n.Popup_popupIconTicked__kBj4x g {\n  stroke: #fff; }\n";
var styles$e = {"popup":"Popup_popup__eOhfN","popupButton":"Popup_popupButton__3vueC","popupIcon":"Popup_popupIcon__Q8_io","popupIconTicked":"Popup_popupIconTicked__kBj4x"};
styleInject$1(css_248z$e);

// default for LOCATION HSL
var DEFAULT_LOCATION_OBJECT = {
  message: "Selected location: \n%s",
  gogoMessage: "{api_name:uber_api}",
  location: [{
    latKey: "origin_lat",
    lngKey: "origin_lng",
    descriptionText: "",
    actionableText: "",
    index: 0
  }]
};
var Popup = /*#__PURE__*/function (_React$Component) {
  function Popup() {
    var _this;
    _classCallCheck$4(this, Popup);
    _this = _callSuper(this, Popup);
    _defineProperty$1(_this, "_renderPopup", function () {
      switch (_this.props.type) {
        case "CAROUSEL_DETAIL_WITH_BUTTON":
          return /*#__PURE__*/React.createElement(CarouselDetail, {
            value: _this.props.value,
            onChange: _this._handleChange,
            active: _this.state.popupActive,
            onClose: _this._deactivatePopup,
            withButton: true
          });
        case "CAROUSEL_DETAIL_WITH_TEXT":
          return /*#__PURE__*/React.createElement(CarouselDetail, {
            value: _this.props.value,
            onChange: _this._handleChange,
            active: _this.state.popupActive,
            onClose: _this._deactivatePopup,
            withText: true
          });
        case "SINGLE_LOCATION":
          return /*#__PURE__*/React.createElement(LocationDetail, {
            value: _this.props.value,
            onChange: _this._handleChange,
            active: _this.state.popupActive,
            onClose: _this._deactivatePopup
          });
        default:
          return null;
      }
    });
    _defineProperty$1(_this, "_handleChange", function (data, e) {
      _this.props.onChange(data, e);
      _this._deactivatePopup();
    });
    _defineProperty$1(_this, "_activatePopup", function () {
      _this.setState({
        popupActive: true
      });
    });
    _defineProperty$1(_this, "_deactivatePopup", function () {
      _this.setState({
        popupActive: false
      });
    });
    _this.state = {
      popupActive: false
    };
    return _this;
  }
  _inherits$3(Popup, _React$Component);
  return _createClass$4(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // setting default LOCATION HSL
      if (this.props.type === "SINGLE_LOCATION") {
        this._handleChange(DEFAULT_LOCATION_OBJECT);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(prevProps) {
      // setting default LOCATION HSL
      if (this.props.type !== prevProps.type && this.props.type === "SINGLE_LOCATION") {
        this._handleChange(DEFAULT_LOCATION_OBJECT);
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      // disabling popup for LOCATION HSL
      if (this.props.type === "SINGLE_LOCATION") {
        return /*#__PURE__*/React.createElement(React.Fragment, null);
      }
      return /*#__PURE__*/React.createElement("div", null, this.props.value && Object.keys(this.props.value).length > 0 ? /*#__PURE__*/React.createElement(Button, {
        onClick: this._activatePopup,
        className: styles$e.popupButton,
        type: "secondary"
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$e.popup
      }, "Information Added"), /*#__PURE__*/React.createElement(Icon, {
        src: TickIcon,
        className: "".concat(styles$e.popupIcon, " ").concat(styles$e.popupIconTicked)
      })) : /*#__PURE__*/React.createElement(Button, {
        onClick: this._activatePopup,
        className: styles$e.popupButton,
        type: "secondary"
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$e.popup
      }, "Add Information"), /*#__PURE__*/React.createElement(Icon, {
        src: AddIcon,
        className: styles$e.popupIcon
      })), this._renderPopup());
    }
  }]);
}(React.Component);
Popup.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  type: PropTypes.string
};
Popup.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_renderPopup",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_handleChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "data",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_activatePopup",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_deactivatePopup",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Popup",
  "props": {
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var sort = function sort(items, oldIndex, newIndex) {
  return arrayMove(items, oldIndex, newIndex);
};
var toggle = function toggle(active, index) {
  if (active === index) {
    return false;
  }
  return index;
};
var edit = function edit(items, index, key, value) {
  var editedItem = _objectSpread2$1({}, items[index]);
  if (key === "type") {
    editedItem.uri = {};
  }
  if (key === "type" || key === "uri") {
    editedItem.url = "";
  }
  editedItem[key] = value;
  items[index] = editedItem;
  return items;
};
var add$1 = function add(items, index, newItemReference) {
  var indexToInsertAt = typeof index === "number" ? index : items.length - 1;
  var newItem = _objectSpread2$1(_objectSpread2$1({}, newItemReference), {}, {
    id: items.length,
    title: "".concat(newItemReference.title, "  ").concat(items.length + 1),
    text: ""
  });
  var list = items.reduce(function (items, item, index) {
    items.push(item);
    if (index === indexToInsertAt) {
      items.push(newItem);
    }
    return items;
  }, []);
  if (list.length === 0) {
    list = [newItem];
  }
  return list;
};
var remove = function remove(items, index) {
  return items.filter(function (_, i) {
    return i !== index;
  });
};
var toggleDefault = function toggleDefault(items, index, toggleValue) {
  return items.map(function (item, i) {
    item.isDefault = i === index ? toggleValue : false;
    return item;
  });
};
var renderAdditionalFields = function renderAdditionalFields(actionable, additionalFields, actionableIndex, editActionable, toggleActionable, actionableActive, showAdvancedOptions, onEmojiClick) {
  return additionalFields.map(function (field, i) {
    var value = actionable[field.key];
    if (value && typeof value !== "string") {
      if (field.type === "MULTI_DROPDOWN") {
        // For multi select dropdown, we don't have a single text field,
        // instead we've to pass array of selected items.
        value = actionable[field.key] || [];
      } else {
        value = actionable[field.key].text || "";
      }
    }
    var commonProps = {
      key: i,
      value: value,
      label: field.label,
      placeholder: field.placeholder,
      className: "input-margin",
      onFocus: function onFocus() {
        return actionableActive !== actionableIndex && toggleActionable(actionableIndex);
      },
      onChange: function onChange(value) {
        return editActionable(actionableIndex, field.key, value);
      },
      onEmojiClick: onEmojiClick
    };
    if (field.defaultValue && !actionable[field.key]) {
      editActionable(actionableIndex, field.key, field.defaultValue);
    }
    if (!showAdvancedOptions && field.advanced) {
      return null;
    }
    if (field.type === "DROPDOWN") {
      return /*#__PURE__*/React.createElement(Dropdown, _extends$9({}, commonProps, {
        options: field.options
      }));
    }
    if (field.type === "MULTI_DROPDOWN") {
      return /*#__PURE__*/React.createElement(Dropdown, _extends$9({
        withMultiple: true
      }, commonProps, {
        options: field.options
      }));
    }
    if (field.type === "TEXT" || field.type === "MULTITEXT") {
      return /*#__PURE__*/React.createElement(Text$1, _extends$9({}, commonProps, {
        multiline: field.type === "MULTITEXT"
      }));
    }
    if (field.type === "POPUP") {
      return /*#__PURE__*/React.createElement(Popup, _extends$9({}, commonProps, {
        type: field.popupType,
        value: actionable[field.key] || {}
      }));
    }
    if (field.type === "TOGGLE") {
      return /*#__PURE__*/React.createElement(Toggle, _extends$9({}, commonProps, {
        value: actionable[field.key]
      }));
    }
    if (field.type === "IMAGE") {
      return /*#__PURE__*/React.createElement(File, _extends$9({}, commonProps, {
        value: actionable[field.key],
        source: 0
      }));
    }
    return null;
  });
};

var humps = createCommonjsModule(function (module) {
(function(global) {

  var _processKeys = function(convert, obj, options) {
    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
      return obj;
    }

    var output,
        i = 0,
        l = 0;

    if(_isArray(obj)) {
      output = [];
      for(l=obj.length; i<l; i++) {
        output.push(_processKeys(convert, obj[i], options));
      }
    }
    else {
      output = {};
      for(var key in obj) {
        if(Object.prototype.hasOwnProperty.call(obj, key)) {
          output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
      }
    }
    return output;
  };

  // String conversion methods

  var separateWords = function(string, options) {
    options = options || {};
    var separator = options.separator || '_';
    var split = options.split || /(?=[A-Z])/;

    return string.split(split).join(separator);
  };

  var camelize = function(string) {
    if (_isNumerical(string)) {
      return string;
    }
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
  };

  var pascalize = function(string) {
    var camelized = camelize(string);
    // Ensure 1st char is always uppercase
    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
  };

  var decamelize = function(string, options) {
    return separateWords(string, options).toLowerCase();
  };

  // Utilities
  // Taken from Underscore.js

  var toString = Object.prototype.toString;

  var _isFunction = function(obj) {
    return typeof(obj) === 'function';
  };
  var _isObject = function(obj) {
    return obj === Object(obj);
  };
  var _isArray = function(obj) {
    return toString.call(obj) == '[object Array]';
  };
  var _isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
  };
  var _isRegExp = function(obj) {
    return toString.call(obj) == '[object RegExp]';
  };
  var _isBoolean = function(obj) {
    return toString.call(obj) == '[object Boolean]';
  };

  // Performant way to determine if obj coerces to a number
  var _isNumerical = function(obj) {
    obj = obj - 0;
    return obj === obj;
  };

  // Sets up function which handles processing keys
  // allowing the convert function to be modified by a callback
  var _processor = function(convert, options) {
    var callback = options && 'process' in options ? options.process : options;

    if(typeof(callback) !== 'function') {
      return convert;
    }

    return function(string, options) {
      return callback(string, convert, options);
    }
  };

  var humps = {
    camelize: camelize,
    decamelize: decamelize,
    pascalize: pascalize,
    depascalize: decamelize,
    camelizeKeys: function(object, options) {
      return _processKeys(_processor(camelize, options), object);
    },
    decamelizeKeys: function(object, options) {
      return _processKeys(_processor(decamelize, options), object, options);
    },
    pascalizeKeys: function(object, options) {
      return _processKeys(_processor(pascalize, options), object);
    },
    depascalizeKeys: function () {
      return this.decamelizeKeys.apply(this, arguments);
    }
  };

  if ( module.exports) {
    module.exports = humps;
  } else {
    global.humps = humps;
  }

})(commonjsGlobal);
});

function _removeEmpty(items) {
  Object.keys(items).forEach(function (key) {
    return items[key] && _typeof$1(items[key]) === "object" && _removeEmpty(items[key]) || items[key] === undefined && delete items[key];
  });
  return items;
}
var getURI = function getURI(uri) {
  var matchedUris = SCREEN_OPTIONS.filter(function (actionableType) {
    return actionableType.value === uri;
  });
  return matchedUris.length > 0 ? matchedUris[0] : {};
};
var getType = function getType(type) {
  var matchedTypes = ACTIONABLE_OPTIONS.filter(function (actionableType) {
    return actionableType.value === type;
  });
  return matchedTypes.length > 0 ? matchedTypes[0] : {};
};
var getSize = function getSize(width) {
  var matchedTypes = CAROUSEL_SIZE_OPTIONS.filter(function (sizeOption) {
    return sizeOption.value === width;
  });
  return matchedTypes.length > 0 ? matchedTypes[0] : {};
};
var getAspectRatio = function getAspectRatio(ratio) {
  var matchedTypes = CAROUSEL_RATIO_OPTIONS.filter(function (sizeOption) {
    return sizeOption.value === ratio;
  });
  if (matchedTypes.length > 0) {
    return matchedTypes[0];
  }
  if (ratio && ratio > 0) {
    return {
      text: "Custom",
      value: ratio
    };
  }
  return {};
};
var getActionableSubtitle = function getActionableSubtitle(actionable) {
  var subtitle = "".concat(actionable.type.text || "");
  ACTIONABLE_OPTIONS.map(function (OPTION) {
    if (OPTION.additionalFields) {
      OPTION.additionalFields.map(function (additionalField) {
        var actionableField = actionable[additionalField.key];
        if (actionableField && actionableField.text) subtitle += ": ".concat(actionableField.text);else if (actionableField && typeof actionableField === "string") subtitle += ": ".concat(actionableField);
      });
    }
  });
  return subtitle;
};
var fromCarouselDetail = function fromCarouselDetail() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    payload: {}
  };
  var carouselDetailsConverted = {
    title: item.payload.title,
    subtitle: item.payload.sub_title,
    description: item.payload.description,
    images: item.payload.images,
    buttonText: item.payload.actionable_text,
    userMessage: item.payload.user_message,
    gogoMessage: item.payload.gogo_message,
    link: item.payload.link
  };
  if (item.payload.actionables && item.payload.actionables.length === 1) {
    carouselDetailsConverted.gogoMessage = item.payload.actionables[0].payload.gogo_message;
    if (!carouselDetailsConverted.buttonText) {
      carouselDetailsConverted.buttonText = item.payload.actionables[0].actionable_text;
    }
  }
  return carouselDetailsConverted;
};
var toCarouselDetail = function toCarouselDetail() {
  var actionable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    carouselDetails: {},
    actionables: []
  };
  var isDefault = arguments.length > 1 ? arguments[1] : undefined;
  var carouselDetails = actionable.carouselDetails || {};
  var carouselDetailsConverted = {
    actionable_text: carouselDetails.buttonText,
    title: carouselDetails.title,
    sub_title: carouselDetails.subtitle,
    description: carouselDetails.description,
    images: carouselDetails.images || [],
    user_message: carouselDetails.userMessage,
    gogo_message: carouselDetails.gogoMessage,
    link: carouselDetails.link || ""
  };
  if (isDefault) {
    carouselDetailsConverted.actionables = [{
      actionable_text: carouselDetails.buttonText,
      location_required: false,
      uri: actionable.actionables && actionable.actionables[0] ? actionable.actionables[0].uri : "",
      is_default: 1,
      type: actionable.actionables && actionable.actionables[0] ? actionable.actionables[0].type : "TEXT_ONLY",
      payload: {
        link: "",
        gogo_message: carouselDetails.gogoMessage
      },
      emoji: ""
    }];
  }
  return carouselDetailsConverted;
};
var fromLocationDetail = function fromLocationDetail() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    payload: {}
  };
  return {
    location: humps.camelizeKeys(item.payload.location),
    message: item.payload.message,
    gogoMessage: item.payload.gogo_message,
    link: item.payload.link,
    showZoomButton: item.payload.show_zoom_button,
    mapType: item.payload.map_type,
    defaultLat: item.payload.default_lat,
    defaultLng: item.payload.default_lng,
    defaultPincode: item.payload.default_pincode,
    showMapTypeButton: item.payload.show_map_type_button
  };
};
var toLocationDetail = function toLocationDetail() {
  var actionable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    locationDetails: {}
  };
  var locationDetails = actionable.locationDetails || {};
  return {
    location: humps.decamelizeKeys(locationDetails.location),
    message: locationDetails.message,
    gogo_message: locationDetails.gogoMessage,
    link: locationDetails.link || "",
    show_zoom_button: actionable.showZoomButton,
    map_type: actionable.mapType,
    default_lat: actionable.defaultLat,
    default_lng: actionable.defaultLng,
    default_pincode: actionable.defaultPincode,
    show_map_type_button: actionable.showMapTypeButton
  };
};
var toDocumentMimeDetail = function toDocumentMimeDetail(actionable) {
  var mimeTypesDetails = actionable.mimeTypes || [];
  var mimeValueList = [];
  mimeTypesDetails.forEach(function (item) {
    // Concating mimeType array
    mimeValueList = mimeValueList.concat(item.value);
  });
  return {
    mime_types: mimeValueList
  };
};
var fromDocumentMimeDetail = function fromDocumentMimeDetail(item, mimeType) {
  var mimeTypes = item.payload.mime_types || [];
  // As payload.mime_types array contains only mime code of selected mimes,
  // iterating over original mime list to get all data of mime.
  // Some mimeTypes have multiple code values, using only 0th index value.
  // payload.mime_types will have all values of a given mimeType or none.
  var mimeList = Object.values(mimeType).filter(function (mime) {
    return mimeTypes.includes(mime.value[0]);
  });
  return mimeList;
};
var convertToActionables = function convertToActionables(_ref) {
  var _ref$actionables = _ref.actionables,
    actionables = _ref$actionables === void 0 ? [] : _ref$actionables;
  var items = actionables.map(function (actionable) {
    var actionableHSL = {
      actionable_text: actionable.text,
      location_required: actionable.locationRequired || false,
      is_default: actionable.isDefault ? 1 : 0,
      uri: (actionable.uri || {}).value ? (actionable.uri || {}).value : "",
      type: (actionable.type || {}).value,
      payload: _objectSpread2$1(_objectSpread2$1({}, humps.decamelizeKeys(actionable)), {}, {
        gogo_message: actionable.gogoMessage || ""
      })
    };
    if (actionableHSL.uri === "CAROUSEL_DETAIL" || actionableHSL.uri === "CAROUSEL_DEFAULT") {
      actionableHSL.payload = toCarouselDetail(actionable, actionableHSL.uri === "CAROUSEL_DEFAULT");
    }
    if (actionableHSL.uri === "DOCUMENT_PICKER" || actionableHSL.uri === "VIDEO_PICKER") {
      actionableHSL.payload = toDocumentMimeDetail(actionable);
    }
    if (actionableHSL.uri === "SEND_LOCATION" || actionableHSL.uri === "SEND_MULTIPLE_LOCATIONS") {
      actionableHSL.payload = toLocationDetail(actionable);
    }
    var payload = actionableHSL.payload;
    Object.keys(payload).map(function (key) {
      var keys = key.split(".");
      var keyValue = payload[key];

      // Sometimes the key is of the format location.details, we want
      // to nest the key in that case, so instead of payload[location.details]
      // we want to nest that value under payload[location][details]
      if (keys.length === 2) {
        delete payload[key];
        if (!payload[keys[0]]) payload[keys[0]] = {};
        payload[keys[0]][keys[1]] = keyValue;
      }
    });
    var deleteKeys = ["text", "locationRequired", "isDefault", "uri", "type", "id"];
    deleteKeys.map(function (key) {
      return delete actionableHSL.payload[key];
    });
    if (actionableHSL.uri === "LAUNCH_CHANNEL" && actionableHSL.type === "APP_ACTION") {
      actionableHSL.payload.message = actionableHSL.payload.message || "";
    }
    return _removeEmpty(actionableHSL);
  });
  return items;
};
var convertFromActionables = function convertFromActionables(_ref2) {
  var _ref2$data = _ref2.data,
    data = _ref2$data === void 0 ? {
      items: []
    } : _ref2$data;
  var actionables = (data.items || []).map(function (item) {
    var actionable = _objectSpread2$1({
      text: item.actionable_text,
      uri: getURI(item.uri) || "",
      type: getType(item.type)
    }, humps.camelizeKeys(item.payload));
    if (item.uri === "CAROUSEL_DETAIL" || item.uri === "CAROUSEL_DEFAULT") {
      actionable.carouselDetails = fromCarouselDetail(item);
    }
    if (item.uri === "DOCUMENT_PICKER" || item.uri === "VIDEO_PICKER") {
      var mimeType = item.uri === "DOCUMENT_PICKER" ? DOCUMENT_MIME_TYPES : VIDEO_MIME_TYPES;
      actionable.mimeTypes = fromDocumentMimeDetail(item, mimeType);
    }
    if (item.uri === "SEND_LOCATION" || item.uri === "SEND_MULTIPLE_LOCATIONS") {
      actionable.locationDetails = fromLocationDetail(item);
    }
    return actionable;
  });
  return actionables;
};
var convertFromFormHSL = function convertFromFormHSL(_ref3) {
  var _ref3$fields = _ref3.fields,
    fields = _ref3$fields === void 0 ? [] : _ref3$fields;
  var items = fields.map(function (field) {
    var item = {
      autoFill: field.auto_fill,
      autoFillSource: field.auto_fill_source,
      hint: field.hint,
      icon: field.icon,
      key: field.key,
      fixedLength: field.fixed_length,
      isFixedLengthValidation: !!field.fixed_length,
      options: field.options ? field.options.join(",") : null,
      order: field.order,
      searchPlaceholder: field.search_placeholder,
      searchSource: field.search_source,
      type: field.type,
      regex: field.regex,
      errorMessage: field.error_message,
      required: field.required,
      isStartDateValidation: field.start_date,
      isEndDateValidation: field.end_date,
      isRangeValidation: field.range_start || field.range_end,
      startDate: field.start_date,
      endDate: field.end_date,
      rangeStart: field.range_start,
      rangeEnd: field.range_end,
      preFilledValue: field.prefilled_value
    };
    // We've 2 types of regex, default(predefined regexs) and custom.
    // If no regex is selected or predefined regex is selected,
    // we'll show default validation view. Else we'll show custom validation view.
    if (field.regex === undefined || TEXT_VALIDATION_REGEX.find(function (item) {
      return item.value === field.regex;
    })) {
      item.isDefaultValidation = true;
      item.isCustomValidation = false;
    } else {
      item.isDefaultValidation = false;
      item.isCustomValidation = true;
    }
    return item;
  });
  return items;
};
var convertToFormHSL = function convertToFormHSL(_ref4) {
  var _ref4$fields = _ref4.fields,
    fields = _ref4$fields === void 0 ? [] : _ref4$fields;
  var items = fields.map(function (field) {
    var options = field.options ? field.options.split(",") : null;
    var item = {
      auto_fill: field.autoFill,
      auto_fill_source: field.autoFillSource,
      hint: field.hint,
      icon: field.icon,
      key: field.key,
      fixed_length: field.fixedLength,
      options: options,
      order: field.order,
      search_placeholder: field.searchPlaceholder,
      search_source: field.searchSource,
      type: field.type,
      regex: field.regex,
      error_message: field.errorMessage,
      required: field.required,
      range_start: field.rangeStart,
      range_end: field.rangeEnd,
      start_date: field.startDate,
      end_date: field.endDate,
      prefilled_value: field.preFilledValue
    };
    return item;
  });
  return items;
};
var convertToQuickReplies = function convertToQuickReplies(_ref5) {
  var _ref5$quickReplies = _ref5.quickReplies,
    quickReplies = _ref5$quickReplies === void 0 ? [] : _ref5$quickReplies;
  var items = quickReplies.map(function (quickReply) {
    return {
      actionable_text: quickReply.text,
      is_default: quickReply.isDefault ? 1 : 0,
      type: (quickReply.type || {
        value: "TEXT_ONLY"
      }).value,
      payload: {
        link: quickReply.link || "",
        message: quickReply.userSays || quickReply.text,
        gogo_message: quickReply.gogoMessage || ""
      }
    };
  });
  return items;
};
var convertFromQuickReplies = function convertFromQuickReplies(_ref6) {
  var _ref6$data = _ref6.data,
    data = _ref6$data === void 0 ? {
      quick_replies: []
    } : _ref6$data;
  var quickReplies = (data.quick_replies || []).map(function (item, i) {
    var quickReply = {
      title: "Quick Reply ".concat(i + 1),
      text: item.actionable_text,
      isDefault: item.is_default,
      type: getType(item.type),
      link: item.payload.link,
      userSays: item.payload.message,
      gogoMessage: item.payload.gogo_message,
      hasUserSays: item.actionable_text !== item.payload.message,
      hasGogoMessage: item.payload.gogo_message && item.payload.gogo_message.length > 0
    };
    return quickReply;
  });
  return quickReplies;
};
var convertToCarouselItems = function convertToCarouselItems(data) {
  var thumbnailItem = data.type === "CAROUSEL" ? "image" : data.type.toLowerCase();
  var carouselItems = data.items;
  var items = carouselItems.map(function (carouselItem) {
    var thumbnail = carouselItem.thumbnail,
      thumbnailOrientation = carouselItem.thumbnailOrientation,
      title = carouselItem.title,
      subtitle = carouselItem.subtitle,
      metadata = carouselItem.metadata,
      description = carouselItem.description,
      hasMiniActionable = carouselItem.hasMiniActionable,
      actionables = carouselItem.actionables,
      horizontalAlignment = carouselItem.horizontalAlignment,
      verticalAlignment = carouselItem.verticalAlignment;
    var item = {
      horizontalAlignment: horizontalAlignment,
      verticalAlignment: verticalAlignment,
      thumbnail: {
        type: thumbnailOrientation
      },
      title: title,
      sub_title: subtitle,
      meta_data: metadata,
      description: description,
      actionables: hasMiniActionable ? [] : convertToActionables({
        actionables: actionables
      }),
      mini_actionable: hasMiniActionable ? convertToActionables({
        actionables: [actionables[KEYS.MINI_ACTIONABLE_INDEX]]
      })[0] : undefined
    };
    item.thumbnail[thumbnailItem] = thumbnail;
    return item;
  });
  return items;
};
var convertFromCarouselItems = function convertFromCarouselItems(_ref7) {
  var _ref7$data = _ref7.data,
    data = _ref7$data === void 0 ? {
      items: []
    } : _ref7$data;
  var carouselItems = (data.items || []).map(function (item) {
    var carouselItem = {
      horizontalAlignment: item.horizontalAlignment,
      verticalAlignment: item.verticalAlignment,
      thumbnail: (item.thumbnail || {}).image || (item.thumbnail || {}).video,
      thumbnailOrientation: (item.thumbnail || {}).type,
      title: item.title,
      subtitle: item.sub_title,
      description: item.description,
      actionables: convertFromActionables({
        data: {
          items: item.actionables
        }
      }),
      hasMiniActionable: item.mini_actionable && (item.actionables || []).length === 0
    };
    if (carouselItem.hasMiniActionable) {
      carouselItem.actionables[KEYS.MINI_ACTIONABLE_INDEX] = convertFromActionables({
        data: {
          items: [item.mini_actionable]
        }
      })[0];
    }
    return carouselItem;
  });
  return carouselItems;
};
var addLostKeys = function addLostKeys() {
  var destination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.keys(source).map(function (topLevelKey) {
    if (!Object.keys(destination).includes(topLevelKey) && topLevelKey !== "supported_response" // Added to remove the supported response key we get from translated responses after editing
    ) {
      destination[topLevelKey] = source[topLevelKey];
    } else if (Array.isArray(source[topLevelKey])) {
      source[topLevelKey].map(function (sourceItem, i) {
        if (_typeof$1(sourceItem) === "object" && destination[topLevelKey][i]) {
          addLostKeys(destination[topLevelKey][i], sourceItem);
        }
      });
    } else if (_typeof$1(source[topLevelKey]) === "object") {
      addLostKeys(destination[topLevelKey], source[topLevelKey]);
    }
  });
  return destination;
};

function isValidURL(str) {
  /*
    validUrlList = [
      "https://www.google.com",
      "http://www.google.com",
      "https://www.google.com/awd",
      "https://www.google.com/awd?w=654&h=890",
      "http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac621e74282a5beec6c172bdd192359fdcc47.jpeg?w=1081&h=1080"
    ]
     invalidUrlList = [
      "[test_image]",
      "{this}",
      "only_text"
    ]
  */
  return /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/.test(str);
}
function isVideo(url) {
  var extension = url.split('.').pop();
  if (url !== undefined || url !== "") {
    if (VIDEO_EXTENSIONS.includes(extension)) return {
      isYoutubeVideo: false,
      isVideo: true
    };
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;
    var match = url.match(regExp);
    if (match && match[2].length === 11) return {
      isYoutubeVideo: true,
      isVideo: false
    };
  }
  return {
    isYoutubeVideo: false,
    isVideo: false
  };
}
function getFormIconUrl(icon) {
  return "https://toolassets.haptikapi.com/platform/form_icons/".concat(icon, ".svg");
}

/**
 * This method formats the date in YYYY-MM-DD format.
 * @param {object} date Date object
 */
function getFormattedDate(date) {
  return "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
}
function triggerMixPanelEvent(hslElementTitle, hslAction) {
  var _window$mixpanel, _botData$business;
  var botData = JSON.parse(localStorage.getItem("ww_iva"));
  (_window$mixpanel = window.mixpanel) === null || _window$mixpanel === void 0 || _window$mixpanel.track(MIXPANEL_HSL_ELEMENTS, {
    "Bot Name": botData === null || botData === void 0 ? void 0 : botData.title,
    "Bot ID": botData === null || botData === void 0 ? void 0 : botData.id,
    "Business": botData.isSmartSkill ? botData.business_via_name : botData === null || botData === void 0 || (_botData$business = botData.business) === null || _botData$business === void 0 || (_botData$business = _botData$business[0]) === null || _botData$business === void 0 ? void 0 : _botData$business.via_name,
    "Account": botData === null || botData === void 0 ? void 0 : botData.client,
    "Action": hslAction,
    "HSL Type": hslElementTitle
  });
}

var css_248z$f = ".Slider_componentSliderWrapper__2ze27 {\n  position: relative;\n  display: flex;\n  align-items: center; }\n\n.Slider_componentSlider__3NTDg {\n  flex: 1;\n  width: 100%;\n  transition: transform 0.5s cubic-bezier(0.175, 0.5, 0.12, 1);\n  -webkit-mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 5%, black 15%, black 80%, rgba(0, 0, 0, 0) 98%); }\n  .Slider_componentSlider__3NTDg.Slider_disabled__lL6M1 {\n    -webkit-mask-image: linear-gradient(to right, black 0%, black 85%, rgba(0, 0, 0, 0) 98%); }\n\n.Slider_componentSliderTrack__1nwTv {\n  display: inline-flex;\n  flex-wrap: nowrap;\n  transition: transform 0.5s cubic-bezier(0.175, 0.5, 0.12, 1);\n  min-width: 300px; }\n\n.Slider_componentSliderArrow__y_cw0 {\n  position: absolute;\n  z-index: 2;\n  left: 0px;\n  top: 50%;\n  transform: translateY(-50%);\n  min-width: 40px;\n  height: 40px;\n  border-radius: 100px;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n  border: 1px solid #eee;\n  cursor: pointer;\n  transition: 0.2s ease-out;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .Slider_componentSliderArrow__y_cw0:hover {\n    background-color: #fff; }\n  .Slider_componentSliderArrow__y_cw0:active {\n    background-color: #fff; }\n  .Slider_componentSliderArrow__y_cw0.Slider_disabled__lL6M1 {\n    opacity: 0;\n    pointer-events: none;\n    transform: translateY(-40%); }\n  .Slider_componentSliderArrow__y_cw0.Slider_right__1ultP {\n    left: auto;\n    right: 0px;\n    transform: translateY(-50%) rotate(180deg);\n    box-shadow: 0 -5px 5px rgba(0, 0, 0, 0.1); }\n\n.Slider_angleDownIcon__2BIDe {\n  transform: rotate(90deg); }\n\n.Slider_card__3V2b- {\n  width: 200px;\n  height: 200px;\n  margin-right: 8px;\n  background-color: #eee;\n  transform-origin: 0 50%;\n  transition: 0.2s ease-out; }\n  .Slider_card__3V2b-.Slider_active__geD5u {\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05); }\n";
var styles$f = {"componentSliderWrapper":"Slider_componentSliderWrapper__2ze27","componentSlider":"Slider_componentSlider__3NTDg","disabled":"Slider_disabled__lL6M1","componentSliderTrack":"Slider_componentSliderTrack__1nwTv","componentSliderArrow":"Slider_componentSliderArrow__y_cw0","right":"Slider_right__1ultP","angleDownIcon":"Slider_angleDownIcon__2BIDe","card":"Slider_card__3V2b-","active":"Slider_active__geD5u"};
styleInject(css_248z$f);

var getNumChildren = function getNumChildren(children) {
  var count = 0;
  React.Children.forEach(children, function (child) {
    if (child) count += 1;
  });
  return count;
};
function useSlider(children, _ref) {
  var onChange = _ref.onChange,
    centerMode = _ref.centerMode,
    initialSlide = _ref.initialSlide;
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray$1(_React$useState, 2),
    left = _React$useState2[0],
    setLeft = _React$useState2[1];
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray$1(_React$useState3, 2),
    offset = _React$useState4[0],
    setOffset = _React$useState4[1];
  var _React$useState5 = React.useState(initialSlide),
    _React$useState6 = _slicedToArray$1(_React$useState5, 2),
    slide = _React$useState6[0],
    setSlide = _React$useState6[1];
  var sliderWrapperRef = React.useRef();
  var numberOfElements = getNumChildren(children);
  var sliderElementRefs = new Array(numberOfElements).fill(0).map(function () {
    return /*#__PURE__*/React.createRef();
  });
  var slideTo = React.useCallback(function (index) {
    return function () {
      var slideToIndex = index;
      if (slideToIndex > numberOfElements - 1) {
        slideToIndex = numberOfElements - 1;
      } else if (slideToIndex < 0) {
        slideToIndex = 0;
      }
      var left = sliderElementRefs.reduce(function (leftTotal, elementRef, i) {
        if (i < index) leftTotal += elementRef.current.getBoundingClientRect().width;
        return leftTotal;
      }, 0);
      if (centerMode) {
        left += sliderElementRefs[index].current.getBoundingClientRect().width / 2;
      } else if (slideToIndex !== 0) {
        left += -60;
      }
      setLeft(left);
      setSlide(slideToIndex);
      onChange && onChange(slideToIndex);
    };
  });
  React.useEffect(function () {
    if (centerMode) {
      var _offset = sliderWrapperRef.current.getBoundingClientRect().width / 2;
      setOffset(_offset);
    }
    slideTo(initialSlide || 0);
  }, [sliderWrapperRef.current]);
  React.useEffect(function () {
    setSlide(initialSlide);
  }, [initialSlide]);
  return {
    left: left,
    offset: offset,
    slide: slide,
    sliderWrapperRef: sliderWrapperRef,
    sliderElementRefs: sliderElementRefs,
    slideTo: slideTo,
    numElements: numberOfElements
  };
}

var renderArrow = function renderArrow(className, onClick) {
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: "".concat(styles$f.componentSliderArrow, " ").concat(className)
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles$f.angleDownIcon,
    src: AngleDownIcon
  }));
};
var Slider = function Slider(_ref) {
  var className = _ref.className,
    centerMode = _ref.centerMode,
    children = _ref.children,
    onChange = _ref.onChange,
    initialSlide = _ref.initialSlide,
    prefixClassName = _ref.prefixClassName;
  var _useSlider = useSlider(children, {
      onChange: onChange,
      centerMode: centerMode,
      initialSlide: initialSlide
    }),
    left = _useSlider.left,
    offset = _useSlider.offset,
    slide = _useSlider.slide,
    sliderWrapperRef = _useSlider.sliderWrapperRef,
    sliderElementRefs = _useSlider.sliderElementRefs,
    slideTo = _useSlider.slideTo,
    numElements = _useSlider.numElements;
  var leftArrowDisabledClass = slide === 0 ? styles$f.disabled : "";
  var rightArrowDisabledClass = slide === numElements - 1 || numElements < 2 ? styles$f.disabled : "";
  var transformStyle = {
    transform: "translate3d(".concat(-1 * (left - offset), "px, 0, 0)")
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "slider",
    ref: sliderWrapperRef,
    className: "".concat(styles$f.componentSliderWrapper, " ").concat(className, " ").concat(prefixClassName)
  }, renderArrow("".concat(styles$f.left, " ").concat(prefixClassName, "-arrow  ").concat(prefixClassName, "-arrow-left ").concat(leftArrowDisabledClass), slideTo(slide - 1)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$f.componentSlider, " ").concat(leftArrowDisabledClass)
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "slider-track",
    style: transformStyle,
    className: "".concat(styles$f.componentSliderTrack, " ").concat(prefixClassName, "-items")
  }, React.Children.map(children, function (child, index) {
    if (!child) return null;
    var activeClassName = index === slide ? "".concat(prefixClassName, "-item-active") : "";
    return /*#__PURE__*/React.createElement("div", {
      ref: sliderElementRefs[index],
      className: "".concat(styles$f.componentSliderItem, " ").concat(prefixClassName, "-item ").concat(activeClassName)
    }, /*#__PURE__*/React.cloneElement(child, {
      active: index === slide
    }));
  }))), renderArrow("".concat(styles$f.right, " ").concat(prefixClassName, "-arrow  ").concat(prefixClassName, "-arrow-right ").concat(rightArrowDisabledClass), slideTo(slide + 1)));
};
Slider.propTypes = {
  children: PropTypes.node,
  centerMode: PropTypes.bool,
  className: PropTypes.string,
  prefixClassName: PropTypes.string,
  onChange: PropTypes.func,
  initialSlide: PropTypes.number
};
Slider.defaultProps = {
  children: null,
  centerMode: false,
  className: "",
  prefixClassName: "",
  onChange: function onChange() {},
  initialSlide: 0
};
Slider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Slider",
  "props": {
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "centerMode": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "prefixClassName": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "initialSlide": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    }
  }
};

var convertFromHSL = function convertFromHSL(HSL) {
  var component = {
    botSays: HSL === null || HSL === void 0 ? void 0 : HSL.text,
    voiceSays: HSL === null || HSL === void 0 ? void 0 : HSL.voice_text,
    autoOpenMic: HSL === null || HSL === void 0 ? void 0 : HSL.mic_auto_open,
    type: HSL === null || HSL === void 0 ? void 0 : HSL.type,
    _originalHSL: HSL
  };
  component.quickReplies = convertFromQuickReplies(HSL);
  return component;
};
var convertToHSL = function convertToHSL(component) {
  var HSL = {
    text: component.botSays,
    voice_text: component.voiceSays,
    mic_auto_open: component.autoOpenMic,
    type: component.type,
    data: {}
  };
  HSL.data.quick_replies = convertToQuickReplies(component);
  HSL = addLostKeys(HSL, component._originalHSL);
  return HSL;
};

export { AddIcon as A, BASE as B, ConfirmationDialog as C, Drawer as D, EmojiPicker as E, File as F, convertFromActionables as G, HSLWrapper as H, convertToActionables as I, getFormIconUrl as J, KEY_CODES as K, getFormattedDate as L, FORM_ICON_LIST as M, FORM_FIELD_TYPES as N, convertFromFormHSL as O, Portal$3 as P, convertToFormHSL as Q, RichText as R, Slider as S, TEXT_VALIDATION_REGEX as T, EMAIL_VALIDATION_REGEX as U, sendGoogleAnalyticsEvents as V, convertFromHSL as W, _assertThisInitialized as X, _extends as Y, convertToHSL as Z, _setPrototypeOf as _, ACTIONABLE_OPTIONS as a, CONSTRAINTS as b, AddButton as c, remove as d, add$1 as e, edit as f, getActionableSubtitle as g, toggleDefault as h, triggerMixPanelEvent as i, isValidURL as j, isVideo as k, KEYS as l, CAROUSEL_SIZE_OPTIONS as m, CAROUSEL_RATIO_OPTIONS as n, getSize as o, getAspectRatio as p, convertFromCarouselItems as q, renderAdditionalFields as r, sort as s, toggle as t, convertToCarouselItems as u, addLostKeys as v, arrayMove as w, sortableContainer as x, sortableElement as y, sortableHandle as z };
